// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 16 16%27%3e%3cpath stroke=%27white%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M4 8h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 width=%27786%27 height=%27786%27 viewBox=%270 0 786 786%27%3E%3Cdefs%3E%3ClinearGradient id=%27linear-gradient%27 x1=%270.5%27 x2=%270.5%27 y2=%271%27 gradientUnits=%27objectBoundingBox%27%3E%3Cstop offset=%270%27 stop-color=%27%238a97ac%27/%3E%3Cstop offset=%271%27 stop-color=%27%235d6c83%27/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id=%27Group_2%27 data-name=%27Group 2%27 transform=%27translate%28-567 -93%29%27%3E%3Crect id=%27Rectangle_4%27 data-name=%27Rectangle 4%27 width=%27418%27 height=%27681%27 rx=%2740%27 transform=%27translate%28896 109%29%27 fill=%27%2395a5b9%27/%3E%3Crect id=%27Rectangle_3%27 data-name=%27Rectangle 3%27 width=%27433%27 height=%27681%27 rx=%2740%27 transform=%27translate%28606 93%29%27 fill=%27%23a0aec0%27/%3E%3Crect id=%27Rectangle_2%27 data-name=%27Rectangle 2%27 width=%27786%27 height=%27721%27 rx=%2740%27 transform=%27translate%28567 158%29%27 fill=%27url%28%23linear-gradient%29%27/%3E%3C/g%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 width=%27786%27 height=%27786%27 viewBox=%270 0 786 786%27%3E%3Cdefs%3E%3ClinearGradient id=%27linear-gradient%27 x1=%270.5%27 x2=%270.5%27 y2=%271%27 gradientUnits=%27objectBoundingBox%27%3E%3Cstop offset=%270%27 stop-color=%27%238a97ac%27/%3E%3Cstop offset=%271%27 stop-color=%27%235d6c83%27/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id=%27Group_3%27 data-name=%27Group 3%27 transform=%27translate%28-567 -93%29%27%3E%3Crect id=%27Rectangle_4%27 data-name=%27Rectangle 4%27 width=%27418%27 height=%27681%27 rx=%2740%27 transform=%27translate%28896 109%29%27 fill=%27%2395a5b9%27/%3E%3Crect id=%27Rectangle_3%27 data-name=%27Rectangle 3%27 width=%27433%27 height=%27681%27 rx=%2740%27 transform=%27translate%28606 93%29%27 fill=%27%23a0aec0%27/%3E%3Crect id=%27Rectangle_2%27 data-name=%27Rectangle 2%27 width=%27742%27 height=%27734%27 rx=%2740%27 transform=%27translate%28590 145%29%27 fill=%27%23bec8d9%27/%3E%3Crect id=%27Rectangle_5%27 data-name=%27Rectangle 5%27 width=%27786%27 height=%27692%27 rx=%2740%27 transform=%27translate%28567 187%29%27 fill=%27url%28%23linear-gradient%29%27/%3E%3C/g%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 width=%27628.027%27 height=%27786.012%27 viewBox=%270 0 628.027 786.012%27%3E%3Cdefs%3E%3ClinearGradient id=%27linear-gradient%27 x1=%270.5%27 x2=%270.5%27 y2=%271%27 gradientUnits=%27objectBoundingBox%27%3E%3Cstop offset=%270%27 stop-color=%27%238a97ac%27/%3E%3Cstop offset=%271%27 stop-color=%27%235d6c83%27/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id=%27Group_5%27 data-name=%27Group 5%27 transform=%27translate%28-646 -92.988%29%27%3E%3Cpath id=%27Union_2%27 data-name=%27Union 2%27 d=%27M40,786A40,40,0,0,1,0,746V40A40,40,0,0,1,40,0H501V103h29v24h98V746a40,40,0,0,1-40,40Z%27 transform=%27translate%28646 93%29%27 fill=%27url%28%23linear-gradient%29%27/%3E%3Cpath id=%27Intersection_2%27 data-name=%27Intersection 2%27 d=%27M.409,162.042l.058-109.9c31.605,29.739,125.37,125.377,125.37,125.377l-109.976.049A20.025,20.025,0,0,1,.409,162.042Z%27 transform=%27translate%281147 42%29%27 fill=%27%23bec8d9%27 stroke=%27%23bec8d9%27 stroke-width=%271%27/%3E%3C/g%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23e8eeff%27 stroke-width=%271%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right breadcrumb__icon%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%271%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right breadcrumb__icon%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23718096%27 stroke-width=%271%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27feather feather-chevron-right breadcrumb__icon%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2780%27 viewBox=%270 0 20 122.1%27%3E%3Cpath data-name=%27Union 1%27 d=%27M16.038 122H16v-2.213a95.805 95.805 0 00-2.886-20.735 94.894 94.894 0 00-7.783-20.434A39.039 39.039 0 010 61.051a39.035 39.035 0 015.331-17.567 94.9 94.9 0 007.783-20.435A95.746 95.746 0 0016 2.314V0h4v122h-3.961v.1l-.001-.1z%27 fill=%27%23f1f5f8%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml;charset=utf-8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2720%27 height=%2780%27 viewBox=%270 0 20 122.1%27%3E%3Cpath data-name=%27Union 1%27 d=%27M16.038 122H16v-2.213a95.805 95.805 0 00-2.886-20.735 94.894 94.894 0 00-7.783-20.434A39.039 39.039 0 010 61.051a39.035 39.035 0 015.331-17.567 94.9 94.9 0 007.783-20.435A95.746 95.746 0 0016 2.314V0h4v122h-3.961v.1l-.001-.1z%27 fill=%27%23232e45%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgb%2874, 85, 104%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27lucide lucide-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgb%28102 113 132%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27lucide lucide-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 width=%2724%27 height=%2724%27 stroke=%27%232d3748%27 stroke-width=%271.1%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27css-i6dzq1%27%3E%3Cpolyline points=%2711 17 6 12 11 7%27%3E%3C/polyline%3E%3Cpolyline points=%2718 17 13 12 18 7%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 width=%2724%27 height=%2724%27 stroke=%27%232d3748%27 stroke-width=%271.1%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27css-i6dzq1%27%3E%3Cpolyline points=%2715 18 9 12 15 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 width=%2724%27 height=%2724%27 stroke=%27%232d3748%27 stroke-width=%271.1%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27css-i6dzq1%27%3E%3Cpolyline points=%279 18 15 12 9 6%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 width=%2724%27 height=%2724%27 stroke=%27%232d3748%27 stroke-width=%271.1%27 fill=%27none%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27css-i6dzq1%27%3E%3Cpolyline points=%2713 17 18 12 13 7%27%3E%3C/polyline%3E%3Cpolyline points=%276 17 11 12 6 7%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgb%2874 85 104%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27lucide lucide-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714.828%27 height=%278.414%27 viewBox=%270 0 14.828 8.414%27%3E%3Cpath id=%27chevron%27 d=%27M6,9l6,6,6-6%27 transform=%27translate%2819.414 16%29 rotate%28180%29%27 fill=%27none%27 stroke=%27%234a5568%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgb%28255 255 255%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 class=%27lucide lucide-chevron-down%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2714.828%27 height=%278.414%27 viewBox=%270 0 14.828 8.414%27%3E%3Cpath id=%27chevron%27 d=%27M6,9l6,6,6-6%27 transform=%27translate%2819.414 16%29 rotate%28180%29%27 fill=%27none%27 stroke=%27rgb%28255 255 255%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 |--------------------------------------------------------------------------
 | TailwindCSS Directives
 |--------------------------------------------------------------------------
 |
 | Import TailwindCSS directives and swipe out at build-time with all of
 | the styles it generates based on your configured design system.
 |
 | Please check this link for more details:
 | https://tailwindcss.com/docs/installation#include-tailwind-in-your-css
 |
 */
/*
 ! tailwindcss v3.0.24 | MIT License | https://tailwindcss.com
 */
/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/
*,
::before,
::after {
  box-sizing: border-box;
  /* 1 */
  border-width: 0;
  /* 2 */
  border-style: solid;
  /* 2 */
  border-color: #e5e7eb;
  /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
*/
html {
  line-height: 1.5;
  /* 1 */
  -webkit-text-size-adjust: 100%;
  /* 2 */
  /* 3 */
  tab-size: 4;
  /* 3 */
  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  /* 4 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/
body {
  margin: 0;
  /* 1 */
  line-height: inherit;
  /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/
hr {
  height: 0;
  /* 1 */
  color: inherit;
  /* 2 */
  border-top-width: 1px;
  /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/
abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
  text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/
a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/
b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font family by default.
2. Correct the odd \`em\` font sizing in all browsers.
*/
code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  /* 1 */
  font-size: 1em;
  /* 2 */
}

/*
Add the correct font size in all browsers.
*/
small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/
table {
  text-indent: 0;
  /* 1 */
  border-color: inherit;
  /* 2 */
  border-collapse: collapse;
  /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/
button,
input,
optgroup,
select,
textarea {
  font-family: inherit;
  /* 1 */
  font-size: 100%;
  /* 1 */
  line-height: inherit;
  /* 1 */
  color: inherit;
  /* 1 */
  margin: 0;
  /* 2 */
  padding: 0;
  /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/
button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/
button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
  /* 1 */
  background-color: transparent;
  /* 2 */
  background-image: none;
  /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/
:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/
:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/
progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/
::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/
[type='search'] {
  -webkit-appearance: textfield;
  /* 1 */
  outline-offset: -2px;
  /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/
::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/
::-webkit-file-upload-button {
  -webkit-appearance: button;
  /* 1 */
  font: inherit;
  /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/
summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/
blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/
textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1;
  /* 1 */
  color: #9ca3af;
  /* 2 */
}

/*
Set the default cursor for buttons.
*/
button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/
img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  /* 1 */
  vertical-align: middle;
  /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/
img,
video {
  max-width: 100%;
  height: auto;
}

/*
Ensure the default browser behavior of the \`hidden\` attribute.
*/
[hidden] {
  display: none;
}

[type='text'],
[type='email'],
[type='url'],
[type='password'],
[type='number'],
[type='date'],
[type='datetime-local'],
[type='month'],
[type='search'],
[type='tel'],
[type='time'],
[type='week'],
[multiple],
textarea,
select {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

[type='text']:focus,
[type='email']:focus,
[type='url']:focus,
[type='password']:focus,
[type='number']:focus,
[type='date']:focus,
[type='datetime-local']:focus,
[type='month']:focus,
[type='search']:focus,
[type='tel']:focus,
[type='time']:focus,
[type='week']:focus,
[multiple]:focus,
textarea:focus,
select:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

input::placeholder,
textarea::placeholder {
  color: #6b7280;
  opacity: 1;
}

::-webkit-datetime-edit-fields-wrapper {
  padding: 0;
}

::-webkit-date-and-time-value {
  min-height: 1.5em;
}

::-webkit-datetime-edit,
::-webkit-datetime-edit-year-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-minute-field,
::-webkit-datetime-edit-second-field,
::-webkit-datetime-edit-millisecond-field,
::-webkit-datetime-edit-meridiem-field {
  padding-top: 0;
  padding-bottom: 0;
}

select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
  -moz-print-color-adjust: exact;
  print-color-adjust: exact;
}

[multiple] {
  background-image: initial;
  background-position: initial;
  background-repeat: unset;
  background-size: initial;
  padding-right: 0.75rem;
  -webkit-print-color-adjust: unset;
  -moz-print-color-adjust: unset;
  print-color-adjust: unset;
}

[type='checkbox'],
[type='radio'] {
  appearance: none;
  padding: 0;
  -webkit-print-color-adjust: exact;
  -moz-print-color-adjust: exact;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  user-select: none;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: #2563eb;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
}

[type='checkbox'] {
  border-radius: 0px;
}

[type='radio'] {
  border-radius: 100%;
}

[type='checkbox']:focus,
[type='radio']:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-ring-offset-width: 2px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
}

[type='checkbox']:checked,
[type='radio']:checked {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

[type='radio']:checked {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

[type='checkbox']:checked:hover,
[type='checkbox']:checked:focus,
[type='radio']:checked:hover,
[type='radio']:checked:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='checkbox']:indeterminate {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

[type='checkbox']:indeterminate:hover,
[type='checkbox']:indeterminate:focus {
  border-color: transparent;
  background-color: currentColor;
}

[type='file'] {
  background: unset;
  border-color: inherit;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-size: unset;
  line-height: inherit;
}

[type='file']:focus {
  outline: 1px solid ButtonText;
  outline: 1px auto -webkit-focus-ring-color;
}

*,
::before,
::after {
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x: ;
  --tw-pan-y: ;
  --tw-pinch-zoom: ;
  --tw-scroll-snap-strictness: proximity;
  --tw-ordinal: ;
  --tw-slashed-zero: ;
  --tw-numeric-figure: ;
  --tw-numeric-spacing: ;
  --tw-numeric-fraction: ;
  --tw-ring-inset: ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur: ;
  --tw-brightness: ;
  --tw-contrast: ;
  --tw-grayscale: ;
  --tw-hue-rotate: ;
  --tw-invert: ;
  --tw-saturate: ;
  --tw-sepia: ;
  --tw-drop-shadow: ;
  --tw-backdrop-blur: ;
  --tw-backdrop-brightness: ;
  --tw-backdrop-contrast: ;
  --tw-backdrop-grayscale: ;
  --tw-backdrop-hue-rotate: ;
  --tw-backdrop-invert: ;
  --tw-backdrop-opacity: ;
  --tw-backdrop-saturate: ;
  --tw-backdrop-sepia: ;
}

.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}

@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}

@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}

@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}

@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}

.form-input,
.form-textarea,
.form-select,
.form-multiselect {
  appearance: none;
  background-color: #fff;
  border-color: #6b7280;
  border-width: 1px;
  border-radius: 0px;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-shadow: 0 0 #0000;
}

.form-input:focus,
.form-textarea:focus,
.form-select:focus,
.form-multiselect:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-inset: var(--tw-empty,
      /*!*/
      /*!*/
    );
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: #2563eb;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
  border-color: #2563eb;
}

.form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 0.5rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
  -webkit-print-color-adjust: exact;
  -moz-print-color-adjust: exact;
  print-color-adjust: exact;
}

.accordion .accordion-item {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.accordion .accordion-item:not(:last-child) {
  border-bottom-width: 1px;
  border-color: rgb(var(--color-slate-200) / 0.6);
}

.dark .accordion .accordion-item:not(:last-child) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.accordion .accordion-item:first-child {
  margin-top: -1rem;
}

.accordion .accordion-item:last-child {
  margin-bottom: -1rem;
}

.accordion .accordion-item .accordion-header .accordion-button {
  margin-top: -1rem;
  margin-bottom: -1rem;
  width: 100%;
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: left;
  font-weight: 500;
}

.dark .accordion .accordion-item .accordion-header .accordion-button {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.accordion .accordion-item .accordion-header .accordion-button:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.accordion .accordion-collapse {
  margin-top: 0.75rem;
  line-height: 1.625;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

.dark .accordion .accordion-collapse {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.accordion .accordion-collapse.collapse:not(.show) {
  display: none;
}

.accordion.accordion-boxed .accordion-item {
  margin-top: 0.75rem;
  border-width: 1px;
  border-color: rgb(var(--color-slate-200) / 0.6);
  padding: 1rem;
}

.dark .accordion.accordion-boxed .accordion-item {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.accordion.accordion-boxed .accordion-item:first-child {
  margin-top: 0px;
}

.accordion.accordion-boxed .accordion-item:last-child {
  margin-bottom: 0px;
}

.alert {
  position: relative;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.alert.alert-dismissible {
  padding-left: 1.25rem;
  padding-right: 4rem;
}

.alert.alert-dismissible:not(.show) {
  display: none;
}

.alert .btn-close {
  position: absolute;
  right: 0px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.btn-close {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
}

/* Alert Colors */
.alert-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .alert-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.alert-secondary {
  border-color: rgb(var(--color-secondary) / 0.7);
  background-color: rgb(var(--color-secondary) / 0.7);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .alert-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.alert-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .alert-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.alert-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .alert-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.alert-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .alert-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
}

.alert-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .alert-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.alert-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .alert-dark {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

/* Outline Button */
.alert-outline-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .alert-outline-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.alert-outline-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .alert-outline-secondary {
  border-color: rgb(var(--color-darkmode-100) / 0.4);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.alert-outline-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-success) / var(--tw-text-opacity));
}

.dark .alert-outline-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.alert-outline-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning) / var(--tw-text-opacity));
}

.dark .alert-outline-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.alert-outline-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-pending) / var(--tw-text-opacity));
}

.dark .alert-outline-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
}

.alert-outline-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger) / var(--tw-text-opacity));
}

.dark .alert-outline-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.alert-outline-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-dark) / var(--tw-text-opacity));
}

.dark .alert-outline-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

/* Button Soft Colors */
.alert-primary-soft {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .alert-primary-soft {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 1;
  --tw-bg-opacity: 0.2;
}

.alert-secondary-soft {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.1;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .alert-secondary-soft {
  border-color: rgb(var(--color-darkmode-100) / 0.3);
  background-color: rgb(var(--color-darkmode-100) / 0.2);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.alert-success-soft {
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-success) / var(--tw-text-opacity));
}

.dark .alert-success-soft {
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.alert-warning-soft {
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning) / var(--tw-text-opacity));
}

.dark .alert-warning-soft {
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.alert-pending-soft {
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-pending) / var(--tw-text-opacity));
}

.dark .alert-pending-soft {
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.alert-danger-soft {
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger) / var(--tw-text-opacity));
}

.dark .alert-danger-soft {
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.alert-dark-soft {
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-dark) / var(--tw-text-opacity));
}

.dark .alert-dark-soft {
  border-color: rgb(var(--color-darkmode-800) / 0.6);
  background-color: rgb(var(--color-darkmode-800) / 0.3);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

/* Default Button */
.btn {
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 500;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.btn:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
}

.dark .btn {
  transition-property: none;
}

.dark .btn:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.btn:hover:not(:disabled) {
  --tw-border-opacity: 0.7;
  --tw-bg-opacity: 0.7;
}

.btn:not(button) {
  text-align: center;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  background-color: #c7c7c7;
  border: 1px solid #c7c7c7;
  color: #000;
}

/* Default Sizes */
.btn-sm {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

.btn-lg {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

/* Button Colors */
.btn-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.btn-secondary {
  border-color: rgb(var(--color-secondary) / 0.7);
  background-color: rgb(var(--color-secondary) / 0.7);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .btn-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-secondary:hover:not(:disabled) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .btn-secondary:hover:not(:disabled) {
  border-color: rgb(var(--color-darkmode-300) / 0.8);
  background-color: rgb(var(--color-darkmode-300) / 0.8);
}

.btn-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.btn-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.btn-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
}

.btn-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.btn-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-dark {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .btn-dark:hover:not(:disabled) {
  background-color: rgb(var(--color-darkmode-800) / 0.7);
}

/* Button Elevated */
.btn-elevated-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.btn-elevated-primary {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-elevated-secondary {
  border-color: rgb(var(--color-secondary) / 0.7);
  background-color: rgb(var(--color-secondary) / 0.7);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .btn-elevated-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-elevated-secondary:hover:not(:disabled) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .btn-elevated-secondary:hover:not(:disabled) {
  border-color: rgb(var(--color-darkmode-300) / 0.8);
  background-color: rgb(var(--color-darkmode-300) / 0.8);
}

.btn-elevated-secondary {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-elevated-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-elevated-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.btn-elevated-success {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-elevated-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-elevated-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.btn-elevated-warning {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-elevated-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
}

.btn-elevated-pending {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-elevated-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.btn-elevated-danger {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.btn-elevated-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-dark {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .btn-elevated-dark:hover:not(:disabled) {
  background-color: rgb(var(--color-darkmode-800) / 0.7);
}

.btn-elevated-dark {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

/* Button Rounded */
.btn-rounded {
  border-radius: 9999px;
}

.btn-rounded-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-rounded-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.btn-rounded-primary {
  border-radius: 9999px;
}

.btn-rounded-secondary {
  border-color: rgb(var(--color-secondary) / 0.7);
  background-color: rgb(var(--color-secondary) / 0.7);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .btn-rounded-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-rounded-secondary:hover:not(:disabled) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .btn-rounded-secondary:hover:not(:disabled) {
  border-color: rgb(var(--color-darkmode-300) / 0.8);
  background-color: rgb(var(--color-darkmode-300) / 0.8);
}

.btn-rounded-secondary {
  border-radius: 9999px;
}

.btn-rounded-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-rounded-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.btn-rounded-success {
  border-radius: 9999px;
}

.btn-rounded-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-rounded-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.btn-rounded-warning {
  border-radius: 9999px;
}

.btn-rounded-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-rounded-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
}

.btn-rounded-pending {
  border-radius: 9999px;
}

.btn-rounded-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-rounded-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.btn-rounded-danger {
  border-radius: 9999px;
}

.btn-rounded-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-rounded-dark {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .btn-rounded-dark:hover:not(:disabled) {
  background-color: rgb(var(--color-darkmode-800) / 0.7);
}

.btn-rounded-dark {
  border-radius: 9999px;
}

/* Button Elevated Rounded */
.btn-elevated-rounded-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.btn-elevated-rounded-primary {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 9999px;
}

.btn-elevated-rounded-secondary {
  border-color: rgb(var(--color-secondary) / 0.7);
  background-color: rgb(var(--color-secondary) / 0.7);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-elevated-rounded-secondary:hover:not(:disabled) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .btn-elevated-rounded-secondary:hover:not(:disabled) {
  border-color: rgb(var(--color-darkmode-300) / 0.8);
  background-color: rgb(var(--color-darkmode-300) / 0.8);
}

.btn-elevated-rounded-secondary {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 9999px;
}

.btn-elevated-rounded-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.btn-elevated-rounded-success {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 9999px;
}

.btn-elevated-rounded-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.btn-elevated-rounded-warning {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 9999px;
}

.btn-elevated-rounded-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
}

.btn-elevated-rounded-pending {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 9999px;
}

.btn-elevated-rounded-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.btn-elevated-rounded-danger {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 9999px;
}

.btn-elevated-rounded-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-dark {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .btn-elevated-rounded-dark:hover:not(:disabled) {
  background-color: rgb(var(--color-darkmode-800) / 0.7);
}

.btn-elevated-rounded-dark {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  border-radius: 9999px;
}

/* Social Media Button */
.btn-facebook {
  --tw-border-opacity: 1;
  border-color: rgb(59 89 152 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(59 89 152 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-facebook {
  --tw-border-opacity: 1;
  border-color: rgb(59 89 152 / var(--tw-border-opacity));
}

.btn-twitter {
  --tw-border-opacity: 1;
  border-color: rgb(74 179 244 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(74 179 244 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-twitter {
  --tw-border-opacity: 1;
  border-color: rgb(74 179 244 / var(--tw-border-opacity));
}

.btn-instagram {
  --tw-border-opacity: 1;
  border-color: rgb(81 127 164 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(81 127 164 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-instagram {
  --tw-border-opacity: 1;
  border-color: rgb(81 127 164 / var(--tw-border-opacity));
}

.btn-linkedin {
  --tw-border-opacity: 1;
  border-color: rgb(0 119 181 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(0 119 181 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .btn-linkedin {
  --tw-border-opacity: 1;
  border-color: rgb(0 119 181 / var(--tw-border-opacity));
}

/* Outline Button */
.btn-outline-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .btn-outline-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.btn-outline-primary:hover:not(:disabled) {
  background-color: rgb(var(--color-primary) / 0.1);
}

.btn-outline-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .btn-outline-secondary {
  border-color: rgb(var(--color-darkmode-100) / 0.4);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-outline-secondary:hover:not(:disabled) {
  background-color: rgb(var(--color-secondary) / 0.2);
}

.dark .btn-outline-secondary:hover:not(:disabled) {
  background-color: rgb(var(--color-darkmode-100) / 0.1);
}

.btn-outline-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-success) / var(--tw-text-opacity));
}

.dark .btn-outline-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.btn-outline-success:hover:not(:disabled) {
  background-color: rgb(var(--color-success) / 0.1);
}

.btn-outline-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning) / var(--tw-text-opacity));
}

.dark .btn-outline-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.btn-outline-warning:hover:not(:disabled) {
  background-color: rgb(var(--color-warning) / 0.1);
}

.btn-outline-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-pending) / var(--tw-text-opacity));
}

.dark .btn-outline-pending {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
}

.btn-outline-pending:hover:not(:disabled) {
  background-color: rgb(var(--color-pending) / 0.1);
}

.btn-outline-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger) / var(--tw-text-opacity));
}

.dark .btn-outline-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.btn-outline-danger:hover:not(:disabled) {
  background-color: rgb(var(--color-danger) / 0.1);
}

.btn-outline-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-dark) / var(--tw-text-opacity));
}

.dark .btn-outline-dark {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-outline-dark:hover:not(:disabled) {
  background-color: rgb(var(--color-darkmode-800) / 0.3);
}

.dark .btn-outline-dark:hover:not(:disabled) {
  --tw-bg-opacity: 0.3;
}

/* Button Soft Colors */
.btn-primary-soft {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .btn-primary-soft {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 1;
  --tw-bg-opacity: 0.2;
}

.btn-primary-soft:hover:not(:disabled) {
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 0.1;
}

.dark .btn-primary-soft:hover:not(:disabled) {
  --tw-border-opacity: 0.6;
}

.btn-secondary-soft {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));
  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .btn-secondary-soft {
  border-color: rgb(var(--color-darkmode-100) / 0.3);
  background-color: rgb(var(--color-darkmode-100) / 0.2);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-secondary-soft:hover:not(:disabled) {
  --tw-bg-opacity: 0.1;
}

.dark .btn-secondary-soft:hover:not(:disabled) {
  border-color: rgb(var(--color-darkmode-100) / 0.2);
  background-color: rgb(var(--color-darkmode-100) / 0.1);
}

.btn-success-soft {
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-success) / var(--tw-text-opacity));
}

.dark .btn-success-soft {
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.btn-success-soft:hover:not(:disabled) {
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 0.1;
}

.btn-warning-soft {
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning) / var(--tw-text-opacity));
}

.dark .btn-warning-soft {
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.btn-warning-soft:hover:not(:disabled) {
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 0.1;
}

.btn-pending-soft {
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-pending) / var(--tw-text-opacity));
}

.dark .btn-pending-soft {
  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.btn-pending-soft:hover:not(:disabled) {
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 0.1;
}

.btn-danger-soft {
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger) / var(--tw-text-opacity));
}

.dark .btn-danger-soft {
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
  --tw-border-opacity: 0.2;
}

.btn-danger-soft:hover:not(:disabled) {
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 0.1;
}

.btn-dark-soft {
  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));
  --tw-border-opacity: 0.05;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.2;
  --tw-text-opacity: 1;
  color: rgb(var(--color-dark) / var(--tw-text-opacity));
}

.dark .btn-dark-soft {
  border-color: rgb(var(--color-darkmode-800) / 0.6);
  background-color: rgb(var(--color-darkmode-800) / 0.3);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.btn-dark-soft:hover:not(:disabled) {
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 0.1;
}

.dark .btn-dark-soft:hover:not(:disabled) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
  background-color: rgb(var(--color-darkmode-800) / 0.5);
}

.dropdown .dropdown-menu {
  transform: translate3d(-10000px, 0px, 0px) !important;
}

.dropdown-menu {
  z-index: 9999;
  inset: 0px auto auto 0px;
  transition: visibility 0s ease-in-out 0.2s, opacity 0.2s 0s;
  visibility: hidden;
  position: absolute;
  opacity: 0;
}

.dropdown-menu.show {
  transition: visibility 0s ease-in-out 0s, opacity 0.2s 0s;
  visibility: visible;
  opacity: 1;
}

.dropdown-menu.show>.dropdown-content {
  margin-top: 0.25rem;
}

.dropdown-menu.show>.dropdown-content .tab-content .tab-pane {
  visibility: visible;
}

.dropdown-menu .dropdown-content {
  transition: margin-top 0.2s;
  box-shadow: 0px 3px 10px #00000017;
  position: relative;
  margin-top: 1.25rem;
  width: 100%;
  border-radius: 0.375rem;
  padding: 0.5rem;
}

.dropdown-menu .dropdown-content .dropdown-header {
  padding: 0.5rem;
  font-weight: 500;
}

.dropdown-menu .dropdown-content .dropdown-divider {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}

.dropdown-menu .dropdown-content .dropdown-item {
  display: flex;
  align-items: center;
  border-radius: 0.375rem;
  padding: 0.5rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.dropdown-menu .dropdown-content .dropdown-footer {
  display: flex;
  padding: 0.25rem;
}

.dropdown-menu .dropdown-content .tab-content .tab-pane {
  visibility: hidden;
}

.dropdown-content {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.dark .dropdown-content {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dropdown-divider {
  border-color: rgb(var(--color-slate-200) / 0.6);
}

.dark .dropdown-divider {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.dropdown-item:hover {
  background-color: rgb(var(--color-slate-200) / 0.6);
}

.dark .dropdown-item {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dark .dropdown-item:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.file .file__icon {
  position: relative;
  display: block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.file .file__icon.file__icon--empty-directory {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.file .file__icon.file__icon--directory {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.file .file__icon.file__icon--file {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.file .file__icon.file__icon--image .file__icon--image__preview {
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
}

.file .file__icon.file__icon--image .file__icon--image__preview img {
  border-radius: 0.375rem;
}

.file .file__icon .file__icon__file-name {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.file .file__icon:before {
  content: "";
  padding-top: 100%;
  display: block;
  width: 100%;
}

[type="text"],
[type="email"],
[type="url"],
[type="password"],
[type="number"],
[type="date"],
[type="datetime-local"],
[type="month"],
[type="search"],
[type="tel"],
[type="time"],
[type="week"],
[multiple],
textarea,
select {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.form-check {
  display: flex;
  align-items: center;
}

.form-check-label {
  margin-left: 0.5rem;
  cursor: pointer;
}

.form-check-input {
  transition-property: all;
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.form-check-input[type="radio"] {
  cursor: pointer;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.form-check-input[type="radio"]:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
  --tw-ring-offset-width: 0px;
}

.dark .form-check-input[type="radio"] {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .form-check-input[type="radio"]:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.form-check-input[type="radio"]:checked {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.form-check-input[type="radio"]:disabled:not(:checked) {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .form-check-input[type="radio"]:disabled:not(:checked) {
  background-color: rgb(var(--color-darkmode-800) / 0.5);
}

.form-check-input[type="radio"]:disabled:checked {
  cursor: not-allowed;
  opacity: 0.7;
}

.dark .form-check-input[type="radio"]:disabled:checked {
  background-color: rgb(var(--color-darkmode-800) / 0.5);
}

.form-check-input[type="checkbox"] {
  cursor: pointer;
  border-radius: 0.25rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.form-check-input[type="checkbox"]:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
  --tw-ring-offset-width: 0px;
}

.dark .form-check-input[type="checkbox"] {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .form-check-input[type="checkbox"]:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.form-check-input[type="checkbox"]:checked {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 0.1;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.form-check-input[type="checkbox"]:disabled:not(:checked) {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .form-check-input[type="checkbox"]:disabled:not(:checked) {
  background-color: rgb(var(--color-darkmode-800) / 0.5);
}

.form-check-input[type="checkbox"]:disabled:checked {
  cursor: not-allowed;
  opacity: 0.7;
}

.dark .form-check-input[type="checkbox"]:disabled:checked {
  background-color: rgb(var(--color-darkmode-800) / 0.5);
}

.form-switch .form-check-input {
  width: 38px;
  height: 24px;
  padding: 1px;
  position: relative;
  border-radius: 9999px;
  background-image: none;
}

.form-switch .form-check-input:before {
  content: "";
  width: 20px;
  height: 20px;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
  transition-property: margin-left;
  position: absolute;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 9999px;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.dark .form-switch .form-check-input:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.form-switch .form-check-input:checked {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.form-switch .form-check-input:checked::before {
  margin-left: 14px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

/* Default Form Control */
.form-control {
  width: 100%;
  border-radius: 0.375rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.form-control.input-padding {
  padding: 5px 0.5rem !important;
  font-size: 12px;
}

.form-control::placeholder {
  color: rgb(var(--color-slate-400) / 0.9);
}

.form-control:focus {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 0.4;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
}

.dark .form-control {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  transition-property: none;
}

.dark .form-control::placeholder {
  color: rgb(var(--color-slate-500) / 0.8);
}

.dark .form-control:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.form-control:disabled,
.form-control[readonly] {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .form-control:disabled,
.dark .form-control[readonly] {
  border-color: transparent;
  background-color: rgb(var(--color-darkmode-800) / 0.5);
}

/* Default Sizes */
.form-control-sm {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

.form-control-lg {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 1rem;
  padding-right: 1rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

/* Form Control Rounded */
.form-control-rounded {
  border-radius: 9999px;
}

.form-help {
  margin-top: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.form-inline {
  display: flex;
  align-items: center;
}

.form-inline .form-label {
  margin-bottom: 0px;
  margin-right: 1.25rem;
  text-align: right;
}

.form-inline .form-control {
  flex: 1 1;
}

.form-label {
  margin-bottom: 0.1rem;
  display: inline-block;
}

/* Default Form Select */
.form-select {
  /* width: 100%; */
  border-radius: 0.375rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  /* padding-top: 0.5rem; */
  /* padding-bottom: 0.5rem; */
  /* padding-left: 0.75rem; */
  /* padding-right: 2rem; */
  /* font-size: 0.875rem; */
  font-size: 12px;
  padding: 5px 2rem 5px 0.5rem;
  line-height: 1.25rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.form-select:focus {
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-border-opacity: 0.4;
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
}

.dark .form-select {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .form-select:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.form-select:disabled,
.form-select[readonly] {
  cursor: not-allowed;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .form-select:disabled,
.dark .form-select[readonly] {
  background-color: rgb(var(--color-darkmode-800) / 0.5);
}

/* Default Sizes */
.form-select-sm {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 0.5rem;
  padding-right: 2rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

.form-select-lg {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  padding-left: 1rem;
  padding-right: 2rem;
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.image-fit {
  position: relative;
}

.image-fit>img {
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
}

.input-group {
  display: flex;
}

.input-group .input-group-text {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .input-group .input-group-text {
  border-color: rgb(var(--color-darkmode-900) / 0.2);
  background-color: rgb(var(--color-darkmode-900) / 0.2);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.input-group>.input-group-text,
.input-group>.form-control {
  border-radius: 0px;
}

.input-group>.input-group-text:not(:first-child),
.input-group>.form-control:not(:first-child) {
  border-left-color: transparent;
}

.input-group>.input-group-text:first-child,
.input-group>.form-control:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.input-group>.input-group-text:last-child,
.input-group>.form-control:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.input-group>.form-control {
  z-index: 10;
}

.modal {
  margin-top: -10000px;
  margin-left: -10000px;
  background: #000000a6;
  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;
  visibility: hidden;
  position: fixed;
  left: 0px;
  top: 0px;
  height: 100dvh;
  width: 100vw;
  opacity: 0;
}

.modal.modal-overlap {
  background: #000000a6;
}

.modal.modal-static .modal-content {
  animation: modal-static-backdrop 0.3s infinite;
  animation-direction: alternate;
}

.modal.show {
  transition: visibility 0s ease-in-out 0s, opacity 0.4s ease-in-out 0s;
  visibility: visible;
  opacity: 1;
}

.modal.show>.modal-dialog {
  margin-top: 4rem;
}

.modal .modal-dialog {
  width: 90%;
  transition: margin-top 0.4s;
  margin-left: auto;
  margin-right: auto;
  margin-top: -4rem;
  margin-bottom: 4rem;
}

@media (min-width: 640px) {
  .modal .modal-dialog {
    width: 460px
  }

  .modal .modal-dialog.modal-sm {
    width: 300px;
  }

  .modal .modal-dialog.modal-lg {
    width: 600px;
  }

  .modal .modal-dialog.modal-xl {
    width: 600px;
  }
}

@media (min-width: 1024px) {
  .modal .modal-dialog.modal-xl {
    width: 900px;
  }
}

.modal .modal-dialog .modal-content {
  position: relative;
}

.modal .modal-dialog .modal-content>[data-tw-dismiss="modal"] {
  position: absolute;
  right: 0px;
  top: 0px;
  margin-top: 0.75rem;
  margin-right: 0.75rem;
}

.modal.modal-slide-over {
  overflow-x: hidden;
}

.modal.modal-slide-over.modal-static .modal-content {
  animation: none;
}

.modal.modal-slide-over.show {
  transition: visibility 0s ease-in-out 0s, opacity 0.6s ease-in-out 0s;
  visibility: visible;
  opacity: 1;
}

.modal.modal-slide-over.show>.modal-dialog {
  margin-right: 0px;
}

.modal.modal-slide-over .modal-dialog {
  margin-right: -100%;
  transition: margin-right 0.6s;
  margin-top: 0px;
  margin-bottom: 0px;
}

.modal.modal-slide-over .modal-dialog .modal-content {
  min-height: 100dvh;
  border-radius: 0px;
}

.modal.modal-slide-over .modal-dialog .modal-content>[data-tw-dismiss="modal"] {
  position: absolute;
  top: 0px;
  left: 0px;
  right: auto;
  margin-top: 1rem;
  margin-left: -3rem;
}

.modal-content {
  position: relative;
  width: 100%;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .modal-content {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.modal-header {
  display: flex;
  align-items: center;
  border-bottom-width: 1px;
  border-color: rgb(var(--color-slate-200) / 0.6);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-size: 14px;
}

.dark .modal-header {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.modal-body {
  padding: 1.25rem;
}

.modal-footer {
  border-top-width: 1px;
  border-color: rgb(var(--color-slate-200) / 0.6);
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  text-align: right;
}

.dark .modal-footer {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

@keyframes modal-static-backdrop {
  0% {
    transform: scale(1);
  }

  100% {
    transform: scale(1.05);
  }
}

.pagination {
  margin-right: auto;
  display: flex;
}

.pagination .page-item.active .page-link {
  box-shadow: 0px 3px 20px #0000000b;
  position: relative;
  border-radius: 0.375rem;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.dark .pagination .page-item.active .page-link {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.pagination .page-item.active .page-link {
  font-weight: 500;
}

.dark .pagination .page-item.active .page-link {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.pagination .page-item .page-link {
  min-width: 40px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-weight: 500;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.pagination .page-item .page-link:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
}

.dark .pagination .page-item .page-link {
  transition-property: none;
}

.dark .pagination .page-item .page-link:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.pagination .page-item .page-link:hover:not(:disabled) {
  --tw-border-opacity: 0.9;
  --tw-bg-opacity: 0.9;
}

.pagination .page-item .page-link:not(button) {
  text-align: center;
}

.pagination .page-item .page-link:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.pagination .page-item .page-link {
  margin-right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-color: transparent;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .pagination .page-item .page-link {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.progress {
  height: 0.5rem;
  width: 100%;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
}

.dark .progress {
  background-color: rgb(0 0 0 / 0.2);
}

.progress-bar {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  font-size: 0.75rem;
  line-height: 1rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.scrollbar-hidden::-webkit-scrollbar,
.scrollbar-hidden *::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: transparent;
}
.scrollbar-hidden::-webkit-scrollbar-thumb,
.scrollbar-hidden *::-webkit-scrollbar-thumb {
  background: rgba(0,0,0,0.15);
  border-radius: 3px;
}
.scrollbar-hidden::-webkit-scrollbar-thumb:hover,
.scrollbar-hidden *::-webkit-scrollbar-thumb:hover {
  background: rgba(0,0,0,0.3);
}
.scrollbar-hidden::-webkit-scrollbar-track,
.scrollbar-hidden *::-webkit-scrollbar-track {
  background: transparent;
}

.nav {
  display: flex;
  width: 100%;
}

.nav.nav-tabs {
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.dark .nav.nav-tabs {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.nav.nav-tabs .nav-item {
  margin-bottom: -1px;
}

.nav.nav-tabs .nav-item .nav-link {
  display: block;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  border-color: transparent;
}

.nav.nav-tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .nav.nav-tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.nav.nav-tabs .nav-item .nav-link.active {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  border-bottom-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  font-weight: 500;
}

.dark .nav.nav-tabs .nav-item .nav-link.active {
  border-left-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  border-right-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  border-top-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-border-opacity: 1;
  border-bottom-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));
  background-color: transparent;
}

.nav.nav-pills .nav-item .nav-link {
  border-radius: 0.375rem;
  border-width: 0px;
}

.nav.nav-pills .nav-item .nav-link.active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.nav.nav-boxed-tabs .nav-item .nav-link {
  box-shadow: 0px 3px 20px #0000000b;
  border-radius: 0.375rem;
}

.nav.nav-boxed-tabs .nav-item .nav-link.active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.nav.nav-link-tabs .nav-item .nav-link {
  border-bottom-width: 2px;
  border-color: transparent;
}

.nav.nav-link-tabs .nav-item .nav-link.active {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  font-weight: 500;
}

.nav-link {
  display: block;
  appearance: none;
  border-width: 1px;
  border-color: transparent;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

.dark .nav-link {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.nav-link.active {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
}

.dark .nav-link.active {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.tab-content {
  position: relative;
}

.tab-content .tab-pane {
  top: -9999px;
  left: -9999px;
  transition: visibility 0s linear 0.6s, opacity 0.6s 0s;
  visibility: hidden;
  position: absolute;
  opacity: 0;
}

.tab-content .tab-pane.active {
  transition: visibility 0s linear 0s, opacity 0.6s 0s;
  visibility: visible;
  position: static;
  opacity: 1;
}

.typing-dots span {
  opacity: 0;
}

.typing-dots span:nth-child(1) {
  animation: 1s type-animation infinite 0.33333s;
}

.typing-dots span:nth-child(2) {
  animation: 1s type-animation infinite 0.66666s;
}

.typing-dots span:nth-child(3) {
  animation: 1s type-animation infinite 0.99999s;
}

@keyframes type-animation {
  50% {
    opacity: 1;
  }
}

.zoom-in {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  cursor: pointer;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.zoom-in:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.box {
  box-shadow: 0px 3px 20px #0000000b;
  position: relative;
  border-radius: 0.375rem;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.dark .box {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.visible {
  visibility: visible;
}

.static {
  position: static;
}

.fixed {
  position: fixed;
}

.absolute {
  position: absolute;
}

.relative {
  position: relative;
}

.sticky {
  position: sticky;
}

.inset-y-0 {
  top: 0px;
  bottom: 0px;
}

.right-0 {
  right: 0px;
}

.bottom-0 {
  bottom: 0px;
}

.left-0 {
  left: 0px;
}

.top-0 {
  top: 0px;
}

.z-10 {
  z-index: 10;
}

.z-30 {
  z-index: 30;
}

.z-40 {
  z-index: 40;
}

.z-50 {
  z-index: 50;
}

.z-\\[51\\] {
  z-index: 51;
}

.col-span-12 {
  grid-column: span 12 / span 12;
}

.col-span-6 {
  grid-column: span 6 / span 6;
}

.col-span-2 {
  grid-column: span 2 / span 2;
}

.col-span-3 {
  grid-column: span 3 / span 3;
}

.col-span-4 {
  grid-column: span 4 / span 4;
}

.row-start-2 {
  grid-row-start: 2;
}

.row-start-4 {
  grid-row-start: 4;
}

.float-right {
  float: right;
}

.float-left {
  float: left;
}

.clear-both {
  clear: both;
}

.mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.my-auto {
  margin-top: auto;
  margin-bottom: auto;
}

.-mx-3 {
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}

.mx-3 {
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.-mx-5 {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}

.mx-4 {
  margin-left: 1rem;
  margin-right: 1rem;
}

.my-4 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.-my-3 {
  margin-top: -0.75rem;
  margin-bottom: -0.75rem;
}

.my-5 {
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

.my-10 {
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.mx-6 {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.mx-2 {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.my-6 {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.mt-1 {
  margin-top: 0.25rem;
}

.-ml-5 {
  margin-left: -1.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-3 {
  margin-right: 0.75rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.mt-2 {
  margin-top: 0.5rem;
}

.mt-8 {
  margin-top: 2rem;
}

.mr-auto {
  margin-right: auto;
}

.mt-5 {
  margin-top: 1.25rem;
}

.mt-3 {
  margin-top: 0.75rem;
}

.ml-0 {
  margin-left: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.ml-3 {
  margin-left: 0.75rem;
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.ml-auto {
  margin-left: auto;
}

.mt-4 {
  margin-top: 1rem;
}

.mt-0\\.5 {
  margin-top: 0.125rem;
}

.mt-0 {
  margin-top: 0px;
}

.-ml-4 {
  margin-left: -1rem;
}

.ml-2 {
  margin-left: 0.5rem;
}

.mt-6 {
  margin-top: 1.5rem;
}

.-mt-12 {
  margin-top: -3rem;
}

.mb-5 {
  margin-bottom: 1.25rem;
}

.ml-6 {
  margin-left: 1.5rem;
}

.ml-4 {
  margin-left: 1rem;
}

.mr-4 {
  margin-right: 1rem;
}

.-mt-1 {
  margin-top: -0.25rem;
}

.-mr-1 {
  margin-right: -0.25rem;
}

.ml-5 {
  margin-left: 1.25rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.mr-5 {
  margin-right: 1.25rem;
}

.mb-10 {
  margin-bottom: 2.5rem;
}

.ml-1 {
  margin-left: 0.25rem;
}

.mt-10 {
  margin-top: 2.5rem;
}

.-mt-2 {
  margin-top: -0.5rem;
}

.ml-0\\.5 {
  margin-left: 0.125rem;
}

.mt-12 {
  margin-top: 3rem;
}

.-mb-6 {
  margin-bottom: -1.5rem;
}

.mb-3 {
  margin-bottom: 0.75rem;
}

.-ml-1 {
  margin-left: -0.25rem;
}

.-mb-10 {
  margin-bottom: -2.5rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.-ml-0\\.5 {
  margin-left: -0.125rem;
}

.-ml-0 {
  margin-left: -0px;
}

.mr-0\\.5 {
  margin-right: 0.125rem;
}

.mt-1\\.5 {
  margin-top: 0.375rem;
}

.-mr-2 {
  margin-right: -0.5rem;
}

.-mb-1\\.5 {
  margin-bottom: -0.375rem;
}

.-ml-2\\.5 {
  margin-left: -0.625rem;
}

.-mb-1 {
  margin-bottom: -0.25rem;
}

.-ml-2 {
  margin-left: -0.5rem;
}

.-mt-3 {
  margin-top: -0.75rem;
}

.-mr-12 {
  margin-right: -3rem;
}

.mt-14 {
  margin-top: 3.5rem;
}

.ml-1\\.5 {
  margin-left: 0.375rem;
}

.-mt-4 {
  margin-top: -1rem;
}

.ml-3\\.5 {
  margin-left: 0.875rem;
}

.-mb-7 {
  margin-bottom: -1.75rem;
}

.-mt-8 {
  margin-top: -2rem;
}

.mt-3\\.5 {
  margin-top: 0.875rem;
}

.-mt-1\\.5 {
  margin-top: -0.375rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.-mt-10 {
  margin-top: -2.5rem;
}

.mr-6 {
  margin-right: 1.5rem;
}

.mt-20 {
  margin-top: 5rem;
}

.mt-16 {
  margin-top: 4rem;
}

.-mt-16 {
  margin-top: -4rem;
}

.mt-2\\.5 {
  margin-top: 0.625rem;
}

.ml-8 {
  margin-left: 2rem;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.-mr-5 {
  margin-right: -1.25rem;
}

.mr-10 {
  margin-right: 2.5rem;
}

.mr-52 {
  margin-right: 13rem;
}

.block {
  display: block;
}

.inline-block {
  display: inline-block;
}

.inline {
  display: inline;
}

.flex {
  display: flex;
}

.inline-flex {
  display: inline-flex;
}

.table {
  display: table;
}

.grid {
  display: grid;
}

.hidden {
  display: none;
}

.h-0 {
  height: 0px;
}

.h-10 {
  height: 2.5rem;
}

.h-4 {
  height: 1rem;
}

.h-6 {
  height: 1.5rem;
}

.h-5 {
  height: 1.25rem;
}

.h-40 {
  height: 10rem;
}

.h-8 {
  height: 2rem;
}

.h-3 {
  height: 0.75rem;
}

.h-\\[320px\\] {
  height: 320px;
}

.h-12 {
  height: 3rem;
}

.h-2 {
  height: 0.5rem;
}

.h-px {
  height: 1px;
}

.h-\\[400px\\] {
  height: 400px;
}

.h-20 {
  height: 5rem;
}

.h-full {
  height: 100%;
}

.h-16 {
  height: 4rem;
}

.h-32 {
  height: 8rem;
}

.h-\\[275px\\] {
  height: 275px;
}

.h-\\[213px\\] {
  height: 213px;
}

.h-\\[90px\\] {
  height: 90px;
}

.h-\\[58px\\] {
  height: 58px;
}

.h-\\[79px\\] {
  height: 79px;
}

.h-\\[208px\\] {
  height: 208px;
}

.h-\\[290px\\] {
  height: 290px;
}

.h-\\[215px\\] {
  height: 215px;
}

.h-\\[110px\\] {
  height: 110px;
}

.h-\\[196px\\] {
  height: 196px;
}

.h-screen {
  height: 100dvh;
}

.h-48 {
  height: 12rem;
}

.h-64 {
  height: 16rem;
}

.h-56 {
  height: 14rem;
}

.h-24 {
  height: 6rem;
}

.h-\\[55px\\] {
  height: 55px;
}

.h-\\[30px\\] {
  height: 30px;
}

.h-1 {
  height: 0.25rem;
}

.h-\\[51px\\] {
  height: 51px;
}

.h-\\[420px\\] {
  height: 420px;
}

.h-\\[212px\\] {
  height: 212px;
}

.h-\\[70px\\] {
  height: 70px;
}

.h-\\[45px\\] {
  height: 45px;
}

.max-h-full {
  max-height: 100%;
}

.min-h-screen {
  min-height: 100dvh;
}

.w-0 {
  width: 0px;
}

.w-10 {
  width: 2.5rem;
}

.w-4 {
  width: 1rem;
}

.w-full {
  width: 100%;
}

.w-6 {
  width: 1.5rem;
}

.w-5 {
  width: 1.25rem;
}

.w-40 {
  width: 10rem;
}

.w-8 {
  width: 2rem;
}

.w-3 {
  width: 0.75rem;
}

.w-20 {
  width: 5rem;
}

.w-12 {
  width: 3rem;
}

.w-24 {
  width: 6rem;
}

.w-32 {
  width: 8rem;
}

.w-2 {
  width: 0.5rem;
}

.w-56 {
  width: 14rem;
}

.w-16 {
  width: 4rem !important;
}

.w-px {
  width: 1px;
}

.w-52 {
  width: 13rem;
}

.w-2\\/4 {
  width: 50%;
}

.w-\\[90px\\] {
  width: 90px;
}

.w-4\\/5 {
  width: 80%;
}

.w-2\\/5 {
  width: 40%;
}

.w-48 {
  width: 12rem;
}

.w-1\\/2 {
  width: 50%;
}

.w-44 {
  width: 11rem;
}

.w-auto {
  width: auto;
}

.w-3\\/4 {
  width: 75%;
}

.w-10\\/12 {
  width: 83.333333%;
}

.w-60 {
  width: 15rem;
}

.w-3\\/5 {
  width: 60%;
}

.w-72 {
  width: 18rem;
}

.w-64 {
  width: 16rem;
}

.w-1\\/4 {
  width: 25%;
}

.w-5\\/6 {
  width: 83.333333%;
}

.w-2\\/3 {
  width: 66.666667%;
}

.max-w-\\[50\\%\\] {
  max-width: 50%;
}

.flex-none {
  flex: none;
}

.flex-1 {
  flex: 1 1;
}

.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-rotate-90 {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.scale-110 {
  --tw-scale-x: 1.1;
  --tw-scale-y: 1.1;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.cursor-pointer {
  cursor: pointer;
}

.select-none {
  -webkit-user-select: none;
  user-select: none;
}

.resize-none {
  resize: none;
}

.resize {
  resize: both;
}

.grid-cols-12 {
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.grid-cols-7 {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.grid-cols-8 {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.flex-col {
  flex-direction: column;
}

.flex-col-reverse {
  flex-direction: column-reverse;
}

.flex-wrap {
  flex-wrap: wrap;
}

.items-start {
  align-items: flex-start;
}

.items-end {
  align-items: flex-end;
}

.items-center {
  align-items: center;
}

.justify-start {
  justify-content: flex-start;
}

.justify-end {
  justify-content: flex-end;
}

.justify-center {
  justify-content: center;
}

.gap-6 {
  gap: 1.5rem;
}

.gap-5 {
  gap: 1.25rem;
}

.gap-4 {
  gap: 1rem;
}

.gap-2 {
  gap: 0.5rem;
}

.gap-1 {
  gap: 0.25rem;
}

.gap-3 {
  gap: 0.75rem;
}

.gap-x-6 {
  column-gap: 1.5rem;
}

.gap-y-6 {
  row-gap: 1.5rem;
}

.gap-y-8 {
  row-gap: 2rem;
}

.gap-x-10 {
  column-gap: 2.5rem;
}

.gap-y-3 {
  row-gap: 0.75rem;
}

.gap-y-2 {
  row-gap: 0.5rem;
}

.gap-x-5 {
  column-gap: 1.25rem;
}

.gap-y-5 {
  row-gap: 1.25rem;
}

.overflow-auto {
  overflow: auto;
}

.overflow-hidden {
  overflow: hidden;
}

.overflow-x-auto {
  overflow-x: auto;
}

.overflow-y-auto {
  overflow-y: auto;
}

.overflow-y-hidden {
  overflow-y: hidden;
}

.overflow-y-scroll {
  overflow-y: scroll;
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.whitespace-nowrap {
  white-space: nowrap;
}

.rounded-full {
  border-radius: 9999px;
}

.rounded-md {
  border-radius: 0.375rem;
}

.rounded {
  border-radius: 0.25rem;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-t-md {
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
}

.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.rounded-l-md {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.rounded-l {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.border {
  border-width: 1px;
}

.border-2 {
  border-width: 2px;
}

.border-0 {
  border-width: 0px;
}

.border-4 {
  border-width: 4px;
}

.border-b {
  border-bottom-width: 1px;
}

.border-t {
  border-top-width: 1px;
}

.border-r {
  border-right-width: 1px;
}

.border-l {
  border-left-width: 1px;
}

.border-b-2 {
  border-bottom-width: 2px;
}

.border-l-2 {
  border-left-width: 2px;
}

.border-dashed {
  border-style: dashed;
}

.border-dotted {
  border-style: dotted;
}

.border-slate-200\\/60 {
  border-color: rgb(var(--color-slate-200) / 0.6);
}

.border-slate-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-300) / var(--tw-border-opacity));
}

.border-white {
  --tw-border-opacity: 1;
  border-color: rgb(255 255 255 / var(--tw-border-opacity));
}

.border-transparent {
  border-color: transparent;
}

.border-slate-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.border-slate-400 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-400) / var(--tw-border-opacity));
}

.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}

.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.border-slate-500 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-500) / var(--tw-border-opacity));
}

.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}

.border-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.border-white\\/\\[0\\.08\\] {
  border-color: rgb(255 255 255 / 0.08);
}

.border-opacity-10 {
  --tw-border-opacity: 0.1;
}

.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.bg-slate-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-500) / var(--tw-bg-opacity));
}

.bg-primary\\/10 {
  background-color: rgb(var(--color-primary) / 0.1);
}

.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.bg-slate-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.bg-white\\/20 {
  background-color: rgb(255 255 255 / 0.2);
}

.bg-pending {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));
}

.bg-warning {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));
}

.bg-success\\/20 {
  background-color: rgb(var(--color-success) / 0.2);
}

.bg-pending\\/20 {
  background-color: rgb(var(--color-pending) / 0.2);
}

.bg-danger {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
}

.bg-success {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));
}

.bg-slate-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
}

.bg-transparent {
  background-color: transparent;
}

.bg-slate-300\\/50 {
  background-color: rgb(var(--color-slate-300) / 0.5);
}

.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}

.bg-pending\\/10 {
  background-color: rgb(var(--color-pending) / 0.1);
}

.bg-slate-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));
}

.bg-yellow-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 240 138 / var(--tw-bg-opacity));
}

.bg-cyan-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(22 78 99 / var(--tw-bg-opacity));
}

.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}

.bg-blue-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 58 138 / var(--tw-bg-opacity));
}

.bg-emerald-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(6 78 59 / var(--tw-bg-opacity));
}

.bg-indigo-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(49 46 129 / var(--tw-bg-opacity));
}

.bg-primary\\/80 {
  background-color: rgb(var(--color-primary) / 0.8);
}

.bg-opacity-20 {
  --tw-bg-opacity: 0.2;
}

.fill-current {
  fill: currentColor;
}

.p-0 {
  padding: 0px;
}

.p-5 {
  padding: 1.25rem;
}

.p-4 {
  padding: 1rem;
}

.p-3 {
  padding: 0.75rem;
}

.p-1 {
  padding: 0.25rem;
}

.p-2 {
  padding: 0.5rem;
}

.p-8 {
  padding: 2rem;
}

.p-10 {
  padding: 2.5rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.px-1 {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.px-10 {
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}

.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.pt-3 {
  padding-top: 0.75rem;
}

.pb-5 {
  padding-bottom: 1.25rem;
}

.pr-10 {
  padding-right: 2.5rem;
}

.pt-6 {
  padding-top: 1.5rem;
}

.pb-6 {
  padding-bottom: 1.5rem;
}

.pt-16 {
  padding-top: 4rem;
}

.pt-5 {
  padding-top: 1.25rem;
}

.pl-16 {
  padding-left: 4rem;
}

.pb-10 {
  padding-bottom: 2.5rem;
}

.pr-1 {
  padding-right: 0.25rem;
}

.pt-1 {
  padding-top: 0.25rem;
}

.pt-4 {
  padding-top: 1rem;
}

.pb-8 {
  padding-bottom: 2rem;
}

.pl-10 {
  padding-left: 2.5rem;
}

.pl-4 {
  padding-left: 1rem;
}

.pb-2 {
  padding-bottom: 0.5rem;
}

.pt-0\\.5 {
  padding-top: 0.125rem;
}

.pt-0 {
  padding-top: 0px;
}

.pl-3 {
  padding-left: 0.75rem;
}

.pl-3\\.5 {
  padding-left: 0.875rem;
}

.pt-8 {
  padding-top: 2rem;
}

.pb-14 {
  padding-bottom: 3.5rem;
}

.pb-3 {
  padding-bottom: 0.75rem;
}

.pl-12 {
  padding-left: 3rem;
}

.pl-5 {
  padding-left: 1.25rem;
}

.pb-4 {
  padding-bottom: 1rem;
}

.pt-2 {
  padding-top: 0.5rem;
}

.pt-10 {
  padding-top: 2.5rem;
}

.pl-1 {
  padding-left: 0.25rem;
}

.pr-5 {
  padding-right: 1.25rem;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-justify {
  text-align: justify;
}

.align-top {
  vertical-align: top;
}

.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}

.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}

.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}

.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}

.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}

.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}

.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.text-8xl {
  font-size: 6rem;
  line-height: 1;
}

.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}

.text-5xl {
  font-size: 3rem;
  line-height: 1;
}

.font-medium {
  font-weight: 500;
}

.font-normal {
  font-weight: 400;
}

.font-semibold {
  font-weight: 600;
}

.font-bold {
  font-weight: 700;
}

.font-extrabold {
  font-weight: 800;
}

.uppercase {
  text-transform: uppercase;
}

.lowercase {
  text-transform: lowercase;
}

.capitalize {
  text-transform: capitalize;
}

.normal-case {
  text-transform: none;
}

.leading-relaxed {
  line-height: 1.625;
}

.leading-8 {
  line-height: 2rem;
}

.leading-\\[2\\.15rem\\] {
  line-height: 2.15rem;
}

.leading-3 {
  line-height: .75rem;
}

.leading-6 {
  line-height: 1.5rem;
}

.leading-5 {
  line-height: 1.25rem;
}

.leading-tight {
  line-height: 1.25;
}

.leading-none {
  line-height: 1;
}

.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}

.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.text-success {
  --tw-text-opacity: 1;
  color: rgb(var(--color-success) / var(--tw-text-opacity));
}

.text-danger {
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger) / var(--tw-text-opacity));
}

.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
}

.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}

.text-slate-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.text-primary {
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.text-pending {
  --tw-text-opacity: 1;
  color: rgb(var(--color-pending) / var(--tw-text-opacity));
}

.text-warning {
  --tw-text-opacity: 1;
  color: rgb(var(--color-warning) / var(--tw-text-opacity));
}

.text-white\\/70 {
  color: rgb(255 255 255 / 0.7);
}

.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}

.text-primary\\/80 {
  color: rgb(var(--color-primary) / 0.8);
}

.text-white\\/60 {
  color: rgb(255 255 255 / 0.6);
}

.text-opacity-80 {
  --tw-text-opacity: 0.8;
}

.text-opacity-70 {
  --tw-text-opacity: 0.7;
}

.underline {
  text-decoration-line: underline;
}

.decoration-dotted {
  text-decoration-style: dotted;
}

.underline-offset-4 {
  text-underline-offset: 4px;
}

.opacity-0 {
  opacity: 0;
}

.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-none {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}

.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.duration-300 {
  transition-duration: 300ms;
}

.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

/*
   |--------------------------------------------------------------------------
   | Colors
   |--------------------------------------------------------------------------
   |
   | Import all fonts used in the template, the font configuration can be
   | seen in "tailwind.config.js".
   |
   | Please check this link for more details:
   | https://tailwindcss.com/docs/theme
   |
   */
/* Default colors */
:root {
  --color-primary: 0 0 0;
  /*22 78 99*/
  --color-secondary: 67 66 66;
  --color-success: 13 148 136;
  --color-info: 6 182 212;
  --color-warning: 245 158 11;
  --color-pending: 217 119 6;
  --color-danger: 185 28 28;
  --color-light: 241 245 249;
  --color-dark: 30 41 59;
  --color-slate-50: 248 250 252;
  --color-slate-100: 241 245 249;
  --color-slate-200: 226 232 240;
  --color-slate-300: 203 213 225;
  --color-slate-400: 148 163 184;
  --color-slate-500: 100 116 139;
  --color-slate-600: 71 85 105;
  --color-slate-700: 51 65 85;
  --color-slate-800: 30 41 59;
  --color-slate-900: 15 23 42;
}

/* Default dark-mode colors */
.dark {
  --color-primary: 21 94 117;
  --color-slate-500: 148 163 184;
  --color-darkmode-50: 87 103 132;
  --color-darkmode-100: 74 90 121;
  --color-darkmode-200: 65 81 114;
  --color-darkmode-300: 53 69 103;
  --color-darkmode-400: 48 61 93;
  --color-darkmode-500: 41 53 82;
  --color-darkmode-600: 40 51 78;
  --color-darkmode-700: 35 45 69;
  --color-darkmode-800: 27 37 59;
  --color-darkmode-900: 15 23 42;
}

/* Theme 1 colors */
.theme-1 {
  --color-primary: 30 64 175;
  --color-secondary: 226 232 240;
  --color-success: 132 204 22;
  --color-info: 6 182 212;
  --color-warning: 250 204 21;
  --color-pending: 249 115 22;
  --color-danger: 220 38 38;
  --color-light: 241 245 249;
  --color-dark: 30 41 59;
}

.theme-1.dark {
  --color-primary: 29 78 216;
}

/* Theme 2 colors */
.theme-2 {
  --color-primary: 30 58 138;
  --color-secondary: 226 232 240;
  --color-success: 13 148 136;
  --color-info: 6 182 212;
  --color-warning: 245 158 11;
  --color-pending: 249 115 22;
  --color-danger: 185 28 28;
  --color-light: 241 245 249;
  --color-dark: 30 41 59;
}

.theme-2.dark {
  --color-primary: 30 64 175;
}

/* Theme 3 colors */
.theme-3 {
  --color-primary: 6 78 59;
  --color-secondary: 226 232 240;
  --color-success: 5 150 105;
  --color-info: 6 182 212;
  --color-warning: 250 204 21;
  --color-pending: 245 158 11;
  --color-danger: 225 29 72;
  --color-light: 241 245 249;
  --color-dark: 30 41 59;
}

.theme-3.dark {
  --color-primary: 6 95 70;
}

/* Theme 4 colors */
.theme-4 {
  --color-primary: 49 46 129;
  --color-secondary: 226 232 240;
  --color-success: 5 150 105;
  --color-info: 6 182 212;
  --color-warning: 234 179 8;
  --color-pending: 234 88 12;
  --color-danger: 185 28 28;
  --color-light: 241 245 249;
  --color-dark: 30 41 59;
}

.theme-4.dark {
  --color-primary: 67 56 202;
}

/*
   |--------------------------------------------------------------------------
   | Fonts
   |--------------------------------------------------------------------------
   |
   | Import all fonts used in the template, the font configuration can be
   | seen in "tailwind.config.js".
   |
   | Please check this link for more details:
   | https://tailwindcss.com/docs/theme
   |
   */
/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin Italic"), local("Roboto-ThinItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEz0dL-vwnYh2eg.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin Italic"), local("Roboto-ThinItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzQdL-vwnYh2eg.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin Italic"), local("Roboto-ThinItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzwdL-vwnYh2eg.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin Italic"), local("Roboto-ThinItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzMdL-vwnYh2eg.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin Italic"), local("Roboto-ThinItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEz8dL-vwnYh2eg.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin Italic"), local("Roboto-ThinItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEz4dL-vwnYh2eg.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin Italic"), local("Roboto-ThinItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzAdL-vwnYg.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc3CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc-CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc2CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc5CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc1CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc0CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light Italic"), local("Roboto-LightItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc6CsTYl4BO.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto Italic"), local("Roboto-Italic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xFIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto Italic"), local("Roboto-Italic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xMIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto Italic"), local("Roboto-Italic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xEIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto Italic"), local("Roboto-Italic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xLIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto Italic"), local("Roboto-Italic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xHIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto Italic"), local("Roboto-Italic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xGIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto Italic"), local("Roboto-Italic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xIIzIXKMny.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc3CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc-CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc2CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc5CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc1CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc0CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium Italic"), local("Roboto-MediumItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc6CsTYl4BO.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold Italic"), local("Roboto-BoldItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic3CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold Italic"), local("Roboto-BoldItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic-CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold Italic"), local("Roboto-BoldItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic2CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold Italic"), local("Roboto-BoldItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic5CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold Italic"), local("Roboto-BoldItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic1CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold Italic"), local("Roboto-BoldItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic0CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold Italic"), local("Roboto-BoldItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic6CsTYl4BO.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black Italic"), local("Roboto-BlackItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc3CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black Italic"), local("Roboto-BlackItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc-CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black Italic"), local("Roboto-BlackItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc2CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black Italic"), local("Roboto-BlackItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc5CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black Italic"), local("Roboto-BlackItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc1CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black Italic"), local("Roboto-BlackItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc0CsTYl4BOQ3o.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: italic;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black Italic"), local("Roboto-BlackItalic"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc6CsTYl4BO.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin"), local("Roboto-Thin"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxFIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin"), local("Roboto-Thin"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxMIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin"), local("Roboto-Thin"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxEIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin"), local("Roboto-Thin"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxLIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin"), local("Roboto-Thin"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxHIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin"), local("Roboto-Thin"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxGIzIXKMnyrYk.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 100;
  font-display: swap;
  src: local("Roboto Thin"), local("Roboto-Thin"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxIIzIXKMny.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light"), local("Roboto-Light"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fCRc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light"), local("Roboto-Light"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fABc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light"), local("Roboto-Light"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fCBc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light"), local("Roboto-Light"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fBxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light"), local("Roboto-Light"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fCxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light"), local("Roboto-Light"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fChc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-display: swap;
  src: local("Roboto Light"), local("Roboto-Light"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fBBc4AMP6lQ.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"), local("Roboto-Regular"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu72xKKTU1Kvnz.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"), local("Roboto-Regular"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu5mxKKTU1Kvnz.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"), local("Roboto-Regular"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu7mxKKTU1Kvnz.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"), local("Roboto-Regular"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4WxKKTU1Kvnz.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"), local("Roboto-Regular"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu7WxKKTU1Kvnz.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"), local("Roboto-Regular"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu7GxKKTU1Kvnz.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  src: local("Roboto"), local("Roboto-Regular"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fCRc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fABc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fCBc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fBxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fCxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fChc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-display: swap;
  src: local("Roboto Medium"), local("Roboto-Medium"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fBBc4AMP6lQ.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfCRc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfABc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfCBc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfCxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfChc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-display: swap;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc4AMP6lQ.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/* cyrillic-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black"), local("Roboto-Black"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfCRc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,
    U+FE2E-FE2F;
}

/* cyrillic */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black"), local("Roboto-Black"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfABc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;
}

/* greek-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black"), local("Roboto-Black"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfCBc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+1F00-1FFF;
}

/* greek */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black"), local("Roboto-Black"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfBxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0370-03FF;
}

/* vietnamese */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black"), local("Roboto-Black"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfCxc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;
}

/* latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black"), local("Roboto-Black"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfChc4AMP6lbBP.woff2) format("woff2");
  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,
    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;
}

/* latin */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 900;
  font-display: swap;
  src: local("Roboto Black"), local("Roboto-Black"),
    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfBBc4AMP6lQ.woff2) format("woff2");
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,
    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,
    U+FEFF, U+FFFD;
}

/*
   |--------------------------------------------------------------------------
   | Mixins
   |--------------------------------------------------------------------------
   |
   | Import helper mixins.
   |
   */
/* Breakpoint up */
/* Breakpoint down */
/* Breakpoint only */
/*
   |--------------------------------------------------------------------------
   | 3rd Party Libraries
   |--------------------------------------------------------------------------
   |
   | Import 3rd party library CSS/SASS files.
   |
   */
.breadcrumb {
  display: flex;
  align-items: center;
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .breadcrumb {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.breadcrumb.breadcrumb-light {
  color: rgb(255 255 255 / var(--tw-text-opacity));
  --tw-text-opacity: 0.9;
}

.breadcrumb.breadcrumb-light .breadcrumb-item:not(:first-child):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.breadcrumb.breadcrumb-light .breadcrumb-item.active {
  color: rgb(255 255 255 / var(--tw-text-opacity));
  --tw-text-opacity: 0.8;
}

.breadcrumb .breadcrumb-item:not(:first-child) {
  position: relative;
  margin-left: 1.25rem;
  padding-left: 0.125rem;
}

.breadcrumb .breadcrumb-item:not(:first-child):before {
  content: "";
  width: 14px;
  height: 14px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: 100%;
  margin-left: -1.125rem;
  position: absolute;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
}

.breadcrumb .breadcrumb-item.active {
  cursor: text;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
}

.dark .breadcrumb .breadcrumb-item.active {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.dark .breadcrumb .breadcrumb-item:not(:first-child):before {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

@media (max-width: calc(640px - 1px)) {
  .form-inline {
    display: block;
  }

  .form-inline .form-label {
    margin-bottom: 0.5rem;
    margin-right: 0px;
    text-align: left;
  }
}

*>.intro-x:nth-child(1) {
  z-index: calc(50 - 1);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

*>.-intro-x:nth-child(1) {
  z-index: calc(50 - 1);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

*>.intro-y:nth-child(1) {
  /* z-index: calc(50 - 1); */
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

*>.-intro-y:nth-child(1) {
  z-index: calc(50 - 1);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

*>.intro-x:nth-child(2) {
  z-index: calc(50 - 2);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

*>.-intro-x:nth-child(2) {
  z-index: calc(50 - 2);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

*>.intro-y:nth-child(2) {
  /* z-index: calc(50 - 2); */
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

*>.-intro-y:nth-child(2) {
  z-index: calc(50 - 2);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

*>.intro-x:nth-child(3) {
  z-index: calc(50 - 3);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

*>.-intro-x:nth-child(3) {
  z-index: calc(50 - 3);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

*>.intro-y:nth-child(3) {
  z-index: calc(50 - 3);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

*>.-intro-y:nth-child(3) {
  z-index: calc(50 - 3);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

*>.intro-x:nth-child(4) {
  z-index: calc(50 - 4);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

*>.-intro-x:nth-child(4) {
  z-index: calc(50 - 4);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

*>.intro-y:nth-child(4) {
  z-index: calc(50 - 4);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

*>.-intro-y:nth-child(4) {
  z-index: calc(50 - 4);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

*>.intro-x:nth-child(5) {
  z-index: calc(50 - 5);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

*>.-intro-x:nth-child(5) {
  z-index: calc(50 - 5);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

*>.intro-y:nth-child(5) {
  z-index: calc(50 - 5);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

*>.-intro-y:nth-child(5) {
  z-index: calc(50 - 5);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

*>.intro-x:nth-child(6) {
  z-index: calc(50 - 6);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

*>.-intro-x:nth-child(6) {
  z-index: calc(50 - 6);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

*>.intro-y:nth-child(6) {
  z-index: calc(50 - 6);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

*>.-intro-y:nth-child(6) {
  z-index: calc(50 - 6);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

*>.intro-x:nth-child(7) {
  z-index: calc(50 - 7);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

*>.-intro-x:nth-child(7) {
  z-index: calc(50 - 7);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

*>.intro-y:nth-child(7) {
  z-index: calc(50 - 7);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

*>.-intro-y:nth-child(7) {
  z-index: calc(50 - 7);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

*>.intro-x:nth-child(8) {
  z-index: calc(50 - 8);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

*>.-intro-x:nth-child(8) {
  z-index: calc(50 - 8);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

*>.intro-y:nth-child(8) {
  z-index: calc(50 - 8);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

*>.-intro-y:nth-child(8) {
  z-index: calc(50 - 8);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

*>.intro-x:nth-child(9) {
  z-index: calc(50 - 9);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

*>.-intro-x:nth-child(9) {
  z-index: calc(50 - 9);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

*>.intro-y:nth-child(9) {
  z-index: calc(50 - 9);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

*>.-intro-y:nth-child(9) {
  z-index: calc(50 - 9);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

*>.intro-x:nth-child(10) {
  z-index: calc(50 - 10);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

*>.-intro-x:nth-child(10) {
  z-index: calc(50 - 10);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

*>.intro-y:nth-child(10) {
  z-index: calc(50 - 10);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

*>.-intro-y:nth-child(10) {
  z-index: calc(50 - 10);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

*>.intro-x:nth-child(11) {
  z-index: calc(50 - 11);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

*>.-intro-x:nth-child(11) {
  z-index: calc(50 - 11);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

*>.intro-y:nth-child(11) {
  z-index: calc(50 - 11);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

*>.-intro-y:nth-child(11) {
  z-index: calc(50 - 11);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

*>.intro-x:nth-child(12) {
  z-index: calc(50 - 12);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

*>.-intro-x:nth-child(12) {
  z-index: calc(50 - 12);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

*>.intro-y:nth-child(12) {
  z-index: calc(50 - 12);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

*>.-intro-y:nth-child(12) {
  z-index: calc(50 - 12);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

*>.intro-x:nth-child(13) {
  z-index: calc(50 - 13);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

*>.-intro-x:nth-child(13) {
  z-index: calc(50 - 13);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

*>.intro-y:nth-child(13) {
  z-index: calc(50 - 13);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

*>.-intro-y:nth-child(13) {
  z-index: calc(50 - 13);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

*>.intro-x:nth-child(14) {
  z-index: calc(50 - 14);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

*>.-intro-x:nth-child(14) {
  z-index: calc(50 - 14);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

*>.intro-y:nth-child(14) {
  z-index: calc(50 - 14);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

*>.-intro-y:nth-child(14) {
  z-index: calc(50 - 14);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

*>.intro-x:nth-child(15) {
  z-index: calc(50 - 15);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

*>.-intro-x:nth-child(15) {
  z-index: calc(50 - 15);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

*>.intro-y:nth-child(15) {
  z-index: calc(50 - 15);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

*>.-intro-y:nth-child(15) {
  z-index: calc(50 - 15);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

*>.intro-x:nth-child(16) {
  z-index: calc(50 - 16);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

*>.-intro-x:nth-child(16) {
  z-index: calc(50 - 16);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

*>.intro-y:nth-child(16) {
  z-index: calc(50 - 16);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

*>.-intro-y:nth-child(16) {
  z-index: calc(50 - 16);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

*>.intro-x:nth-child(17) {
  z-index: calc(50 - 17);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

*>.-intro-x:nth-child(17) {
  z-index: calc(50 - 17);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

*>.intro-y:nth-child(17) {
  z-index: calc(50 - 17);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

*>.-intro-y:nth-child(17) {
  z-index: calc(50 - 17);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

*>.intro-x:nth-child(18) {
  z-index: calc(50 - 18);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

*>.-intro-x:nth-child(18) {
  z-index: calc(50 - 18);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

*>.intro-y:nth-child(18) {
  z-index: calc(50 - 18);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

*>.-intro-y:nth-child(18) {
  z-index: calc(50 - 18);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

*>.intro-x:nth-child(19) {
  z-index: calc(50 - 19);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

*>.-intro-x:nth-child(19) {
  z-index: calc(50 - 19);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

*>.intro-y:nth-child(19) {
  z-index: calc(50 - 19);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

*>.-intro-y:nth-child(19) {
  z-index: calc(50 - 19);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

*>.intro-x:nth-child(20) {
  z-index: calc(50 - 20);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

*>.-intro-x:nth-child(20) {
  z-index: calc(50 - 20);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

*>.intro-y:nth-child(20) {
  z-index: calc(50 - 20);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

*>.-intro-y:nth-child(20) {
  z-index: calc(50 - 20);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

*>.intro-x:nth-child(21) {
  z-index: calc(50 - 21);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

*>.-intro-x:nth-child(21) {
  z-index: calc(50 - 21);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

*>.intro-y:nth-child(21) {
  z-index: calc(50 - 21);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

*>.-intro-y:nth-child(21) {
  z-index: calc(50 - 21);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

*>.intro-x:nth-child(22) {
  z-index: calc(50 - 22);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

*>.-intro-x:nth-child(22) {
  z-index: calc(50 - 22);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

*>.intro-y:nth-child(22) {
  z-index: calc(50 - 22);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

*>.-intro-y:nth-child(22) {
  z-index: calc(50 - 22);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

*>.intro-x:nth-child(23) {
  z-index: calc(50 - 23);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

*>.-intro-x:nth-child(23) {
  z-index: calc(50 - 23);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

*>.intro-y:nth-child(23) {
  z-index: calc(50 - 23);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

*>.-intro-y:nth-child(23) {
  z-index: calc(50 - 23);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

*>.intro-x:nth-child(24) {
  z-index: calc(50 - 24);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

*>.-intro-x:nth-child(24) {
  z-index: calc(50 - 24);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

*>.intro-y:nth-child(24) {
  z-index: calc(50 - 24);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

*>.-intro-y:nth-child(24) {
  z-index: calc(50 - 24);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

*>.intro-x:nth-child(25) {
  z-index: calc(50 - 25);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

*>.-intro-x:nth-child(25) {
  z-index: calc(50 - 25);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

*>.intro-y:nth-child(25) {
  z-index: calc(50 - 25);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

*>.-intro-y:nth-child(25) {
  z-index: calc(50 - 25);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

*>.intro-x:nth-child(26) {
  z-index: calc(50 - 26);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

*>.-intro-x:nth-child(26) {
  z-index: calc(50 - 26);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

*>.intro-y:nth-child(26) {
  z-index: calc(50 - 26);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

*>.-intro-y:nth-child(26) {
  z-index: calc(50 - 26);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

*>.intro-x:nth-child(27) {
  z-index: calc(50 - 27);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

*>.-intro-x:nth-child(27) {
  z-index: calc(50 - 27);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

*>.intro-y:nth-child(27) {
  z-index: calc(50 - 27);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

*>.-intro-y:nth-child(27) {
  z-index: calc(50 - 27);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

*>.intro-x:nth-child(28) {
  z-index: calc(50 - 28);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

*>.-intro-x:nth-child(28) {
  z-index: calc(50 - 28);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

*>.intro-y:nth-child(28) {
  z-index: calc(50 - 28);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

*>.-intro-y:nth-child(28) {
  z-index: calc(50 - 28);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

*>.intro-x:nth-child(29) {
  z-index: calc(50 - 29);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

*>.-intro-x:nth-child(29) {
  z-index: calc(50 - 29);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

*>.intro-y:nth-child(29) {
  z-index: calc(50 - 29);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

*>.-intro-y:nth-child(29) {
  z-index: calc(50 - 29);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

*>.intro-x:nth-child(30) {
  z-index: calc(50 - 30);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

*>.-intro-x:nth-child(30) {
  z-index: calc(50 - 30);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

*>.intro-y:nth-child(30) {
  z-index: calc(50 - 30);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

*>.-intro-y:nth-child(30) {
  z-index: calc(50 - 30);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

*>.intro-x:nth-child(31) {
  z-index: calc(50 - 31);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

*>.-intro-x:nth-child(31) {
  z-index: calc(50 - 31);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

*>.intro-y:nth-child(31) {
  z-index: calc(50 - 31);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

*>.-intro-y:nth-child(31) {
  z-index: calc(50 - 31);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

*>.intro-x:nth-child(32) {
  z-index: calc(50 - 32);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

*>.-intro-x:nth-child(32) {
  z-index: calc(50 - 32);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

*>.intro-y:nth-child(32) {
  z-index: calc(50 - 32);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

*>.-intro-y:nth-child(32) {
  z-index: calc(50 - 32);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

*>.intro-x:nth-child(33) {
  z-index: calc(50 - 33);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

*>.-intro-x:nth-child(33) {
  z-index: calc(50 - 33);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

*>.intro-y:nth-child(33) {
  z-index: calc(50 - 33);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

*>.-intro-y:nth-child(33) {
  z-index: calc(50 - 33);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

*>.intro-x:nth-child(34) {
  z-index: calc(50 - 34);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

*>.-intro-x:nth-child(34) {
  z-index: calc(50 - 34);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

*>.intro-y:nth-child(34) {
  z-index: calc(50 - 34);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

*>.-intro-y:nth-child(34) {
  z-index: calc(50 - 34);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

*>.intro-x:nth-child(35) {
  z-index: calc(50 - 35);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

*>.-intro-x:nth-child(35) {
  z-index: calc(50 - 35);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

*>.intro-y:nth-child(35) {
  z-index: calc(50 - 35);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

*>.-intro-y:nth-child(35) {
  z-index: calc(50 - 35);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

*>.intro-x:nth-child(36) {
  z-index: calc(50 - 36);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

*>.-intro-x:nth-child(36) {
  z-index: calc(50 - 36);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

*>.intro-y:nth-child(36) {
  z-index: calc(50 - 36);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

*>.-intro-y:nth-child(36) {
  z-index: calc(50 - 36);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

*>.intro-x:nth-child(37) {
  z-index: calc(50 - 37);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

*>.-intro-x:nth-child(37) {
  z-index: calc(50 - 37);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

*>.intro-y:nth-child(37) {
  z-index: calc(50 - 37);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

*>.-intro-y:nth-child(37) {
  z-index: calc(50 - 37);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

*>.intro-x:nth-child(38) {
  z-index: calc(50 - 38);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

*>.-intro-x:nth-child(38) {
  z-index: calc(50 - 38);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

*>.intro-y:nth-child(38) {
  z-index: calc(50 - 38);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

*>.-intro-y:nth-child(38) {
  z-index: calc(50 - 38);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

*>.intro-x:nth-child(39) {
  z-index: calc(50 - 39);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

*>.-intro-x:nth-child(39) {
  z-index: calc(50 - 39);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

*>.intro-y:nth-child(39) {
  z-index: calc(50 - 39);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

*>.-intro-y:nth-child(39) {
  z-index: calc(50 - 39);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

*>.intro-x:nth-child(40) {
  z-index: calc(50 - 40);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

*>.-intro-x:nth-child(40) {
  z-index: calc(50 - 40);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

*>.intro-y:nth-child(40) {
  z-index: calc(50 - 40);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

*>.-intro-y:nth-child(40) {
  z-index: calc(50 - 40);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

*>.intro-x:nth-child(41) {
  z-index: calc(50 - 41);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

*>.-intro-x:nth-child(41) {
  z-index: calc(50 - 41);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

*>.intro-y:nth-child(41) {
  z-index: calc(50 - 41);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

*>.-intro-y:nth-child(41) {
  z-index: calc(50 - 41);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

*>.intro-x:nth-child(42) {
  z-index: calc(50 - 42);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

*>.-intro-x:nth-child(42) {
  z-index: calc(50 - 42);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

*>.intro-y:nth-child(42) {
  z-index: calc(50 - 42);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

*>.-intro-y:nth-child(42) {
  z-index: calc(50 - 42);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

*>.intro-x:nth-child(43) {
  z-index: calc(50 - 43);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

*>.-intro-x:nth-child(43) {
  z-index: calc(50 - 43);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

*>.intro-y:nth-child(43) {
  z-index: calc(50 - 43);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

*>.-intro-y:nth-child(43) {
  z-index: calc(50 - 43);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

*>.intro-x:nth-child(44) {
  z-index: calc(50 - 44);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

*>.-intro-x:nth-child(44) {
  z-index: calc(50 - 44);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

*>.intro-y:nth-child(44) {
  z-index: calc(50 - 44);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

*>.-intro-y:nth-child(44) {
  z-index: calc(50 - 44);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

*>.intro-x:nth-child(45) {
  z-index: calc(50 - 45);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

*>.-intro-x:nth-child(45) {
  z-index: calc(50 - 45);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

*>.intro-y:nth-child(45) {
  z-index: calc(50 - 45);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

*>.-intro-y:nth-child(45) {
  z-index: calc(50 - 45);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

*>.intro-x:nth-child(46) {
  z-index: calc(50 - 46);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

*>.-intro-x:nth-child(46) {
  z-index: calc(50 - 46);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

*>.intro-y:nth-child(46) {
  z-index: calc(50 - 46);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

*>.-intro-y:nth-child(46) {
  z-index: calc(50 - 46);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

*>.intro-x:nth-child(47) {
  z-index: calc(50 - 47);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

*>.-intro-x:nth-child(47) {
  z-index: calc(50 - 47);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

*>.intro-y:nth-child(47) {
  z-index: calc(50 - 47);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

*>.-intro-y:nth-child(47) {
  z-index: calc(50 - 47);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

*>.intro-x:nth-child(48) {
  z-index: calc(50 - 48);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

*>.-intro-x:nth-child(48) {
  z-index: calc(50 - 48);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

*>.intro-y:nth-child(48) {
  z-index: calc(50 - 48);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

*>.-intro-y:nth-child(48) {
  z-index: calc(50 - 48);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

*>.intro-x:nth-child(49) {
  z-index: calc(50 - 49);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

*>.-intro-x:nth-child(49) {
  z-index: calc(50 - 49);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

*>.intro-y:nth-child(49) {
  z-index: calc(50 - 49);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

*>.-intro-y:nth-child(49) {
  z-index: calc(50 - 49);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

*>.intro-x:nth-child(50) {
  z-index: calc(50 - 50);
  opacity: 0;
  position: relative;
  transform: translateX(50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

*>.-intro-x:nth-child(50) {
  z-index: calc(50 - 50);
  opacity: 0;
  position: relative;
  transform: translateX(-50px);
  animation: 0.4s intro-x-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

*>.intro-y:nth-child(50) {
  z-index: calc(50 - 50);
  opacity: 0;
  position: relative;
  transform: translateY(50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

*>.-intro-y:nth-child(50) {
  z-index: calc(50 - 50);
  opacity: 0;
  position: relative;
  transform: translateY(-50px);
  animation: 0.4s intro-y-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

@keyframes intro-x-animation {
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes intro-y-animation {
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

@media (max-width: calc(640px - 1px)) {
  .modal.modal-slide-over.show>.modal-dialog .modal-content>[data-tw-dismiss="modal"] {
    margin-left: -2.5rem;
  }

  .pagination {
    margin-right: 0px;
    width: 100%;
  }

  .pagination .page-item {
    flex: 1 1;
  }

  .pagination .page-item:nth-child(1) .page-link,
  .pagination .page-item:nth-child(2) .page-link,
  .pagination .page-item:nth-child(3) .page-link,
  .pagination .page-item:nth-child(7) .page-link,
  .pagination .page-item:nth-child(8) .page-link,
  .pagination .page-item:nth-child(9) .page-link {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .pagination .page-item .page-link {
    margin-right: 0px;
    min-width: 0px;
  }
}

.table {
  width: 100%;
  text-align: left;
}

.table thead.table-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .table thead.table-dark {
  background-color: rgb(0 0 0 / 0.3);
}

.table thead.table-dark tr th {
  border-bottom-width: 0px;
}

.table thead.table-light {
  background-color: rgb(var(--color-slate-200) / 0.6);
}

.dark .table thead.table-light {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
}

.table thead.table-light tr th {
  border-bottom-width: 0px;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

.table th {
  border-bottom-width: 2px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  font-weight: 500;
}

.dark .table th {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));
}

.table td {
  border-bottom-width: 1px;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.dark .table td {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));
}

.table.table-dark {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .table.table-dark {
  background-color: rgb(0 0 0 / 0.3);
}

.table.table-dark th {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-600) / var(--tw-border-opacity));
}

.dark .table.table-dark th {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));
}

.table.table-dark td {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-600) / var(--tw-border-opacity));
}

.dark .table.table-dark td {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));
}

.table.table-bordered th,
.table.table-bordered td {
  border-left-width: 1px;
  border-right-width: 1px;
  border-top-width: 1px;
}

.table.table-hover tr:hover td {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .table.table-hover tr:hover td {
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
}

.table.table-striped tr:nth-of-type(odd) td {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .table.table-striped tr:nth-of-type(odd) td {
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
}

.table.table-sm th {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.table.table-sm td {
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

/*

github.com style (c) Vasily Polovnyov <vast@whiteants.net>

*/
.hljs {
  display: block;
  overflow-x: auto;
  padding: 0.5em;
  color: #333;
  background: #f8f8f8;
}

.hljs-comment,
.hljs-quote {
  color: #998;
  font-style: italic;
}

.hljs-keyword,
.hljs-selector-tag,
.hljs-subst {
  color: #333;
  font-weight: bold;
}

.hljs-number,
.hljs-literal,
.hljs-variable,
.hljs-template-variable,
.hljs-tag .hljs-attr {
  color: #008080;
}

.hljs-string,
.hljs-doctag {
  color: #d14;
}

.hljs-title,
.hljs-section,
.hljs-selector-id {
  color: #900;
  font-weight: bold;
}

.hljs-subst {
  font-weight: normal;
}

.hljs-type,
.hljs-class .hljs-title {
  color: #458;
  font-weight: bold;
}

.hljs-tag,
.hljs-name,
.hljs-attribute {
  color: #000080;
  font-weight: normal;
}

.hljs-regexp,
.hljs-link {
  color: #009926;
}

.hljs-symbol,
.hljs-bullet {
  color: #990073;
}

.hljs-built_in,
.hljs-builtin-name {
  color: #0086b3;
}

.hljs-meta {
  color: #999;
  font-weight: bold;
}

.hljs-deletion {
  background: #fdd;
}

.hljs-addition {
  background: #dfd;
}

.hljs-emphasis {
  font-style: italic;
}

.hljs-strong {
  font-weight: bold;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}

[data-tippy-root] {
  max-width: calc(100vw - 10px)
}

.tippy-box {
  position: relative;
  background-color: #333;
  color: #fff;
  border-radius: 4px;
  font-size: 14px;
  line-height: 1.4;
  white-space: normal;
  outline: 0;
  transition-property: transform, visibility, opacity
}

.tippy-box[data-placement^=top]>.tippy-arrow {
  bottom: 0
}

.tippy-box[data-placement^=top]>.tippy-arrow:before {
  bottom: -7px;
  left: 0;
  border-width: 8px 8px 0;
  border-top-color: initial;
  transform-origin: center top
}

.tippy-box[data-placement^=bottom]>.tippy-arrow {
  top: 0
}

.tippy-box[data-placement^=bottom]>.tippy-arrow:before {
  top: -7px;
  left: 0;
  border-width: 0 8px 8px;
  border-bottom-color: initial;
  transform-origin: center bottom
}

.tippy-box[data-placement^=left]>.tippy-arrow {
  right: 0
}

.tippy-box[data-placement^=left]>.tippy-arrow:before {
  border-width: 8px 0 8px 8px;
  border-left-color: initial;
  right: -7px;
  transform-origin: center left
}

.tippy-box[data-placement^=right]>.tippy-arrow {
  left: 0
}

.tippy-box[data-placement^=right]>.tippy-arrow:before {
  left: -7px;
  border-width: 8px 8px 8px 0;
  border-right-color: initial;
  transform-origin: center right
}

.tippy-box[data-inertia][data-state=visible] {
  transition-timing-function: cubic-bezier(.54, 1.5, .38, 1.11)
}

.tippy-arrow {
  width: 16px;
  height: 16px;
  color: #333
}

.tippy-arrow:before {
  content: "";
  position: absolute;
  border-color: transparent;
  border-style: solid
}

.tippy-content {
  position: relative;
  padding: 5px 9px;
  z-index: 1
}

.tippy-box[data-theme~=light] {
  color: #26323d;
  box-shadow: 0 0 20px 4px rgba(154, 161, 177, .15), 0 4px 80px -8px rgba(36, 40, 47, .25), 0 4px 4px -2px rgba(91, 94, 105, .15);
  background-color: #fff
}

.tippy-box[data-theme~=light][data-placement^=top]>.tippy-arrow:before {
  border-top-color: #fff
}

.tippy-box[data-theme~=light][data-placement^=bottom]>.tippy-arrow:before {
  border-bottom-color: #fff
}

.tippy-box[data-theme~=light][data-placement^=left]>.tippy-arrow:before {
  border-left-color: #fff
}

.tippy-box[data-theme~=light][data-placement^=right]>.tippy-arrow:before {
  border-right-color: #fff
}

.tippy-box[data-theme~=light]>.tippy-backdrop {
  background-color: #fff
}

.tippy-box[data-theme~=light]>.tippy-svg-arrow {
  fill: #fff
}

.tippy-box[data-placement^=top]>.tippy-svg-arrow {
  bottom: 0
}

.tippy-box[data-placement^=top]>.tippy-svg-arrow:after,
.tippy-box[data-placement^=top]>.tippy-svg-arrow>svg {
  top: 16px;
  transform: rotate(180deg)
}

.tippy-box[data-placement^=bottom]>.tippy-svg-arrow {
  top: 0
}

.tippy-box[data-placement^=bottom]>.tippy-svg-arrow>svg {
  bottom: 16px
}

.tippy-box[data-placement^=left]>.tippy-svg-arrow {
  right: 0
}

.tippy-box[data-placement^=left]>.tippy-svg-arrow:after,
.tippy-box[data-placement^=left]>.tippy-svg-arrow>svg {
  transform: rotate(90deg);
  top: calc(50% - 3px);
  left: 11px
}

.tippy-box[data-placement^=right]>.tippy-svg-arrow {
  left: 0
}

.tippy-box[data-placement^=right]>.tippy-svg-arrow:after,
.tippy-box[data-placement^=right]>.tippy-svg-arrow>svg {
  transform: rotate(-90deg);
  top: calc(50% - 3px);
  right: 11px
}

.tippy-svg-arrow {
  width: 16px;
  height: 16px;
  fill: #333;
  text-align: initial
}

.tippy-svg-arrow,
.tippy-svg-arrow>svg {
  position: absolute
}

.tippy-box[data-animation=shift-away][data-state=hidden] {
  opacity: 0
}

.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=top] {
  transform: translateY(10px)
}

.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=bottom] {
  transform: translateY(-10px)
}

.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=left] {
  transform: translateX(10px)
}

.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=right] {
  transform: translateX(-10px)
}

/*!
 * Toastify js 1.11.2
 * https://github.com/apvarun/toastify-js
 * @license MIT licensed
 *
 * Copyright (C) 2018 Varun A P
 */
.toastify {
  padding: 12px 20px;
  color: #ffffff;
  display: inline-block;
  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);
  background: linear-gradient(135deg, #73a5ff, #5477f5);
  position: fixed;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  max-width: calc(50% - 20px);
  z-index: 2147483647;
}

.toastify.on {
  opacity: 1;
}

.toast-close {
  opacity: 0.4;
  padding: 0 5px;
}

.toastify-right {
  right: 15px;
}

.toastify-left {
  left: 15px;
}

.toastify-top {
  top: -150px;
}

.toastify-bottom {
  bottom: -150px;
}

.toastify-rounded {
  border-radius: 25px;
}

.toastify-avatar {
  width: 1.5em;
  height: 1.5em;
  margin: -7px 5px;
  border-radius: 2px;
}

.toastify-center {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  max-width: fit-content;
  max-width: -moz-fit-content;
}

@media only screen and (max-width: 360px) {

  .toastify-right,
  .toastify-left {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-width: fit-content;
  }
}

@keyframes passing-through {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }

  30%,
  70% {
    opacity: 1;
    transform: translateY(0px);
  }

  100% {
    opacity: 0;
    transform: translateY(-40px);
  }
}

@keyframes slide-in {
  0% {
    opacity: 0;
    transform: translateY(40px);
  }

  30% {
    opacity: 1;
    transform: translateY(0px);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
  }

  10% {
    transform: scale(1.1);
  }

  20% {
    transform: scale(1);
  }
}

.dropzone,
.dropzone * {
  box-sizing: border-box;
}

.dropzone {
  min-height: 150px;
  border: 2px solid rgba(0, 0, 0, 0.3);
  background: white;
  padding: 20px 20px;
}

.dropzone.dz-clickable {
  cursor: pointer;
}

.dropzone.dz-clickable * {
  cursor: default;
}

.dropzone.dz-clickable .dz-message,
.dropzone.dz-clickable .dz-message * {
  cursor: pointer;
}

.dropzone.dz-started .dz-message {
  display: none;
}

.dropzone.dz-drag-hover {
  border-style: solid;
}

.dropzone.dz-drag-hover .dz-message {
  opacity: 0.5;
}

.dropzone .dz-message {
  text-align: center;
  margin: 2em 0;
}

.dropzone .dz-message .dz-button {
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
}

.dropzone .dz-preview {
  position: relative;
  display: inline-block;
  vertical-align: top;
  margin: 16px;
  min-height: 100px;
}

.dropzone .dz-preview:hover {
  z-index: 1000;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-file-preview .dz-image {
  border-radius: 20px;
  background: #999;
  background: linear-gradient(to bottom, #eee, #ddd);
}

.dropzone .dz-preview.dz-file-preview .dz-details {
  opacity: 1;
}

.dropzone .dz-preview.dz-image-preview {
  background: white;
}

.dropzone .dz-preview.dz-image-preview .dz-details {
  transition: opacity 0.2s linear;
}

.dropzone .dz-preview .dz-remove {
  font-size: 14px;
  text-align: center;
  display: block;
  cursor: pointer;
  border: none;
}

.dropzone .dz-preview .dz-remove:hover {
  text-decoration: underline;
}

.dropzone .dz-preview:hover .dz-details {
  opacity: 1;
}

.dropzone .dz-preview .dz-details {
  z-index: 20;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  font-size: 13px;
  min-width: 100%;
  max-width: 100%;
  padding: 2em 1em;
  text-align: center;
  color: rgba(0, 0, 0, 0.9);
  line-height: 150%;
}

.dropzone .dz-preview .dz-details .dz-size {
  margin-bottom: 1em;
  font-size: 16px;
}

.dropzone .dz-preview .dz-details .dz-filename {
  white-space: nowrap;
}

.dropzone .dz-preview .dz-details .dz-filename:hover span {
  border: 1px solid rgba(200, 200, 200, 0.8);
  background-color: rgba(255, 255, 255, 0.8);
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {
  border: 1px solid transparent;
}

.dropzone .dz-preview .dz-details .dz-filename span,
.dropzone .dz-preview .dz-details .dz-size span {
  background-color: rgba(255, 255, 255, 0.4);
  padding: 0 0.4em;
  border-radius: 3px;
}

.dropzone .dz-preview:hover .dz-image img {
  transform: scale(1.05, 1.05);
  filter: blur(8px);
}

.dropzone .dz-preview .dz-image {
  border-radius: 20px;
  overflow: hidden;
  width: 120px;
  height: 120px;
  position: relative;
  display: block;
  z-index: 10;
}

.dropzone .dz-preview .dz-image img {
  display: block;
}

.dropzone .dz-preview.dz-success .dz-success-mark {
  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview.dz-error .dz-error-mark {
  opacity: 1;
  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);
}

.dropzone .dz-preview .dz-success-mark,
.dropzone .dz-preview .dz-error-mark {
  pointer-events: none;
  opacity: 0;
  z-index: 500;
  position: absolute;
  display: block;
  top: 50%;
  left: 50%;
  margin-left: -27px;
  margin-top: -27px;
}

.dropzone .dz-preview .dz-success-mark svg,
.dropzone .dz-preview .dz-error-mark svg {
  display: block;
  width: 54px;
  height: 54px;
}

.dropzone .dz-preview.dz-processing .dz-progress {
  opacity: 1;
  transition: all 0.2s linear;
}

.dropzone .dz-preview.dz-complete .dz-progress {
  opacity: 0;
  transition: opacity 0.4s ease-in;
}

.dropzone .dz-preview:not(.dz-processing) .dz-progress {
  animation: pulse 6s ease infinite;
}

.dropzone .dz-preview .dz-progress {
  opacity: 1;
  z-index: 1000;
  pointer-events: none;
  position: absolute;
  height: 16px;
  left: 50%;
  top: 50%;
  margin-top: -8px;
  width: 80px;
  margin-left: -40px;
  background: rgba(255, 255, 255, 0.9);
  -webkit-transform: scale(1);
  border-radius: 8px;
  overflow: hidden;
}

.dropzone .dz-preview .dz-progress .dz-upload {
  background: #333;
  background: linear-gradient(to bottom, #666, #444);
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  transition: width 300ms ease-in-out;
}

.dropzone .dz-preview.dz-error .dz-error-message {
  display: block;
}

.dropzone .dz-preview.dz-error:hover .dz-error-message {
  opacity: 1;
  pointer-events: auto;
}

.dropzone .dz-preview .dz-error-message {
  pointer-events: none;
  z-index: 1000;
  position: absolute;
  display: block;
  display: none;
  opacity: 0;
  transition: opacity 0.3s ease;
  border-radius: 8px;
  font-size: 13px;
  top: 130px;
  left: -10px;
  width: 140px;
  background: #be2626;
  background: linear-gradient(to bottom, #be2626, #a92222);
  padding: 0.5em 1.2em;
  color: white;
}

.dropzone .dz-preview .dz-error-message:after {
  content: "";
  position: absolute;
  top: -6px;
  left: 64px;
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #be2626;
}

img[data-action="zoom"] {
  cursor: zoom-in;
}

.zoom-img,
.zoom-img-wrap {
  position: relative;
  z-index: 666;
  transition: all 300ms;
}

img.zoom-img {
  cursor: zoom-out;
}

.zoom-overlay {
  cursor: zoom-out;
  z-index: 420;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  filter: "alpha(opacity=0)";
  opacity: 0;
  transition: opacity 300ms;
}

.zoom-overlay-open .zoom-overlay {
  filter: "alpha(opacity=100)";
  opacity: 1;
}

/* Tabulator v4.9.3 (c) Oliver Folkerd */
.tabulator {
  position: relative;
  border: 1px solid #999;
  background-color: #888;
  font-size: 12px;
  text-align: left;
  overflow: hidden;
  transform: translatez(0);
}

.tabulator .hover_text:hover {
  cursor: pointer;
  font-weight: bold;
}

.tabulator[tabulator-layout="fitDataFill"] .tabulator-tableHolder .tabulator-table {
  min-width: 100%;
}

.tabulator[tabulator-layout="fitDataTable"] {
  display: inline-block;
}

.tabulator.tabulator-block-select {
  -webkit-user-select: none;
  user-select: none;
}

.tabulator .tabulator-header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  border-bottom: 1px solid #999;
  background-color: #e6e6e6;
  color: #555;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

.tabulator .tabulator-header.tabulator-header-hidden {
  display: none;
}

.tabulator .tabulator-header .tabulator-col {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  border-right: 1px solid #aaa;
  background: #e6e6e6;
  text-align: left;
  vertical-align: bottom;
  overflow: hidden;
}

.tabulator .tabulator-header .tabulator-col.tabulator-moving {
  position: absolute;
  border: 1px solid #999;
  background: #cdcdcd;
  pointer-events: none;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content {
  box-sizing: border-box;
  position: relative;
  padding: 4px;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-header-menu-button {
  padding: 0 8px;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-header-menu-button:hover {
  cursor: pointer;
  opacity: .6;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title-holder {
  position: relative;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {
  box-sizing: border-box;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title .tabulator-title-editor {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #999;
  padding: 1px;
  background: #fff;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title .tabulator-header-menu-button+.tabulator-title-editor {
  width: calc(100% - 22px);
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-sorter {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 4px;
}

.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #bbb;
}

.tabulator .tabulator-header .tabulator-col.tabulator-col-group .tabulator-col-group-cols {
  position: relative;
  display: flex;
  border-top: 1px solid #aaa;
  overflow: hidden;
  margin-right: -1px;
}

.tabulator .tabulator-header .tabulator-col:first-child .tabulator-col-resize-handle.prev {
  display: none;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter {
  position: relative;
  box-sizing: border-box;
  margin-top: 2px;
  width: 100%;
  text-align: center;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter textarea {
  height: auto !important;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter svg {
  margin-top: 3px;
}

.tabulator .tabulator-header .tabulator-col .tabulator-header-filter input::-ms-clear {
  width: 0;
  height: 0;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
  padding-right: 25px;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {
  /* cursor: pointer;
  background-color: #cdcdcd; */
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="none"] .tabulator-col-content .tabulator-col-sorter {
  color: #bbb;
  display: none;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="none"] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {
  border-top: none;
  border-bottom: 6px solid #bbb;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="asc"] .tabulator-col-content .tabulator-col-sorter {
  color: #666;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="asc"] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {
  border-top: none;
  border-bottom: 6px solid #666;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="desc"] .tabulator-col-content .tabulator-col-sorter {
  color: #666;
}

.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort="desc"] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {
  border-bottom: none;
  border-top: 6px solid #666;
  color: #666;
}

.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical .tabulator-col-content .tabulator-col-title {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-col-vertical-flip .tabulator-col-title {
  transform: rotate(180deg);
}

.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-sortable .tabulator-col-title {
  padding-right: 0;
  padding-top: 20px;
}

.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-sortable.tabulator-col-vertical-flip .tabulator-col-title {
  padding-right: 0;
  padding-bottom: 20px;
}

.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-sortable .tabulator-col-sorter {
  justify-content: center;
  left: 0;
  right: 0;
  top: 4px;
  bottom: auto;
}

.tabulator .tabulator-header .tabulator-frozen {
  display: inline-block;
  position: absolute;
  z-index: 10;
}

.tabulator .tabulator-header .tabulator-frozen.tabulator-frozen-left {
  border-right: 2px solid #aaa;
}

.tabulator .tabulator-header .tabulator-frozen.tabulator-frozen-right {
  border-left: 2px solid #aaa;
}

.tabulator .tabulator-header .tabulator-calcs-holder {
  box-sizing: border-box;
  min-width: 600%;
  background: #f3f3f3 !important;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  overflow: hidden;
}

.tabulator .tabulator-header .tabulator-calcs-holder .tabulator-row {
  background: #f3f3f3 !important;
}

.tabulator .tabulator-header .tabulator-calcs-holder .tabulator-row .tabulator-col-resize-handle {
  display: none;
}

.tabulator .tabulator-header .tabulator-frozen-rows-holder {
  min-width: 600%;
}

.tabulator .tabulator-header .tabulator-frozen-rows-holder:empty {
  display: none;
}

.tabulator .tabulator-tableHolder {
  position: relative;
  width: 100%;
  white-space: nowrap;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.tabulator .tabulator-tableHolder:focus {
  outline: none;
}

.tabulator .tabulator-tableHolder .tabulator-placeholder {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
}

.tabulator .tabulator-tableHolder .tabulator-placeholder[tabulator-render-mode="virtual"] {
  min-height: 100%;
  min-width: 100%;
}

.tabulator .tabulator-tableHolder .tabulator-placeholder span {
  display: inline-block;
  margin: 0 auto;
  padding: 10px;
  color: #ccc;
  font-weight: bold;
  font-size: 20px;
}

.tabulator .tabulator-tableHolder .tabulator-table {
  position: relative;
  display: inline-block;
  /* background-color: #fff; */
  background-color: #fafafa;
  white-space: nowrap;
  overflow: visible;
  color: #333;
}

.tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-calcs {
  font-weight: bold;
  background: #e2e2e2 !important;
}

.tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-calcs.tabulator-calcs-top {
  border-bottom: 2px solid #aaa;
}

.tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-calcs.tabulator-calcs-bottom {
  border-top: 2px solid #aaa;
}

.tabulator .tabulator-footer {
  padding: 5px 10px;
  border-top: 1px solid #999;
  background-color: #e6e6e6;
  text-align: right;
  color: #555;
  font-weight: bold;
  white-space: nowrap;
  user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

.tabulator .tabulator-footer .tabulator-calcs-holder {
  box-sizing: border-box;
  width: calc(100% + 20px);
  margin: -5px -10px 5px -10px;
  text-align: left;
  background: #f3f3f3 !important;
  border-bottom: 1px solid #aaa;
  border-top: 1px solid #aaa;
  overflow: hidden;
}

.tabulator .tabulator-footer .tabulator-calcs-holder .tabulator-row {
  background: #f3f3f3 !important;
}

.tabulator .tabulator-footer .tabulator-calcs-holder .tabulator-row .tabulator-col-resize-handle {
  display: none;
}

.tabulator .tabulator-footer .tabulator-calcs-holder:only-child {
  margin-bottom: -5px;
  border-bottom: none;
}

.tabulator .tabulator-footer .tabulator-paginator {
  color: #555;
  font-family: inherit;
  font-weight: inherit;
  font-size: inherit;
}

.tabulator .tabulator-footer .tabulator-page-size {
  display: inline-block;
  margin: 0 5px;
  padding: 2px 5px;
  border: 1px solid #aaa;
  border-radius: 3px;
}

.tabulator .tabulator-footer .tabulator-pages {
  margin: 0 7px;
}

.tabulator .tabulator-footer .tabulator-page {
  display: inline-block;
  margin: 0 2px;
  padding: 2px 5px;
  border: 1px solid #aaa;
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.2);
}

.tabulator .tabulator-footer .tabulator-page.active {
  color: #d00;
}

.tabulator .tabulator-footer .tabulator-page:disabled {
  opacity: .5;
}

.tabulator .tabulator-footer .tabulator-page:not(.disabled):hover {
  cursor: pointer;
  background: rgba(0, 0, 0, 0.2);
  color: #fff;
}

.tabulator .tabulator-col-resize-handle {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 5px;
}

.tabulator .tabulator-col-resize-handle.prev {
  left: 0;
  right: auto;
}

.tabulator .tabulator-col-resize-handle:hover {
  cursor: ew-resize;
}

.tabulator .tabulator-loader {
  position: absolute;
  display: flex;
  align-items: center;
  top: 0;
  left: 0;
  z-index: 100;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.4);
  text-align: center;
}

.tabulator .tabulator-loader .tabulator-loader-msg {
  display: inline-block;
  margin: 0 auto;
  padding: 10px 20px;
  border-radius: 10px;
  background: #fff;
  font-weight: bold;
  font-size: 16px;
}

.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-loading {
  border: 4px solid #333;
  color: #000;
}

.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-error {
  border: 4px solid #D00;
  color: #590000;
}

.tabulator-row {
  position: relative;
  box-sizing: border-box;
  min-height: 22px;
  background-color: #fff;
  display: flex;
  user-select: none;
  /* 표준 */
  -webkit-user-select: none;
  /* 크롬/사파리용 */
  -moz-user-select: none;
  /* 파이어폭스용 */
  -ms-user-select: none;
  /* IE/엣지 구버전용 */
}

.tabulator-row.tabulator-row-even {
  background-color: #EFEFEF;
}

.tabulator-row.tabulator-selectable:hover {
  background-color: #bbb;
}

.tabulator-row.tabulator-selected {
  background-color: #9ABCEA;
}

.tabulator-row.tabulator-selected:hover {
  background-color: #769BCC;
  cursor: pointer;
}

.tabulator-row.tabulator-row-moving {
  border: 1px solid #000;
  background: #fff;
}

.tabulator-row.tabulator-moving {
  position: absolute;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
  pointer-events: none;
  z-index: 15;
}

.tabulator-row .tabulator-row-resize-handle {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  height: 5px;
}

.tabulator-row .tabulator-row-resize-handle.prev {
  top: 0;
  bottom: auto;
}

.tabulator-row .tabulator-row-resize-handle:hover {
  cursor: ns-resize;
}

.tabulator-row .tabulator-frozen {
  display: inline-block;
  position: absolute;
  background-color: inherit;
  z-index: 10;
}

.tabulator-row .tabulator-frozen.tabulator-frozen-left {
  border-right: 2px solid #aaa;
}

.tabulator-row .tabulator-frozen.tabulator-frozen-right {
  border-left: 2px solid #aaa;
}

.tabulator-row .tabulator-responsive-collapse {
  box-sizing: border-box;
  padding: 5px;
  border-top: 1px solid #aaa;
  border-bottom: 1px solid #aaa;
}

.tabulator-row .tabulator-responsive-collapse:empty {
  display: none;
}

.tabulator-row .tabulator-responsive-collapse table {
  font-size: 14px;
}

.tabulator-row .tabulator-responsive-collapse table tr td {
  position: relative;
}

.tabulator-row .tabulator-responsive-collapse table tr td:first-of-type {
  padding-right: 10px;
}

.tabulator-row .tabulator-cell {
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding: 4px;
  border-right: 1px solid #aaa;
  vertical-align: middle;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tabulator-row .tabulator-cell.tabulator-editing {
  border: 1px solid #1D68CD;
  outline: none;
  padding: 0;
}

.tabulator-row .tabulator-cell.tabulator-editing input,
.tabulator-row .tabulator-cell.tabulator-editing select {
  border: 1px;
  background: transparent;
}

.tabulator-row .tabulator-cell.tabulator-validation-fail {
  border: 1px solid #dd0000;
}

.tabulator-row .tabulator-cell.tabulator-validation-fail input,
.tabulator-row .tabulator-cell.tabulator-validation-fail select {
  border: 1px;
  background: transparent;
  color: #dd0000;
}

.tabulator-row .tabulator-cell:first-child .tabulator-col-resize-handle.prev {
  display: none;
}

.tabulator-row .tabulator-cell.tabulator-row-handle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
}

.tabulator-row .tabulator-cell.tabulator-row-handle .tabulator-row-handle-box {
  width: 80%;
}

.tabulator-row .tabulator-cell.tabulator-row-handle .tabulator-row-handle-box .tabulator-row-handle-bar {
  width: 100%;
  height: 3px;
  margin-top: 2px;
  background: #666;
}

.tabulator-row .tabulator-cell .tabulator-data-tree-branch {
  display: inline-block;
  vertical-align: middle;
  height: 9px;
  width: 7px;
  margin-top: -9px;
  margin-right: 5px;
  border-bottom-left-radius: 1px;
  border-left: 2px solid #aaa;
  border-bottom: 2px solid #aaa;
}

.tabulator-row .tabulator-cell .tabulator-data-tree-control {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  height: 11px;
  width: 11px;
  margin-right: 5px;
  border: 1px solid #333;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.tabulator-row .tabulator-cell .tabulator-data-tree-control:hover {
  background: rgba(0, 0, 0, 0.2);
}

.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-collapse {
  display: inline-block;
  position: relative;
  height: 7px;
  width: 1px;
  background: transparent;
}

.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-collapse:after {
  position: absolute;
  content: "";
  left: -3px;
  top: 3px;
  height: 1px;
  width: 7px;
  background: #333;
}

.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-expand {
  display: inline-block;
  position: relative;
  height: 7px;
  width: 1px;
  background: #333;
}

.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-expand:after {
  position: absolute;
  content: "";
  left: -3px;
  top: 3px;
  height: 1px;
  width: 7px;
  background: #333;
}

.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -o-user-select: none;
  height: 15px;
  width: 15px;
  border-radius: 20px;
  background: #666;
  color: #fff;
  font-weight: bold;
  font-size: 1.1em;
}

.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle:hover {
  opacity: .7;
}

.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle.open .tabulator-responsive-collapse-toggle-close {
  display: initial;
}

.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle.open .tabulator-responsive-collapse-toggle-open {
  display: none;
}

.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle .tabulator-responsive-collapse-toggle-close {
  display: none;
}

.tabulator-row .tabulator-cell .tabulator-traffic-light {
  display: inline-block;
  height: 14px;
  width: 14px;
  border-radius: 14px;
}

.tabulator-row.tabulator-group {
  box-sizing: border-box;
  border-bottom: 1px solid #999;
  border-right: 1px solid #aaa;
  border-top: 1px solid #999;
  padding: 5px;
  padding-left: 10px;
  background: #ccc;
  font-weight: bold;
  min-width: 100%;
}

.tabulator-row.tabulator-group:hover {
  background-color: rgba(0, 0, 0, 0.1);
}

.tabulator-row.tabulator-group.tabulator-group-visible .tabulator-arrow {
  margin-right: 10px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  border-bottom: 0;
}

.tabulator-row.tabulator-group.tabulator-group-level-1 {
  padding-left: 30px;
}

.tabulator-row.tabulator-group.tabulator-group-level-2 {
  padding-left: 50px;
}

.tabulator-row.tabulator-group.tabulator-group-level-3 {
  padding-left: 70px;
}

.tabulator-row.tabulator-group.tabulator-group-level-4 {
  padding-left: 90px;
}

.tabulator-row.tabulator-group.tabulator-group-level-5 {
  padding-left: 110px;
}

.tabulator-row.tabulator-group .tabulator-group-toggle {
  display: inline-block;
}

.tabulator-row.tabulator-group .tabulator-arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 16px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 0;
  border-left: 6px solid #666;
  vertical-align: middle;
}

.tabulator-row.tabulator-group span {
  margin-left: 10px;
  color: #d00;
}

.tabulator-menu {
  position: absolute;
  display: inline-block;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #aaa;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  font-size: 14px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 10000;
}

.tabulator-menu .tabulator-menu-item {
  position: relative;
  box-sizing: border-box;
  padding: 5px 10px;
  -webkit-user-select: none;
  user-select: none;
}

.tabulator-menu .tabulator-menu-item.tabulator-menu-item-disabled {
  opacity: .5;
}

.tabulator-menu .tabulator-menu-item:not(.tabulator-menu-item-disabled):hover {

  background: #EFEFEF;
}

.tabulator-menu .tabulator-menu-item.tabulator-menu-item-submenu {
  padding-right: 25px;
}

.tabulator-menu .tabulator-menu-item.tabulator-menu-item-submenu::after {
  display: inline-block;
  position: absolute;
  top: calc(5px + .4em);
  right: 10px;
  height: 7px;
  width: 7px;
  content: '';
  border-width: 1px 1px 0 0;
  border-style: solid;
  border-color: #aaa;
  vertical-align: top;
  transform: rotate(45deg);
}

.tabulator-menu .tabulator-menu-separator {
  border-top: 1px solid #aaa;
}

.tabulator-edit-select-list {
  position: absolute;
  display: inline-block;
  box-sizing: border-box;
  max-height: 200px;
  background: #fff;
  border: 1px solid #aaa;
  font-size: 14px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  z-index: 10000;
}

.tabulator-edit-select-list .tabulator-edit-select-list-item {
  padding: 4px;
  color: #333;
}

.tabulator-edit-select-list .tabulator-edit-select-list-item.active {
  color: #fff;
  background: #1D68CD;
}

.tabulator-edit-select-list .tabulator-edit-select-list-item.active.focused {
  outline: 1px solid rgba(255, 255, 255, 0.5);
}

.tabulator-edit-select-list .tabulator-edit-select-list-item.focused {
  outline: 1px solid #1D68CD;
}

.tabulator-edit-select-list .tabulator-edit-select-list-item:hover {

  color: #fff;
  background: #1D68CD;
}

.tabulator-edit-select-list .tabulator-edit-select-list-notice {
  padding: 4px;
  color: #333;
  text-align: center;
}

.tabulator-edit-select-list .tabulator-edit-select-list-group {
  border-bottom: 1px solid #aaa;
  padding: 4px;
  padding-top: 6px;
  color: #333;
  font-weight: bold;
}

.tabulator.tabulator-ltr {
  direction: ltr;
}

.tabulator.tabulator-rtl {
  text-align: initial;
  direction: rtl;
}

.tabulator.tabulator-rtl .tabulator-header .tabulator-col {
  text-align: initial;
  border-left: 1px solid #aaa;
  border-right: initial;
}

.tabulator.tabulator-rtl .tabulator-header .tabulator-col.tabulator-col-group .tabulator-col-group-cols {
  margin-right: initial;
  margin-left: -1px;
}

.tabulator.tabulator-rtl .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {
  padding-right: 0;
  padding-left: 25px;
}

.tabulator.tabulator-rtl .tabulator-header .tabulator-col .tabulator-col-content .tabulator-arrow {
  left: 8px;
  right: initial;
}

.tabulator.tabulator-rtl .tabulator-row .tabulator-cell {
  border-right: initial;
  border-left: 1px solid #aaa;
}

.tabulator.tabulator-rtl .tabulator-row .tabulator-cell .tabulator-data-tree-branch {
  margin-right: initial;
  margin-left: 5px;
  border-bottom-left-radius: initial;
  border-bottom-right-radius: 1px;
  border-left: initial;
  border-right: 2px solid #aaa;
}

.tabulator.tabulator-rtl .tabulator-row .tabulator-cell .tabulator-data-tree-control {
  margin-right: initial;
  margin-left: 5px;
}

.tabulator.tabulator-rtl .tabulator-col-resize-handle {
  position: absolute;
  left: 0;
  right: auto;
}

.tabulator.tabulator-rtl .tabulator-col-resize-handle.prev {
  right: 0;
  left: auto;
}

.tabulator-print-fullscreen {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
}

body.tabulator-print-fullscreen-hide>*:not(.tabulator-print-fullscreen) {
  display: none !important;
}

.tabulator-print-table {
  border-collapse: collapse;
}

.tabulator-print-table .tabulator-data-tree-branch {
  display: inline-block;
  vertical-align: middle;
  height: 9px;
  width: 7px;
  margin-top: -9px;
  margin-right: 5px;
  border-bottom-left-radius: 1px;
  border-left: 2px solid #aaa;
  border-bottom: 2px solid #aaa;
}

.tabulator-print-table .tabulator-print-table-group {
  box-sizing: border-box;
  border-bottom: 1px solid #999;
  border-right: 1px solid #aaa;
  border-top: 1px solid #999;
  padding: 5px;
  padding-left: 10px;
  background: #ccc;
  font-weight: bold;
  min-width: 100%;
}

.tabulator-print-table .tabulator-print-table-group:hover {

  background-color: rgba(0, 0, 0, 0.1);
}

.tabulator-print-table .tabulator-print-table-group.tabulator-group-visible .tabulator-arrow {
  margin-right: 10px;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid #666;
  border-bottom: 0;
}

.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-1 td {
  padding-left: 30px !important;
}

.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-2 td {
  padding-left: 50px !important;
}

.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-3 td {
  padding-left: 70px !important;
}

.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-4 td {
  padding-left: 90px !important;
}

.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-5 td {
  padding-left: 110px !important;
}

.tabulator-print-table .tabulator-print-table-group .tabulator-group-toggle {
  display: inline-block;
}

.tabulator-print-table .tabulator-print-table-group .tabulator-arrow {
  display: inline-block;
  width: 0;
  height: 0;
  margin-right: 16px;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-right: 0;
  border-left: 6px solid #666;
  vertical-align: middle;
}

.tabulator-print-table .tabulator-print-table-group span {
  margin-left: 10px;
  color: #d00;
}

.tabulator-print-table .tabulator-data-tree-control {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  height: 11px;
  width: 11px;
  margin-right: 5px;
  border: 1px solid #333;
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.tabulator-print-table .tabulator-data-tree-control:hover {

  background: rgba(0, 0, 0, 0.2);
}

.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-collapse {
  display: inline-block;
  position: relative;
  height: 7px;
  width: 1px;
  background: transparent;
}

.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-collapse:after {
  position: absolute;
  content: "";
  left: -3px;
  top: 3px;
  height: 1px;
  width: 7px;
  background: #333;
}

.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-expand {
  display: inline-block;
  position: relative;
  height: 7px;
  width: 1px;
  background: #333;
}

.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-expand:after {
  position: absolute;
  content: "";
  left: -3px;
  top: 3px;
  height: 1px;
  width: 7px;
  background: #333;
}

/**
 * tom-select.css (v1.7.8)
 * Copyright (c) contributors
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this
 * file except in compliance with the License. You may obtain a copy of the License at:
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 *
 */
.ts-control.plugin-drag_drop.multi>.ts-input>div.ui-sortable-placeholder {
  visibility: visible !important;
  background: #f2f2f2 !important;
  background: rgba(0, 0, 0, 0.06) !important;
  border: 0 none !important;
  box-shadow: inset 0 0 12px 4px #fff;
}

.ts-control.plugin-drag_drop .ui-sortable-placeholder::after {
  content: '!';
  visibility: hidden;
}

.ts-control.plugin-drag_drop .ui-sortable-helper {
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.plugin-checkbox_options .option input {
  margin-right: 0.5rem;
}

.plugin-clear_button .items {
  padding-right: calc(1em + (3 * 6px)) !important;
}

.plugin-clear_button .clear-button {
  opacity: 0;
  position: absolute;
  top: 8px;
  right: calc(8px - 6px);
  margin-right: 0 !important;
  background: transparent !important;
  transition: opacity 0.5s;
  cursor: pointer;
}

.plugin-clear_button.single .clear-button {
  right: calc(8px - 6px + 2rem);
}

.plugin-clear_button .has-items.focus .clear-button,
.plugin-clear_button:hover .has-items .clear-button {
  opacity: 1;
}

.ts-control .dropdown-header {
  position: relative;
  padding: 10px 8px;
  border-bottom: 1px solid #d0d0d0;
  background: #f8f8f8;
  border-radius: 3px 3px 0 0;
}

.ts-control .dropdown-header-close {
  position: absolute;
  right: 8px;
  top: 50%;
  color: #303030;
  opacity: 0.4;
  margin-top: -12px;
  line-height: 20px;
  font-size: 20px !important;
}

.ts-control .dropdown-header-close:hover {
  color: black;
}

.plugin-dropdown_input .ts-input.focus {
  box-shadow: none;
  border: 1px solid #d0d0d0;
}

.plugin-dropdown_input .dropdown-input {
  border: 1px solid #d0d0d0;
  border-width: 0 0 1px 0;
  display: block;
  padding: 8px 8px;
  box-shadow: none;
  width: 100%;
  background: transparent;
}

.ts-control.plugin-input_autogrow .ts-input.has-items>input {
  min-width: 0;
}

.ts-control.plugin-input_autogrow .ts-input.focus.has-items>input {
  flex: none;
  min-width: 4px;
}

.ts-control.plugin-input_autogrow .ts-input.focus.has-items>input::placeholder {
  color: transparent;
}

.ts-dropdown.plugin-optgroup_columns .ts-dropdown-content {
  display: flex;
}

.ts-dropdown.plugin-optgroup_columns .optgroup {
  border-right: 1px solid #f2f2f2;
  border-top: 0 none;
  flex-grow: 1;
  flex-basis: 0;
  min-width: 0;
}

.ts-dropdown.plugin-optgroup_columns .optgroup:last-child {
  border-right: 0 none;
}

.ts-dropdown.plugin-optgroup_columns .optgroup:before {
  display: none;
}

.ts-dropdown.plugin-optgroup_columns .optgroup-header {
  border-top: 0 none;
}

.ts-control.plugin-remove_button .item {
  display: inline-flex;
  align-items: center;
  padding-right: 0 !important;
}

.ts-control.plugin-remove_button .item .remove {
  color: inherit;
  text-decoration: none;
  vertical-align: middle;
  display: inline-block;
  padding: 2px 6px;
  border-left: 1px solid #d0d0d0;
  border-radius: 0 2px 2px 0;
  box-sizing: border-box;
  margin-left: 6px;
}

.ts-control.plugin-remove_button .item .remove:hover {
  background: rgba(0, 0, 0, 0.05);
}

.ts-control.plugin-remove_button .item.active .remove {
  border-left-color: #cacaca;
}

.ts-control.plugin-remove_button .disabled .item .remove:hover {
  background: none;
}

.ts-control.plugin-remove_button .disabled .item .remove {
  border-left-color: white;
}

.ts-control.plugin-remove_button .remove-single {
  position: absolute;
  right: 0;
  top: 0;
  font-size: 23px;
}

.ts-control {
  position: relative;
}

.ts-dropdown,
.ts-input,
.ts-input input {
  color: #303030;
  font-family: inherit;
  font-size: 13px;
  line-height: 18px;
  font-smoothing: inherit;
}

.ts-input,
.ts-control.single .ts-input.input-active {
  background: #fff;
  cursor: text;
}

.ts-input {
  border: 1px solid #d0d0d0;
  padding: 8px 8px;
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  box-shadow: none;
  border-radius: 3px;
  display: flex;
  flex-wrap: wrap;
}

.ts-control.multi .ts-input.has-items {
  padding: calc(8px - 2px - 0) 8px calc(8px - 2px - 3px - 0);
}

.ts-input.full {
  background-color: #fff;
}

.ts-input.disabled,
.ts-input.disabled * {
  cursor: default !important;
}

.ts-input.focus {
  box-shadow: none;
}

.ts-input>* {
  vertical-align: baseline;
  display: inline-block;
}

.ts-control.multi .ts-input>div {
  cursor: pointer;
  margin: 0 3px 3px 0;
  padding: 2px 6px;
  background: #f2f2f2;
  color: #303030;
  border: 0 solid #d0d0d0;
}

.ts-control.multi .ts-input>div.active {
  background: #e8e8e8;
  color: #303030;
  border: 0 solid #cacaca;
}

.ts-control.multi .ts-input.disabled>div,
.ts-control.multi .ts-input.disabled>div.active {
  color: #7d7c7c;
  background: white;
  border: 0 solid white;
}

.ts-input>input {
  flex: 1 1 auto;
  min-width: 7rem;
  display: inline-block !important;
  padding: 0 !important;
  min-height: 0 !important;
  max-height: none !important;
  max-width: 100% !important;
  margin: 0 !important;
  text-indent: 0 !important;
  border: 0 none !important;
  background: none !important;
  line-height: inherit !important;
  -webkit-user-select: auto !important;
  user-select: auto !important;
  box-shadow: none !important;
}

.ts-input>input::-ms-clear {
  display: none;
}

.ts-input>input:focus {
  outline: none !important;
}

.ts-input.has-items>input {
  margin: 0 4px !important;
}

.ts-input.dropdown-active::before {
  content: ' ';
  display: block;
  position: absolute;
  background: #f0f0f0;
  height: 1px;
  bottom: 0;
  left: 0;
  right: 0;
}

.ts-input.rtl {
  text-align: right;
}

.ts-input.rtl.single .ts-input:after {
  left: 15px;
  right: auto;
}

.ts-input.rtl .ts-input>input {
  margin: 0 4px 0 -2px !important;
}

.ts-input.disabled {
  opacity: 0.5;
  background-color: #fafafa;
}

.input-hidden .ts-input>input {
  opacity: 0;
  position: absolute;
  left: -10000px;
}

.ts-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  z-index: 10;
  border: 1px solid #d0d0d0;
  background: #fff;
  margin: 0.25rem 0 0 0;
  border-top: 0 none;
  box-sizing: border-box;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 0 0 3px 3px;
}

.ts-dropdown [data-selectable] {
  cursor: pointer;
  overflow: hidden;
}

.ts-dropdown [data-selectable] .highlight {
  background: rgba(125, 168, 208, 0.2);
  border-radius: 1px;
}

.ts-dropdown .option,
.ts-dropdown .optgroup-header,
.ts-dropdown .no-results,
.ts-dropdown .create {
  padding: 5px 8px;
}

.ts-dropdown .option,
.ts-dropdown [data-disabled],
.ts-dropdown [data-disabled] [data-selectable].option {
  cursor: inherit;
  opacity: 0.5;
}

.ts-dropdown [data-selectable].option {
  opacity: 1;
  cursor: pointer;
}

.ts-dropdown .optgroup:first-child .optgroup-header {
  border-top: 0 none;
}

.ts-dropdown .optgroup-header {
  color: #303030;
  background: #fff;
  cursor: default;
}

.ts-dropdown .create:hover,
.ts-dropdown .option:hover,
.ts-dropdown .active {
  background-color: #f5fafd;
  color: #495c68;
}

.ts-dropdown .create:hover.create,
.ts-dropdown .option:hover.create,
.ts-dropdown .active.create {
  color: #495c68;
}

.ts-dropdown .create {
  color: rgba(48, 48, 48, 0.5);
}

.ts-dropdown .spinner {
  display: inline-block;
  width: 30px;
  height: 30px;
  margin: 5px 8px;
}

.ts-dropdown .spinner:after {
  content: " ";
  display: block;
  width: 24px;
  height: 24px;
  margin: 3px;
  border-radius: 50%;
  border: 5px solid #d0d0d0;
  border-color: #d0d0d0 transparent #d0d0d0 transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.ts-dropdown-content {
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 200px;
  overflow-scrolling: touch;
  scroll-behavior: smooth;
}

.tns-outer {
  padding: 0 !important
}

.tns-outer [hidden] {
  display: none !important
}

.tns-outer [aria-controls],
.tns-outer [data-action] {
  cursor: pointer
}

.tns-slider {
  transition: all 0s
}

.tns-slider>.tns-item {
  box-sizing: border-box
}

.tns-horizontal.tns-subpixel {
  white-space: nowrap
}

.tns-horizontal.tns-subpixel>.tns-item {
  display: inline-block;
  vertical-align: top;
  white-space: normal
}

.tns-horizontal.tns-no-subpixel:after {
  content: '';
  display: table;
  clear: both
}

.tns-horizontal.tns-no-subpixel>.tns-item {
  float: left
}

.tns-horizontal.tns-carousel.tns-no-subpixel>.tns-item {
  margin-right: -100%
}

.tns-no-calc {
  position: relative;
  left: 0
}

.tns-gallery {
  position: relative;
  left: 0;
  min-height: 1px
}

.tns-gallery>.tns-item {
  position: absolute;
  left: -100%;
  transition: transform 0s, opacity 0s
}

.tns-gallery>.tns-slide-active {
  position: relative;
  left: auto !important
}

.tns-gallery>.tns-moving {
  transition: all 0.25s
}

.tns-autowidth {
  display: inline-block
}

.tns-lazy-img {
  transition: opacity 0.6s;
  opacity: 0.6
}

.tns-lazy-img.tns-complete {
  opacity: 1
}

.tns-ah {
  transition: height 0s
}

.tns-ovh {
  overflow: hidden
}

.tns-visually-hidden {
  position: absolute;
  left: -10000em
}

.tns-transparent {
  opacity: 0;
  visibility: hidden
}

.tns-fadeIn {
  opacity: 1;
  filter: alpha(opacity=100);
  z-index: 0
}

.tns-normal,
.tns-fadeOut {
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1
}

.tns-vpfix {
  white-space: nowrap
}

.tns-vpfix>div,
.tns-vpfix>li {
  display: inline-block
}

.tns-t-subp2 {
  margin: 0 auto;
  width: 310px;
  position: relative;
  height: 10px;
  overflow: hidden
}

.tns-t-ct {
  width: 2333.3333333%;
  width: calc(100% * 70 / 3);
  position: absolute;
  right: 0
}

.tns-t-ct:after {
  content: '';
  display: table;
  clear: both
}

.tns-t-ct>div {
  width: 1.4285714%;
  width: calc(100% / 70);
  height: 10px;
  float: left
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.simplebar-content:before,
.simplebar-content:after {
  content: ' ';
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  left: 0;
  right: 0;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: '';
  background: black;
  border-radius: 7px;
  left: 2px;
  right: 2px;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

/* Rtl support */
[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

/*
 |--------------------------------------------------------------------------
 | Components
 |--------------------------------------------------------------------------
 |
 | Import CSS/SCSS components.
 |
 */
html {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

@media (min-width: 768px) {
  html {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  }
}

html.dark {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

html.dark body {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

html.dark body *,
html.dark body ::before,
html.dark body ::after {
  border-color: rgb(255 255 255 / 0.05);
}

html body {
  overflow-x: hidden;
  font-family: Roboto;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fff;
}

@media (max-width: calc(768px - 1px)) {
  html body {
    padding-left: 2rem;
    padding-right: 2rem;
  }
}

@media (max-width: calc(640px - 1px)) {
  html body {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

.login {
  position: relative;
  overflow: hidden;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  padding-left: 2rem;
  padding-right: 2rem;
}

.dark .login {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .login {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  }

  .dark .login {
    --tw-bg-opacity: 1;
    background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  }
}

.login:before {
  content: "";
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  margin-top: -28%;
  margin-bottom: -15%;
  margin-left: -13%;
  width: 57%;
  --tw-rotate: -4deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 100%;
  background-color: rgb(var(--color-primary) / 0.2);
}

.dark .login:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .login:before {
    display: none;
  }
}

.login:after {
  content: "";
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  margin-top: -20%;
  margin-bottom: -12%;
  margin-left: -13%;
  width: 57%;
  --tw-rotate: -4deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  border-radius: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.login.login--light-tenant:before {
  background-color: #c3cbd3;
}

.login.login--light-tenant:after {
  background-color: #d9dee3;
}

.login.login--light-tenant .tenant-login-logo {
  width: 14rem;
  max-height: 7rem;
  object-fit: contain;
  object-position: left center;
}

.login.login--light-tenant .tenant-login-title {
  color: #334155 !important;
}

.dark .login:after {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.dark .login.login--light-tenant:before {
  background-color: #c3cbd3;
}

.dark .login.login--light-tenant:after {
  background-color: #d9dee3;
}

@media (max-width: calc(1280px - 1px)) {
  .login.login--light-tenant {
    background-color: #d9dee3;
  }

  .login:after {
    display: none;
  }
}

.login .login__input {
  min-width: 350px;
}

@media (max-width: calc(1280px - 1px)) {
  .login .login__input {
    min-width: 100%;
  }
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) {
  border-spacing: 0 10px;
  border-collapse: separate;
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) th {
  border-bottom-width: 0px;
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) td {
  border-bottom-width: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.dark .table-report:not(.table-report--bordered):not(.table-report--tabulator) td {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) td {
  box-shadow: 20px 3px 20px #0000000b;
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) td:first-child {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) td:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) td.table-report__action {
  position: relative;
  padding-top: 0px;
  padding-bottom: 0px;
}

.table-report:not(.table-report--bordered):not(.table-report--tabulator) td.table-report__action::before {
  position: absolute;
  top: 0px;
  bottom: 0px;
  left: 0px;
  margin-top: auto;
  margin-bottom: auto;
  display: block;
  height: 2rem;
  width: 1px;
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
}

.dark .table-report:not(.table-report--bordered):not(.table-report--tabulator) td.table-report__action::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.table-report img {
  box-shadow: 0px 0px 0px 2px #fff, 1px 1px 5px rgba(0, 0, 0, 0.32);
}

.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(3) .tabulator-col-content .tabulator-col-title,
.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(4) .tabulator-col-content .tabulator-col-title,
.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(5) .tabulator-col-content .tabulator-col-title,
.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(6) .tabulator-col-content .tabulator-col-title {
  /* text-align: center; */
}

.dark .table-report img {
  box-shadow: 0px 0px 0px 2px #3f4865, 1px 1px 5px rgba(0, 0, 0, 0.32);
}

.report-chart {
  position: relative;
}

.report-chart:before {
  content: "";
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  margin-left: 2.5rem;
  margin-bottom: 1.75rem;
  display: block;
  width: 4rem;
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
  --tw-gradient-from: #fff;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0));
  --tw-gradient-to: transparent;
}

@supports (color: rgb(0 0 0 / 0)) {
.report-chart:before {
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.8), var(--tw-gradient-to, rgb(255 255 255 / 0));
}
}

.dark .report-chart:before {
  --tw-gradient-from: rgb(var(--color-darkmode-600));
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-600) / 0));
}

.report-chart:after {
  content: "";
  position: absolute;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin-bottom: 1.75rem;
  display: block;
  width: 4rem;
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
  --tw-gradient-from: #fff;
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0));
  --tw-gradient-to: transparent;
}

@supports (color: rgb(0 0 0 / 0)) {
.report-chart:after {
  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.8), var(--tw-gradient-to, rgb(255 255 255 / 0));
}
}

.dark .report-chart:after {
  --tw-gradient-from: rgb(var(--color-darkmode-600));
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-600) / 0));
}

.search {
  position: relative;
}

.search .search__input {
  width: 14rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  padding-right: 2rem;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: width;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.search .search__input:focus {
  border-color: transparent;
}

.dark .search .search__input {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.search .search__input:focus {
  width: 18rem;
}

.search .search__icon {
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  margin-top: auto;
  margin-bottom: auto;
  margin-right: 0.75rem;
  height: 1.25rem;
  width: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
}

.notification {
  position: relative;
  color: rgb(255 255 255 / 0.7);
}

.notification .notification__icon {
  height: 1.25rem;
  width: 1.25rem;
}

.notification.notification--bullet:before {
  content: "";
  width: 8px;
  height: 8px;
  position: absolute;
  top: -2px;
  right: 0px;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
}

.report-box {
  position: relative;
}

.report-box:before {
  content: "";
  width: 90%;
  box-shadow: 0px 3px 20px #0000000b;
  position: absolute;
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.75rem;
  height: 100%;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-50) / var(--tw-bg-opacity));
}

.dark .report-box:before {
  background-color: rgb(var(--color-darkmode-400) / 0.7);
}

.report-box .report-box__icon {
  width: 28px;
  height: 28px;
}

.report-box .report-box__indicator {
  padding-top: 3px;
  padding-bottom: 3px;
  display: flex;
  align-items: center;
  border-radius: 9999px;
  padding-left: 0.5rem;
  padding-right: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.report-box-2 {
  position: relative;
}

.report-box-2:before {
  content: "";
  width: 90%;
  background: #f9fafc;
  box-shadow: 0px 3px 20px #0000000b;
  position: absolute;
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.75rem;
  height: 100%;
  border-radius: 0.375rem;
}

.dark .report-box-2:before {
  background-color: rgb(var(--color-darkmode-400) / 0.7);
}

.report-box-2 .report-box-2__indicator {
  padding-top: 3px;
  padding-bottom: 3px;
  margin-top: 0.75rem;
  margin-right: auto;
  display: flex;
  align-items: center;
  border-radius: 9999px;
  padding-left: 0.5rem;
  padding-right: 0.25rem;
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.report-box-3 {
  margin-left: -22px;
  margin-right: -22px;
  position: relative;
}

@media (max-width: calc(768px - 1px)) {
  .report-box-3 {
    margin-left: -16px;
    margin-right: -16px;
  }
}

.report-box-3:before {
  content: "";
  border-radius: 30px 30px 0px 0px;
  transform: translatey(35px);
  animation: 0.4s intro-report-box-3-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: 0.1s;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
  background-color: rgb(var(--color-slate-200) / 0.7);
  opacity: 0;
}

.dark .report-box-3:before {
  background-color: rgb(var(--color-darkmode-500) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.5;
}

.report-box-3.report-box-3--content {
  padding: 0px 22px;
  min-height: 400px;
}

.report-box-3.report-box-3--content:before {
  content: "";
  border-radius: 30px;
  transform: translatey(35px);
  animation: 0.4s intro-report-box-3-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: 0.1s;
  box-shadow: 0px 3px 20px #0000000b;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 100%;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  opacity: 0;
}

.dark .report-box-3.report-box-3--content:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .report-box-3.report-box-3--content:before {
    border-top-left-radius: 0px;
    border-top-right-radius: 0px;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }
}

@keyframes intro-report-box-3-animation {
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

.report-box-4 {
  position: relative;
}

.report-box-4:before {
  content: "";
  border-radius: 30px 30px 0px 0px;
  transform: translatey(35px);
  animation: 0.4s intro-report-box-4-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: 0.1s;
  margin-left: -22px;
  margin-right: -22px;
  box-shadow: 0px 3px 20px #0000000b;
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  display: none;
  height: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  opacity: 0;
}

.dark .report-box-4:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .report-box-4:before {
    display: block;
  }
}

@media (max-width: calc(768px - 1px)) {
  .report-box-4:before {
    margin-left: -16px;
    margin-right: -16px;
  }
}

.report-box-4 .report-box-4__content {
  flex: 1 1;
}

@keyframes intro-report-box-4-animation {
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

.content {
  padding: 0px 22px;
  position: relative;
  /*margin-top: 0.25rem;*/
  min-height: 100dvh;
  min-width: 0px;
  flex: 1 1;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  padding-top: 5rem;
  /* padding-bottom: 2rem; */
}

.dark .content {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

@media (max-width: calc(768px - 1px)) {
  .content {
    border-radius: 5px;
    /* border-radius: 30px; */
    margin-top: 2.5rem;
    max-width: 100%;
    padding-left: .5rem;
    padding-right: .5rem;
    /* padding-top: 0px; */
    padding-top: .3rem;
    padding-bottom: .5rem;
    margin-bottom: 15px;
  }
}

.content:before {
  content: "";
  display: block;
  height: 1px;
  width: 100%;
}

.content.content--top-nav {
  border-radius: 35px 35px 0 0;
  margin-top: 1.25rem;
  padding-top: 0px;
}

.top-nav {
  transform: translatey(35px);
  animation: 0.4s intro-top-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: 0.2s;
  position: relative;
  z-index: 50;
  margin-top: -1rem;
  padding-top: 8rem;
  opacity: 0;
}

@media (max-width: calc(768px - 1px)) {
  .top-nav {
    display: none;
  }
}

.top-nav>ul>li:nth-child(1)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

.top-nav>ul>li:nth-child(1)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(2)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

.top-nav>ul>li:nth-child(2)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(3)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

.top-nav>ul>li:nth-child(3)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(4)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

.top-nav>ul>li:nth-child(4)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(5)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

.top-nav>ul>li:nth-child(5)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(6)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

.top-nav>ul>li:nth-child(6)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(7)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

.top-nav>ul>li:nth-child(7)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(8)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

.top-nav>ul>li:nth-child(8)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(9)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

.top-nav>ul>li:nth-child(9)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(10)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

.top-nav>ul>li:nth-child(10)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(11)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

.top-nav>ul>li:nth-child(11)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(12)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

.top-nav>ul>li:nth-child(12)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(13)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

.top-nav>ul>li:nth-child(13)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(14)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

.top-nav>ul>li:nth-child(14)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(15)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

.top-nav>ul>li:nth-child(15)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(16)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

.top-nav>ul>li:nth-child(16)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(17)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

.top-nav>ul>li:nth-child(17)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(18)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

.top-nav>ul>li:nth-child(18)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(19)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

.top-nav>ul>li:nth-child(19)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(20)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

.top-nav>ul>li:nth-child(20)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(21)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

.top-nav>ul>li:nth-child(21)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(22)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

.top-nav>ul>li:nth-child(22)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(23)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

.top-nav>ul>li:nth-child(23)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(24)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

.top-nav>ul>li:nth-child(24)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(25)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

.top-nav>ul>li:nth-child(25)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(26)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

.top-nav>ul>li:nth-child(26)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(27)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

.top-nav>ul>li:nth-child(27)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(28)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

.top-nav>ul>li:nth-child(28)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(29)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

.top-nav>ul>li:nth-child(29)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(30)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

.top-nav>ul>li:nth-child(30)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(31)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

.top-nav>ul>li:nth-child(31)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(32)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

.top-nav>ul>li:nth-child(32)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(33)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

.top-nav>ul>li:nth-child(33)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(34)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

.top-nav>ul>li:nth-child(34)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(35)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

.top-nav>ul>li:nth-child(35)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(36)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

.top-nav>ul>li:nth-child(36)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(37)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

.top-nav>ul>li:nth-child(37)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(38)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

.top-nav>ul>li:nth-child(38)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(39)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

.top-nav>ul>li:nth-child(39)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(40)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

.top-nav>ul>li:nth-child(40)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(41)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

.top-nav>ul>li:nth-child(41)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(42)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

.top-nav>ul>li:nth-child(42)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(43)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

.top-nav>ul>li:nth-child(43)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(44)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

.top-nav>ul>li:nth-child(44)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(45)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

.top-nav>ul>li:nth-child(45)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(46)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

.top-nav>ul>li:nth-child(46)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(47)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

.top-nav>ul>li:nth-child(47)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(48)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

.top-nav>ul>li:nth-child(48)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(49)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

.top-nav>ul>li:nth-child(49)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul>li:nth-child(50)>a:not(.top-menu--active) {
  opacity: 0;
  transform: translateY(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

.top-nav>ul>li:nth-child(50)>a.top-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.top-nav>ul {
  padding: 0px 50px;
  display: flex;
  flex-wrap: wrap;
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }
}

.top-nav>ul>li>.top-menu {
  margin-top: 3px;
}

.top-nav>ul>li>.top-menu>.top-menu__icon {
  margin-top: -3px;
}

.top-nav>ul>li>.top-menu>.top-menu__title {
  margin-top: -3px;
}

.top-nav>ul li {
  position: relative;
}

.top-nav>ul li:hover>.top-menu>.top-menu__title>.top-menu__sub-icon {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.top-nav>ul li:hover>ul {
  display: block;
}

.top-nav>ul li:hover>ul li:hover .top-menu>.top-menu__title>.top-menu__sub-icon {
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.top-nav>ul li .top-menu {
  height: 55px;
  position: relative;
  margin-right: 0.25rem;
  display: flex;
  align-items: center;
  border-radius: 0.75rem;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul li .top-menu {
    border-radius: 9999px;
  }
}

.top-nav>ul li .top-menu.top-menu--active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .top-nav>ul li .top-menu.top-menu--active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.top-nav>ul li .top-menu.top-menu--active:before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: block;
  border-radius: 0.75rem;
  border-bottom-width: 3px;
  border-style: solid;
  border-color: rgb(0 0 0 / 0.08);
}

.dark .top-nav>ul li .top-menu.top-menu--active:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul li .top-menu.top-menu--active:before {
    display: none;
  }
}

.top-nav>ul li .top-menu.top-menu--active:after {
  content: "";
  width: 20px;
  height: 80px;
  margin-bottom: -74px;
  animation: 0.3s active-top-menu-chevron-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: 1s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  position: absolute;
  left: 0px;
  right: 0px;
  bottom: 0px;
  margin-left: auto;
  margin-right: auto;
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul li .top-menu.top-menu--active:after {
    display: none;
  }
}

.dark .top-nav>ul li .top-menu.top-menu--active .top-menu__icon {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul li .top-menu.top-menu--active .top-menu__icon {
    --tw-text-opacity: 1;
    color: rgb(var(--color-primary) / var(--tw-text-opacity));
  }
}

.top-nav>ul li .top-menu.top-menu--active .top-menu__title {
  font-weight: 500;
}

.dark .top-nav>ul li .top-menu.top-menu--active .top-menu__title {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul li .top-menu.top-menu--active .top-menu__title {
    --tw-text-opacity: 1;
    color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
  }
}

.top-nav>ul li .top-menu .top-menu__icon {
  z-index: 10;
}

.dark .top-nav>ul li .top-menu .top-menu__icon {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.top-nav>ul li .top-menu .top-menu__title {
  z-index: 10;
}

.dark .top-nav>ul li .top-menu .top-menu__title {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.top-nav>ul li .top-menu .top-menu__title {
  margin-left: 0.75rem;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.top-nav>ul li .top-menu .top-menu__title .top-menu__sub-icon {
  margin-left: 0.5rem;
  height: 1rem;
  width: 1rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul li .top-menu .top-menu__title .top-menu__sub-icon {
    display: none;
  }
}

.top-nav>ul li ul {
  box-shadow: 0px 3px 20px #00000014;
  position: absolute;
  z-index: 20;
  margin-top: 0.25rem;
  display: none;
  width: 14rem;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  padding-left: 0px;
  padding-right: 0px;
}

.top-nav>ul li ul::before {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 0.375rem;
  content: var(--tw-content);
  background-color: rgb(255 255 255 / 0.04);
}

.dark .top-nav>ul li ul::before {
  content: var(--tw-content);
  background-color: rgb(0 0 0 / 0.1);
}

.top-nav>ul li ul:after {
  content: "";
  position: absolute;
  top: 0px;
  left: 0px;
  margin-top: -0.25rem;
  height: 0.25rem;
  width: 100%;
  cursor: pointer;
}

.top-nav>ul li ul li {
  position: relative;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.top-nav>ul li ul li .top-menu {
  margin-right: 0px;
  padding-left: 0px;
  padding-right: 0px;
}

.top-nav>ul li ul li .top-menu .top-menu__icon:before {
  display: none;
}

.top-nav>ul li ul li .top-menu .top-menu__title {
  width: 100%;
}

.top-nav>ul li ul li .top-menu .top-menu__title .top-menu__sub-icon {
  margin-left: auto;
}

.top-nav>ul li ul ul {
  left: 100%;
  top: 0px;
  margin-top: 0px;
  margin-left: 0px;
  display: none;
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.top-nav>ul li ul ul::before {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
  display: block;
  height: 100%;
  width: 100%;
  border-radius: 0.375rem;
  content: var(--tw-content);
  background-color: rgb(255 255 255 / 0.04);
}

.dark .top-nav>ul li ul ul::before {
  content: var(--tw-content);
  background-color: rgb(0 0 0 / 0.1);
}

.top-nav>ul>li:hover>.top-menu:not(.top-menu--active) {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.dark .top-nav>ul>li:hover>.top-menu:not(.top-menu--active) {
  background-color: transparent;
}

.top-nav>ul>li:hover>.top-menu:not(.top-menu--active):before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
  display: block;
  border-radius: 0.75rem;
  border-bottom-width: 3px;
  border-style: solid;
  border-color: rgb(0 0 0 / 0.08);
}

.dark .top-nav>ul>li:hover>.top-menu:not(.top-menu--active):before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

@media (max-width: calc(1280px - 1px)) {
  .top-nav>ul>li:hover>.top-menu:not(.top-menu--active):before {
    border-radius: 9999px;
  }
}

@keyframes intro-top-menu-animation {
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

@keyframes intro-active-top-menu-animation {
  100% {
    z-index: 10;
  }
}

@keyframes active-top-menu-chevron-animation {
  100% {
    margin-bottom: -54px;
    opacity: 1;
  }
}

.dark .top-nav>ul li .top-menu.top-menu--active:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.dark .top-nav>ul li ul {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dark .top-nav>ul ul {
  box-shadow: 0px 3px 7px #0000001c;
}

.side-nav {
  width: 260px;
  z-index: 50;
  margin-top: -1rem;
  overflow-x: hidden;
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-bottom: 4rem;
  padding-top: 8rem;
}

.side-nav ul li {
  cursor: pointer;
}

@media (max-width: calc(768px - 1px)) {
  .side-nav {
    display: none;
  }
}

.side-nav.side-nav--simple {
  width: 105px;
}

.side-nav.side-nav--simple .side-menu .side-menu__title {
  display: none;
}

.side-nav.side-nav--simple .side-menu .side-menu__title .side-menu__sub-icon {
  display: none;
}

.side-nav.side-nav--simple .side-menu:not(.side-menu--active) .side-menu__icon:before {
  display: none;
}

.side-nav .side-nav__devider {
  position: relative;
  z-index: 10;
  height: 1px;
  width: 100%;
  background-color: rgb(255 255 255 / 0.08);
}

.dark .side-nav .side-nav__devider {
  background-color: rgb(255 255 255 / 0.07);
}

.side-nav .side-menu {
  position: relative;
  margin-bottom: 0.25rem;
  display: flex;
  height: 40px;
  align-items: center;
  border-radius: 0.75rem;
  padding-left: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
}

.dark .side-nav .side-menu {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.side-nav .side-menu .side-menu__title {
  margin-left: 0.75rem;
  display: flex;
  width: 100%;
  align-items: center;
}

.side-nav .side-menu .side-menu__title .side-menu__sub-icon {
  margin-left: auto;
  margin-right: 1.25rem;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.side-nav .side-menu .side-menu__title .side-menu__sub-icon svg {
  height: 1rem;
  width: 1rem;
}

.side-nav>ul>li:nth-child(1).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

.side-nav>ul>li:nth-child(1)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

.side-nav>ul>li:nth-child(1)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(2).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

.side-nav>ul>li:nth-child(2)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

.side-nav>ul>li:nth-child(2)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(3).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

.side-nav>ul>li:nth-child(3)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

.side-nav>ul>li:nth-child(3)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(4).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

.side-nav>ul>li:nth-child(4)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

.side-nav>ul>li:nth-child(4)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(5).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

.side-nav>ul>li:nth-child(5)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

.side-nav>ul>li:nth-child(5)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(6).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

.side-nav>ul>li:nth-child(6)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

.side-nav>ul>li:nth-child(6)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(7).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

.side-nav>ul>li:nth-child(7)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

.side-nav>ul>li:nth-child(7)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(8).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

.side-nav>ul>li:nth-child(8)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

.side-nav>ul>li:nth-child(8)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(9).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

.side-nav>ul>li:nth-child(9)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

.side-nav>ul>li:nth-child(9)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(10).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

.side-nav>ul>li:nth-child(10)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

.side-nav>ul>li:nth-child(10)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(11).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

.side-nav>ul>li:nth-child(11)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

.side-nav>ul>li:nth-child(11)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(12).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

.side-nav>ul>li:nth-child(12)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

.side-nav>ul>li:nth-child(12)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(13).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

.side-nav>ul>li:nth-child(13)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

.side-nav>ul>li:nth-child(13)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(14).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

.side-nav>ul>li:nth-child(14)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

.side-nav>ul>li:nth-child(14)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(15).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

.side-nav>ul>li:nth-child(15)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

.side-nav>ul>li:nth-child(15)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(16).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

.side-nav>ul>li:nth-child(16)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

.side-nav>ul>li:nth-child(16)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(17).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

.side-nav>ul>li:nth-child(17)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

.side-nav>ul>li:nth-child(17)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(18).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

.side-nav>ul>li:nth-child(18)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

.side-nav>ul>li:nth-child(18)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(19).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

.side-nav>ul>li:nth-child(19)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

.side-nav>ul>li:nth-child(19)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(20).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

.side-nav>ul>li:nth-child(20)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

.side-nav>ul>li:nth-child(20)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(21).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

.side-nav>ul>li:nth-child(21)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

.side-nav>ul>li:nth-child(21)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(22).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

.side-nav>ul>li:nth-child(22)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

.side-nav>ul>li:nth-child(22)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(23).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

.side-nav>ul>li:nth-child(23)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

.side-nav>ul>li:nth-child(23)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(24).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

.side-nav>ul>li:nth-child(24)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

.side-nav>ul>li:nth-child(24)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(25).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

.side-nav>ul>li:nth-child(25)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

.side-nav>ul>li:nth-child(25)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(26).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

.side-nav>ul>li:nth-child(26)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

.side-nav>ul>li:nth-child(26)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(27).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

.side-nav>ul>li:nth-child(27)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

.side-nav>ul>li:nth-child(27)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(28).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

.side-nav>ul>li:nth-child(28)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

.side-nav>ul>li:nth-child(28)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(29).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

.side-nav>ul>li:nth-child(29)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

.side-nav>ul>li:nth-child(29)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(30).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

.side-nav>ul>li:nth-child(30)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

.side-nav>ul>li:nth-child(30)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(31).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

.side-nav>ul>li:nth-child(31)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

.side-nav>ul>li:nth-child(31)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(32).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

.side-nav>ul>li:nth-child(32)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

.side-nav>ul>li:nth-child(32)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(33).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

.side-nav>ul>li:nth-child(33)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

.side-nav>ul>li:nth-child(33)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(34).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

.side-nav>ul>li:nth-child(34)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

.side-nav>ul>li:nth-child(34)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(35).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

.side-nav>ul>li:nth-child(35)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

.side-nav>ul>li:nth-child(35)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(36).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

.side-nav>ul>li:nth-child(36)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

.side-nav>ul>li:nth-child(36)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(37).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

.side-nav>ul>li:nth-child(37)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

.side-nav>ul>li:nth-child(37)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(38).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

.side-nav>ul>li:nth-child(38)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

.side-nav>ul>li:nth-child(38)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(39).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

.side-nav>ul>li:nth-child(39)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

.side-nav>ul>li:nth-child(39)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(40).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

.side-nav>ul>li:nth-child(40)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

.side-nav>ul>li:nth-child(40)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(41).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

.side-nav>ul>li:nth-child(41)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

.side-nav>ul>li:nth-child(41)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(42).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

.side-nav>ul>li:nth-child(42)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

.side-nav>ul>li:nth-child(42)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(43).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

.side-nav>ul>li:nth-child(43)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

.side-nav>ul>li:nth-child(43)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(44).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

.side-nav>ul>li:nth-child(44)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

.side-nav>ul>li:nth-child(44)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(45).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

.side-nav>ul>li:nth-child(45)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

.side-nav>ul>li:nth-child(45)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(46).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

.side-nav>ul>li:nth-child(46)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

.side-nav>ul>li:nth-child(46)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(47).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

.side-nav>ul>li:nth-child(47)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

.side-nav>ul>li:nth-child(47)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(48).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

.side-nav>ul>li:nth-child(48)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

.side-nav>ul>li:nth-child(48)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(49).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

.side-nav>ul>li:nth-child(49)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

.side-nav>ul>li:nth-child(49)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul>li:nth-child(50).side-nav__devider {
  opacity: 0;
  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

.side-nav>ul>li:nth-child(50)>a:not(.side-menu--active) {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

.side-nav>ul>li:nth-child(50)>a.side-menu--active {
  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
}

.side-nav>ul ul li:nth-child(1)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(1 * 0.1s);
}

.side-nav>ul ul li:nth-child(2)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(2 * 0.1s);
}

.side-nav>ul ul li:nth-child(3)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(3 * 0.1s);
}

.side-nav>ul ul li:nth-child(4)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(4 * 0.1s);
}

.side-nav>ul ul li:nth-child(5)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(5 * 0.1s);
}

.side-nav>ul ul li:nth-child(6)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(6 * 0.1s);
}

.side-nav>ul ul li:nth-child(7)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(7 * 0.1s);
}

.side-nav>ul ul li:nth-child(8)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(8 * 0.1s);
}

.side-nav>ul ul li:nth-child(9)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(9 * 0.1s);
}

.side-nav>ul ul li:nth-child(10)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(10 * 0.1s);
}

.side-nav>ul ul li:nth-child(11)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(11 * 0.1s);
}

.side-nav>ul ul li:nth-child(12)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(12 * 0.1s);
}

.side-nav>ul ul li:nth-child(13)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(13 * 0.1s);
}

.side-nav>ul ul li:nth-child(14)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(14 * 0.1s);
}

.side-nav>ul ul li:nth-child(15)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(15 * 0.1s);
}

.side-nav>ul ul li:nth-child(16)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(16 * 0.1s);
}

.side-nav>ul ul li:nth-child(17)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(17 * 0.1s);
}

.side-nav>ul ul li:nth-child(18)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(18 * 0.1s);
}

.side-nav>ul ul li:nth-child(19)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(19 * 0.1s);
}

.side-nav>ul ul li:nth-child(20)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(20 * 0.1s);
}

.side-nav>ul ul li:nth-child(21)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(21 * 0.1s);
}

.side-nav>ul ul li:nth-child(22)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(22 * 0.1s);
}

.side-nav>ul ul li:nth-child(23)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(23 * 0.1s);
}

.side-nav>ul ul li:nth-child(24)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(24 * 0.1s);
}

.side-nav>ul ul li:nth-child(25)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(25 * 0.1s);
}

.side-nav>ul ul li:nth-child(26)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(26 * 0.1s);
}

.side-nav>ul ul li:nth-child(27)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(27 * 0.1s);
}

.side-nav>ul ul li:nth-child(28)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(28 * 0.1s);
}

.side-nav>ul ul li:nth-child(29)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(29 * 0.1s);
}

.side-nav>ul ul li:nth-child(30)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(30 * 0.1s);
}

.side-nav>ul ul li:nth-child(31)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(31 * 0.1s);
}

.side-nav>ul ul li:nth-child(32)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(32 * 0.1s);
}

.side-nav>ul ul li:nth-child(33)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(33 * 0.1s);
}

.side-nav>ul ul li:nth-child(34)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(34 * 0.1s);
}

.side-nav>ul ul li:nth-child(35)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(35 * 0.1s);
}

.side-nav>ul ul li:nth-child(36)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(36 * 0.1s);
}

.side-nav>ul ul li:nth-child(37)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(37 * 0.1s);
}

.side-nav>ul ul li:nth-child(38)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(38 * 0.1s);
}

.side-nav>ul ul li:nth-child(39)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(39 * 0.1s);
}

.side-nav>ul ul li:nth-child(40)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(40 * 0.1s);
}

.side-nav>ul ul li:nth-child(41)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(41 * 0.1s);
}

.side-nav>ul ul li:nth-child(42)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(42 * 0.1s);
}

.side-nav>ul ul li:nth-child(43)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(43 * 0.1s);
}

.side-nav>ul ul li:nth-child(44)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(44 * 0.1s);
}

.side-nav>ul ul li:nth-child(45)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(45 * 0.1s);
}

.side-nav>ul ul li:nth-child(46)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(46 * 0.1s);
}

.side-nav>ul ul li:nth-child(47)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(47 * 0.1s);
}

.side-nav>ul ul li:nth-child(48)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(48 * 0.1s);
}

.side-nav>ul ul li:nth-child(49)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(49 * 0.1s);
}

.side-nav>ul ul li:nth-child(50)>a {
  opacity: 0;
  transform: translateX(50px);
  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: calc(50 * 0.1s);
}

.side-nav>ul ul {
  position: relative;
  /* display: none; */
  border-radius: 0.75rem;
  background-color: #fff;
  /* background-color: rgb(255 255 255 / 0.04); */
}

.dark .side-nav>ul ul {
  background-color: transparent;
}

.side-nav>ul ul:before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
  display: block;
  border-radius: 0.75rem;
  background-color: rgb(255 255 255 / 0.3);
}

.dark .side-nav>ul ul:before {
  background-color: rgb(var(--color-darkmode-900) / 0.3);
}

.side-nav>ul ul.side-menu__sub-open {
  display: block;
}

.side-nav>ul ul .side-menu__icon:before {
  display: none;
}

.side-nav>ul ul li a:not(.side-menu--active) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
}

.dark .side-nav>ul ul li a:not(.side-menu--active) {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.side-nav>ul ul li a.side-menu--active .side-menu__icon {
  --tw-text-opacity: 1;
  /* color: rgb(var(--color-slate-700) / var(--tw-text-opacity)); */
}

.dark .side-nav>ul ul li a.side-menu--active .side-menu__icon {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.side-nav>ul ul li a.side-menu--active .side-menu__title {
  font-weight: 500;
  --tw-text-opacity: 1;
  /* color: rgb(var(--color-slate-700) / var(--tw-text-opacity)); */
}

.dark .side-nav>ul ul li a.side-menu--active .side-menu__title {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.side-nav>ul ul ul {
  position: relative;
  display: none;
  border-radius: 0.75rem;
  background-color: rgb(255 255 255 / 0.04);
}

.dark .side-nav>ul ul ul {
  background-color: transparent;
}

.side-nav>ul ul ul:before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
  display: block;
  border-radius: 0.75rem;
  background-color: rgb(255 255 255 / 0.3);
}

.dark .side-nav>ul ul ul:before {
  background-color: rgb(var(--color-darkmode-900) / 0.3);
}

.side-nav>ul>li>.side-menu.side-menu--active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.side-menu.sideActive {
  background: #676767;
  color: #fff;
}


.dark .side-nav>ul>li>.side-menu.side-menu--active {
  background-color: transparent;
}

.side-nav>ul>li>.side-menu.side-menu--active:before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  display: block;
  border-radius: 0.75rem;
  border-bottom-width: 3px;
  border-style: solid;
  border-color: rgb(0 0 0 / 0.08);
}

.dark .side-nav>ul>li>.side-menu.side-menu--active:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.side-nav>ul>li>.side-menu.side-menu--active::after {
  content: "";
  width: 20px;
  height: 80px;
  margin-right: -47px;
  animation: 0.3s active-side-menu-chevron-animation ease-in-out 0.33333s;
  animation-fill-mode: forwards;
  animation-delay: 1s;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  margin-top: auto;
  margin-bottom: auto;
  background-size: cover;
  background-repeat: no-repeat;
  opacity: 0;
}

.side-nav>ul>li>.side-menu.side-menu--active .side-menu__icon {
  z-index: 10;
  --tw-text-opacity: 1;
  /* color: rgb(var(--color-primary) / var(--tw-text-opacity)); */
}

.dark .side-nav>ul>li>.side-menu.side-menu--active .side-menu__icon {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.side-nav>ul>li>.side-menu.side-menu--active .side-menu__title {
  z-index: 10;
  font-weight: 500;
  --tw-text-opacity: 1;
  /* color: rgb(var(--color-primary) / var(--tw-text-opacity)); */
}

.dark .side-nav>ul>li>.side-menu.side-menu--active .side-menu__title {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .side-nav>ul>li>.side-menu .side-menu__icon {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.dark .side-nav>ul>li>.side-menu .side-menu__title {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open) {
  --tw-bg-opacity: 1;
  /* background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity)); */
  background-color: #ffffff;
}

.dark .side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open) {
  background-color: transparent;
}

.side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open):before {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  z-index: -1;
  display: block;
  border-radius: 0.75rem;
  border-bottom-width: 3px;
  border-style: solid;
  border-color: rgb(0 0 0 / 0.08);
}

.dark .side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open):before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

@keyframes intro-devider-animation {
  100% {
    opacity: 1;
  }
}

@keyframes intro-menu-animation {
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes intro-submenu-animation {
  100% {
    opacity: 1;
    transform: translateX(0px);
  }
}

@keyframes intro-active-menu-animation {
  100% {
    z-index: 10;
  }
}

@keyframes active-side-menu-chevron-animation {
  100% {
    margin-right: -27px;
    opacity: 1;
  }
}

.dark .side-nav>ul>li>.side-menu.side-menu--active:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
}

.breadcrumb.breadcrumb-light {
  margin-left: 2rem;
  height: 100%;
  border-left-width: 1px;
  border-color: rgb(255 255 255 / 0.08);
  padding-left: 1.5rem;
}

.breadcrumb.breadcrumb-light .active {
  color: rgb(255 255 255 / 0.7) !important;
}

@media (max-width: calc(768px - 1px)) {
  .breadcrumb.breadcrumb-light {
    margin-left: 0px;
    border-left-width: 0px;
    padding-left: 0px;
  }
}

.toastify {
  background: none;
  padding: 0px;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

@media (max-width: calc(768px - 1px)) {
  .toastify {
    max-width: calc(100% - 30px);
  }
}

.toastify .toast-close {
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  padding-right: 0.75rem;
  color: transparent;
  opacity: 1;
}

.toastify .toast-close:before {
  content: "×";
  margin-top: -0.375rem;
  display: block;
  font-size: 1.875rem;
  line-height: 2.25rem;
  font-weight: 300;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.toastify-content {
  border-radius: 0.5rem;
  border-width: 1px;
  border-color: rgb(var(--color-slate-200) / 0.6);
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  padding-left: 1.25rem;
  padding-right: 3.5rem;
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .toastify-content {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.lucide {
  stroke-width: 1.5;
}

.top-bar-boxed.top-bar-boxed--simple-menu .logo {
  width: auto;
}

.top-bar-boxed.top-bar-boxed--simple-menu .logo .logo__text {
  display: none;
}

@media (min-width: 768px) {
  .dark .top-bar-boxed.top-bar-boxed--top-menu {
    --tw-gradient-from: rgb(var(--color-darkmode-800));
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-800) / 0));
  }
}

.top-bar-boxed.top-bar-boxed--top-menu .logo {
  width: auto;
}

@media (min-width: 768px) {
  .top-bar-boxed.top-bar-boxed--top-menu .breadcrumb {
    margin-left: 2.5rem;
    padding-left: 2.5rem;
  }
}

.top-bar-boxed:not(.top-bar-boxed--top-menu) .logo__text {
  display: none;
}

@media (min-width: 1280px) {
  .top-bar-boxed:not(.top-bar-boxed--top-menu) .logo__text {
    display: block;
  }
}

.top-bar-boxed:before {
  content: "";
  position: absolute;
  right: 0px;
  bottom: 0px;
  left: 0px;
  top: 0px;
  margin-left: 1.75rem;
  margin-right: 1.75rem;
  margin-top: 0.75rem;
  display: none;
  height: 65px;
  border-radius: 0.75rem;
  background-color: rgb(var(--color-primary) / 0.3);
}

.dark .top-bar-boxed:before {
  background-color: rgb(var(--color-darkmode-600) / 0.3);
}

@media (min-width: 768px) {
  .top-bar-boxed:before {
    display: block;
  }
}

.top-bar-boxed:after {
  content: "";
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  margin-left: 0.75rem;
  margin-right: 0.75rem;
  margin-top: 1.25rem;
  display: none;
  height: 65px;
  border-radius: 0.75rem;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .top-bar-boxed:after {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

@media (min-width: 768px) {
  .top-bar-boxed:after {
    display: block;
  }
}

.mobile-menu {
  position: fixed;
  z-index: 60;
  margin-left: -2rem;
  margin-right: -2rem;
  margin-top: -1.25rem;
  margin-bottom: 1.5rem;
  width: 100%;
  border-bottom-width: 1px;
  border-color: rgb(255 255 255 / 0.08);
  background-color: rgb(var(--color-primary) / 0.9);
}

.mobile-menu:before {
  content: "";
  visibility: hidden;
  position: fixed;
  left: 0px;
  right: 0px;
  z-index: 10;
  height: 100dvh;
  width: 100%;
  background-color: rgb(0 0 0 / 0.9);
  opacity: 0;
  transition-property: opacity;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu.mobile-menu--active:before {
  content: "";
  visibility: visible;
  opacity: 1;
}

.mobile-menu.mobile-menu--active .scrollable {
  margin-left: 0px;
}

.mobile-menu.mobile-menu--active .scrollable .mobile-menu-toggler {
  visibility: visible;
  opacity: 1;
}

@media (max-width: calc(640px - 1px)) {
  .mobile-menu {
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }
}

.mobile-menu .mobile-menu-bar {
  height: 52px;
  display: flex;
  align-items: center;
  padding-left: 2rem;
  padding-right: 2rem;
}

@media (max-width: calc(640px - 1px)) {
  .mobile-menu .mobile-menu-bar {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }
}

.mobile-menu .scrollable {
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 20;
  margin-left: -100%;
  height: 100dvh;
  width: 270px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  transition-property: all;
  transition-duration: 300ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu .scrollable .mobile-menu-toggler {
  visibility: hidden;
  position: fixed;
  top: 0px;
  right: 0px;
  margin-top: 1rem;
  margin-right: 1rem;
  opacity: 0;
  transition-property: opacity;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-menu .scrollable .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  background-color: rgb(0 0 0 / 0.5);
}

.mobile-menu ul.menu__sub-open {
  display: block;
}

.mobile-menu ul li {
  cursor: pointer;
  max-width: 1280px;
  margin-left: auto;
  margin-right: auto;
  /* width: 100%; */
}

.mobile-menu ul li ul {
  margin-left: 1rem;
  margin-right: 1rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  /* display: none; */
  border-radius: 0.5rem;
  background-color: rgb(0 0 0 / 0.1);
}

.dark .mobile-menu ul li ul {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.mobile-menu ul li ul .menu {
  padding-left: 1rem;
  padding-right: 1rem;
}

.mobile-menu ul li ul ul {
  margin-left: 0px;
  margin-right: 0px;
  display: none;
  border-radius: 0.5rem;
  background-color: rgb(0 0 0 / 0.1);
}

.dark .mobile-menu ul li ul ul {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.mobile-menu .menu__devider {
  position: relative;
  height: 1px;
  width: 100%;
  background-color: rgb(255 255 255 / 0.08);
}

.mobile-menu .menu {
  height: 50px;
  display: flex;
  align-items: center;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.mobile-menu .menu .menu__title {
  margin-left: 0.75rem;
  display: flex;
  width: 100%;
  align-items: center;
}

.mobile-menu .menu .menu__title .menu__sub-icon {
  margin-left: auto;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 100ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.mobile-menu .menu .menu__title .menu__sub-icon svg {
  height: 1.25rem;
  width: 1.25rem;
}

.inbox-filter .inbox-filter__dropdown-menu {
  width: 250px;
}

.inbox-filter__dropdown-menu .dropdown-content {
  margin-left: -228px;
  width: auto;
}

.inbox .inbox__item {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  cursor: pointer;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: 200ms;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.inbox .inbox__item:hover {
  transform: scale(1.02, 1.02);
  position: relative;
  z-index: 20;
  border-radius: 0.25rem;
  border-width: 0px;
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.inbox .inbox__item.inbox__item--active {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
}

.dark .inbox .inbox__item.inbox__item--active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.inbox .inbox__item.inbox__item--active .inbox__item--sender {
  font-weight: 500;
}

.inbox .inbox__item.inbox__item--active .inbox__item--highlight {
  font-weight: 500;
}

.inbox .inbox__item.inbox__item--active .inbox__item--time {
  font-weight: 500;
}

.inbox .form-check-input {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-400) / var(--tw-border-opacity));
}

.inbox .form-check-input:checked {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.chat .chat__chat-list {
  height: 525px;
}

.chat .chat__user-list {
  height: 525px;
}

.chat .chat__box {
  height: 782px;
}

.chat .chat__box .chat__box__text-box {
  max-width: 49%;
}

@media (max-width: calc(640px - 1px)) {
  .chat .chat__box .chat__box__text-box {
    max-width: 90%;
  }
}

.chat .chat__box__input {
  height: 46px;
}

.chat-dropdown {
  margin-top: -364px;
  width: 320px;
}

.chat-dropdown .chat-dropdown__box {
  height: 364px;
}

.chat-dropdown .chat-dropdown__box .chat-dropdown__box__tabs .nav-item .nav-link.active {
  border-bottom-width: 0px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
}

.dark .chat-dropdown .chat-dropdown__box .chat-dropdown__box__tabs .nav-item .nav-link.active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.news .news__preview {
  height: 400px;
}

@media (max-width: calc(768px - 1px)) {
  .news .news__preview {
    height: 250px;
  }
}

.news p {
  text-indent: 30px;
}

.news .news__input {
  height: 69px;
}

.pricing-tabs.nav.nav-pills .nav-item .nav-link {
  border-radius: 0px;
}

.error-page img {
  width: 450px;
}

.search-result {
  width: 250px;
  visibility: hidden;
  position: absolute;
  right: 0px;
  z-index: 20;
  margin-top: 0.25rem;
  opacity: 0;
  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;
}

.search-result.show {
  transition: visibility 0s linear 0s, opacity 0.2s 0s;
  visibility: visible;
  opacity: 1;
}

.search-result.show>.search-result__content {
  margin-top: -1px;
}

.search-result.show>.search-result__content .tab-content .tab-pane {
  visibility: visible;
}

.search-result .search-result__content {
  transition: margin-top 0.2s;
  box-shadow: 0px 3px 20px #0000000b;
  position: relative;
  border-radius: 0.375rem;
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.dark .search-result .search-result__content {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.search-result .search-result__content {
  margin-top: 1.25rem;
  padding: 1.25rem;
}

.search-result .search-result__content .search-result__content__title {
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.notification-content {
  width: 350px;
}

@media (max-width: calc(640px - 1px)) {
  .notification-content {
    width: 280px;
  }
}

.notification-content .notification-content__title {
  margin-bottom: 1.25rem;
  font-weight: 500;
}

.notification-content .notification-content__box {
  padding: 1.25rem;
}

.report-maps {
  height: 310px;
}

.pos-dropdown .pos-dropdown__dropdown-menu {
  width: 265px;
}

.post .post__tabs {
  border-color: transparent;
}

.dark .post .post__tabs {
  border-color: transparent;
}

.post .post__tabs .nav-item .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.post .post__tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {
  border-color: transparent;
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));
}

.dark .post .post__tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.post .post__tabs .nav-item .nav-link.active {
  border-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.dark .post .post__tabs .nav-item .nav-link.active {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.litepicker {
  border-radius: 0.375rem;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  font-size: 0.875rem;
  line-height: 1.25rem;
  z-index: 999999 !important;
  margin-top: 7px;
  box-shadow: 0px 3px 20px #00000014;
}

@media (max-width: calc(1024px - 1px)) {
  .litepicker {
    width: 310px;
  }
}

@media (max-width: calc(640px - 1px)) {
  .litepicker {
    left: 0px !important;
    right: 0px;
    margin-left: auto;
    margin-right: auto;
  }
}

.litepicker:before {
  content: "";
  left: 9px;
  top: -7px;
  border-bottom-color: #f7f7f7;
  border-right: 7px solid transparent;
  border-left: 7px solid transparent;
  border-bottom: 7px solid #e8e8e8;
  position: absolute;
  display: inline-block;
}

.litepicker:after {
  content: "";
  left: 10px;
  top: -6px;
  border-right: 6px solid transparent;
  border-bottom: 6px solid #fff;
  border-left: 6px solid transparent;
  position: absolute;
  display: inline-block;
}

.litepicker .container__months,
.litepicker .container__footer {
  background-color: transparent;
  padding-top: 0px;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.litepicker .container__footer {
  margin: 0px;
  border-top-width: 1px;
  border-color: rgb(var(--color-slate-200) / 0.6);
  padding: 0.75rem;
}

@media (max-width: calc(1024px - 1px)) {
  .litepicker .container__footer {
    display: flex;
    flex-direction: column-reverse;
    text-align: center;
  }

  .litepicker .container__footer .preview-date-range {
    order: 1;
    margin-bottom: 0.375rem;
    display: block;
    width: 100%;
  }

  .litepicker .container__footer .button-cancel {
    width: 100% !important;
    margin-left: 0px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }

  .litepicker .container__footer .button-apply {
    width: 100% !important;
    margin-left: 0px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    margin-bottom: 0.375rem;
  }
}

.litepicker .container__footer .button-apply,
.litepicker .container__footer .button-cancel {
  margin-left: 0.25rem;
  margin-right: 0px;
  width: 5rem;
  border-radius: 0.375rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 500;
}

.litepicker .container__footer .button-apply {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.litepicker .container__footer .button-cancel {
  background-color: rgb(var(--color-slate-200) / 0.7);
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.litepicker .container__months {
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.litepicker .container__months .month-item-weekdays-row {
  margin-top: 0.75rem;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.litepicker .container__months .month-item-header {
  padding-left: 0px;
  padding-right: 0px;
  padding-bottom: 0px;
  padding-top: 0.5rem;
}

.litepicker .container__months .month-item-header .button-previous-month {
  display: flex;
  height: 2rem;
  width: 2rem;
  align-items: center;
  justify-content: center;
}

.litepicker .container__months .month-item-header .button-previous-month:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.litepicker .container__months .month-item-header .button-previous-month svg {
  transform: rotate(135deg);
  margin-right: -0.25rem;
}

.litepicker .container__months .month-item-header .button-next-month {
  display: flex;
  height: 2rem;
  width: 2rem;
  align-items: center;
  justify-content: center;
}

.litepicker .container__months .month-item-header .button-next-month:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.litepicker .container__months .month-item-header .button-next-month svg {
  transform: rotate(-45deg);
  margin-left: -0.25rem;
}

.litepicker .container__months .month-item-header .button-previous-month:hover svg,
.litepicker .container__months .month-item-header .button-previous-month svg,
.litepicker .container__months .month-item-header .button-next-month:hover svg,
.litepicker .container__months .month-item-header .button-next-month svg {
  fill: transparent;
  border: solid black;
  border-width: 0 2px 2px 0;
  border-radius: 0;
  display: inline-block;
  border-color: #4a5568;
  display: block;
  height: 0.5rem;
  width: 0.5rem;
}

.litepicker .container__months .month-item-header div>.month-item-name,
.litepicker .container__months .month-item-header div>.month-item-year {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: 15px;
  background-position: center right 0.6rem;
  border-radius: 0.375rem;
  border-width: 1px;
  background-color: transparent;
  background-repeat: no-repeat;
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
  padding-left: 0.5rem !important;
  padding-right: 2rem !important;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.litepicker .container__months .month-item-header div>.month-item-name:focus,
.litepicker .container__months .month-item-header div>.month-item-year:focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
  --tw-ring-color: transparent;
}

.litepicker .container__days .day-item {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
}

.litepicker .container__days .day-item:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.litepicker .container__days .day-item.is-today,
.litepicker .container__days .day-item.is-today:hover {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgb(var(--color-primary) / var(--tw-text-opacity));
}

.litepicker .container__days .day-item.is-start-date,
.litepicker .container__days .day-item.is-start-date:hover,
.litepicker .container__days .day-item.is-end-date,
.litepicker .container__days .day-item.is-end-date:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.litepicker .container__days .day-item.is-in-range,
.litepicker .container__days .day-item.is-in-range:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.litepicker .container__days .week-number {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

@media (max-width: calc(1024px - 1px)) {
  & :root {
    --litepicker-day-width: 35px;
  }
}

.dark .litepicker {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dark .litepicker:before,
.dark .litepicker:after {
  border-right-color: transparent;
  border-left-color: transparent;
  border-bottom-color: rgb(var(--color-darkmode-600));
}

.dark .litepicker .container__months .button-previous-month:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .litepicker .container__months .button-next-month:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .litepicker .container__months .month-item-header .button-previous-month:hover svg,
.dark .litepicker .container__months .month-item-header .button-previous-month svg,
.dark .litepicker .container__months .month-item-header .button-next-month:hover svg,
.dark .litepicker .container__months .month-item-header .button-next-month svg {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.dark .litepicker .container__months .month-item-header div>.month-item-name,
.dark .litepicker .container__months .month-item-header div>.month-item-year {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.dark .litepicker .container__days .day-item {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .litepicker .container__days .day-item:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .litepicker .container__days .day-item.is-start-date,
.dark .litepicker .container__days .day-item.is-start-date:hover,
.dark .litepicker .container__days .day-item.is-end-date,
.dark .litepicker .container__days .day-item.is-end-date:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .litepicker .container__days .day-item.is-in-range,
.dark .litepicker .container__days .day-item.is-in-range:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .litepicker .container__days .day-item.is-today,
.dark .litepicker .container__days .day-item.is-today:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .litepicker .container__footer {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.dark .litepicker .container__footer .button-cancel {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .litepicker .container__tooltip {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .litepicker .container__tooltip:before,
.dark .litepicker .container__tooltip:after {
  border-top-color: rgb(var(--color-darkmode-600));
}

.tns-outer {
  position: relative;
}

.tns-outer .tns-controls button {
  position: absolute;
  top: 0px;
  bottom: 0px;
  z-index: 10;
  margin-top: auto;
  margin-bottom: auto;
  height: 1.25rem;
  width: 1.25rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  color: transparent;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.dark .tns-outer .tns-controls button {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
}

.tns-outer .tns-controls button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));
}

.dark .tns-outer .tns-controls button:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-200) / var(--tw-bg-opacity));
}

.tns-outer .tns-controls button[data-controls="prev"] {
  left: 0px;
  margin-left: -1.5rem;
}

.tns-outer .tns-controls button[data-controls="prev"]:before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-size: 80%;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  --tw-rotate: 90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  background-position: center;
}

.tns-outer .tns-controls button[data-controls="next"] {
  right: 0px;
  margin-right: -1.5rem;
}

.tns-outer .tns-controls button[data-controls="next"]:before {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-size: 80%;
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  width: 100%;
  --tw-rotate: -90deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  background-position: center;
}

.tns-outer .tns-nav {
  margin-bottom: -1.8rem;
  position: absolute;
  bottom: 0px;
  z-index: 10;
  display: flex;
  width: 100%;
  justify-content: center;
}

.tns-outer .tns-nav button {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
  height: 0.75rem;
  width: 0.75rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.dark .tns-outer .tns-nav button {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
}

.tns-outer .tns-nav button.tns-nav-active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-500) / var(--tw-bg-opacity));
}

.dark .tns-outer .tns-nav button.tns-nav-active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-200) / var(--tw-bg-opacity));
}

.tns-outer button[data-action] {
  display: none;
}

.tns-outer .tns-visually-hidden {
  display: none;
}

.tooltip-content {
  left: 10000px;
  position: fixed;
}

.tippy-box {
  border-radius: 0.375rem;
}

.dark .tippy-box {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tippy-box>.tippy-svg-arrow {
  fill: rgb(var(--color-darkmode-300));
}

.tippy-box .tippy-content {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.tippy-popper[x-placement="left"] .tippy-roundarrow,
.tippy-popper[x-placement="left"] .tippy-arrow,
.tippy-popper[x-placement="right"] .tippy-roundarrow,
.tippy-popper[x-placement="right"] .tippy-arrow,
.tippy-popper[x-placement="left-start"] .tippy-roundarrow,
.tippy-popper[x-placement="left-start"] .tippy-arrow,
.tippy-popper[x-placement="left-end"] .tippy-roundarrow,
.tippy-popper[x-placement="left-end"] .tippy-arrow,
.tippy-popper[x-placement="right-start"] .tippy-roundarrow,
.tippy-popper[x-placement="right-start"] .tippy-arrow,
.tippy-popper[x-placement="right-end"] .tippy-roundarrow,
.tippy-popper[x-placement="right-end"] .tippy-arrow {
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
}

.tippy-popper[x-placement="top"] .tippy-roundarrow,
.tippy-popper[x-placement="top"] .tippy-arrow,
.tippy-popper[x-placement="bottom"] .tippy-roundarrow,
.tippy-popper[x-placement="bottom"] .tippy-arrow,
.tippy-popper[x-placement="top-start"] .tippy-roundarrow,
.tippy-popper[x-placement="top-start"] .tippy-arrow,
.tippy-popper[x-placement="top-end"] .tippy-roundarrow,
.tippy-popper[x-placement="top-end"] .tippy-arrow,
.tippy-popper[x-placement="bottom-start"] .tippy-roundarrow,
.tippy-popper[x-placement="bottom-start"] .tippy-arrow,
.tippy-popper[x-placement="bottom-end"] .tippy-roundarrow,
.tippy-popper[x-placement="bottom-end"] .tippy-arrow {
  left: 0px;
  right: 0px;
  margin-left: auto;
  margin-right: auto;
}

.dark .tippy-box {
  box-shadow: 0 0 20px 4px #00000026, 0 4px 80px -8px #24282f40,
    0 4px 4px -2px #5b5e6926;
}

.tabulator-print-fullscreen-hide:before {
  content: "";
  position: fixed;
  top: 0px;
  left: 0px;
  height: 100dvh;
  width: 100%;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.tabulator {
  overflow: hidden;
  border-width: 0px;
  background-color: transparent;
}

.tabulator .tabulator-header {
  border-top: 1px solid #e7eaf3;
  border-bottom: 1px solid #e7eaf3;
  background-color: transparent;
  font-weight: 500;
  color: currentColor;
  outline: none;
}

.tabulator .tabulator-header .tabulator-headers .tabulator-col {
  background-color: transparent;
  border-right: 1px solid #e7eaf3;
}

.tabulator .tabulator-header .tabulator-headers .tabulator-col:first-child {
  border-left: 1px solid #e7eaf3;
}

.tabulator .tabulator-header .tabulator-headers .tabulator-col:hover {
  /* --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity)); */
}

.tabulator .tabulator-header .tabulator-headers .tabulator-col .tabulator-col-content {
  /* padding-left: 0.5rem; */
  /* padding-right: 0.5rem; */
  /* padding-top: 0.75rem; */
  /* padding-bottom: 0.75rem; */
  padding: 0.5rem;
}

.tabulator .tabulator-header .tabulator-headers .tabulator-col .tabulator-col-content .tabulator-col-title {
  padding-right: 0px;
}

.tabulator .tabulator-header .tabulator-headers .tabulator-col .tabulator-col-content .tabulator-arrow {
  top: -3px;
  border-left-width: 5px;
  border-right-width: 5px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
}

.tabulator .tabulator-header .tabulator-headers .tabulator-col.tabulator-sortable[aria-sort="none"] .tabulator-col-content .tabulator-arrow {
  border-bottom-color: #cbd5e0;
}

.tabulator .tabulator-row {
  border-bottom: 1px solid #e7eaf3;
}

.tabulator .tabulator-row:hover,
.tabulator .tabulator-row.tabulator-row-even:hover {
  background-color: #fafafa;
}

.tabulator .tabulator-row.tabulator-row-even {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.tabulator .tabulator-row .tabulator-cell {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  /* padding-left: 1.25rem;
  padding-right: 1.25rem; */
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-right: 1px solid #e7eaf3;
}

.tabulator .tabulator-row .tabulator-cell:first-child {
  border-left: 1px solid #e7eaf3;
}

.tabulator .tabulator-row.clickData .tabulator-cell:last-child {
  border-right: none;
}

.tabulator .tabulator-row .tabulator-cell.tabulator-row-handle {
  padding-left: 0px;
  /*padding-right: 0px;*/
}

.tabulator .tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle {
  margin-right: -1.25rem;
  height: 1rem;
  width: 1rem;
  border-radius: 9999px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-400) / var(--tw-bg-opacity));
}

.tabulator .tabulator-row .tabulator-responsive-collapse {
  border-bottom-width: 0px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  padding: 0.75rem;
}

.tabulator .tabulator-row .tabulator-responsive-collapse td {
  padding: 0.5rem;
}

.tabulator .tabulator-row .tabulator-responsive-collapse td strong {
  font-weight: 500;
}

.tabulator .tabulator-footer {
  margin-top: 0.5rem;
  border-top-width: 0px;
  background-color: transparent;
  padding: 0px;
}

@media (max-width: calc(768px - 1px)) {
  .tabulator .tabulator-footer {
    white-space: normal;
  }
}

.tabulator .tabulator-footer .tabulator-paginator {
  display: flex;
  align-items: center;
}

@media (max-width: calc(768px - 1px)) {
  .tabulator .tabulator-footer .tabulator-paginator {
    display: block;
    text-align: left;
  }
}

.tabulator .tabulator-footer .tabulator-paginator>label {
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page-size {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: 15px;
  background-position: center right 0.6rem;
  margin-left: 0.5rem;
  margin-right: auto;
  appearance: none;
  border-radius: 0.375rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
  background-repeat: no-repeat;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 2rem;
}

@media (max-width: calc(768px - 1px)) {
  .tabulator .tabulator-footer .tabulator-paginator .tabulator-page-size {
    margin-right: 0.75rem;
  }
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page {
  min-width: 37px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-top: 0.2rem;
  padding-bottom: 0.2rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-weight: 500;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
}

.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page {
  transition-property: none;
}

.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:hover:not(:disabled) {
  --tw-border-opacity: 0.9;
  --tw-bg-opacity: 0.9;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:not(button) {
  text-align: center;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-color: transparent;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

@media (max-width: calc(640px - 1px)) {
  .tabulator .tabulator-footer .tabulator-paginator .tabulator-page {
    margin-right: 0px;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  font-weight: 500;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="first"],
.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="prev"],
.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="next"],
.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="last"] {
  width: 1.25rem;
  color: transparent;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="first"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="prev"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  background-size: 45%;
  background-position: center;
  background-repeat: no-repeat;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="next"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: 45%;
  background-position: center;
  background-repeat: no-repeat;
}

.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page="last"] {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-size: 50%;
  background-position: center;
  background-repeat: no-repeat;
}

.tabulator .tabulator-tableHolder .tabulator-placeholder span {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 400;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.tabulator .tabulator-loader {
  background: #ffffffbd;
}

.tabulator .tabulator-loader .tabulator-loader-msg {
  background-color: transparent;
  font-size: 1rem;
  line-height: 1.5rem;
  font-weight: 400;
}

.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-loading {
  border-width: 0px;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));
}

.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-error {
  border-width: 0px;
  --tw-text-opacity: 1;
  color: rgb(var(--color-danger) / var(--tw-text-opacity));
}

.dark .tabulator .tabulator-header {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tabulator .tabulator-header .tabulator-headers .tabulator-col:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
}

.dark .tabulator .tabulator-table {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .tabulator .tabulator-table .tabulator-row {
  border-color: transparent;
  background-color: transparent;
}

.dark .tabulator .tabulator-table .tabulator-row:hover,
.dark .tabulator .tabulator-table .tabulator-row.tabulator-row-even:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.dark .tabulator .tabulator-table .tabulator-row.tabulator-row-even {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .tabulator .tabulator-footer .tabulator-paginator>label {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page-size {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page {
  background-color: transparent;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active,
.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
}

.dark .tabulator .tabulator-loader {
  background-color: rgb(0 0 0 / 0.3);
}

.dark .tabulator .tabulator-loader .tabulator-loader-msg.tabulator-loading {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.tom-select .ts-input {
  min-height: 40px;
  padding: 7.5px 32px 7.5px 12px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-size: 18px;
  background-position: center right 0.6rem;
  border-radius: 0.25rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  background-repeat: no-repeat;
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tom-select .ts-input .item {
  line-height: 22px;
}

.tom-select .ts-input.dropdown-active {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) !important;
  background-size: 11px !important;
  background-position: center right 0.8rem !important;
  background-repeat: no-repeat !important;
}

.tom-select .ts-input input {
  height: 23px;
  font-size: 0.875rem;
  line-height: 1.25rem;
}

.tom-select.multi .ts-input {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.tom-select.multi .ts-input>div {
  margin-top: 0.125rem;
  margin-bottom: 0.125rem;
  margin-right: 0.25rem;
  border-radius: 0.25rem;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  padding-top: 0px;
  padding-bottom: 0px;
}

.tom-select.multi .ts-input>div.active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));
}

.tom-select.multi .ts-input>div.active .remove {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-400) / var(--tw-border-opacity));
}

.tom-select.plugin-remove_button .item .remove {
  margin-left: 0.5rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-300) / var(--tw-border-opacity));
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.tom-select.plugin-dropdown_input .ts-input.focus {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.tom-select .ts-dropdown {
  margin-top: -1px;
  border-top: 1px solid rgba(226, 232, 240, var(--tw-border-opacity));
  z-index: 50;
  border-radius: 0.25rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  font-size: 0.875rem;
  line-height: 1.25rem;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.tom-select .ts-dropdown .optgroup-header {
  padding: 9px 10px;
  font-weight: 500;
}

.tom-select .ts-dropdown .option {
  padding: 9px 13px;
}

.tom-select .ts-dropdown .option .highlight {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.tom-select .ts-dropdown .option.active {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.tom-select .ts-dropdown .option:hover:not(.active) {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
}

.tom-select .ts-dropdown.plugin-dropdown_input .dropdown-input-wrap {
  padding: 0.5rem;
}

.tom-select .ts-dropdown.plugin-dropdown_input .dropdown-input-wrap input {
  border-radius: 0.25rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.tom-select .ts-dropdown .dropdown-header {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.tom-select .ts-dropdown .dropdown-header .dropdown-header-close {
  margin-right: 0.125rem;
  cursor: pointer;
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
  opacity: 1;
}

.dark .tom-select .ts-input {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tom-select .ts-input.dropdown-active {
  border-color: transparent;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) !important;
}

.dark .tom-select .ts-input.dropdown-active:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .tom-select.multi .ts-input>div {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tom-select.multi .ts-input>div.active {
  background-color: rgb(var(--color-darkmode-400) / 0.8);
}

.dark .tom-select.multi .ts-input>div .remove {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.dark .tom-select.plugin-dropdown_input .ts-input.focus {
  border-color: transparent;
}

.dark .tom-select .ts-dropdown {
  border-color: rgb(var(--color-darkmode-800) / 0.8);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tom-select .ts-dropdown.plugin-dropdown_input .dropdown-input-wrap input {
  border-color: rgb(var(--color-darkmode-800) / 0.8);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dark .tom-select .ts-dropdown .optgroup-header {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.dark .tom-select .ts-dropdown .create {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tom-select .ts-dropdown .create:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dark .tom-select .ts-dropdown .option:hover:not(.active) {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tom-select .ts-dropdown .dropdown-header {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-700) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .tom-select .ts-dropdown .dropdown-header .dropdown-header-close {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dropzone {
  border-style: dashed;
  border-color: rgb(var(--color-slate-200) / 0.6);
}

.dark .dropzone {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.ck-editor,
.document-editor,
.ck-editor__editable {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.document-editor {
  display: flex;
  max-height: 700px;
  flex-flow: column nowrap;
  border-radius: var(--ck-border-radius);
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.document-editor .document-editor__toolbar {
  z-index: 1;
  border-bottom-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.document-editor .document-editor__toolbar .ck-toolbar {
  border: 0;
  border-radius: 0;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.document-editor .document-editor__toolbar .ck-toolbar .ck-icon {
  width: 16px;
}

.document-editor .document-editor__editable-container {
  overflow-y: scroll;
  padding: calc(2 * var(--ck-spacing-large));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.document-editor .document-editor__editable-container .ck-editor__editable {
  width: 15.8cm;
  margin: 0 auto;
  min-height: 21cm;
  background: white;
  padding: 1cm 2cm 2cm;
  border-radius: var(--ck-border-radius);
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.document-editor .ck-heading-dropdown .ck-list .ck-button__label {
  line-height: calc(1.7 * var(--ck-line-height-base) * var(--ck-font-size-base));
  min-width: 6em;
}

.document-editor .ck-heading-dropdown .ck-list .ck-button:not(.ck-heading_paragraph) .ck-button__label {
  transform: scale(0.8);
  transform-origin: left;
}

.document-editor .ck-content h2,
.document-editor .ck-heading-dropdown .ck-heading_heading1 .ck-button__label {
  font-size: 2.18em;
  font-weight: normal;
}

.document-editor .ck-content h2 {
  line-height: 1.37em;
  padding-top: 0.342em;
  margin-bottom: 0.142em;
}

.document-editor .ck-content h3,
.document-editor .ck-heading-dropdown .ck-heading_heading2 .ck-button__label {
  font-size: 1.75em;
  font-weight: normal;
  color: hsl(203, 100%, 50%);
}

.document-editor .ck-heading-dropdown .ck-heading_heading2.ck-on .ck-button__label {
  color: var(--ck-color-list-button-on-text);
}

.document-editor .ck-content h3 {
  line-height: 1.86em;
  padding-top: 0.171em;
  margin-bottom: 0.357em;
}

.document-editor .ck-content h4,
.document-editor .ck-heading-dropdown .ck-heading_heading3 .ck-button__label {
  font-size: 1.31em;
  font-weight: bold;
}

.document-editor .ck-content h4 {
  line-height: 1.24em;
  padding-top: 0.286em;
  margin-bottom: 0.952em;
}

.document-editor .ck-content p {
  font-size: 1em;
  line-height: 1.63em;
  padding-top: 0.5em;
  margin-bottom: 1.13em;
}

.document-editor .ck-content blockquote {
  font-family: Georgia, serif;
  margin-left: calc(2 * var(--ck-spacing-large));
  margin-right: calc(2 * var(--ck-spacing-large));
}

.ck.ck-content {
  min-height: 250px;
}

.ck.ck-content.ck-editor__editable_inline {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.ck .ck .ck-content {
  min-height: 250px;
}

.ck .ck .ck-content.ck-editor__editable_inline {
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.ck .ck.ck-reset_all,
.ck .ck.ck-reset_all * {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));
}

.ck .ck.ck-toolbar,
.ck .ck.ck-balloon-panel {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.ck .ck.ck-toolbar .ck-icon,
.ck .ck.ck-balloon-panel .ck-icon {
  width: 16px;
}

.ck .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.ck .ck.ck-button:not(.ck-disabled):hover,
.ck .cka.ck-button:not(.ck-disabled):hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
}

.dark .document-editor {
  border-color: rgb(var(--color-darkmode-900) / 0.3);
}

.dark .document-editor .document-editor__toolbar {
  border-color: rgb(var(--color-darkmode-900) / 0.2);
}

.dark .document-editor .document-editor__toolbar .ck-toolbar {
  background-color: rgb(var(--color-darkmode-900) / 0.2);
}

.dark .document-editor .document-editor__toolbar .ck-toolbar .ck-toolbar__separator {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .document-editor .document-editor__toolbar .ck-toolbar .ck-tooltip .ck-tooltip__text {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .document-editor .document-editor__toolbar .ck-toolbar .ck-tooltip .ck-tooltip__text:after {
  --tw-border-opacity: 1;
  border-bottom-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
}

.dark .document-editor .document-editor__toolbar .ck-toolbar .ck.ck-icon :not([fill]) {
  fill: rgb(var(--color-slate-300));
}

.dark .document-editor .document-editor__toolbar .ck-toolbar .ck.ck-dropdown__panel {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
}

.dark .document-editor .document-editor__toolbar .ck-toolbar .ck.ck-button.ck-on,
.dark .document-editor .document-editor__toolbar .ck-toolbar a.ck.ck-button.ck-on {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .document-editor .document-editor__editable-container {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dark .document-editor .document-editor__editable-container .ck-editor__editable {
  border-color: rgb(var(--color-darkmode-900) / 0.2);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck.ck-content.ck-editor__editable_inline {
  border-color: rgb(var(--color-darkmode-900) / 0.2);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck.ck-list {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck.ck-dropdown__panel {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck.ck.ck-input-text {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .ck.ck.ck-input-text:focus {
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.dark .ck .ck-insert-table-dropdown-grid-box {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.dark .ck.ck-reset_all,
.dark .ck.ck-reset_all * {
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity)) !important;
}

.dark .ck .ck .ck-content.ck-editor__editable_inline {
  border-color: rgb(var(--color-darkmode-900) / 0.2);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck .ck.ck-toolbar,
.dark .ck .ck.ck-balloon-panel {
  border-color: rgb(var(--color-darkmode-900) / 0.2);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.dark .ck .ck.ck-toolbar:before,
.dark .ck .ck.ck-balloon-panel:before {
  border-bottom-color: rgb(var(--color-darkmode-900) / 0.2) !important;
}

.dark .ck .ck.ck-toolbar:after,
.dark .ck .ck.ck-balloon-panel:after {
  border-bottom-color: rgb(var(--color-darkmode-900) / 0.2) !important;
}

.dark .ck .ck.ck-toolbar .ck-toolbar__separator,
.dark .ck .ck.ck-balloon-panel .ck-toolbar__separator {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck .ck.ck-toolbar .ck-tooltip .ck-tooltip__text,
.dark .ck .ck.ck-balloon-panel .ck-tooltip .ck-tooltip__text {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .ck .ck.ck-toolbar .ck-tooltip .ck-tooltip__text:after,
.dark .ck .ck.ck-balloon-panel .ck-tooltip .ck-tooltip__text:after {
  border-bottom-color: rgb(var(--color-darkmode-900) / 0.2);
}

.dark .ck .ck.ck-toolbar .ck.ck-icon :not([fill]),
.dark .ck .ck.ck-balloon-panel .ck.ck-icon :not([fill]) {
  fill: rgb(var(--color-slate-300));
}

.dark .ck .ck.ck-toolbar .ck.ck-dropdown__panel,
.dark .ck .ck.ck-balloon-panel .ck.ck-dropdown__panel {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
}

.dark .ck .ck.ck-toolbar .ck.ck-button.ck-on,
.dark .ck .ck.ck-toolbar a.ck.ck-button.ck-on,
.dark .ck .ck.ck-balloon-panel .ck.ck-button.ck-on,
.dark .ck .ck.ck-balloon-panel a.ck.ck-button.ck-on {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck .ck.ck-editor__main>.ck-editor__editable {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .ck .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {
  border-color: rgb(var(--color-darkmode-900) / 0.2);
}

.dark .ck .ck.ck-button:not(.ck-disabled):hover,
.dark .ck .cka.ck-button:not(.ck-disabled):hover {
  background-color: rgb(var(--color-darkmode-900) / 0.2);
}

.zoom-overlay {
  background-color: rgb(0 0 0 / 0.75);
}

.dark .zoom-overlay {
  background-color: rgb(0 0 0 / 0.4);
}

.dark-mode-switcher .dark-mode-switcher__toggle {
  width: 38px;
  height: 24px;
  padding: 1px;
  position: relative;
  cursor: pointer;
  border-radius: 9999px;
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.dark-mode-switcher .dark-mode-switcher__toggle:before {
  content: "";
  width: 22px;
  height: 22px;
  transition: all 0.2s ease-in-out;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 0px;
  bottom: 0px;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 9999px;
}

.dark-mode-switcher .dark-mode-switcher__toggle.dark-mode-switcher__toggle--active {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.dark-mode-switcher .dark-mode-switcher__toggle.dark-mode-switcher__toggle--active::before {
  margin-left: 13px;
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.source-preview {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}

.source-preview .hljs {
  margin-top: -20px;
  margin-bottom: -40px;
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
  font-size: 0.75rem;
  line-height: 1rem;
  line-height: 1.625;
}

.dark .source-preview .hljs {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
}

.source-preview {
  position: relative;
}

.source-preview code:before {
  content: "HTML";
  position: absolute;
  top: 0px;
  right: 0px;
  display: block;
  border-bottom-left-radius: 0.25rem;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
  --tw-bg-opacity: 0.7;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-family: Roboto;
  font-weight: 500;
}

.dark .source-preview code:before {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));
}

.source-preview code.javascript:before {
  content: "JS";
}

@media (max-width: calc(1024px - 1px)) {
  .full-calendar .fc-toolbar {
    flex-direction: column;
  }
}

.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(1) {
  order: 3;
}

.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(2) {
  order: 1;
}

.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) {
  order: 2;
}

@media (max-width: calc(1024px - 1px)) {
  .full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
}

@media (max-width: calc(640px - 1px)) {
  .full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) .fc-button-group {
    display: block;
  }
}

.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) .fc-button-group button {
  width: 5rem;
}

@media (max-width: calc(640px - 1px)) {
  .full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) .fc-button-group button {
    margin-bottom: 0.5rem;
    width: 100%;
    border-radius: 0.375rem;
  }
}

.full-calendar .fc-toolbar .fc-toolbar-title {
  font-size: 1.125rem;
  line-height: 1.75rem;
  font-weight: 500;
}

.full-calendar .fc-toolbar-chunk .fc-button-primary:first-child {
  border-top-left-radius: 0.375rem;
  border-bottom-left-radius: 0.375rem;
}

.full-calendar .fc-toolbar-chunk .fc-button-primary:last-child {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}

.full-calendar.fc-theme-standard .fc-scrollgrid,
.full-calendar.fc-theme-standard th,
.full-calendar.fc-theme-standard td,
.full-calendar.fc-theme-standard .fc-list {
  border-color: rgb(var(--color-slate-200) / 0.6);
}

.dark .full-calendar.fc-theme-standard .fc-scrollgrid,
.dark .full-calendar.fc-theme-standard th,
.dark .full-calendar.fc-theme-standard td,
.dark .full-calendar.fc-theme-standard .fc-list {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.full-calendar table {
  border-radius: 0.375rem;
}

.full-calendar table tr th .fc-scrollgrid-sync-inner {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.full-calendar .fc-daygrid-event-harness {
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.full-calendar .fc-h-event {
  border-radius: 0.375rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.full-calendar .fc-event-title-container {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  font-size: 0.75rem;
  line-height: 1rem;
}

.full-calendar .fc-daygrid-event {
  font-size: 0.75rem;
  line-height: 1rem;
}

.full-calendar .fc-daygrid-event-dot {
  margin-right: 0.5rem;
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.full-calendar .fc-daygrid-dot-event .fc-event-title {
  font-weight: 500;
}

.full-calendar .fc-col-header-cell-cushion {
  font-weight: 500;
}

@media (max-width: calc(640px - 1px)) {
  .full-calendar.fc .fc-view-harness {
    min-height: 400px !important;
  }

  .full-calendar.fc .fc-daygrid-day-frame {
    min-height: 60px !important;
  }
}

.full-calendar .fc-daygrid-more-link {
  font-size: 0.875rem;
  line-height: 1.25rem;
}

@media (max-width: calc(768px - 1px)) {
  .full-calendar .fc-daygrid-more-link {
    font-size: 10px;
    --tw-text-opacity: 1;
    color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
  }
}

@media (max-width: calc(640px - 1px)) {
  .full-calendar .fc-daygrid-more-link {
    margin-top: -0.75rem;
    display: block;
    padding-left: 0px;
    line-height: 10px;
  }
}

.full-calendar .fc-daygrid-day-bottom {
  padding-top: 0.25rem;
}

.full-calendar .fc-day-other {
  background-color: rgb(var(--color-slate-100) / 0.5);
}

.dark .full-calendar .fc-day-other {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.full-calendar .fc-button-primary {
  display: inline-block !important;
  border-color: rgb(var(--color-slate-200) / 0.6) !important;
  background-color: transparent !important;
  padding-left: 0.65em !important;
  padding-right: 0.65em !important;
  padding-top: 0.4em !important;
  padding-bottom: 0.4em !important;
  text-transform: capitalize !important;
  --tw-text-opacity: 1 !important;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity)) !important;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  border-radius: 0.375rem;
  border-width: 1px;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  font-weight: 500;
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
}

.full-calendar .fc-button-primary:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.2;
}

.dark .full-calendar .fc-button-primary {
  transition-property: none;
}

.dark .full-calendar .fc-button-primary:focus {
  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));
  --tw-ring-opacity: 0.5;
}

.full-calendar .fc-button-primary:hover:not(:disabled) {
  --tw-border-opacity: 0.9;
  --tw-bg-opacity: 0.9;
}

.full-calendar .fc-button-primary:not(button) {
  text-align: center;
}

.full-calendar .fc-button-primary:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.full-calendar .fc-button-primary .fc-icon {
  font-size: 1.2em !important;
}

.full-calendar .fc-button-primary:focus {
  --tw-shadow: 0 0 #0000 !important;
  --tw-shadow-colored: 0 0 #0000 !important;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}

.full-calendar .fc-button-primary:not(:disabled):active,
.full-calendar .fc-button-primary:not(:disabled).fc-button-active {
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity)) !important;
  --tw-text-opacity: 1 !important;
  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;
}

.full-calendar .fc-list-day-cushion {
  background-color: rgb(var(--color-slate-100) / 0.5) !important;
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
  padding-top: 0.75rem !important;
  padding-bottom: 0.75rem !important;
}

.full-calendar .fc-list-event td {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.full-calendar .fc-list-event-dot {
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity)) !important;
}

.full-calendar .fc-event-time {
  padding-left: 0.125rem;
  padding-right: 0.125rem;
  font-size: 0.75rem !important;
}

.full-calendar .fc-daygrid-more-link {
  padding-left: 0.5rem;
}

.dark .full-calendar .fc-button-primary {
  --tw-border-opacity: 1 !important;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity)) !important;
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity)) !important;
}

.dark .full-calendar .fc-list-day-cushion {
  --tw-bg-opacity: 1 !important;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity)) !important;
}

.dark .full-calendar .fc-event:hover td {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.has-error .form-control {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.dark .has-error .form-control {
  border-color: rgb(var(--color-danger) / 0.7);
}

.before\\:absolute::before {
  content: var(--tw-content);
  position: absolute;
}

.before\\:inset-0::before {
  content: var(--tw-content);
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}

.before\\:top-0::before {
  content: var(--tw-content);
  top: 0px;
}

.before\\:left-0::before {
  content: var(--tw-content);
  left: 0px;
}

.before\\:bottom-0::before {
  content: var(--tw-content);
  bottom: 0px;
}

.before\\:z-10::before {
  content: var(--tw-content);
  z-index: 10;
}

.before\\:z-\\[-1\\]::before {
  content: var(--tw-content);
  z-index: -1;
}

.before\\:ml-5::before {
  content: var(--tw-content);
  margin-left: 1.25rem;
}

.before\\:mt-5::before {
  content: var(--tw-content);
  margin-top: 1.25rem;
}

.before\\:mt-4::before {
  content: var(--tw-content);
  margin-top: 1rem;
}

.before\\:block::before {
  content: var(--tw-content);
  display: block;
}

.before\\:hidden::before {
  content: var(--tw-content);
  display: none;
}

.before\\:h-full::before {
  content: var(--tw-content);
  height: 100%;
}

.before\\:h-\\[85\\%\\]::before {
  content: var(--tw-content);
  height: 85%;
}

.before\\:h-px::before {
  content: var(--tw-content);
  height: 1px;
}

.before\\:h-\\[3px\\]::before {
  content: var(--tw-content);
  height: 3px;
}

.before\\:w-full::before {
  content: var(--tw-content);
  width: 100%;
}

.before\\:w-px::before {
  content: var(--tw-content);
  width: 1px;
}

.before\\:w-20::before {
  content: var(--tw-content);
  width: 5rem;
}

.before\\:w-\\[69\\%\\]::before {
  content: var(--tw-content);
  width: 69%;
}

.before\\:rounded-md::before {
  content: var(--tw-content);
  border-radius: 0.375rem;
}

.before\\:bg-slate-200::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));
}

.before\\:bg-slate-100::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.before\\:bg-black::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}

.before\\:bg-gradient-to-t::before {
  content: var(--tw-content);
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}

.before\\:from-black\\/90::before {
  content: var(--tw-content);
  --tw-gradient-from: rgb(0 0 0 / 0.9);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(0 0 0 / 0));
}

.before\\:to-black\\/10::before {
  content: var(--tw-content);
  --tw-gradient-to: rgb(0 0 0 / 0.1);
}

.before\\:pt-\\[100\\%\\]::before {
  content: var(--tw-content);
  padding-top: 100%;
}

.hover\\:border-slate-200:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));
}

.hover\\:bg-slate-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));
}

.hover\\:bg-white\\/5:hover {
  background-color: rgb(255 255 255 / 0.05);
}

.hover\\:bg-opacity-30:hover {
  --tw-bg-opacity: 0.3;
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-0:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.dark .dark\\:border-darkmode-400 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));
}

.dark .dark\\:border-darkmode-600 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));
}

.dark .dark\\:border-darkmode-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));
}

.dark .dark\\:border-darkmode-800 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));
}

.dark .dark\\:border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));
}

.dark .dark\\:border-darkmode-500 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-darkmode-500) / var(--tw-border-opacity));
}

.dark .dark\\:border-transparent {
  border-color: transparent;
}

.dark .dark\\:border-darkmode-100\\/40 {
  border-color: rgb(var(--color-darkmode-100) / 0.4);
}

.dark .dark\\:border-success {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-success) / var(--tw-border-opacity));
}

.dark .dark\\:border-warning {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));
}

.dark .dark\\:border-danger {
  --tw-border-opacity: 1;
  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));
}

.dark .dark\\:border-darkmode-800\\/80 {
  border-color: rgb(var(--color-darkmode-800) / 0.8);
}

.dark .dark\\:bg-darkmode-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));
}

.dark .dark\\:bg-success\\/30 {
  background-color: rgb(var(--color-success) / 0.3);
}

.dark .dark\\:bg-pending\\/30 {
  background-color: rgb(var(--color-pending) / 0.3);
}

.dark .dark\\:bg-primary\\/50 {
  background-color: rgb(var(--color-primary) / 0.5);
}

.dark .dark\\:bg-darkmode-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .dark\\:bg-darkmode-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));
}

.dark .dark\\:bg-black\\/20 {
  background-color: rgb(0 0 0 / 0.2);
}

.dark .dark\\:bg-darkmode-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));
}

.dark .dark\\:bg-transparent {
  background-color: transparent;
}

.dark .dark\\:bg-black\\/10 {
  background-color: rgb(0 0 0 / 0.1);
}

.dark .dark\\:bg-darkmode-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));
}

.dark .dark\\:bg-darkmode-400\\/70 {
  background-color: rgb(var(--color-darkmode-400) / 0.7);
}

.dark .dark\\:bg-darkmode-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-500) / var(--tw-bg-opacity));
}

.dark .dark\\:bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));
}

.dark .dark\\:bg-success\\/10 {
  background-color: rgb(var(--color-success) / 0.1);
}

.dark .dark\\:bg-primary\\/20 {
  background-color: rgb(var(--color-primary) / 0.2);
}

.dark .dark\\:text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));
}

.dark .dark\\:text-slate-300 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));
}

.dark .dark\\:text-slate-200 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));
}

.dark .dark\\:text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.dark .dark\\:text-slate-400 {
  --tw-text-opacity: 1;
  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));
}

.dark .dark\\:text-gray-300 {
  --tw-text-opacity: 1;
  color: rgb(209 213 219 / var(--tw-text-opacity));
}

.dark .before\\:dark\\:bg-darkmode-400::before {
  content: var(--tw-content);
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

.dark .dark\\:hover\\:bg-darkmode-400:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));
}

@media (min-width: 640px) {
  .sm\\:static {
    position: static;
  }

  .sm\\:absolute {
    position: absolute;
  }

  .sm\\:relative {
    position: relative;
  }

  .sm\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .sm\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .sm\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .sm\\:mx-0 {
    margin-left: 0px;
    margin-right: 0px;
  }

  .sm\\:mx-2 {
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .sm\\:-mx-8 {
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .sm\\:ml-auto {
    margin-left: auto;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:ml-0 {
    margin-left: 0px;
  }

  .sm\\:mr-auto {
    margin-right: auto;
  }

  .sm\\:mr-3 {
    margin-right: 0.75rem;
  }

  .sm\\:ml-3 {
    margin-left: 0.75rem;
  }

  .sm\\:mb-0 {
    margin-bottom: 0px;
  }

  .sm\\:mr-5 {
    margin-right: 1.25rem;
  }

  .sm\\:mt-5 {
    margin-top: 1.25rem;
  }

  .sm\\:mt-2 {
    margin-top: 0.5rem;
  }

  .sm\\:mt-10 {
    margin-top: 2.5rem;
  }

  .sm\\:ml-40 {
    margin-left: 10rem;
  }

  .sm\\:mr-28 {
    margin-right: 7rem;
  }

  .sm\\:mr-40 {
    margin-right: 10rem;
  }

  .sm\\:mr-20 {
    margin-right: 5rem;
  }

  .sm\\:mr-0 {
    margin-right: 0px;
  }

  .sm\\:mr-2 {
    margin-right: 0.5rem;
  }

  .sm\\:ml-20 {
    margin-left: 5rem;
  }

  .sm\\:mr-4 {
    margin-right: 1rem;
  }

  .sm\\:ml-1 {
    margin-left: 0.25rem;
  }

  .sm\\:ml-2 {
    margin-left: 0.5rem;
  }

  .sm\\:mr-6 {
    margin-right: 1.5rem;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:flex {
    display: flex;
  }

  .sm\\:grid {
    display: grid;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-10 {
    height: 2.5rem;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-5 {
    height: 1.25rem;
  }

  .sm\\:h-24 {
    height: 6rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:w-10 {
    width: 2.5rem;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-5 {
    width: 1.25rem;
  }

  .sm\\:w-56 {
    width: 14rem;
  }

  .sm\\:w-72 {
    width: 18rem;
  }

  .sm\\:w-52 {
    width: 13rem;
  }

  .sm\\:w-60 {
    width: 15rem;
  }

  .sm\\:w-full {
    width: 100%;
  }

  .sm\\:w-64 {
    width: 16rem;
  }

  .sm\\:w-3\\/4 {
    width: 75%;
  }

  .sm\\:w-40 {
    width: 10rem;
  }

  .sm\\:w-24 {
    width: 6rem;
  }

  .sm\\:w-20 {
    width: 5rem;
  }

  .sm\\:w-32 {
    width: 8rem;
  }

  .sm\\:w-16 {
    width: 4rem;
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .sm\\:items-end {
    align-items: flex-end;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:justify-end {
    justify-content: flex-end;
  }

  .sm\\:gap-10 {
    gap: 2.5rem;
  }

  .sm\\:gap-6 {
    gap: 1.5rem;
  }

  .sm\\:overflow-x-visible {
    overflow-x: visible;
  }

  .sm\\:whitespace-normal {
    white-space: normal;
  }

  .sm\\:border-0 {
    border-width: 0px;
  }

  .sm\\:border-t-0 {
    border-top-width: 0px;
  }

  .sm\\:border-l {
    border-left-width: 1px;
  }

  .sm\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .sm\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .sm\\:py-4 {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:px-28 {
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .sm\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:px-20 {
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .sm\\:py-20 {
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:px-16 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:px-8 {
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .sm\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:pt-6 {
    padding-top: 1.5rem;
  }

  .sm\\:pt-0 {
    padding-top: 0px;
  }

  .sm\\:pl-5 {
    padding-left: 1.25rem;
  }

  .sm\\:pb-20 {
    padding-bottom: 5rem;
  }

  .sm\\:pt-20 {
    padding-top: 5rem;
  }

  .sm\\:pb-0 {
    padding-bottom: 0px;
  }

  .sm\\:text-left {
    text-align: left;
  }

  .sm\\:text-right {
    text-align: right;
  }

  .sm\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 768px) {
  .md\\:fixed {
    position: fixed;
  }

  .md\\:inset-x-0 {
    left: 0px;
    right: 0px;
  }

  .md\\:top-0 {
    top: 0px;
  }

  .md\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .md\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:row-start-auto {
    grid-row-start: auto;
  }

  .md\\:-mx-0 {
    margin-left: -0px;
    margin-right: -0px;
  }

  .md\\:ml-0 {
    margin-left: 0px;
  }

  .md\\:ml-auto {
    margin-left: auto;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:flex {
    display: flex;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:h-\\[65px\\] {
    height: 65px;
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:border-t-0 {
    border-top-width: 0px;
  }

  .md\\:border-l {
    border-left-width: 1px;
  }

  .md\\:border-r {
    border-right-width: 1px;
  }

  .md\\:border-l-0 {
    border-left-width: 0px;
  }

  .md\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .md\\:bg-gradient-to-b {
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
  }

  .md\\:from-slate-100 {
    --tw-gradient-from: rgb(var(--color-slate-100));
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-slate-100) / 0));
  }

  .md\\:to-transparent {
    --tw-gradient-to: transparent;
  }

  .md\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .md\\:px-10 {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:pl-0 {
    padding-left: 0px;
  }

  .md\\:pt-10 {
    padding-top: 2.5rem;
  }

  .md\\:pt-15 {
    padding-top: 3rem;
  }

  .dark .dark\\:md\\:from-darkmode-700 {
    --tw-gradient-from: rgb(var(--color-darkmode-700));
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-700) / 0));
  }
}

@media (min-width: 1024px) {
  .lg\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .lg\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:row-start-3 {
    grid-row-start: 3;
  }

  .lg\\:mx-auto {
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:mt-5 {
    margin-top: 1.25rem;
  }

  .lg\\:mt-6 {
    margin-top: 1.5rem;
  }

  .lg\\:mr-20 {
    margin-right: 5rem;
  }

  .lg\\:mt-0 {
    margin-top: 0px;
  }

  .lg\\:ml-auto {
    margin-left: auto;
  }

  .lg\\:ml-5 {
    margin-left: 1.25rem;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:ml-8 {
    margin-left: 2rem;
  }

  .lg\\:mt-3 {
    margin-top: 0.75rem;
  }

  .lg\\:mr-1 {
    margin-right: 0.25rem;
  }

  .lg\\:ml-2 {
    margin-left: 0.5rem;
  }

  .lg\\:mr-auto {
    margin-right: auto;
  }

  .lg\\:ml-0 {
    margin-left: 0px;
  }

  .lg\\:ml-4 {
    margin-left: 1rem;
  }

  .lg\\:block {
    display: block;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:h-auto {
    height: auto;
  }

  .lg\\:h-32 {
    height: 8rem;
  }

  .lg\\:h-12 {
    height: 3rem;
  }

  .lg\\:w-auto {
    width: auto;
  }

  .lg\\:w-2\\/4 {
    width: 50%;
  }

  .lg\\:w-64 {
    width: 16rem;
  }

  .lg\\:w-40 {
    width: 10rem;
  }

  .lg\\:w-32 {
    width: 8rem;
  }

  .lg\\:w-56 {
    width: 14rem;
  }

  .lg\\:w-12 {
    width: 3rem;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:flex-nowrap {
    flex-wrap: nowrap;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:justify-start {
    justify-content: flex-start;
  }

  .lg\\:justify-end {
    justify-content: flex-end;
  }

  .lg\\:justify-center {
    justify-content: center;
  }

  .lg\\:overflow-visible {
    overflow: visible;
  }

  .lg\\:border-0 {
    border-width: 0px;
  }

  .lg\\:border-t-0 {
    border-top-width: 0px;
  }

  .lg\\:border-l {
    border-left-width: 1px;
  }

  .lg\\:border-b-0 {
    border-bottom-width: 0px;
  }

  .lg\\:border-r {
    border-right-width: 1px;
  }

  .lg\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:py-3 {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:px-5 {
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:pb-0 {
    padding-bottom: 0px;
  }

  .lg\\:pl-5 {
    padding-left: 1.25rem;
  }

  .lg\\:pb-20 {
    padding-bottom: 5rem;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:text-left {
    text-align: left;
  }

  .lg\\:text-center {
    text-align: center;
  }

  .lg\\:text-right {
    text-align: right;
  }

  .lg\\:text-justify {
    text-align: justify;
  }

  .lg\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .before\\:lg\\:block::before {
    content: var(--tw-content);
    display: block;
  }
}

@media (min-width: 1280px) {
  .xl\\:absolute {
    position: absolute;
  }

  .xl\\:sticky {
    position: sticky;
  }

  .xl\\:z-auto {
    z-index: auto;
  }

  .xl\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .xl\\:col-span-8 {
    grid-column: span 8 / span 8;
  }

  .xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .xl\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .xl\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .xl\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:col-start-1 {
    grid-column-start: 1;
  }

  .xl\\:col-start-10 {
    grid-column-start: 10;
  }

  .xl\\:row-start-1 {
    grid-row-start: 1;
  }

  .xl\\:row-start-2 {
    grid-row-start: 2;
  }

  .xl\\:row-start-auto {
    grid-row-start: auto;
  }

  .xl\\:mx-5 {
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .xl\\:mx-6 {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .xl\\:my-0 {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  .xl\\:ml-auto {
    margin-left: auto;
  }

  .xl\\:mt-2 {
    margin-top: 0.5rem;
  }

  .xl\\:mt-0 {
    margin-top: 0px;
  }

  .xl\\:-mt-5 {
    margin-top: -1.25rem;
  }

  .xl\\:mt-8 {
    margin-top: 2rem;
  }

  .xl\\:ml-20 {
    margin-left: 5rem;
  }

  .xl\\:mr-3 {
    margin-right: 0.75rem;
  }

  .xl\\:mt-24 {
    margin-top: 6rem;
  }

  .xl\\:mr-0 {
    margin-right: 0px;
  }

  .xl\\:ml-6 {
    margin-left: 1.5rem;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:grid {
    display: grid;
  }

  .xl\\:hidden {
    display: none;
  }

  .xl\\:h-auto {
    height: auto;
  }

  .xl\\:min-h-0 {
    min-height: 0px;
  }

  .xl\\:w-3\\/5 {
    width: 60%;
  }

  .xl\\:w-auto {
    width: auto;
  }

  .xl\\:w-32 {
    width: 8rem;
  }

  .xl\\:w-\\[180px\\] {
    width: 180px;
  }

  .xl\\:flex-initial {
    flex: 0 1 auto;
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:items-start {
    align-items: flex-start;
  }

  .xl\\:overflow-y-auto {
    overflow-y: auto;
  }

  .xl\\:bg-transparent {
    background-color: transparent;
  }

  .xl\\:p-0 {
    padding: 0px;
  }

  .xl\\:px-0 {
    padding-left: 0px;
    padding-right: 0px;
  }

  .xl\\:py-0 {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .xl\\:pb-0 {
    padding-bottom: 0px;
  }

  .xl\\:pb-16 {
    padding-bottom: 4rem;
  }

  .xl\\:text-left {
    text-align: left;
  }

  .xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .xl\\:shadow-none {
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  }

  .xl\\:before\\:block::before {
    content: var(--tw-content);
    display: block;
  }
}

@media (min-width: 1536px) {
  .\\32xl\\:z-10 {
    z-index: 10;
  }

  .\\32xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .\\32xl\\:col-span-9 {
    grid-column: span 9 / span 9;
  }

  .\\32xl\\:col-span-12 {
    grid-column: span 12 / span 12;
  }

  .\\32xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .\\32xl\\:col-span-10 {
    grid-column: span 10 / span 10;
  }

  .\\32xl\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .\\32xl\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .\\32xl\\:col-start-auto {
    grid-column-start: auto;
  }

  .\\32xl\\:row-start-auto {
    grid-row-start: auto;
  }

  .\\32xl\\:mt-8 {
    margin-top: 2rem;
  }

  .\\32xl\\:mt-6 {
    margin-top: 1.5rem;
  }

  .\\32xl\\:mt-24 {
    margin-top: 6rem;
  }

  .\\32xl\\:mt-0 {
    margin-top: 0px;
  }

  .\\32xl\\:ml-16 {
    margin-left: 4rem;
  }

  .\\32xl\\:-ml-20 {
    margin-left: -5rem;
  }

  .\\32xl\\:mb-0 {
    margin-bottom: 0px;
  }

  .\\32xl\\:-mt-1\\.5 {
    margin-top: -0.375rem;
  }

  .\\32xl\\:-mt-1 {
    margin-top: -0.25rem;
  }

  .\\32xl\\:mr-auto {
    margin-right: auto;
  }

  .\\32xl\\:-mt-8 {
    margin-top: -2rem;
  }

  .\\32xl\\:flex {
    display: flex;
  }

  .\\32xl\\:h-56 {
    height: 14rem;
  }

  .\\32xl\\:w-14 {
    width: 3.5rem;
  }

  .\\32xl\\:w-52 {
    width: 13rem;
  }

  .\\32xl\\:w-4\\/6 {
    width: 66.666667%;
  }

  .\\32xl\\:w-2\\/3 {
    width: 66.666667%;
  }

  .\\32xl\\:w-full {
    width: 100%;
  }

  .\\32xl\\:flex-none {
    flex: none;
  }

  .\\32xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .\\32xl\\:justify-center {
    justify-content: center;
  }

  .\\32xl\\:gap-x-0 {
    column-gap: 0px;
  }

  .\\32xl\\:border-l {
    border-left-width: 1px;
  }

  .\\32xl\\:bg-transparent {
    background-color: transparent;
  }

  .\\32xl\\:p-0 {
    padding: 0px;
  }

  .\\32xl\\:px-6 {
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .\\32xl\\:pl-6 {
    padding-left: 1.5rem;
  }

  .\\32xl\\:pt-0 {
    padding-top: 0px;
  }

  .\\32xl\\:pl-4 {
    padding-left: 1rem;
  }

  .\\32xl\\:pl-2\\.5 {
    padding-left: 0.625rem;
  }

  .\\32xl\\:pl-2 {
    padding-left: 0.5rem;
  }

  .\\32xl\\:text-base {
    font-size: 1rem;
    line-height: 1.5rem;
  }

  .\\32xl\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .\\32xl\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .\\32xl\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .\\32xl\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .\\32xl\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }

  .\\32xl\\:leading-5 {
    line-height: 1.25rem;
  }

  .\\32xl\\:text-success {
    --tw-text-opacity: 1;
    color: rgb(var(--color-success) / var(--tw-text-opacity));
  }
}


/**/
.multiselect__container {
  z-index: 9999;

}

.multiselect__show_search_box {
  flex-basis: unset !important;
  display: block;
  width: 90%;
  align-items: center;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 1px 3px 0 #d1d1d2, 0 0 0 1px #d1d1d2;
  box-sizing: border-box;
  display: flex;
  font-family: Arial, Helvetica, sans-serif;
  min-height: 36px;
  padding: 4px 8px 0 8px;
  position: relative;
}

.d_none {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./src/Pages/css/app.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;EAWE;AACF;;EAEE;AACF;;;CAGC;AACD;;;EAGE,sBAAsB;EACtB,MAAM;EACN,eAAe;EACf,MAAM;EACN,mBAAmB;EACnB,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;;CAKC;AACD;EACE,gBAAgB;EAChB,MAAM;EACN,8BAA8B;EAC9B,MAAM;EAEN,MAAM;EAEN,WAAW;EACX,MAAM;EACN,4NAA4N;EAC5N,MAAM;AACR;;AAEA;;;CAGC;AACD;EACE,SAAS;EACT,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;;;CAIC;AACD;EACE,SAAS;EACT,MAAM;EACN,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;;CAEC;AACD;;;;;;EAME,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;CAEC;AACD;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;;CAEC;AACD;;EAEE,mBAAmB;AACrB;;AAEA;;;CAGC;AACD;;;;EAIE,+GAA+G;EAC/G,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,cAAc;AAChB;;AAEA;;CAEC;AACD;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;;;CAIC;AACD;EACE,cAAc;EACd,MAAM;EACN,qBAAqB;EACrB,MAAM;EACN,yBAAyB;EACzB,MAAM;AACR;;AAEA;;;;CAIC;AACD;;;;;EAKE,oBAAoB;EACpB,MAAM;EACN,eAAe;EACf,MAAM;EACN,oBAAoB;EACpB,MAAM;EACN,cAAc;EACd,MAAM;EACN,SAAS;EACT,MAAM;EACN,UAAU;EACV,MAAM;AACR;;AAEA;;CAEC;AACD;;EAEE,oBAAoB;AACtB;;AAEA;;;CAGC;AACD;;;;EAIE,0BAA0B;EAC1B,MAAM;EACN,6BAA6B;EAC7B,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,aAAa;AACf;;AAEA;;CAEC;AACD;EACE,gBAAgB;AAClB;;AAEA;;CAEC;AACD;EACE,wBAAwB;AAC1B;;AAEA;;CAEC;AACD;;EAEE,YAAY;AACd;;AAEA;;;CAGC;AACD;EACE,6BAA6B;EAC7B,MAAM;EACN,oBAAoB;EACpB,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,wBAAwB;AAC1B;;AAEA;;;CAGC;AACD;EACE,0BAA0B;EAC1B,MAAM;EACN,aAAa;EACb,MAAM;AACR;;AAEA;;CAEC;AACD;EACE,kBAAkB;AACpB;;AAEA;;CAEC;AACD;;;;;;;;;;;;;EAaE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;;CAEC;AACD;EACE,gBAAgB;AAClB;;AAEA;;;CAGC;;AAiBD;;EAEE,UAAU;EACV,MAAM;EACN,cAAc;EACd,MAAM;AACR;;AAEA;;CAEC;AACD;;EAEE,eAAe;AACjB;;AAEA;;CAEC;AACD;EACE,eAAe;AACjB;;AAEA;;;;CAIC;AACD;;;;;;;;EAQE,cAAc;EACd,MAAM;EACN,sBAAsB;EACtB,MAAM;AACR;;AAEA;;CAEC;AACD;;EAEE,eAAe;EACf,YAAY;AACd;;AAEA;;CAEC;AACD;EACE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;EAiBE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;;;;;;;;;;;;EAeE,8BAA8B;EAC9B,mBAAmB;EACnB;;;KAGG;EACH,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,2GAA2G;EAC3G,yGAAyG;EACzG,iFAAiF;EACjF,qBAAqB;AACvB;;AAcA;;EAEE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;;;EASE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,yDAAmP;EACnP,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;;EAIE,gBAAgB;EAChB,UAAU;EACV,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,yBAAyB;EAGzB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,8BAA8B;EAC9B,mBAAmB;EACnB;;;KAGG;EACH,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,2GAA2G;EAC3G,yGAAyG;EACzG,iFAAiF;AACnF;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yDAAsQ;AACxQ;;AAEA;EACE,yDAAoK;AACtK;;AAEA;;;;EAIE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,yDAAuO;EACvO,yBAAyB;EACzB,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,sCAAsC;EACtC,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,sCAAsC;EACtC,kCAAkC;EAClC,2BAA2B;EAC3B,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;;;EAME,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;EAIE,8BAA8B;EAC9B,mBAAmB;EACnB;;;KAGG;EACH,2BAA2B;EAC3B,4BAA4B;EAC5B,wBAAwB;EACxB,2GAA2G;EAC3G,yGAAyG;EACzG,iFAAiF;EACjF,qBAAqB;AACvB;;AAEA;EACE,yDAAmP;EACnP,wCAAwC;EACxC,4BAA4B;EAC5B,4BAA4B;EAC5B,qBAAqB;EACrB,iCAAiC;EACjC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,+CAA+C;EAC/C,mDAAmD;EACnD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,kBAAkB;EAClB,iEAAiE;EACjE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,kBAAkB;EAClB,+DAA+D;EAC/D,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA,uBAAuB;AACvB;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,oEAAoE;EACpE,oBAAoB;EACpB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;EACtD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,iEAAiE;EACjE,yBAAyB;EACzB,iEAAiE;EACjE,oBAAoB;EACpB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,iEAAiE;EACjE,wBAAwB;AAC1B;;AAEA;EACE,+DAA+D;EAC/D,yBAAyB;EACzB,+DAA+D;EAC/D,oBAAoB;EACpB,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;EACtD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA,mBAAmB;AACnB;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;EAEvG,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,+CAA+C;EAC/C,mDAAmD;EACnD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,kBAAkB;EAClB,iEAAiE;EACjE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,kBAAkB;EAClB,+DAA+D;EAC/D,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD;AACxD;;AAEA,oBAAoB;AACpB;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,+CAA+C;EAC/C,mDAAmD;EACnD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,kBAAkB;EAClB,iEAAiE;EACjE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,kBAAkB;EAClB,+DAA+D;EAC/D,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,mDAAmD;EACnD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,kBAAkB;EAClB,iEAAiE;EACjE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,kBAAkB;EAClB,+DAA+D;EAC/D,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,mDAAmD;EACnD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,kBAAkB;EAClB,iEAAiE;EACjE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,kBAAkB;EAClB,+DAA+D;EAC/D,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;EACvG,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,sBAAsB;EACtB,uDAAuD;EACvD,kBAAkB;EAClB,uDAAuD;EACvD,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,kBAAkB;EAClB,wDAAwD;EACxD,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;EACxD,kBAAkB;EAClB,wDAAwD;EACxD,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;EACvD,kBAAkB;EAClB,uDAAuD;EACvD,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA,mBAAmB;AACnB;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;EAClD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;EACjE,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;EACtB,+DAA+D;EAC/D,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,oBAAoB;AACtB;;AAEA,uBAAuB;AACvB;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,oEAAoE;EACpE,oBAAoB;EACpB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;EACtD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;AACxD;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kEAAkE;EAClE,yBAAyB;EACzB,kEAAkE;EAClE,oBAAoB;EACpB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,iEAAiE;EACjE,yBAAyB;EACzB,iEAAiE;EACjE,oBAAoB;EACpB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,iEAAiE;EACjE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,+DAA+D;EAC/D,yBAAyB;EACzB,+DAA+D;EAC/D,oBAAoB;EACpB,oBAAoB;EACpB,sDAAsD;AACxD;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;EACtD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,sDAAsD;AACxD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,2DAA2D;EAC3D,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yDAAyD;EACzD,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EAEf,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yDAAm5B;AACr5B;;AAEA;EACE,yDAAwhC;AAC1hC;;AAEA;EACE,yDAAo9B;AACt9B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;;;;;;;;;;EAeE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,oEAAoE;EACpE,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;EACxB,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,oEAAoE;EACpE,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;EACxB,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,gCAAgC;EAChC,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,oEAAoE;EACpE,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;EAEvG,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;EAC9B,eAAe;AACjB;;AAUA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;EACxB,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,yBAAyB;AAC3B;;AAUA;EACE,wCAAwC;AAC1C;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;;EAEE,yBAAyB;EACzB,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,yBAAyB;AACzB;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,SAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,oEAAoE;EACpE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,4BAA4B;EAC5B,oBAAoB;EACpB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;EAEvG,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;EACxB,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EAEX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,oEAAoE;EACpE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,2DAA2D;EAC3D,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,kDAAkD;EAClD,sDAAsD;EACtD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sDAAsD;EACtD,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,8CAA8C;EAE9C,8BAA8B;AAChC;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE;EACF;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,eAAe;AACjB;;AAEA;EACE,qEAAqE;EACrE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,yDAAyD;EACzD,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAYA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;EAEvG,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,2DAA2D;EAC3D,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;AACzG;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,kEAAkE;EAClE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;;EAEE,UAAU;EACV,WAAW;EACX,6BAA6B;AAC/B;AACA;;EAEE,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;EAChC,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,gCAAgC;EAChC,kBAAkB;EAClB,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,4EAA4E;EAC5E,6EAA6E;EAC7E,2EAA2E;EAC3E,sBAAsB;EACtB,8EAA8E;EAC9E,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;EAClE,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;EAClE,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,yEAAyE;EACzE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EAGd,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;EACxB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sDAAsD;EACtD,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;EAEE,8CAA8C;AAChD;;AAEA;EAEE,8CAA8C;AAChD;;AAQA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,+LAA+L;EAC/L,eAAe;EAEf,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+LAA+L;EAC/L,gFAAgF;EAChF,oGAAoG;EACpG,uGAAuG;AACzG;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,+LAA+L;AACjM;;AAEA;EACE,mBAAmB;EACnB,+LAA+L;AACjM;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,+LAA+L;AACjM;;AAEA;EACE,+LAA+L;AACjM;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;AACzG;;AAEA;EACE,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,+EAA+E;EAC/E,mGAAmG;EACnG,uGAAuG;AACzG;;AAEA;EACE,0EAA0E;EAC1E,8FAA8F;EAC9F,uGAAuG;AACzG;;AAEA;EACE,iLAAiL;AACnL;;AAEA;EAEE,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;;;;;;;;;;;IAWI;AACJ,mBAAmB;AACnB;EACE,sBAAsB;EACtB,WAAW;EACX,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;EACtB,6BAA6B;EAC7B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,mBAAmB;AACnB;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;IAWI;AACJ,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;wGACsG;EACtG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;wGACsG;EACtG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;wGACsG;EACtG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;wGACsG;EACtG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;wGACsG;EACtG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;wGACsG;EACtG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;yGACuG;EACvG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;qGACmG;EACnG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;oGACkG;EAClG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;kGACgG;EAChG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;gGAC8F;EAC9F;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;oGACkG;EAClG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;oGACkG;EAClG;;kBAEgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;eACa;AACf;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG,4DAA4D;AAC9D;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;sGACoG;EACpG;iDAC+C;AACjD;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB;oGACkG;EAClG;;kBAEgB;AAClB;;AAEA;;;;;;;IAOI;AACJ,kBAAkB;AAClB,oBAAoB;AACpB,oBAAoB;AACpB;;;;;;;IAOI;AACJ;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,yDAAwV;AAC1V;;AAEA;EACE,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,yDAA2V;EAC3V,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,yDAAwV;AAC1V;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,2BAA2B;EAE3B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kBAAkB;EAClB,4BAA4B;EAE5B,sDAAsD;EAEtD,6BAA6B;EAE7B,gCAAgC;AAClC;;AASA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AASA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,SAAY;EACd;;EAEA;;;;;;IAME,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,+DAA+D;EAC/D,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,+DAA+D;EAC/D,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,uEAAuE;EACvE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,uEAAuE;EACvE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;;;CAIC;AACD;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV;AACF;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,uBAAuB;EACvB,yBAAyB;EACzB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAS;EACT,OAAO;EACP,uBAAuB;EACvB,4BAA4B;EAC5B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,2BAA2B;EAC3B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE,cAAc;EACd,+HAA+H;EAC/H;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,SAAS;EACT;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;;;;;EAME;AACF;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,uFAAuF;EACvF,qDAAqD;EACrD,eAAe;EACf,UAAU;EACV,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EAER,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IAGR,sBAAsB;EACxB;AACF;;AAoBA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;;IAEE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;AACF;;AAcA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAgBA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,eAAe;EACf,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,0CAA0C;EAC1C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,6DAA6D;AAC/D;;AAEA;EACE,UAAU;EAEV,sDAAsD;AACxD;;AAEA;;EAEE,oBAAoB;EACpB,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EAEE,iCAAiC;AACnC;;AAEA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kDAAkD;EAClD,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,mCAAmC;AACrC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,wDAAwD;EACxD,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0BAA0B;EAC1B,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;8BAC4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EAEE,yBAAyB;EAEzB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,8BAA8B;EAC9B,0BAA0B;EAC1B,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EAEnB,iBAAiB;EACjB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,4BAA4B;EAC5B,gBAAgB;EAChB,8BAA8B;EAC9B,6BAA6B;EAC7B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,iBAAiB;EACjB,OAAO;EACP,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;AACb;;AAEA;EACE,MAAM;EACN,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,yBAAyB;EACzB,oBAAoB;EACpB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;EAClC,+BAA+B;EAC/B,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,mCAAmC;EACnC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;EACpC,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;EAaE;AACF;EACE,8BAA8B;EAC9B,8BAA8B;EAC9B,0CAA0C;EAC1C,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,sBAAsB;EACtB,0BAA0B;EAC1B,kCAAkC;EAClC,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,cAAc;AAChB;;AAUA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,8BAA8B;EAC9B,0BAA0B;EAC1B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,yBAAyB;EACzB,yBAAyB;EACzB,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EAGpC,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,sBAAsB;EACtB,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;EAGE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;EAGE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qDAAqD;EAErD,6CAA6C;AAC/C;;AAYA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,wBAAwB;EACxB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB;AACF;;AAEA;EACE,UAAU;EACV;AACF;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B;AACF;;AAEA;;EAEE,UAAU;EACV,wBAAwB;EACxB;AACF;;AAEA;EACE;AACF;;AAEA;;EAEE;AACF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ;AACF;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,UAAU;EACV,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mGAAmG;EACnG,WAAW;EACX,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,0CAA0C;EAC1C,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;EAEE,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EAGpB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE,0DAA0D;EAC1D,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;;;;;;EAOE;AACF;EACE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE;IACE,kBAAkB;IAClB,oEAAoE;EACtE;AACF;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,2DAA2D;EAC3D,mCAAmC;EACnC,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,kBAAkB;IAClB,kEAAkE;EACpE;;EAEA;IACE,kBAAkB;IAClB,uEAAuE;EACzE;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,+LAA+L;EAC/L,mBAAmB;EACnB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,+LAA+L;EAC/L,mBAAmB;EACnB,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,iEAAiE;AACnE;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,qEAAqE;EACrE,wBAAwB;EACxB,yFAAyF;EAEzF,6BAA6B;AAC/B;;AAfA;AAAA;EAaE,iHAAiH;AAEnH;AAAA;;AAEA;EACE,kDAAkD;EAClD,uGAAuG;AACzG;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,WAAW;EACX,oEAAoE;EACpE,wBAAwB;EACxB,yFAAyF;EAEzF,6BAA6B;AAC/B;;AAdA;AAAA;EAYE,iHAAiH;AAEnH;AAAA;;AAEA;EACE,kDAAkD;EAClD,uGAAuG;AACzG;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,oEAAoE;EACpE,mBAAmB;EACnB,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;EACvG,0BAA0B;EAC1B,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,mEAAmE;AACrE;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,2BAA2B;EAE3B,iEAAiE;EAEjE,6BAA6B;EAE7B,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,uEAAuE;EACvE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EAE3B,iEAAiE;EAEjE,6BAA6B;EAE7B,qBAAqB;EACrB,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,oEAAoE;EACpE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,8BAA8B;IAC9B,uGAAuG;EACzG;AACF;;AASA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,2BAA2B;EAE3B,iEAAiE;EAEjE,6BAA6B;EAE7B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,oEAAoE;EACpE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE,SAAW;AACb;;AASA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,SAAY;EACZ,kBAAkB;EAClB,oEAAoE;EACpE,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,oBAAoB;IACpB,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;IACrB,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAE3B,6DAA6D;EAE7D,6BAA6B;EAE7B,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE;IACE,oBAAoB;IACpB,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,+LAA+L;AACjM;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,+LAA+L;AACjM;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oBAAoB;EAEpB,sEAAsE;EAEtE,6BAA6B;EAE7B,mBAAmB;EACnB,0DAAob;EACpb,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,+LAA+L;EAC/L,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE;IACE,oBAAoB;IACpB,yDAAyD;EAC3D;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE;IACE,oBAAoB;IACpB,2DAA2D;EAC7D;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EAEX,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,oEAAoE;EACpE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,cAAc;EACd,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AASA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAQA;EACE;IACE,WAAW;EACb;AACF;;AASA;EACE;IACE,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE,0DAAob;AACtb;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EAErB,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EAEV,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,yDAAyD;EAEzD,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EAEE,gEAAgE;EAEhE,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,2BAA2B;EAE3B,4DAA4D;EAE5D,6BAA6B;EAE7B,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,iEAAiE;AACnE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,wCAAwC;AAC1C;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;;AAGA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mBAAmB;EAEnB,uEAAuE;EAEvE,6BAA6B;EAE7B,mBAAmB;EACnB,0DAAob;EACpb,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,+DAA+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,+DAA+D;AACjE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,0EAA0E;EAC1E,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAQA;EACE;IACE,UAAU;EACZ;AACF;;AASA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AASA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAQA;EACE;IACE,WAAW;EACb;AACF;;AASA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,0DAAob;AACtb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,qCAAqC;EACrC,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,2DAA2D;EAC3D,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;AACzG;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,+CAA+C;EAC/C,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,gFAAgF;EAChF,oGAAoG;EACpG,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,kDAAkD;IAClD,uGAAuG;EACzG;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,QAAQ;EACR,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,kEAAkE;EAClE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,WAAW;EACX,wBAAwB;EACxB,qCAAqC;EACrC,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,UAAU;EACV,WAAW;EACX,cAAc;EACd,WAAW;EACX,kCAAkC;EAClC,UAAU;EACV,4BAA4B;EAC5B,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kEAAkE;EAClE,wBAAwB;EACxB,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,4BAA4B;EAC5B,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EAEjB,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;EAC1B,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,+LAA+L;EAC/L,eAAe;EAEf,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,kBAAkB;EAClB,yDAAyD;EACzD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,oEAAoE;EACpE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,oDAAoD;EACpD,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yDAAyD;EACzD,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,SAAS;EACT,SAAS;EACT,4BAA4B;EAC5B,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,mCAAmC;EACnC,6BAA6B;EAC7B,kCAAkC;EAClC,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,6BAA6B;EAC7B,gBAAgB;EAChB,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;AACzG;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;IACE,QAAQ;IACR,uBAAuB;IACvB,cAAc;IACd,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,gCAAgC;IAChC,mCAAmC;EACrC;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,gCAAgC;IAChC,mCAAmC;IACnC,uBAAuB;EACzB;AACF;;AAEA;;EAEE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,mDAAmD;EACnD,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;;EAIE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,0DAAsS;EACtS,qBAAqB;EACrB,wCAAwC;EACxC,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,kCAAkC;EAClC,+BAA+B;EAC/B,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;EACtB,oEAAoE;EACpE,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,oBAAoB;EACpB,2DAA2D;EAC3D,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;AACzG;;AAEA;;EAEE,gBAAgB;EAChB,oBAAoB;EACpB,yDAAyD;AAC3D;;AAEA;;;;EAIE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;;EAEE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;;;EAIE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;;EAEE,oBAAoB;EACpB,2DAA2D;EAC3D,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;;;EAIE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;;EAEE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;EAEE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,oEAAoE;EACpE,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0DAAsS;EACtS,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,+LAA+L;EAC/L,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,0DAAsS;EACtS,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,+LAA+L;EAC/L,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,oEAAoE;EACpE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;;;;;;;;;;;;EAYE,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;EAYE,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE;4BAC0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,SAAS;EACT,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;yEACuE;AACzE;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB;2BACyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,oEAAoE;EACpE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,0DAAsS;EACtS,qBAAqB;EACrB,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAGlB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,yDAAyD;EACzD,4BAA4B;EAC5B,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;EAEvG,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE;IACE,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;;;;EAIE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0DAA8W;EAC9W,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0DAAuT;EACvT,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0DAAsT;EACtT,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,0DAA6W;EAC7W,oBAAoB;EACpB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;;EAEE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;EAC9B,0DAAoS;EACpS,qBAAqB;EACrB,wCAAwC;EACxC,sBAAsB;EACtB,sBAAsB;EACtB,oEAAoE;EACpE,4BAA4B;EAC5B,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qEAA8V;EAC9V,gCAAgC;EAChC,mDAAmD;EACnD,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,oEAAoE;EACpE,oBAAoB;EACpB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,oEAAoE;EACpE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,gBAAgB;EAChB,mEAAmE;EACnE,WAAW;EACX,sBAAsB;EACtB,sBAAsB;EACtB,oEAAoE;EACpE,mBAAmB;EACnB,oBAAoB;EACpB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iEAAiE;EACjE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;EAClE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;EACpE,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,oEAAoE;EACpE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,2DAA2D;EAC3D,UAAU;AACZ;;AAEA;EACE,0DAAsS;EACtS,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;EAC3D,qEAAqW;AACvW;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;;EAGE,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;AACzG;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,wBAAwB;EACxB,sCAAsC;EACtC,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,UAAU;EACV,wBAAwB;EACxB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sCAAsC;EACtC,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;EACpE,6EAA6E;EAC7E,iGAAiG;EACjG,uGAAuG;AACzG;;AAEA;EACE,8EAA8E;EAC9E,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;EAC9C,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;;EAEE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;;EAEE,sBAAsB;EACtB,oEAAoE;EACpE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;;EAEE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,sBAAsB;EACtB,8EAA8E;AAChF;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;;EAEE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,uGAAuG;AACzG;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;;EAEE,+BAA+B;EAC/B,sEAAsE;AACxE;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;EAEE,kDAAkD;EAClD,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;;EAEE,oEAAoE;AACtE;;AAEA;;EAEE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;;EAEE,kBAAkB;EAClB,uEAAuE;EACvE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;;EAEE,yDAAyD;AAC3D;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;;;;EAIE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;EACpE,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,oEAAoE;EACpE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,cAAc;EACd,kCAAkC;EAClC,oEAAoE;EACpE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,qBAAqB;IACrB,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;;;;EAIE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kEAAkE;EAClE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;IACf,oBAAoB;IACpB,2DAA2D;EAC7D;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,gCAAgC;EAChC,0DAA0D;EAC1D,wCAAwC;EACxC,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;EAChC,qCAAqC;EACrC,+BAA+B;EAC/B,sEAAsE;EACtE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;EAC1C,uDAAuD;EACvD,uGAAuG;EAEvG,gKAAwJ;EAAxJ,wJAAwJ;EACxJ,iLAAgN;EAChN,wDAAwD;EACxD,0BAA0B;AAC5B;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;EAC5F,mEAAmE;EACnE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qEAAqE;EACrE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,yCAAyC;EACzC,kHAAkH;AACpH;;AAEA;;EAEE,iCAAiC;EACjC,6EAA6E;EAC7E,6BAA6B;EAC7B,6EAA6E;EAC7E,+BAA+B;EAC/B,2DAA2D;AAC7D;;AAEA;EACE,8DAA8D;EAC9D,gCAAgC;EAChC,iCAAiC;EACjC,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,6EAA6E;AAC/E;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,kFAAkF;EAClF,6BAA6B;EAC7B,kFAAkF;AACpF;;AAEA;EACE,6BAA6B;EAC7B,kFAAkF;AACpF;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;EACvE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;EACR,UAAU;EACV,WAAW;EACX,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,QAAQ;AACV;;AAEA;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mDAAmD;AACrD;;AAEA;EACE,0BAA0B;EAC1B,mEAAmE;AACrE;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,mFAAmF;AACrF;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,oEAAoE;AACtE;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2GAA2G;EAC3G,yGAAyG;EACzG,4FAA4F;AAC9F;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,kEAAkE;AACpE;;AAEA;EACE,sBAAsB;EACtB,iEAAiE;AACnE;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,kEAAkE;AACpE;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,oBAAoB;EACpB,2DAA2D;AAC7D;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE,kBAAkB;EAClB,uEAAuE;AACzE;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sEAAsE;EACxE;;EAEA;IACE,+CAA+C;IAC/C,oGAAoG;EACtG;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kDAAkD;IAClD,uGAAuG;EACzG;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IAEE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,sBAAsB;IACtB,8BAA8B;IAC9B,uGAAuG;EACzG;;EAEA;IACE,0BAA0B;IAC1B,cAAc;EAChB;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IAEE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;IACpB,yDAAyD;EAC3D;AACF;;;AAGA,GAAG;AACH;EACE,aAAa;;AAEf;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,UAAU;EAIV,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAElB,kDAAkD;EAElD,sBAAsB;EAGtB,aAAa;EACb,yCAAyC;EACzC,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf","sourcesContent":["/*\r\n |--------------------------------------------------------------------------\r\n | TailwindCSS Directives\r\n |--------------------------------------------------------------------------\r\n |\r\n | Import TailwindCSS directives and swipe out at build-time with all of\r\n | the styles it generates based on your configured design system.\r\n |\r\n | Please check this link for more details:\r\n | https://tailwindcss.com/docs/installation#include-tailwind-in-your-css\r\n |\r\n */\r\n/*\r\n ! tailwindcss v3.0.24 | MIT License | https://tailwindcss.com\r\n */\r\n/*\r\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\r\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\r\n*/\r\n*,\r\n::before,\r\n::after {\r\n  box-sizing: border-box;\r\n  /* 1 */\r\n  border-width: 0;\r\n  /* 2 */\r\n  border-style: solid;\r\n  /* 2 */\r\n  border-color: #e5e7eb;\r\n  /* 2 */\r\n}\r\n\r\n::before,\r\n::after {\r\n  --tw-content: '';\r\n}\r\n\r\n/*\r\n1. Use a consistent sensible line-height in all browsers.\r\n2. Prevent adjustments of font size after orientation changes in iOS.\r\n3. Use a more readable tab size.\r\n4. Use the user's configured `sans` font-family by default.\r\n*/\r\nhtml {\r\n  line-height: 1.5;\r\n  /* 1 */\r\n  -webkit-text-size-adjust: 100%;\r\n  /* 2 */\r\n  -moz-tab-size: 4;\r\n  /* 3 */\r\n  -o-tab-size: 4;\r\n  tab-size: 4;\r\n  /* 3 */\r\n  font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\r\n  /* 4 */\r\n}\r\n\r\n/*\r\n1. Remove the margin in all browsers.\r\n2. Inherit line-height from `html` so users can set them as a class directly on the `html` element.\r\n*/\r\nbody {\r\n  margin: 0;\r\n  /* 1 */\r\n  line-height: inherit;\r\n  /* 2 */\r\n}\r\n\r\n/*\r\n1. Add the correct height in Firefox.\r\n2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\r\n3. Ensure horizontal rules are visible by default.\r\n*/\r\nhr {\r\n  height: 0;\r\n  /* 1 */\r\n  color: inherit;\r\n  /* 2 */\r\n  border-top-width: 1px;\r\n  /* 3 */\r\n}\r\n\r\n/*\r\nAdd the correct text decoration in Chrome, Edge, and Safari.\r\n*/\r\nabbr:where([title]) {\r\n  -webkit-text-decoration: underline dotted;\r\n  text-decoration: underline dotted;\r\n}\r\n\r\n/*\r\nRemove the default font size and weight for headings.\r\n*/\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font-size: inherit;\r\n  font-weight: inherit;\r\n}\r\n\r\n/*\r\nReset links to optimize for opt-in styling instead of opt-out.\r\n*/\r\na {\r\n  color: inherit;\r\n  text-decoration: inherit;\r\n}\r\n\r\n/*\r\nAdd the correct font weight in Edge and Safari.\r\n*/\r\nb,\r\nstrong {\r\n  font-weight: bolder;\r\n}\r\n\r\n/*\r\n1. Use the user's configured `mono` font family by default.\r\n2. Correct the odd `em` font sizing in all browsers.\r\n*/\r\ncode,\r\nkbd,\r\nsamp,\r\npre {\r\n  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n  /* 1 */\r\n  font-size: 1em;\r\n  /* 2 */\r\n}\r\n\r\n/*\r\nAdd the correct font size in all browsers.\r\n*/\r\nsmall {\r\n  font-size: 80%;\r\n}\r\n\r\n/*\r\nPrevent `sub` and `sup` elements from affecting the line height in all browsers.\r\n*/\r\nsub,\r\nsup {\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  position: relative;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -0.25em;\r\n}\r\n\r\nsup {\r\n  top: -0.5em;\r\n}\r\n\r\n/*\r\n1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\r\n2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\r\n3. Remove gaps between table borders by default.\r\n*/\r\ntable {\r\n  text-indent: 0;\r\n  /* 1 */\r\n  border-color: inherit;\r\n  /* 2 */\r\n  border-collapse: collapse;\r\n  /* 3 */\r\n}\r\n\r\n/*\r\n1. Change the font styles in all browsers.\r\n2. Remove the margin in Firefox and Safari.\r\n3. Remove default padding in all browsers.\r\n*/\r\nbutton,\r\ninput,\r\noptgroup,\r\nselect,\r\ntextarea {\r\n  font-family: inherit;\r\n  /* 1 */\r\n  font-size: 100%;\r\n  /* 1 */\r\n  line-height: inherit;\r\n  /* 1 */\r\n  color: inherit;\r\n  /* 1 */\r\n  margin: 0;\r\n  /* 2 */\r\n  padding: 0;\r\n  /* 3 */\r\n}\r\n\r\n/*\r\nRemove the inheritance of text transform in Edge and Firefox.\r\n*/\r\nbutton,\r\nselect {\r\n  text-transform: none;\r\n}\r\n\r\n/*\r\n1. Correct the inability to style clickable types in iOS and Safari.\r\n2. Remove default button styles.\r\n*/\r\nbutton,\r\n[type='button'],\r\n[type='reset'],\r\n[type='submit'] {\r\n  -webkit-appearance: button;\r\n  /* 1 */\r\n  background-color: transparent;\r\n  /* 2 */\r\n  background-image: none;\r\n  /* 2 */\r\n}\r\n\r\n/*\r\nUse the modern Firefox focus style for all focusable elements.\r\n*/\r\n:-moz-focusring {\r\n  outline: auto;\r\n}\r\n\r\n/*\r\nRemove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\r\n*/\r\n:-moz-ui-invalid {\r\n  box-shadow: none;\r\n}\r\n\r\n/*\r\nAdd the correct vertical alignment in Chrome and Firefox.\r\n*/\r\nprogress {\r\n  vertical-align: baseline;\r\n}\r\n\r\n/*\r\nCorrect the cursor style of increment and decrement buttons in Safari.\r\n*/\r\n::-webkit-inner-spin-button,\r\n::-webkit-outer-spin-button {\r\n  height: auto;\r\n}\r\n\r\n/*\r\n1. Correct the odd appearance in Chrome and Safari.\r\n2. Correct the outline style in Safari.\r\n*/\r\n[type='search'] {\r\n  -webkit-appearance: textfield;\r\n  /* 1 */\r\n  outline-offset: -2px;\r\n  /* 2 */\r\n}\r\n\r\n/*\r\nRemove the inner padding in Chrome and Safari on macOS.\r\n*/\r\n::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n/*\r\n1. Correct the inability to style clickable types in iOS and Safari.\r\n2. Change font properties to `inherit` in Safari.\r\n*/\r\n::-webkit-file-upload-button {\r\n  -webkit-appearance: button;\r\n  /* 1 */\r\n  font: inherit;\r\n  /* 2 */\r\n}\r\n\r\n/*\r\nAdd the correct display in Chrome and Safari.\r\n*/\r\nsummary {\r\n  display: list-item;\r\n}\r\n\r\n/*\r\nRemoves the default spacing and border for appropriate elements.\r\n*/\r\nblockquote,\r\ndl,\r\ndd,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6,\r\nhr,\r\nfigure,\r\np,\r\npre {\r\n  margin: 0;\r\n}\r\n\r\nfieldset {\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\nlegend {\r\n  padding: 0;\r\n}\r\n\r\nol,\r\nul,\r\nmenu {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n}\r\n\r\n/*\r\nPrevent resizing textareas horizontally by default.\r\n*/\r\ntextarea {\r\n  resize: vertical;\r\n}\r\n\r\n/*\r\n1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\r\n2. Set the default placeholder color to the user's configured gray 400 color.\r\n*/\r\ninput::-moz-placeholder,\r\ntextarea::-moz-placeholder {\r\n  opacity: 1;\r\n  /* 1 */\r\n  color: #9ca3af;\r\n  /* 2 */\r\n}\r\n\r\ninput:-ms-input-placeholder,\r\ntextarea:-ms-input-placeholder {\r\n  opacity: 1;\r\n  /* 1 */\r\n  color: #9ca3af;\r\n  /* 2 */\r\n}\r\n\r\ninput::placeholder,\r\ntextarea::placeholder {\r\n  opacity: 1;\r\n  /* 1 */\r\n  color: #9ca3af;\r\n  /* 2 */\r\n}\r\n\r\n/*\r\nSet the default cursor for buttons.\r\n*/\r\nbutton,\r\n[role=\"button\"] {\r\n  cursor: pointer;\r\n}\r\n\r\n/*\r\nMake sure disabled buttons don't get the pointer cursor.\r\n*/\r\n:disabled {\r\n  cursor: default;\r\n}\r\n\r\n/*\r\n1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\r\n2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\r\n   This can trigger a poorly considered lint error in some tools but is included by design.\r\n*/\r\nimg,\r\nsvg,\r\nvideo,\r\ncanvas,\r\naudio,\r\niframe,\r\nembed,\r\nobject {\r\n  display: block;\r\n  /* 1 */\r\n  vertical-align: middle;\r\n  /* 2 */\r\n}\r\n\r\n/*\r\nConstrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\r\n*/\r\nimg,\r\nvideo {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\n/*\r\nEnsure the default browser behavior of the `hidden` attribute.\r\n*/\r\n[hidden] {\r\n  display: none;\r\n}\r\n\r\n[type='text'],\r\n[type='email'],\r\n[type='url'],\r\n[type='password'],\r\n[type='number'],\r\n[type='date'],\r\n[type='datetime-local'],\r\n[type='month'],\r\n[type='search'],\r\n[type='tel'],\r\n[type='time'],\r\n[type='week'],\r\n[multiple],\r\ntextarea,\r\nselect {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  background-color: #fff;\r\n  border-color: #6b7280;\r\n  border-width: 1px;\r\n  border-radius: 0px;\r\n  padding-top: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.5rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5rem;\r\n  --tw-shadow: 0 0 #0000;\r\n}\r\n\r\n[type='text']:focus,\r\n[type='email']:focus,\r\n[type='url']:focus,\r\n[type='password']:focus,\r\n[type='number']:focus,\r\n[type='date']:focus,\r\n[type='datetime-local']:focus,\r\n[type='month']:focus,\r\n[type='search']:focus,\r\n[type='tel']:focus,\r\n[type='time']:focus,\r\n[type='week']:focus,\r\n[multiple]:focus,\r\ntextarea:focus,\r\nselect:focus {\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n  --tw-ring-inset: var(--tw-empty,\r\n      /*!*/\r\n      /*!*/\r\n    );\r\n  --tw-ring-offset-width: 0px;\r\n  --tw-ring-offset-color: #fff;\r\n  --tw-ring-color: #2563eb;\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\r\n  border-color: #2563eb;\r\n}\r\n\r\ninput::-moz-placeholder,\r\ntextarea::-moz-placeholder {\r\n  color: #6b7280;\r\n  opacity: 1;\r\n}\r\n\r\ninput:-ms-input-placeholder,\r\ntextarea:-ms-input-placeholder {\r\n  color: #6b7280;\r\n  opacity: 1;\r\n}\r\n\r\ninput::placeholder,\r\ntextarea::placeholder {\r\n  color: #6b7280;\r\n  opacity: 1;\r\n}\r\n\r\n::-webkit-datetime-edit-fields-wrapper {\r\n  padding: 0;\r\n}\r\n\r\n::-webkit-date-and-time-value {\r\n  min-height: 1.5em;\r\n}\r\n\r\n::-webkit-datetime-edit,\r\n::-webkit-datetime-edit-year-field,\r\n::-webkit-datetime-edit-month-field,\r\n::-webkit-datetime-edit-day-field,\r\n::-webkit-datetime-edit-hour-field,\r\n::-webkit-datetime-edit-minute-field,\r\n::-webkit-datetime-edit-second-field,\r\n::-webkit-datetime-edit-millisecond-field,\r\n::-webkit-datetime-edit-meridiem-field {\r\n  padding-top: 0;\r\n  padding-bottom: 0;\r\n}\r\n\r\nselect {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\r\n  background-position: right 0.5rem center;\r\n  background-repeat: no-repeat;\r\n  background-size: 1.5em 1.5em;\r\n  padding-right: 2.5rem;\r\n  -webkit-print-color-adjust: exact;\r\n  -moz-print-color-adjust: exact;\r\n  print-color-adjust: exact;\r\n}\r\n\r\n[multiple] {\r\n  background-image: initial;\r\n  background-position: initial;\r\n  background-repeat: unset;\r\n  background-size: initial;\r\n  padding-right: 0.75rem;\r\n  -webkit-print-color-adjust: unset;\r\n  -moz-print-color-adjust: unset;\r\n  print-color-adjust: unset;\r\n}\r\n\r\n[type='checkbox'],\r\n[type='radio'] {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  padding: 0;\r\n  -webkit-print-color-adjust: exact;\r\n  -moz-print-color-adjust: exact;\r\n  print-color-adjust: exact;\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  background-origin: border-box;\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  flex-shrink: 0;\r\n  height: 1rem;\r\n  width: 1rem;\r\n  color: #2563eb;\r\n  background-color: #fff;\r\n  border-color: #6b7280;\r\n  border-width: 1px;\r\n  --tw-shadow: 0 0 #0000;\r\n}\r\n\r\n[type='checkbox'] {\r\n  border-radius: 0px;\r\n}\r\n\r\n[type='radio'] {\r\n  border-radius: 100%;\r\n}\r\n\r\n[type='checkbox']:focus,\r\n[type='radio']:focus {\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n  --tw-ring-inset: var(--tw-empty,\r\n      /*!*/\r\n      /*!*/\r\n    );\r\n  --tw-ring-offset-width: 2px;\r\n  --tw-ring-offset-color: #fff;\r\n  --tw-ring-color: #2563eb;\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\r\n}\r\n\r\n[type='checkbox']:checked,\r\n[type='radio']:checked {\r\n  border-color: transparent;\r\n  background-color: currentColor;\r\n  background-size: 100% 100%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n[type='checkbox']:checked {\r\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e\");\r\n}\r\n\r\n[type='radio']:checked {\r\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3ccircle cx='8' cy='8' r='3'/%3e%3c/svg%3e\");\r\n}\r\n\r\n[type='checkbox']:checked:hover,\r\n[type='checkbox']:checked:focus,\r\n[type='radio']:checked:hover,\r\n[type='radio']:checked:focus {\r\n  border-color: transparent;\r\n  background-color: currentColor;\r\n}\r\n\r\n[type='checkbox']:indeterminate {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16'%3e%3cpath stroke='white' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M4 8h8'/%3e%3c/svg%3e\");\r\n  border-color: transparent;\r\n  background-color: currentColor;\r\n  background-size: 100% 100%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n[type='checkbox']:indeterminate:hover,\r\n[type='checkbox']:indeterminate:focus {\r\n  border-color: transparent;\r\n  background-color: currentColor;\r\n}\r\n\r\n[type='file'] {\r\n  background: unset;\r\n  border-color: inherit;\r\n  border-width: 0;\r\n  border-radius: 0;\r\n  padding: 0;\r\n  font-size: unset;\r\n  line-height: inherit;\r\n}\r\n\r\n[type='file']:focus {\r\n  outline: 1px solid ButtonText;\r\n  outline: 1px auto -webkit-focus-ring-color;\r\n}\r\n\r\n*,\r\n::before,\r\n::after {\r\n  --tw-translate-x: 0;\r\n  --tw-translate-y: 0;\r\n  --tw-rotate: 0;\r\n  --tw-skew-x: 0;\r\n  --tw-skew-y: 0;\r\n  --tw-scale-x: 1;\r\n  --tw-scale-y: 1;\r\n  --tw-pan-x: ;\r\n  --tw-pan-y: ;\r\n  --tw-pinch-zoom: ;\r\n  --tw-scroll-snap-strictness: proximity;\r\n  --tw-ordinal: ;\r\n  --tw-slashed-zero: ;\r\n  --tw-numeric-figure: ;\r\n  --tw-numeric-spacing: ;\r\n  --tw-numeric-fraction: ;\r\n  --tw-ring-inset: ;\r\n  --tw-ring-offset-width: 0px;\r\n  --tw-ring-offset-color: #fff;\r\n  --tw-ring-color: rgb(59 130 246 / 0.5);\r\n  --tw-ring-offset-shadow: 0 0 #0000;\r\n  --tw-ring-shadow: 0 0 #0000;\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  --tw-blur: ;\r\n  --tw-brightness: ;\r\n  --tw-contrast: ;\r\n  --tw-grayscale: ;\r\n  --tw-hue-rotate: ;\r\n  --tw-invert: ;\r\n  --tw-saturate: ;\r\n  --tw-sepia: ;\r\n  --tw-drop-shadow: ;\r\n  --tw-backdrop-blur: ;\r\n  --tw-backdrop-brightness: ;\r\n  --tw-backdrop-contrast: ;\r\n  --tw-backdrop-grayscale: ;\r\n  --tw-backdrop-hue-rotate: ;\r\n  --tw-backdrop-invert: ;\r\n  --tw-backdrop-opacity: ;\r\n  --tw-backdrop-saturate: ;\r\n  --tw-backdrop-sepia: ;\r\n}\r\n\r\n.container {\r\n  width: 100%;\r\n  margin-right: auto;\r\n  margin-left: auto;\r\n}\r\n\r\n@media (min-width: 640px) {\r\n  .container {\r\n    max-width: 640px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .container {\r\n    max-width: 768px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .container {\r\n    max-width: 1024px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1280px) {\r\n  .container {\r\n    max-width: 1280px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1536px) {\r\n  .container {\r\n    max-width: 1536px;\r\n  }\r\n}\r\n\r\n.form-input,\r\n.form-textarea,\r\n.form-select,\r\n.form-multiselect {\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  background-color: #fff;\r\n  border-color: #6b7280;\r\n  border-width: 1px;\r\n  border-radius: 0px;\r\n  padding-top: 0.5rem;\r\n  padding-right: 0.75rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n  font-size: 1rem;\r\n  line-height: 1.5rem;\r\n  --tw-shadow: 0 0 #0000;\r\n}\r\n\r\n.form-input:focus,\r\n.form-textarea:focus,\r\n.form-select:focus,\r\n.form-multiselect:focus {\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n  --tw-ring-inset: var(--tw-empty,\r\n      /*!*/\r\n      /*!*/\r\n    );\r\n  --tw-ring-offset-width: 0px;\r\n  --tw-ring-offset-color: #fff;\r\n  --tw-ring-color: #2563eb;\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);\r\n  border-color: #2563eb;\r\n}\r\n\r\n.form-select {\r\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\r\n  background-position: right 0.5rem center;\r\n  background-repeat: no-repeat;\r\n  background-size: 1.5em 1.5em;\r\n  padding-right: 2.5rem;\r\n  -webkit-print-color-adjust: exact;\r\n  -moz-print-color-adjust: exact;\r\n  print-color-adjust: exact;\r\n}\r\n\r\n.accordion .accordion-item {\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.accordion .accordion-item:not(:last-child) {\r\n  border-bottom-width: 1px;\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n}\r\n\r\n.dark .accordion .accordion-item:not(:last-child) {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.accordion .accordion-item:first-child {\r\n  margin-top: -1rem;\r\n}\r\n\r\n.accordion .accordion-item:last-child {\r\n  margin-bottom: -1rem;\r\n}\r\n\r\n.accordion .accordion-item .accordion-header .accordion-button {\r\n  margin-top: -1rem;\r\n  margin-bottom: -1rem;\r\n  width: 100%;\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n  text-align: left;\r\n  font-weight: 500;\r\n}\r\n\r\n.dark .accordion .accordion-item .accordion-header .accordion-button {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.accordion .accordion-item .accordion-header .accordion-button:focus {\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .accordion .accordion-item .accordion-header .accordion-button:not(.collapsed) {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.accordion .accordion-collapse {\r\n  margin-top: 0.75rem;\r\n  line-height: 1.625;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .accordion .accordion-collapse {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.accordion .accordion-collapse.collapse:not(.show) {\r\n  display: none;\r\n}\r\n\r\n.accordion.accordion-boxed .accordion-item {\r\n  margin-top: 0.75rem;\r\n  border-width: 1px;\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n  padding: 1rem;\r\n}\r\n\r\n.dark .accordion.accordion-boxed .accordion-item {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.accordion.accordion-boxed .accordion-item:first-child {\r\n  margin-top: 0px;\r\n}\r\n\r\n.accordion.accordion-boxed .accordion-item:last-child {\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.alert {\r\n  position: relative;\r\n  border-radius: 0.375rem;\r\n  border-width: 1px;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.alert.alert-dismissible {\r\n  padding-left: 1.25rem;\r\n  padding-right: 4rem;\r\n}\r\n\r\n.alert.alert-dismissible:not(.show) {\r\n  display: none;\r\n}\r\n\r\n.alert .btn-close {\r\n  position: absolute;\r\n  right: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  margin-right: 0.5rem;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n}\r\n\r\n.btn-close {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n}\r\n\r\n/* Alert Colors */\r\n.alert-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-secondary {\r\n  border-color: rgb(var(--color-secondary) / 0.7);\r\n  background-color: rgb(var(--color-secondary) / 0.7);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-secondary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.alert-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-dark {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n/* Outline Button */\r\n.alert-outline-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-outline-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-outline-secondary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-outline-secondary {\r\n  border-color: rgb(var(--color-darkmode-100) / 0.4);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.alert-outline-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-success) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-outline-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-outline-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-warning) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-outline-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-outline-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-pending) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-outline-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-outline-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-danger) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-outline-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.alert-outline-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-dark) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-outline-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n/* Button Soft Colors */\r\n.alert-primary-soft {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-primary-soft {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 1;\r\n  --tw-bg-opacity: 0.2;\r\n}\r\n\r\n.alert-secondary-soft {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));\r\n  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.1;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-secondary-soft {\r\n  border-color: rgb(var(--color-darkmode-100) / 0.3);\r\n  background-color: rgb(var(--color-darkmode-100) / 0.2);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.alert-success-soft {\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-success) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-success-soft {\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.alert-warning-soft {\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-warning) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-warning-soft {\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.alert-pending-soft {\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-pending) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-pending-soft {\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.alert-danger-soft {\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-danger) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-danger-soft {\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.alert-dark-soft {\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-dark) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .alert-dark-soft {\r\n  border-color: rgb(var(--color-darkmode-800) / 0.6);\r\n  background-color: rgb(var(--color-darkmode-800) / 0.3);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n/* Default Button */\r\n.btn {\r\n  display: inline-flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0.375rem;\r\n  border-width: 1px;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  font-weight: 500;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 200ms;\r\n}\r\n\r\n.btn:focus {\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n}\r\n\r\n.dark .btn {\r\n  transition-property: none;\r\n}\r\n\r\n.dark .btn:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.btn:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.7;\r\n  --tw-bg-opacity: 0.7;\r\n}\r\n\r\n.btn:not(button) {\r\n  text-align: center;\r\n}\r\n\r\n.btn:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n  background-color: #c7c7c7;\r\n  border: 1px solid #c7c7c7;\r\n  color: #000;\r\n}\r\n\r\n/* Default Sizes */\r\n.btn-sm {\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n}\r\n\r\n.btn-lg {\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  font-size: 1.125rem;\r\n  line-height: 1.75rem;\r\n}\r\n\r\n/* Button Colors */\r\n.btn-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-secondary {\r\n  border-color: rgb(var(--color-secondary) / 0.7);\r\n  background-color: rgb(var(--color-secondary) / 0.7);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-secondary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-secondary:hover:not(:disabled) {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .btn-secondary:hover:not(:disabled) {\r\n  border-color: rgb(var(--color-darkmode-300) / 0.8);\r\n  background-color: rgb(var(--color-darkmode-300) / 0.8);\r\n}\r\n\r\n.btn-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-dark {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-dark:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.7);\r\n}\r\n\r\n/* Button Elevated */\r\n.btn-elevated-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-primary {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.btn-elevated-secondary {\r\n  border-color: rgb(var(--color-secondary) / 0.7);\r\n  background-color: rgb(var(--color-secondary) / 0.7);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-secondary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-elevated-secondary:hover:not(:disabled) {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .btn-elevated-secondary:hover:not(:disabled) {\r\n  border-color: rgb(var(--color-darkmode-300) / 0.8);\r\n  background-color: rgb(var(--color-darkmode-300) / 0.8);\r\n}\r\n\r\n.btn-elevated-secondary {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.btn-elevated-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-success {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.btn-elevated-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-warning {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.btn-elevated-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-pending {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.btn-elevated-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-danger {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.btn-elevated-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-dark {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-dark:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.7);\r\n}\r\n\r\n.btn-elevated-dark {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n/* Button Rounded */\r\n.btn-rounded {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-rounded-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-rounded-primary {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-rounded-secondary {\r\n  border-color: rgb(var(--color-secondary) / 0.7);\r\n  background-color: rgb(var(--color-secondary) / 0.7);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-secondary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-rounded-secondary:hover:not(:disabled) {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .btn-rounded-secondary:hover:not(:disabled) {\r\n  border-color: rgb(var(--color-darkmode-300) / 0.8);\r\n  background-color: rgb(var(--color-darkmode-300) / 0.8);\r\n}\r\n\r\n.btn-rounded-secondary {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-rounded-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-rounded-success {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-rounded-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-rounded-warning {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-rounded-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-rounded-pending {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-rounded-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-rounded-danger {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-rounded-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-dark {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-rounded-dark:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.7);\r\n}\r\n\r\n.btn-rounded-dark {\r\n  border-radius: 9999px;\r\n}\r\n\r\n/* Button Elevated Rounded */\r\n.btn-elevated-rounded-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-rounded-primary {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-elevated-rounded-secondary {\r\n  border-color: rgb(var(--color-secondary) / 0.7);\r\n  background-color: rgb(var(--color-secondary) / 0.7);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-secondary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-elevated-rounded-secondary:hover:not(:disabled) {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-100) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-secondary:hover:not(:disabled) {\r\n  border-color: rgb(var(--color-darkmode-300) / 0.8);\r\n  background-color: rgb(var(--color-darkmode-300) / 0.8);\r\n}\r\n\r\n.btn-elevated-rounded-secondary {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-elevated-rounded-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-rounded-success {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-elevated-rounded-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-900) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-rounded-warning {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-elevated-rounded-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-rounded-pending {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-elevated-rounded-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-elevated-rounded-danger {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  border-radius: 9999px;\r\n}\r\n\r\n.btn-elevated-rounded-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-dark {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-elevated-rounded-dark:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.7);\r\n}\r\n\r\n.btn-elevated-rounded-dark {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  border-radius: 9999px;\r\n}\r\n\r\n/* Social Media Button */\r\n.btn-facebook {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(59 89 152 / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(59 89 152 / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-facebook {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(59 89 152 / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-twitter {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(74 179 244 / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(74 179 244 / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-twitter {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(74 179 244 / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-instagram {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(81 127 164 / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(81 127 164 / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-instagram {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(81 127 164 / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-linkedin {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(0 119 181 / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(0 119 181 / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-linkedin {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(0 119 181 / var(--tw-border-opacity));\r\n}\r\n\r\n/* Outline Button */\r\n.btn-outline-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-outline-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-outline-primary:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-primary) / 0.1);\r\n}\r\n\r\n.btn-outline-secondary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-outline-secondary {\r\n  border-color: rgb(var(--color-darkmode-100) / 0.4);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-outline-secondary:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-secondary) / 0.2);\r\n}\r\n\r\n.dark .btn-outline-secondary:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-darkmode-100) / 0.1);\r\n}\r\n\r\n.btn-outline-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-success) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-outline-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-outline-success:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-success) / 0.1);\r\n}\r\n\r\n.btn-outline-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-warning) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-outline-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-outline-warning:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-warning) / 0.1);\r\n}\r\n\r\n.btn-outline-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-pending) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-outline-pending {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-outline-pending:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-pending) / 0.1);\r\n}\r\n\r\n.btn-outline-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-danger) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-outline-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.btn-outline-danger:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-danger) / 0.1);\r\n}\r\n\r\n.btn-outline-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-dark) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-outline-dark {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-outline-dark:hover:not(:disabled) {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.3);\r\n}\r\n\r\n.dark .btn-outline-dark:hover:not(:disabled) {\r\n  --tw-bg-opacity: 0.3;\r\n}\r\n\r\n/* Button Soft Colors */\r\n.btn-primary-soft {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-primary-soft {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 1;\r\n  --tw-bg-opacity: 0.2;\r\n}\r\n\r\n.btn-primary-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 0.1;\r\n}\r\n\r\n.dark .btn-primary-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.6;\r\n}\r\n\r\n.btn-secondary-soft {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-secondary) / var(--tw-border-opacity));\r\n  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-secondary-soft {\r\n  border-color: rgb(var(--color-darkmode-100) / 0.3);\r\n  background-color: rgb(var(--color-darkmode-100) / 0.2);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-secondary-soft:hover:not(:disabled) {\r\n  --tw-bg-opacity: 0.1;\r\n}\r\n\r\n.dark .btn-secondary-soft:hover:not(:disabled) {\r\n  border-color: rgb(var(--color-darkmode-100) / 0.2);\r\n  background-color: rgb(var(--color-darkmode-100) / 0.1);\r\n}\r\n\r\n.btn-success-soft {\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-success) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-success-soft {\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.btn-success-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 0.1;\r\n}\r\n\r\n.btn-warning-soft {\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-warning) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-warning-soft {\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.btn-warning-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 0.1;\r\n}\r\n\r\n.btn-pending-soft {\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-pending) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-pending-soft {\r\n  border-color: rgb(var(--color-pending) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.btn-pending-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 0.1;\r\n}\r\n\r\n.btn-danger-soft {\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-danger) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-danger-soft {\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.2;\r\n}\r\n\r\n.btn-danger-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 0.1;\r\n}\r\n\r\n.btn-dark-soft {\r\n  border-color: rgb(var(--color-dark) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.05;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.2;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-dark) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .btn-dark-soft {\r\n  border-color: rgb(var(--color-darkmode-800) / 0.6);\r\n  background-color: rgb(var(--color-darkmode-800) / 0.3);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.btn-dark-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 0.1;\r\n}\r\n\r\n.dark .btn-dark-soft:hover:not(:disabled) {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n  background-color: rgb(var(--color-darkmode-800) / 0.5);\r\n}\r\n\r\n.dropdown .dropdown-menu {\r\n  transform: translate3d(-10000px, 0px, 0px) !important;\r\n}\r\n\r\n.dropdown-menu {\r\n  z-index: 9999;\r\n  inset: 0px auto auto 0px;\r\n  transition: visibility 0s ease-in-out 0.2s, opacity 0.2s 0s;\r\n  visibility: hidden;\r\n  position: absolute;\r\n  opacity: 0;\r\n}\r\n\r\n.dropdown-menu.show {\r\n  transition: visibility 0s ease-in-out 0s, opacity 0.2s 0s;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.dropdown-menu.show>.dropdown-content {\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.dropdown-menu.show>.dropdown-content .tab-content .tab-pane {\r\n  visibility: visible;\r\n}\r\n\r\n.dropdown-menu .dropdown-content {\r\n  transition: margin-top 0.2s;\r\n  box-shadow: 0px 3px 10px #00000017;\r\n  position: relative;\r\n  margin-top: 1.25rem;\r\n  width: 100%;\r\n  border-radius: 0.375rem;\r\n  padding: 0.5rem;\r\n}\r\n\r\n.dropdown-menu .dropdown-content .dropdown-header {\r\n  padding: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.dropdown-menu .dropdown-content .dropdown-divider {\r\n  margin-top: 0.5rem;\r\n  margin-bottom: 0.5rem;\r\n  margin-left: -0.5rem;\r\n  margin-right: -0.5rem;\r\n}\r\n\r\n.dropdown-menu .dropdown-content .dropdown-item {\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 0.375rem;\r\n  padding: 0.5rem;\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-duration: 300ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.dropdown-menu .dropdown-content .dropdown-footer {\r\n  display: flex;\r\n  padding: 0.25rem;\r\n}\r\n\r\n.dropdown-menu .dropdown-content .tab-content .tab-pane {\r\n  visibility: hidden;\r\n}\r\n\r\n.dropdown-content {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dropdown-content {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dropdown-divider {\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n}\r\n\r\n.dark .dropdown-divider {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.dropdown-item:hover {\r\n  background-color: rgb(var(--color-slate-200) / 0.6);\r\n}\r\n\r\n.dark .dropdown-item {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dropdown-item:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.file .file__icon {\r\n  position: relative;\r\n  display: block;\r\n  background-size: contain;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.file .file__icon.file__icon--empty-directory {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='786' height='786' viewBox='0 0 786 786'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%238a97ac'/%3E%3Cstop offset='1' stop-color='%235d6c83'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Group_2' data-name='Group 2' transform='translate(-567 -93)'%3E%3Crect id='Rectangle_4' data-name='Rectangle 4' width='418' height='681' rx='40' transform='translate(896 109)' fill='%2395a5b9'/%3E%3Crect id='Rectangle_3' data-name='Rectangle 3' width='433' height='681' rx='40' transform='translate(606 93)' fill='%23a0aec0'/%3E%3Crect id='Rectangle_2' data-name='Rectangle 2' width='786' height='721' rx='40' transform='translate(567 158)' fill='url(%23linear-gradient)'/%3E%3C/g%3E%3C/svg%3E%0A\");\r\n}\r\n\r\n.file .file__icon.file__icon--directory {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='786' height='786' viewBox='0 0 786 786'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%238a97ac'/%3E%3Cstop offset='1' stop-color='%235d6c83'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Group_3' data-name='Group 3' transform='translate(-567 -93)'%3E%3Crect id='Rectangle_4' data-name='Rectangle 4' width='418' height='681' rx='40' transform='translate(896 109)' fill='%2395a5b9'/%3E%3Crect id='Rectangle_3' data-name='Rectangle 3' width='433' height='681' rx='40' transform='translate(606 93)' fill='%23a0aec0'/%3E%3Crect id='Rectangle_2' data-name='Rectangle 2' width='742' height='734' rx='40' transform='translate(590 145)' fill='%23bec8d9'/%3E%3Crect id='Rectangle_5' data-name='Rectangle 5' width='786' height='692' rx='40' transform='translate(567 187)' fill='url(%23linear-gradient)'/%3E%3C/g%3E%3C/svg%3E%0A\");\r\n}\r\n\r\n.file .file__icon.file__icon--file {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='628.027' height='786.012' viewBox='0 0 628.027 786.012'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%238a97ac'/%3E%3Cstop offset='1' stop-color='%235d6c83'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cg id='Group_5' data-name='Group 5' transform='translate(-646 -92.988)'%3E%3Cpath id='Union_2' data-name='Union 2' d='M40,786A40,40,0,0,1,0,746V40A40,40,0,0,1,40,0H501V103h29v24h98V746a40,40,0,0,1-40,40Z' transform='translate(646 93)' fill='url(%23linear-gradient)'/%3E%3Cpath id='Intersection_2' data-name='Intersection 2' d='M.409,162.042l.058-109.9c31.605,29.739,125.37,125.377,125.37,125.377l-109.976.049A20.025,20.025,0,0,1,.409,162.042Z' transform='translate(1147 42)' fill='%23bec8d9' stroke='%23bec8d9' stroke-width='1'/%3E%3C/g%3E%3C/svg%3E%0A\");\r\n}\r\n\r\n.file .file__icon.file__icon--image .file__icon--image__preview {\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 100%;\r\n  width: 100%;\r\n}\r\n\r\n.file .file__icon.file__icon--image .file__icon--image__preview img {\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.file .file__icon .file__icon__file-name {\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  margin: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.file .file__icon:before {\r\n  content: \"\";\r\n  padding-top: 100%;\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n[type=\"text\"],\r\n[type=\"email\"],\r\n[type=\"url\"],\r\n[type=\"password\"],\r\n[type=\"number\"],\r\n[type=\"date\"],\r\n[type=\"datetime-local\"],\r\n[type=\"month\"],\r\n[type=\"search\"],\r\n[type=\"tel\"],\r\n[type=\"time\"],\r\n[type=\"week\"],\r\n[multiple],\r\ntextarea,\r\nselect {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.form-check {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.form-check-label {\r\n  margin-left: 0.5rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.form-check-input {\r\n  transition-property: all;\r\n  transition-duration: 100ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.form-check-input[type=\"radio\"] {\r\n  cursor: pointer;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.form-check-input[type=\"radio\"]:focus {\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n  --tw-ring-offset-width: 0px;\r\n}\r\n\r\n.dark .form-check-input[type=\"radio\"] {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .form-check-input[type=\"radio\"]:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.form-check-input[type=\"radio\"]:checked {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.form-check-input[type=\"radio\"]:disabled:not(:checked) {\r\n  cursor: not-allowed;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .form-check-input[type=\"radio\"]:disabled:not(:checked) {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.5);\r\n}\r\n\r\n.form-check-input[type=\"radio\"]:disabled:checked {\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.dark .form-check-input[type=\"radio\"]:disabled:checked {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.5);\r\n}\r\n\r\n.form-check-input[type=\"checkbox\"] {\r\n  cursor: pointer;\r\n  border-radius: 0.25rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.form-check-input[type=\"checkbox\"]:focus {\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n  --tw-ring-offset-width: 0px;\r\n}\r\n\r\n.dark .form-check-input[type=\"checkbox\"] {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .form-check-input[type=\"checkbox\"]:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.form-check-input[type=\"checkbox\"]:checked {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.1;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.form-check-input[type=\"checkbox\"]:disabled:not(:checked) {\r\n  cursor: not-allowed;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .form-check-input[type=\"checkbox\"]:disabled:not(:checked) {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.5);\r\n}\r\n\r\n.form-check-input[type=\"checkbox\"]:disabled:checked {\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.dark .form-check-input[type=\"checkbox\"]:disabled:checked {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.5);\r\n}\r\n\r\n.form-switch .form-check-input {\r\n  width: 38px;\r\n  height: 24px;\r\n  padding: 1px;\r\n  position: relative;\r\n  border-radius: 9999px;\r\n  background-image: none;\r\n}\r\n\r\n.form-switch .form-check-input:before {\r\n  content: \"\";\r\n  width: 20px;\r\n  height: 20px;\r\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);\r\n  transition-property: margin-left;\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  border-radius: 9999px;\r\n  transition-duration: 200ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.dark .form-switch .form-check-input:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.form-switch .form-check-input:checked {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.form-switch .form-check-input:checked::before {\r\n  margin-left: 14px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n/* Default Form Control */\r\n.form-control {\r\n  width: 100%;\r\n  border-radius: 0.375rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-duration: 200ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.form-control.input-padding {\r\n  padding: 5px 0.5rem !important;\r\n  font-size: 12px;\r\n}\r\n\r\n.form-control::-moz-placeholder {\r\n  color: rgb(var(--color-slate-400) / 0.9);\r\n}\r\n\r\n.form-control:-ms-input-placeholder {\r\n  color: rgb(var(--color-slate-400) / 0.9);\r\n}\r\n\r\n.form-control::placeholder {\r\n  color: rgb(var(--color-slate-400) / 0.9);\r\n}\r\n\r\n.form-control:focus {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.4;\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n}\r\n\r\n.dark .form-control {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  transition-property: none;\r\n}\r\n\r\n.dark .form-control::-moz-placeholder {\r\n  color: rgb(var(--color-slate-500) / 0.8);\r\n}\r\n\r\n.dark .form-control:-ms-input-placeholder {\r\n  color: rgb(var(--color-slate-500) / 0.8);\r\n}\r\n\r\n.dark .form-control::placeholder {\r\n  color: rgb(var(--color-slate-500) / 0.8);\r\n}\r\n\r\n.dark .form-control:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.form-control:disabled,\r\n.form-control[readonly] {\r\n  cursor: not-allowed;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .form-control:disabled,\r\n.dark .form-control[readonly] {\r\n  border-color: transparent;\r\n  background-color: rgb(var(--color-darkmode-800) / 0.5);\r\n}\r\n\r\n/* Default Sizes */\r\n.form-control-sm {\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n}\r\n\r\n.form-control-lg {\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  font-size: 1.125rem;\r\n  line-height: 1.75rem;\r\n}\r\n\r\n/* Form Control Rounded */\r\n.form-control-rounded {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.form-help {\r\n  margin-top: 0.5rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.form-inline {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.form-inline .form-label {\r\n  margin-bottom: 0px;\r\n  margin-right: 1.25rem;\r\n  text-align: right;\r\n}\r\n\r\n.form-inline .form-control {\r\n  flex: 1 1 0%;\r\n}\r\n\r\n.form-label {\r\n  margin-bottom: 0.1rem;\r\n  display: inline-block;\r\n}\r\n\r\n/* Default Form Select */\r\n.form-select {\r\n  /* width: 100%; */\r\n  border-radius: 0.375rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  /* padding-top: 0.5rem; */\r\n  /* padding-bottom: 0.5rem; */\r\n  /* padding-left: 0.75rem; */\r\n  /* padding-right: 2rem; */\r\n  /* font-size: 0.875rem; */\r\n  font-size: 12px;\r\n  padding: 5px 2rem 5px 0.5rem;\r\n  line-height: 1.25rem;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-duration: 200ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.form-select:focus {\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 0.4;\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n}\r\n\r\n.dark .form-select {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .form-select:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.form-select:disabled,\r\n.form-select[readonly] {\r\n  cursor: not-allowed;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .form-select:disabled,\r\n.dark .form-select[readonly] {\r\n  background-color: rgb(var(--color-darkmode-800) / 0.5);\r\n}\r\n\r\n/* Default Sizes */\r\n.form-select-sm {\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n  padding-left: 0.5rem;\r\n  padding-right: 2rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n}\r\n\r\n.form-select-lg {\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n  padding-left: 1rem;\r\n  padding-right: 2rem;\r\n  font-size: 1.125rem;\r\n  line-height: 1.75rem;\r\n}\r\n\r\n.image-fit {\r\n  position: relative;\r\n}\r\n\r\n.image-fit>img {\r\n  position: absolute;\r\n  height: 100%;\r\n  width: 100%;\r\n  -o-object-fit: cover;\r\n  object-fit: cover;\r\n}\r\n\r\n.input-group {\r\n  display: flex;\r\n}\r\n\r\n.input-group .input-group-text {\r\n  border-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.dark .input-group .input-group-text {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.2);\r\n  background-color: rgb(var(--color-darkmode-900) / 0.2);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.input-group>.input-group-text,\r\n.input-group>.form-control {\r\n  border-radius: 0px;\r\n}\r\n\r\n.input-group>.input-group-text:not(:first-child),\r\n.input-group>.form-control:not(:first-child) {\r\n  border-left-color: transparent;\r\n}\r\n\r\n.input-group>.input-group-text:first-child,\r\n.input-group>.form-control:first-child {\r\n  border-top-left-radius: 0.25rem;\r\n  border-bottom-left-radius: 0.25rem;\r\n}\r\n\r\n.input-group>.input-group-text:last-child,\r\n.input-group>.form-control:last-child {\r\n  border-top-right-radius: 0.25rem;\r\n  border-bottom-right-radius: 0.25rem;\r\n}\r\n\r\n.input-group>.form-control {\r\n  z-index: 10;\r\n}\r\n\r\n.modal {\r\n  margin-top: -10000px;\r\n  margin-left: -10000px;\r\n  background: #000000a6;\r\n  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;\r\n  visibility: hidden;\r\n  position: fixed;\r\n  left: 0px;\r\n  top: 0px;\r\n  height: 100dvh;\r\n  width: 100vw;\r\n  opacity: 0;\r\n}\r\n\r\n.modal.modal-overlap {\r\n  background: #000000a6;\r\n}\r\n\r\n.modal.modal-static .modal-content {\r\n  -webkit-animation: modal-static-backdrop 0.3s infinite;\r\n  animation: modal-static-backdrop 0.3s infinite;\r\n  -webkit-animation-direction: alternate;\r\n  animation-direction: alternate;\r\n}\r\n\r\n.modal.show {\r\n  transition: visibility 0s ease-in-out 0s, opacity 0.4s ease-in-out 0s;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.modal.show>.modal-dialog {\r\n  margin-top: 4rem;\r\n}\r\n\r\n.modal .modal-dialog {\r\n  width: 90%;\r\n  transition: margin-top 0.4s;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  margin-top: -4rem;\r\n  margin-bottom: 4rem;\r\n}\r\n\r\n@media (min-width: 640px) {\r\n  .modal .modal-dialog {\r\n    width: 460px\r\n  }\r\n\r\n  .modal .modal-dialog.modal-sm {\r\n    width: 300px;\r\n  }\r\n\r\n  .modal .modal-dialog.modal-lg {\r\n    width: 600px;\r\n  }\r\n\r\n  .modal .modal-dialog.modal-xl {\r\n    width: 600px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .modal .modal-dialog.modal-xl {\r\n    width: 900px;\r\n  }\r\n}\r\n\r\n.modal .modal-dialog .modal-content {\r\n  position: relative;\r\n}\r\n\r\n.modal .modal-dialog .modal-content>[data-tw-dismiss=\"modal\"] {\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 0px;\r\n  margin-top: 0.75rem;\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.modal.modal-slide-over {\r\n  overflow-x: hidden;\r\n}\r\n\r\n.modal.modal-slide-over.modal-static .modal-content {\r\n  -webkit-animation: none;\r\n  animation: none;\r\n}\r\n\r\n.modal.modal-slide-over.show {\r\n  transition: visibility 0s ease-in-out 0s, opacity 0.6s ease-in-out 0s;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.modal.modal-slide-over.show>.modal-dialog {\r\n  margin-right: 0px;\r\n}\r\n\r\n.modal.modal-slide-over .modal-dialog {\r\n  margin-right: -100%;\r\n  transition: margin-right 0.6s;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.modal.modal-slide-over .modal-dialog .modal-content {\r\n  min-height: 100dvh;\r\n  border-radius: 0px;\r\n}\r\n\r\n.modal.modal-slide-over .modal-dialog .modal-content>[data-tw-dismiss=\"modal\"] {\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  right: auto;\r\n  margin-top: 1rem;\r\n  margin-left: -3rem;\r\n}\r\n\r\n.modal-content {\r\n  position: relative;\r\n  width: 100%;\r\n  border-radius: 0.375rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.dark .modal-content {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  align-items: center;\r\n  border-bottom-width: 1px;\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  font-size: 14px;\r\n}\r\n\r\n.dark .modal-header {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.modal-body {\r\n  padding: 1.25rem;\r\n}\r\n\r\n.modal-footer {\r\n  border-top-width: 1px;\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  text-align: right;\r\n}\r\n\r\n.dark .modal-footer {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n@-webkit-keyframes modal-static-backdrop {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n@keyframes modal-static-backdrop {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n\r\n  100% {\r\n    transform: scale(1.05);\r\n  }\r\n}\r\n\r\n.pagination {\r\n  margin-right: auto;\r\n  display: flex;\r\n}\r\n\r\n.pagination .page-item.active .page-link {\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  position: relative;\r\n  border-radius: 0.375rem;\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .pagination .page-item.active .page-link {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.pagination .page-item.active .page-link {\r\n  font-weight: 500;\r\n}\r\n\r\n.dark .pagination .page-item.active .page-link {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.pagination .page-item .page-link {\r\n  min-width: 40px;\r\n  display: inline-flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0.375rem;\r\n  border-width: 1px;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n  font-weight: 500;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 200ms;\r\n}\r\n\r\n.pagination .page-item .page-link:focus {\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n}\r\n\r\n.dark .pagination .page-item .page-link {\r\n  transition-property: none;\r\n}\r\n\r\n.dark .pagination .page-item .page-link:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.pagination .page-item .page-link:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.9;\r\n  --tw-bg-opacity: 0.9;\r\n}\r\n\r\n.pagination .page-item .page-link:not(button) {\r\n  text-align: center;\r\n}\r\n\r\n.pagination .page-item .page-link:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.pagination .page-item .page-link {\r\n  margin-right: 0.5rem;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-color: transparent;\r\n  font-weight: 400;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.dark .pagination .page-item .page-link {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.progress {\r\n  height: 0.5rem;\r\n  width: 100%;\r\n  border-radius: 0.25rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .progress {\r\n  background-color: rgb(0 0 0 / 0.2);\r\n}\r\n\r\n.progress-bar {\r\n  display: flex;\r\n  height: 100%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0.25rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.scrollbar-hidden::-webkit-scrollbar,\r\n.scrollbar-hidden *::-webkit-scrollbar {\r\n  width: 6px;\r\n  height: 6px;\r\n  background-color: transparent;\r\n}\r\n.scrollbar-hidden::-webkit-scrollbar-thumb,\r\n.scrollbar-hidden *::-webkit-scrollbar-thumb {\r\n  background: rgba(0,0,0,0.15);\r\n  border-radius: 3px;\r\n}\r\n.scrollbar-hidden::-webkit-scrollbar-thumb:hover,\r\n.scrollbar-hidden *::-webkit-scrollbar-thumb:hover {\r\n  background: rgba(0,0,0,0.3);\r\n}\r\n.scrollbar-hidden::-webkit-scrollbar-track,\r\n.scrollbar-hidden *::-webkit-scrollbar-track {\r\n  background: transparent;\r\n}\r\n\r\n.nav {\r\n  display: flex;\r\n  width: 100%;\r\n}\r\n\r\n.nav.nav-tabs {\r\n  border-bottom-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .nav.nav-tabs {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.nav.nav-tabs .nav-item {\r\n  margin-bottom: -1px;\r\n}\r\n\r\n.nav.nav-tabs .nav-item .nav-link {\r\n  display: block;\r\n  border-top-left-radius: 0.375rem;\r\n  border-top-right-radius: 0.375rem;\r\n  border-color: transparent;\r\n}\r\n\r\n.nav.nav-tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .nav.nav-tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.nav.nav-tabs .nav-item .nav-link.active {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  border-bottom-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n  font-weight: 500;\r\n}\r\n\r\n.dark .nav.nav-tabs .nav-item .nav-link.active {\r\n  border-left-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  border-right-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  border-top-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-border-opacity: 1;\r\n  border-bottom-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));\r\n  background-color: transparent;\r\n}\r\n\r\n.nav.nav-pills .nav-item .nav-link {\r\n  border-radius: 0.375rem;\r\n  border-width: 0px;\r\n}\r\n\r\n.nav.nav-pills .nav-item .nav-link.active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  font-weight: 500;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.nav.nav-boxed-tabs .nav-item .nav-link {\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.nav.nav-boxed-tabs .nav-item .nav-link.active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  font-weight: 500;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.nav.nav-link-tabs .nav-item .nav-link {\r\n  border-bottom-width: 2px;\r\n  border-color: transparent;\r\n}\r\n\r\n.nav.nav-link-tabs .nav-item .nav-link.active {\r\n  --tw-border-opacity: 1;\r\n  border-bottom-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  font-weight: 500;\r\n}\r\n\r\n.nav-link {\r\n  display: block;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  border-width: 1px;\r\n  border-color: transparent;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-top: 0.625rem;\r\n  padding-bottom: 0.625rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .nav-link {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.nav-link.active {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .nav-link.active {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.tab-content {\r\n  position: relative;\r\n}\r\n\r\n.tab-content .tab-pane {\r\n  top: -9999px;\r\n  left: -9999px;\r\n  transition: visibility 0s linear 0.6s, opacity 0.6s 0s;\r\n  visibility: hidden;\r\n  position: absolute;\r\n  opacity: 0;\r\n}\r\n\r\n.tab-content .tab-pane.active {\r\n  transition: visibility 0s linear 0s, opacity 0.6s 0s;\r\n  visibility: visible;\r\n  position: static;\r\n  opacity: 1;\r\n}\r\n\r\n.typing-dots span {\r\n  opacity: 0;\r\n}\r\n\r\n.typing-dots span:nth-child(1) {\r\n  -webkit-animation: 1s type-animation infinite 0.33333s;\r\n  animation: 1s type-animation infinite 0.33333s;\r\n}\r\n\r\n.typing-dots span:nth-child(2) {\r\n  -webkit-animation: 1s type-animation infinite 0.66666s;\r\n  animation: 1s type-animation infinite 0.66666s;\r\n}\r\n\r\n.typing-dots span:nth-child(3) {\r\n  -webkit-animation: 1s type-animation infinite 0.99999s;\r\n  animation: 1s type-animation infinite 0.99999s;\r\n}\r\n\r\n@-webkit-keyframes type-animation {\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes type-animation {\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.zoom-in {\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  cursor: pointer;\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-duration: 300ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.zoom-in:hover {\r\n  --tw-scale-x: 1.05;\r\n  --tw-scale-y: 1.05;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.box {\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  position: relative;\r\n  border-radius: 0.375rem;\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .box {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.visible {\r\n  visibility: visible;\r\n}\r\n\r\n.static {\r\n  position: static;\r\n}\r\n\r\n.fixed {\r\n  position: fixed;\r\n}\r\n\r\n.absolute {\r\n  position: absolute;\r\n}\r\n\r\n.relative {\r\n  position: relative;\r\n}\r\n\r\n.sticky {\r\n  position: -webkit-sticky;\r\n  position: sticky;\r\n}\r\n\r\n.inset-y-0 {\r\n  top: 0px;\r\n  bottom: 0px;\r\n}\r\n\r\n.right-0 {\r\n  right: 0px;\r\n}\r\n\r\n.bottom-0 {\r\n  bottom: 0px;\r\n}\r\n\r\n.left-0 {\r\n  left: 0px;\r\n}\r\n\r\n.top-0 {\r\n  top: 0px;\r\n}\r\n\r\n.z-10 {\r\n  z-index: 10;\r\n}\r\n\r\n.z-30 {\r\n  z-index: 30;\r\n}\r\n\r\n.z-40 {\r\n  z-index: 40;\r\n}\r\n\r\n.z-50 {\r\n  z-index: 50;\r\n}\r\n\r\n.z-\\[51\\] {\r\n  z-index: 51;\r\n}\r\n\r\n.col-span-12 {\r\n  grid-column: span 12 / span 12;\r\n}\r\n\r\n.col-span-6 {\r\n  grid-column: span 6 / span 6;\r\n}\r\n\r\n.col-span-2 {\r\n  grid-column: span 2 / span 2;\r\n}\r\n\r\n.col-span-3 {\r\n  grid-column: span 3 / span 3;\r\n}\r\n\r\n.col-span-4 {\r\n  grid-column: span 4 / span 4;\r\n}\r\n\r\n.row-start-2 {\r\n  grid-row-start: 2;\r\n}\r\n\r\n.row-start-4 {\r\n  grid-row-start: 4;\r\n}\r\n\r\n.float-right {\r\n  float: right;\r\n}\r\n\r\n.float-left {\r\n  float: left;\r\n}\r\n\r\n.clear-both {\r\n  clear: both;\r\n}\r\n\r\n.mx-1 {\r\n  margin-left: 0.25rem;\r\n  margin-right: 0.25rem;\r\n}\r\n\r\n.my-auto {\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n\r\n.-mx-3 {\r\n  margin-left: -0.75rem;\r\n  margin-right: -0.75rem;\r\n}\r\n\r\n.mx-auto {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.mx-3 {\r\n  margin-left: 0.75rem;\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.-mx-5 {\r\n  margin-left: -1.25rem;\r\n  margin-right: -1.25rem;\r\n}\r\n\r\n.mx-4 {\r\n  margin-left: 1rem;\r\n  margin-right: 1rem;\r\n}\r\n\r\n.my-4 {\r\n  margin-top: 1rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.-my-3 {\r\n  margin-top: -0.75rem;\r\n  margin-bottom: -0.75rem;\r\n}\r\n\r\n.my-5 {\r\n  margin-top: 1.25rem;\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.my-10 {\r\n  margin-top: 2.5rem;\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.mx-6 {\r\n  margin-left: 1.5rem;\r\n  margin-right: 1.5rem;\r\n}\r\n\r\n.mx-2 {\r\n  margin-left: 0.5rem;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.my-6 {\r\n  margin-top: 1.5rem;\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.mt-1 {\r\n  margin-top: 0.25rem;\r\n}\r\n\r\n.-ml-5 {\r\n  margin-left: -1.25rem;\r\n}\r\n\r\n.mr-2 {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.mr-3 {\r\n  margin-right: 0.75rem;\r\n}\r\n\r\n.mr-1 {\r\n  margin-right: 0.25rem;\r\n}\r\n\r\n.mt-2 {\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n.mt-8 {\r\n  margin-top: 2rem;\r\n}\r\n\r\n.mr-auto {\r\n  margin-right: auto;\r\n}\r\n\r\n.mt-5 {\r\n  margin-top: 1.25rem;\r\n}\r\n\r\n.mt-3 {\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.ml-0 {\r\n  margin-left: 0px;\r\n}\r\n\r\n.mr-0 {\r\n  margin-right: 0px;\r\n}\r\n\r\n.ml-3 {\r\n  margin-left: 0.75rem;\r\n}\r\n\r\n.mb-2 {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.ml-auto {\r\n  margin-left: auto;\r\n}\r\n\r\n.mt-4 {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.mt-0\\.5 {\r\n  margin-top: 0.125rem;\r\n}\r\n\r\n.mt-0 {\r\n  margin-top: 0px;\r\n}\r\n\r\n.-ml-4 {\r\n  margin-left: -1rem;\r\n}\r\n\r\n.ml-2 {\r\n  margin-left: 0.5rem;\r\n}\r\n\r\n.mt-6 {\r\n  margin-top: 1.5rem;\r\n}\r\n\r\n.-mt-12 {\r\n  margin-top: -3rem;\r\n}\r\n\r\n.mb-5 {\r\n  margin-bottom: 1.25rem;\r\n}\r\n\r\n.ml-6 {\r\n  margin-left: 1.5rem;\r\n}\r\n\r\n.ml-4 {\r\n  margin-left: 1rem;\r\n}\r\n\r\n.mr-4 {\r\n  margin-right: 1rem;\r\n}\r\n\r\n.-mt-1 {\r\n  margin-top: -0.25rem;\r\n}\r\n\r\n.-mr-1 {\r\n  margin-right: -0.25rem;\r\n}\r\n\r\n.ml-5 {\r\n  margin-left: 1.25rem;\r\n}\r\n\r\n.mb-4 {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.mr-5 {\r\n  margin-right: 1.25rem;\r\n}\r\n\r\n.mb-10 {\r\n  margin-bottom: 2.5rem;\r\n}\r\n\r\n.ml-1 {\r\n  margin-left: 0.25rem;\r\n}\r\n\r\n.mt-10 {\r\n  margin-top: 2.5rem;\r\n}\r\n\r\n.-mt-2 {\r\n  margin-top: -0.5rem;\r\n}\r\n\r\n.ml-0\\.5 {\r\n  margin-left: 0.125rem;\r\n}\r\n\r\n.mt-12 {\r\n  margin-top: 3rem;\r\n}\r\n\r\n.-mb-6 {\r\n  margin-bottom: -1.5rem;\r\n}\r\n\r\n.mb-3 {\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.-ml-1 {\r\n  margin-left: -0.25rem;\r\n}\r\n\r\n.-mb-10 {\r\n  margin-bottom: -2.5rem;\r\n}\r\n\r\n.mb-6 {\r\n  margin-bottom: 1.5rem;\r\n}\r\n\r\n.-ml-0\\.5 {\r\n  margin-left: -0.125rem;\r\n}\r\n\r\n.-ml-0 {\r\n  margin-left: -0px;\r\n}\r\n\r\n.mr-0\\.5 {\r\n  margin-right: 0.125rem;\r\n}\r\n\r\n.mt-1\\.5 {\r\n  margin-top: 0.375rem;\r\n}\r\n\r\n.-mr-2 {\r\n  margin-right: -0.5rem;\r\n}\r\n\r\n.-mb-1\\.5 {\r\n  margin-bottom: -0.375rem;\r\n}\r\n\r\n.-ml-2\\.5 {\r\n  margin-left: -0.625rem;\r\n}\r\n\r\n.-mb-1 {\r\n  margin-bottom: -0.25rem;\r\n}\r\n\r\n.-ml-2 {\r\n  margin-left: -0.5rem;\r\n}\r\n\r\n.-mt-3 {\r\n  margin-top: -0.75rem;\r\n}\r\n\r\n.-mr-12 {\r\n  margin-right: -3rem;\r\n}\r\n\r\n.mt-14 {\r\n  margin-top: 3.5rem;\r\n}\r\n\r\n.ml-1\\.5 {\r\n  margin-left: 0.375rem;\r\n}\r\n\r\n.-mt-4 {\r\n  margin-top: -1rem;\r\n}\r\n\r\n.ml-3\\.5 {\r\n  margin-left: 0.875rem;\r\n}\r\n\r\n.-mb-7 {\r\n  margin-bottom: -1.75rem;\r\n}\r\n\r\n.-mt-8 {\r\n  margin-top: -2rem;\r\n}\r\n\r\n.mt-3\\.5 {\r\n  margin-top: 0.875rem;\r\n}\r\n\r\n.-mt-1\\.5 {\r\n  margin-top: -0.375rem;\r\n}\r\n\r\n.mb-8 {\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.-mt-10 {\r\n  margin-top: -2.5rem;\r\n}\r\n\r\n.mr-6 {\r\n  margin-right: 1.5rem;\r\n}\r\n\r\n.mt-20 {\r\n  margin-top: 5rem;\r\n}\r\n\r\n.mt-16 {\r\n  margin-top: 4rem;\r\n}\r\n\r\n.-mt-16 {\r\n  margin-top: -4rem;\r\n}\r\n\r\n.mt-2\\.5 {\r\n  margin-top: 0.625rem;\r\n}\r\n\r\n.ml-8 {\r\n  margin-left: 2rem;\r\n}\r\n\r\n.mb-1 {\r\n  margin-bottom: 0.25rem;\r\n}\r\n\r\n.-mr-5 {\r\n  margin-right: -1.25rem;\r\n}\r\n\r\n.mr-10 {\r\n  margin-right: 2.5rem;\r\n}\r\n\r\n.mr-52 {\r\n  margin-right: 13rem;\r\n}\r\n\r\n.block {\r\n  display: block;\r\n}\r\n\r\n.inline-block {\r\n  display: inline-block;\r\n}\r\n\r\n.inline {\r\n  display: inline;\r\n}\r\n\r\n.flex {\r\n  display: flex;\r\n}\r\n\r\n.inline-flex {\r\n  display: inline-flex;\r\n}\r\n\r\n.table {\r\n  display: table;\r\n}\r\n\r\n.grid {\r\n  display: grid;\r\n}\r\n\r\n.hidden {\r\n  display: none;\r\n}\r\n\r\n.h-0 {\r\n  height: 0px;\r\n}\r\n\r\n.h-10 {\r\n  height: 2.5rem;\r\n}\r\n\r\n.h-4 {\r\n  height: 1rem;\r\n}\r\n\r\n.h-6 {\r\n  height: 1.5rem;\r\n}\r\n\r\n.h-5 {\r\n  height: 1.25rem;\r\n}\r\n\r\n.h-40 {\r\n  height: 10rem;\r\n}\r\n\r\n.h-8 {\r\n  height: 2rem;\r\n}\r\n\r\n.h-3 {\r\n  height: 0.75rem;\r\n}\r\n\r\n.h-\\[320px\\] {\r\n  height: 320px;\r\n}\r\n\r\n.h-12 {\r\n  height: 3rem;\r\n}\r\n\r\n.h-2 {\r\n  height: 0.5rem;\r\n}\r\n\r\n.h-px {\r\n  height: 1px;\r\n}\r\n\r\n.h-\\[400px\\] {\r\n  height: 400px;\r\n}\r\n\r\n.h-20 {\r\n  height: 5rem;\r\n}\r\n\r\n.h-full {\r\n  height: 100%;\r\n}\r\n\r\n.h-16 {\r\n  height: 4rem;\r\n}\r\n\r\n.h-32 {\r\n  height: 8rem;\r\n}\r\n\r\n.h-\\[275px\\] {\r\n  height: 275px;\r\n}\r\n\r\n.h-\\[213px\\] {\r\n  height: 213px;\r\n}\r\n\r\n.h-\\[90px\\] {\r\n  height: 90px;\r\n}\r\n\r\n.h-\\[58px\\] {\r\n  height: 58px;\r\n}\r\n\r\n.h-\\[79px\\] {\r\n  height: 79px;\r\n}\r\n\r\n.h-\\[208px\\] {\r\n  height: 208px;\r\n}\r\n\r\n.h-\\[290px\\] {\r\n  height: 290px;\r\n}\r\n\r\n.h-\\[215px\\] {\r\n  height: 215px;\r\n}\r\n\r\n.h-\\[110px\\] {\r\n  height: 110px;\r\n}\r\n\r\n.h-\\[196px\\] {\r\n  height: 196px;\r\n}\r\n\r\n.h-screen {\r\n  height: 100dvh;\r\n}\r\n\r\n.h-48 {\r\n  height: 12rem;\r\n}\r\n\r\n.h-64 {\r\n  height: 16rem;\r\n}\r\n\r\n.h-56 {\r\n  height: 14rem;\r\n}\r\n\r\n.h-24 {\r\n  height: 6rem;\r\n}\r\n\r\n.h-\\[55px\\] {\r\n  height: 55px;\r\n}\r\n\r\n.h-\\[30px\\] {\r\n  height: 30px;\r\n}\r\n\r\n.h-1 {\r\n  height: 0.25rem;\r\n}\r\n\r\n.h-\\[51px\\] {\r\n  height: 51px;\r\n}\r\n\r\n.h-\\[420px\\] {\r\n  height: 420px;\r\n}\r\n\r\n.h-\\[212px\\] {\r\n  height: 212px;\r\n}\r\n\r\n.h-\\[70px\\] {\r\n  height: 70px;\r\n}\r\n\r\n.h-\\[45px\\] {\r\n  height: 45px;\r\n}\r\n\r\n.max-h-full {\r\n  max-height: 100%;\r\n}\r\n\r\n.min-h-screen {\r\n  min-height: 100dvh;\r\n}\r\n\r\n.w-0 {\r\n  width: 0px;\r\n}\r\n\r\n.w-10 {\r\n  width: 2.5rem;\r\n}\r\n\r\n.w-4 {\r\n  width: 1rem;\r\n}\r\n\r\n.w-full {\r\n  width: 100%;\r\n}\r\n\r\n.w-6 {\r\n  width: 1.5rem;\r\n}\r\n\r\n.w-5 {\r\n  width: 1.25rem;\r\n}\r\n\r\n.w-40 {\r\n  width: 10rem;\r\n}\r\n\r\n.w-8 {\r\n  width: 2rem;\r\n}\r\n\r\n.w-3 {\r\n  width: 0.75rem;\r\n}\r\n\r\n.w-20 {\r\n  width: 5rem;\r\n}\r\n\r\n.w-12 {\r\n  width: 3rem;\r\n}\r\n\r\n.w-24 {\r\n  width: 6rem;\r\n}\r\n\r\n.w-32 {\r\n  width: 8rem;\r\n}\r\n\r\n.w-2 {\r\n  width: 0.5rem;\r\n}\r\n\r\n.w-56 {\r\n  width: 14rem;\r\n}\r\n\r\n.w-16 {\r\n  width: 4rem !important;\r\n}\r\n\r\n.w-px {\r\n  width: 1px;\r\n}\r\n\r\n.w-52 {\r\n  width: 13rem;\r\n}\r\n\r\n.w-2\\/4 {\r\n  width: 50%;\r\n}\r\n\r\n.w-\\[90px\\] {\r\n  width: 90px;\r\n}\r\n\r\n.w-4\\/5 {\r\n  width: 80%;\r\n}\r\n\r\n.w-2\\/5 {\r\n  width: 40%;\r\n}\r\n\r\n.w-48 {\r\n  width: 12rem;\r\n}\r\n\r\n.w-1\\/2 {\r\n  width: 50%;\r\n}\r\n\r\n.w-44 {\r\n  width: 11rem;\r\n}\r\n\r\n.w-auto {\r\n  width: auto;\r\n}\r\n\r\n.w-3\\/4 {\r\n  width: 75%;\r\n}\r\n\r\n.w-10\\/12 {\r\n  width: 83.333333%;\r\n}\r\n\r\n.w-60 {\r\n  width: 15rem;\r\n}\r\n\r\n.w-3\\/5 {\r\n  width: 60%;\r\n}\r\n\r\n.w-72 {\r\n  width: 18rem;\r\n}\r\n\r\n.w-64 {\r\n  width: 16rem;\r\n}\r\n\r\n.w-1\\/4 {\r\n  width: 25%;\r\n}\r\n\r\n.w-5\\/6 {\r\n  width: 83.333333%;\r\n}\r\n\r\n.w-2\\/3 {\r\n  width: 66.666667%;\r\n}\r\n\r\n.max-w-\\[50\\%\\] {\r\n  max-width: 50%;\r\n}\r\n\r\n.flex-none {\r\n  flex: none;\r\n}\r\n\r\n.flex-1 {\r\n  flex: 1 1 0%;\r\n}\r\n\r\n.rotate-180 {\r\n  --tw-rotate: 180deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n}\r\n\r\n.-rotate-90 {\r\n  --tw-rotate: -90deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n}\r\n\r\n.scale-110 {\r\n  --tw-scale-x: 1.1;\r\n  --tw-scale-y: 1.1;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n}\r\n\r\n.transform {\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n}\r\n\r\n.cursor-pointer {\r\n  cursor: pointer;\r\n}\r\n\r\n.select-none {\r\n  -webkit-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.resize-none {\r\n  resize: none;\r\n}\r\n\r\n.resize {\r\n  resize: both;\r\n}\r\n\r\n.grid-cols-12 {\r\n  grid-template-columns: repeat(12, minmax(0, 1fr));\r\n}\r\n\r\n.grid-cols-7 {\r\n  grid-template-columns: repeat(7, minmax(0, 1fr));\r\n}\r\n\r\n.grid-cols-8 {\r\n  grid-template-columns: repeat(8, minmax(0, 1fr));\r\n}\r\n\r\n.grid-cols-4 {\r\n  grid-template-columns: repeat(4, minmax(0, 1fr));\r\n}\r\n\r\n.grid-cols-3 {\r\n  grid-template-columns: repeat(3, minmax(0, 1fr));\r\n}\r\n\r\n.grid-cols-2 {\r\n  grid-template-columns: repeat(2, minmax(0, 1fr));\r\n}\r\n\r\n.grid-cols-1 {\r\n  grid-template-columns: repeat(1, minmax(0, 1fr));\r\n}\r\n\r\n.flex-col {\r\n  flex-direction: column;\r\n}\r\n\r\n.flex-col-reverse {\r\n  flex-direction: column-reverse;\r\n}\r\n\r\n.flex-wrap {\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.items-start {\r\n  align-items: flex-start;\r\n}\r\n\r\n.items-end {\r\n  align-items: flex-end;\r\n}\r\n\r\n.items-center {\r\n  align-items: center;\r\n}\r\n\r\n.justify-start {\r\n  justify-content: flex-start;\r\n}\r\n\r\n.justify-end {\r\n  justify-content: flex-end;\r\n}\r\n\r\n.justify-center {\r\n  justify-content: center;\r\n}\r\n\r\n.gap-6 {\r\n  gap: 1.5rem;\r\n}\r\n\r\n.gap-5 {\r\n  gap: 1.25rem;\r\n}\r\n\r\n.gap-4 {\r\n  gap: 1rem;\r\n}\r\n\r\n.gap-2 {\r\n  gap: 0.5rem;\r\n}\r\n\r\n.gap-1 {\r\n  gap: 0.25rem;\r\n}\r\n\r\n.gap-3 {\r\n  gap: 0.75rem;\r\n}\r\n\r\n.gap-x-6 {\r\n  -moz-column-gap: 1.5rem;\r\n  column-gap: 1.5rem;\r\n}\r\n\r\n.gap-y-6 {\r\n  row-gap: 1.5rem;\r\n}\r\n\r\n.gap-y-8 {\r\n  row-gap: 2rem;\r\n}\r\n\r\n.gap-x-10 {\r\n  -moz-column-gap: 2.5rem;\r\n  column-gap: 2.5rem;\r\n}\r\n\r\n.gap-y-3 {\r\n  row-gap: 0.75rem;\r\n}\r\n\r\n.gap-y-2 {\r\n  row-gap: 0.5rem;\r\n}\r\n\r\n.gap-x-5 {\r\n  -moz-column-gap: 1.25rem;\r\n  column-gap: 1.25rem;\r\n}\r\n\r\n.gap-y-5 {\r\n  row-gap: 1.25rem;\r\n}\r\n\r\n.overflow-auto {\r\n  overflow: auto;\r\n}\r\n\r\n.overflow-hidden {\r\n  overflow: hidden;\r\n}\r\n\r\n.overflow-x-auto {\r\n  overflow-x: auto;\r\n}\r\n\r\n.overflow-y-auto {\r\n  overflow-y: auto;\r\n}\r\n\r\n.overflow-y-hidden {\r\n  overflow-y: hidden;\r\n}\r\n\r\n.overflow-y-scroll {\r\n  overflow-y: scroll;\r\n}\r\n\r\n.truncate {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.whitespace-nowrap {\r\n  white-space: nowrap;\r\n}\r\n\r\n.rounded-full {\r\n  border-radius: 9999px;\r\n}\r\n\r\n.rounded-md {\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.rounded {\r\n  border-radius: 0.25rem;\r\n}\r\n\r\n.rounded-lg {\r\n  border-radius: 0.5rem;\r\n}\r\n\r\n.rounded-t-md {\r\n  border-top-left-radius: 0.375rem;\r\n  border-top-right-radius: 0.375rem;\r\n}\r\n\r\n.rounded-r-md {\r\n  border-top-right-radius: 0.375rem;\r\n  border-bottom-right-radius: 0.375rem;\r\n}\r\n\r\n.rounded-l-md {\r\n  border-top-left-radius: 0.375rem;\r\n  border-bottom-left-radius: 0.375rem;\r\n}\r\n\r\n.rounded-l {\r\n  border-top-left-radius: 0.25rem;\r\n  border-bottom-left-radius: 0.25rem;\r\n}\r\n\r\n.border {\r\n  border-width: 1px;\r\n}\r\n\r\n.border-2 {\r\n  border-width: 2px;\r\n}\r\n\r\n.border-0 {\r\n  border-width: 0px;\r\n}\r\n\r\n.border-4 {\r\n  border-width: 4px;\r\n}\r\n\r\n.border-b {\r\n  border-bottom-width: 1px;\r\n}\r\n\r\n.border-t {\r\n  border-top-width: 1px;\r\n}\r\n\r\n.border-r {\r\n  border-right-width: 1px;\r\n}\r\n\r\n.border-l {\r\n  border-left-width: 1px;\r\n}\r\n\r\n.border-b-2 {\r\n  border-bottom-width: 2px;\r\n}\r\n\r\n.border-l-2 {\r\n  border-left-width: 2px;\r\n}\r\n\r\n.border-dashed {\r\n  border-style: dashed;\r\n}\r\n\r\n.border-dotted {\r\n  border-style: dotted;\r\n}\r\n\r\n.border-slate-200\\/60 {\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n}\r\n\r\n.border-slate-300 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-300) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-white {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(255 255 255 / var(--tw-border-opacity));\r\n}\r\n\r\n.border-transparent {\r\n  border-color: transparent;\r\n}\r\n\r\n.border-slate-200 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-slate-400 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-black {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(0 0 0 / var(--tw-border-opacity));\r\n}\r\n\r\n.border-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-slate-500 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-500) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-white\\/10 {\r\n  border-color: rgb(255 255 255 / 0.1);\r\n}\r\n\r\n.border-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.border-white\\/\\[0\\.08\\] {\r\n  border-color: rgb(255 255 255 / 0.08);\r\n}\r\n\r\n.border-opacity-10 {\r\n  --tw-border-opacity: 0.1;\r\n}\r\n\r\n.bg-white {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-slate-500 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-500) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-primary\\/10 {\r\n  background-color: rgb(var(--color-primary) / 0.1);\r\n}\r\n\r\n.bg-primary {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-slate-100 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-white\\/20 {\r\n  background-color: rgb(255 255 255 / 0.2);\r\n}\r\n\r\n.bg-pending {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-pending) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-warning {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-warning) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-success\\/20 {\r\n  background-color: rgb(var(--color-success) / 0.2);\r\n}\r\n\r\n.bg-pending\\/20 {\r\n  background-color: rgb(var(--color-pending) / 0.2);\r\n}\r\n\r\n.bg-danger {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-success {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-success) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-slate-200 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-transparent {\r\n  background-color: transparent;\r\n}\r\n\r\n.bg-slate-300\\/50 {\r\n  background-color: rgb(var(--color-slate-300) / 0.5);\r\n}\r\n\r\n.bg-white\\/10 {\r\n  background-color: rgb(255 255 255 / 0.1);\r\n}\r\n\r\n.bg-pending\\/10 {\r\n  background-color: rgb(var(--color-pending) / 0.1);\r\n}\r\n\r\n.bg-slate-300 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-yellow-200 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(254 240 138 / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-cyan-900 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(22 78 99 / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-blue-800 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(30 64 175 / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-blue-900 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(30 58 138 / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-emerald-900 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(6 78 59 / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-indigo-900 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(49 46 129 / var(--tw-bg-opacity));\r\n}\r\n\r\n.bg-primary\\/80 {\r\n  background-color: rgb(var(--color-primary) / 0.8);\r\n}\r\n\r\n.bg-opacity-20 {\r\n  --tw-bg-opacity: 0.2;\r\n}\r\n\r\n.fill-current {\r\n  fill: currentColor;\r\n}\r\n\r\n.p-0 {\r\n  padding: 0px;\r\n}\r\n\r\n.p-5 {\r\n  padding: 1.25rem;\r\n}\r\n\r\n.p-4 {\r\n  padding: 1rem;\r\n}\r\n\r\n.p-3 {\r\n  padding: 0.75rem;\r\n}\r\n\r\n.p-1 {\r\n  padding: 0.25rem;\r\n}\r\n\r\n.p-2 {\r\n  padding: 0.5rem;\r\n}\r\n\r\n.p-8 {\r\n  padding: 2rem;\r\n}\r\n\r\n.p-10 {\r\n  padding: 2.5rem;\r\n}\r\n\r\n.py-1 {\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n}\r\n\r\n.px-2 {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n}\r\n\r\n.px-1 {\r\n  padding-left: 0.25rem;\r\n  padding-right: 0.25rem;\r\n}\r\n\r\n.px-5 {\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n}\r\n\r\n.py-4 {\r\n  padding-top: 1rem;\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.py-3 {\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n.py-6 {\r\n  padding-top: 1.5rem;\r\n  padding-bottom: 1.5rem;\r\n}\r\n\r\n.py-0\\.5 {\r\n  padding-top: 0.125rem;\r\n  padding-bottom: 0.125rem;\r\n}\r\n\r\n.py-0 {\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.py-2 {\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.px-4 {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n}\r\n\r\n.py-10 {\r\n  padding-top: 2.5rem;\r\n  padding-bottom: 2.5rem;\r\n}\r\n\r\n.py-5 {\r\n  padding-top: 1.25rem;\r\n  padding-bottom: 1.25rem;\r\n}\r\n\r\n.px-0 {\r\n  padding-left: 0px;\r\n  padding-right: 0px;\r\n}\r\n\r\n.px-8 {\r\n  padding-left: 2rem;\r\n  padding-right: 2rem;\r\n}\r\n\r\n.py-12 {\r\n  padding-top: 3rem;\r\n  padding-bottom: 3rem;\r\n}\r\n\r\n.py-1\\.5 {\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n}\r\n\r\n.px-10 {\r\n  padding-left: 2.5rem;\r\n  padding-right: 2.5rem;\r\n}\r\n\r\n.px-3 {\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n}\r\n\r\n.px-2\\.5 {\r\n  padding-left: 0.625rem;\r\n  padding-right: 0.625rem;\r\n}\r\n\r\n.py-8 {\r\n  padding-top: 2rem;\r\n  padding-bottom: 2rem;\r\n}\r\n\r\n.px-6 {\r\n  padding-left: 1.5rem;\r\n  padding-right: 1.5rem;\r\n}\r\n\r\n.py-16 {\r\n  padding-top: 4rem;\r\n  padding-bottom: 4rem;\r\n}\r\n\r\n.pt-3 {\r\n  padding-top: 0.75rem;\r\n}\r\n\r\n.pb-5 {\r\n  padding-bottom: 1.25rem;\r\n}\r\n\r\n.pr-10 {\r\n  padding-right: 2.5rem;\r\n}\r\n\r\n.pt-6 {\r\n  padding-top: 1.5rem;\r\n}\r\n\r\n.pb-6 {\r\n  padding-bottom: 1.5rem;\r\n}\r\n\r\n.pt-16 {\r\n  padding-top: 4rem;\r\n}\r\n\r\n.pt-5 {\r\n  padding-top: 1.25rem;\r\n}\r\n\r\n.pl-16 {\r\n  padding-left: 4rem;\r\n}\r\n\r\n.pb-10 {\r\n  padding-bottom: 2.5rem;\r\n}\r\n\r\n.pr-1 {\r\n  padding-right: 0.25rem;\r\n}\r\n\r\n.pt-1 {\r\n  padding-top: 0.25rem;\r\n}\r\n\r\n.pt-4 {\r\n  padding-top: 1rem;\r\n}\r\n\r\n.pb-8 {\r\n  padding-bottom: 2rem;\r\n}\r\n\r\n.pl-10 {\r\n  padding-left: 2.5rem;\r\n}\r\n\r\n.pl-4 {\r\n  padding-left: 1rem;\r\n}\r\n\r\n.pb-2 {\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.pt-0\\.5 {\r\n  padding-top: 0.125rem;\r\n}\r\n\r\n.pt-0 {\r\n  padding-top: 0px;\r\n}\r\n\r\n.pl-3 {\r\n  padding-left: 0.75rem;\r\n}\r\n\r\n.pl-3\\.5 {\r\n  padding-left: 0.875rem;\r\n}\r\n\r\n.pt-8 {\r\n  padding-top: 2rem;\r\n}\r\n\r\n.pb-14 {\r\n  padding-bottom: 3.5rem;\r\n}\r\n\r\n.pb-3 {\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n.pl-12 {\r\n  padding-left: 3rem;\r\n}\r\n\r\n.pl-5 {\r\n  padding-left: 1.25rem;\r\n}\r\n\r\n.pb-4 {\r\n  padding-bottom: 1rem;\r\n}\r\n\r\n.pt-2 {\r\n  padding-top: 0.5rem;\r\n}\r\n\r\n.pt-10 {\r\n  padding-top: 2.5rem;\r\n}\r\n\r\n.pl-1 {\r\n  padding-left: 0.25rem;\r\n}\r\n\r\n.pr-5 {\r\n  padding-right: 1.25rem;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-right {\r\n  text-align: right;\r\n}\r\n\r\n.text-justify {\r\n  text-align: justify;\r\n}\r\n\r\n.align-top {\r\n  vertical-align: top;\r\n}\r\n\r\n.text-xs {\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n}\r\n\r\n.text-lg {\r\n  font-size: 1.125rem;\r\n  line-height: 1.75rem;\r\n}\r\n\r\n.text-base {\r\n  font-size: 1rem;\r\n  line-height: 1.5rem;\r\n}\r\n\r\n.text-xl {\r\n  font-size: 1.25rem;\r\n  line-height: 1.75rem;\r\n}\r\n\r\n.text-2xl {\r\n  font-size: 1.5rem;\r\n  line-height: 2rem;\r\n}\r\n\r\n.text-3xl {\r\n  font-size: 1.875rem;\r\n  line-height: 2.25rem;\r\n}\r\n\r\n.text-sm {\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n}\r\n\r\n.text-8xl {\r\n  font-size: 6rem;\r\n  line-height: 1;\r\n}\r\n\r\n.text-4xl {\r\n  font-size: 2.25rem;\r\n  line-height: 2.5rem;\r\n}\r\n\r\n.text-5xl {\r\n  font-size: 3rem;\r\n  line-height: 1;\r\n}\r\n\r\n.font-medium {\r\n  font-weight: 500;\r\n}\r\n\r\n.font-normal {\r\n  font-weight: 400;\r\n}\r\n\r\n.font-semibold {\r\n  font-weight: 600;\r\n}\r\n\r\n.font-bold {\r\n  font-weight: 700;\r\n}\r\n\r\n.font-extrabold {\r\n  font-weight: 800;\r\n}\r\n\r\n.uppercase {\r\n  text-transform: uppercase;\r\n}\r\n\r\n.lowercase {\r\n  text-transform: lowercase;\r\n}\r\n\r\n.capitalize {\r\n  text-transform: capitalize;\r\n}\r\n\r\n.normal-case {\r\n  text-transform: none;\r\n}\r\n\r\n.leading-relaxed {\r\n  line-height: 1.625;\r\n}\r\n\r\n.leading-8 {\r\n  line-height: 2rem;\r\n}\r\n\r\n.leading-\\[2\\.15rem\\] {\r\n  line-height: 2.15rem;\r\n}\r\n\r\n.leading-3 {\r\n  line-height: .75rem;\r\n}\r\n\r\n.leading-6 {\r\n  line-height: 1.5rem;\r\n}\r\n\r\n.leading-5 {\r\n  line-height: 1.25rem;\r\n}\r\n\r\n.leading-tight {\r\n  line-height: 1.25;\r\n}\r\n\r\n.leading-none {\r\n  line-height: 1;\r\n}\r\n\r\n.text-gray-600 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(75 85 99 / var(--tw-text-opacity));\r\n}\r\n\r\n.text-slate-500 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-success {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-success) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-danger {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-danger) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-slate-600 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-red-500 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(239 68 68 / var(--tw-text-opacity));\r\n}\r\n\r\n.text-slate-700 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-white {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.text-primary {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-slate-400 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-pending {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-pending) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-warning {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-warning) / var(--tw-text-opacity));\r\n}\r\n\r\n.text-white\\/70 {\r\n  color: rgb(255 255 255 / 0.7);\r\n}\r\n\r\n.text-gray-700 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(55 65 81 / var(--tw-text-opacity));\r\n}\r\n\r\n.text-primary\\/80 {\r\n  color: rgb(var(--color-primary) / 0.8);\r\n}\r\n\r\n.text-white\\/60 {\r\n  color: rgb(255 255 255 / 0.6);\r\n}\r\n\r\n.text-opacity-80 {\r\n  --tw-text-opacity: 0.8;\r\n}\r\n\r\n.text-opacity-70 {\r\n  --tw-text-opacity: 0.7;\r\n}\r\n\r\n.underline {\r\n  -webkit-text-decoration-line: underline;\r\n  text-decoration-line: underline;\r\n}\r\n\r\n.decoration-dotted {\r\n  -webkit-text-decoration-style: dotted;\r\n  text-decoration-style: dotted;\r\n}\r\n\r\n.underline-offset-4 {\r\n  text-underline-offset: 4px;\r\n}\r\n\r\n.opacity-0 {\r\n  opacity: 0;\r\n}\r\n\r\n.shadow-md {\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.shadow-none {\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.shadow-sm {\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.shadow-lg {\r\n  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.shadow {\r\n  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.filter {\r\n  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);\r\n}\r\n\r\n.transition {\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 150ms;\r\n}\r\n\r\n.duration-300 {\r\n  transition-duration: 300ms;\r\n}\r\n\r\n.ease-in-out {\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n/*\r\n   |--------------------------------------------------------------------------\r\n   | Colors\r\n   |--------------------------------------------------------------------------\r\n   |\r\n   | Import all fonts used in the template, the font configuration can be\r\n   | seen in \"tailwind.config.js\".\r\n   |\r\n   | Please check this link for more details:\r\n   | https://tailwindcss.com/docs/theme\r\n   |\r\n   */\r\n/* Default colors */\r\n:root {\r\n  --color-primary: 0 0 0;\r\n  /*22 78 99*/\r\n  --color-secondary: 67 66 66;\r\n  --color-success: 13 148 136;\r\n  --color-info: 6 182 212;\r\n  --color-warning: 245 158 11;\r\n  --color-pending: 217 119 6;\r\n  --color-danger: 185 28 28;\r\n  --color-light: 241 245 249;\r\n  --color-dark: 30 41 59;\r\n  --color-slate-50: 248 250 252;\r\n  --color-slate-100: 241 245 249;\r\n  --color-slate-200: 226 232 240;\r\n  --color-slate-300: 203 213 225;\r\n  --color-slate-400: 148 163 184;\r\n  --color-slate-500: 100 116 139;\r\n  --color-slate-600: 71 85 105;\r\n  --color-slate-700: 51 65 85;\r\n  --color-slate-800: 30 41 59;\r\n  --color-slate-900: 15 23 42;\r\n}\r\n\r\n/* Default dark-mode colors */\r\n.dark {\r\n  --color-primary: 21 94 117;\r\n  --color-slate-500: 148 163 184;\r\n  --color-darkmode-50: 87 103 132;\r\n  --color-darkmode-100: 74 90 121;\r\n  --color-darkmode-200: 65 81 114;\r\n  --color-darkmode-300: 53 69 103;\r\n  --color-darkmode-400: 48 61 93;\r\n  --color-darkmode-500: 41 53 82;\r\n  --color-darkmode-600: 40 51 78;\r\n  --color-darkmode-700: 35 45 69;\r\n  --color-darkmode-800: 27 37 59;\r\n  --color-darkmode-900: 15 23 42;\r\n}\r\n\r\n/* Theme 1 colors */\r\n.theme-1 {\r\n  --color-primary: 30 64 175;\r\n  --color-secondary: 226 232 240;\r\n  --color-success: 132 204 22;\r\n  --color-info: 6 182 212;\r\n  --color-warning: 250 204 21;\r\n  --color-pending: 249 115 22;\r\n  --color-danger: 220 38 38;\r\n  --color-light: 241 245 249;\r\n  --color-dark: 30 41 59;\r\n}\r\n\r\n.theme-1.dark {\r\n  --color-primary: 29 78 216;\r\n}\r\n\r\n/* Theme 2 colors */\r\n.theme-2 {\r\n  --color-primary: 30 58 138;\r\n  --color-secondary: 226 232 240;\r\n  --color-success: 13 148 136;\r\n  --color-info: 6 182 212;\r\n  --color-warning: 245 158 11;\r\n  --color-pending: 249 115 22;\r\n  --color-danger: 185 28 28;\r\n  --color-light: 241 245 249;\r\n  --color-dark: 30 41 59;\r\n}\r\n\r\n.theme-2.dark {\r\n  --color-primary: 30 64 175;\r\n}\r\n\r\n/* Theme 3 colors */\r\n.theme-3 {\r\n  --color-primary: 6 78 59;\r\n  --color-secondary: 226 232 240;\r\n  --color-success: 5 150 105;\r\n  --color-info: 6 182 212;\r\n  --color-warning: 250 204 21;\r\n  --color-pending: 245 158 11;\r\n  --color-danger: 225 29 72;\r\n  --color-light: 241 245 249;\r\n  --color-dark: 30 41 59;\r\n}\r\n\r\n.theme-3.dark {\r\n  --color-primary: 6 95 70;\r\n}\r\n\r\n/* Theme 4 colors */\r\n.theme-4 {\r\n  --color-primary: 49 46 129;\r\n  --color-secondary: 226 232 240;\r\n  --color-success: 5 150 105;\r\n  --color-info: 6 182 212;\r\n  --color-warning: 234 179 8;\r\n  --color-pending: 234 88 12;\r\n  --color-danger: 185 28 28;\r\n  --color-light: 241 245 249;\r\n  --color-dark: 30 41 59;\r\n}\r\n\r\n.theme-4.dark {\r\n  --color-primary: 67 56 202;\r\n}\r\n\r\n/*\r\n   |--------------------------------------------------------------------------\r\n   | Fonts\r\n   |--------------------------------------------------------------------------\r\n   |\r\n   | Import all fonts used in the template, the font configuration can be\r\n   | seen in \"tailwind.config.js\".\r\n   |\r\n   | Please check this link for more details:\r\n   | https://tailwindcss.com/docs/theme\r\n   |\r\n   */\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin Italic\"), local(\"Roboto-ThinItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEz0dL-vwnYh2eg.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin Italic\"), local(\"Roboto-ThinItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzQdL-vwnYh2eg.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin Italic\"), local(\"Roboto-ThinItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzwdL-vwnYh2eg.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin Italic\"), local(\"Roboto-ThinItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzMdL-vwnYh2eg.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin Italic\"), local(\"Roboto-ThinItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEz8dL-vwnYh2eg.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin Italic\"), local(\"Roboto-ThinItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEz4dL-vwnYh2eg.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin Italic\"), local(\"Roboto-ThinItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOiCnqEu92Fr1Mu51QrEzAdL-vwnYg.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light Italic\"), local(\"Roboto-LightItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc3CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light Italic\"), local(\"Roboto-LightItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc-CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light Italic\"), local(\"Roboto-LightItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc2CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light Italic\"), local(\"Roboto-LightItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc5CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light Italic\"), local(\"Roboto-LightItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc1CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light Italic\"), local(\"Roboto-LightItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc0CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light Italic\"), local(\"Roboto-LightItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TjASc6CsTYl4BO.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto Italic\"), local(\"Roboto-Italic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xFIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto Italic\"), local(\"Roboto-Italic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xMIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto Italic\"), local(\"Roboto-Italic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xEIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto Italic\"), local(\"Roboto-Italic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xLIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto Italic\"), local(\"Roboto-Italic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xHIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto Italic\"), local(\"Roboto-Italic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xGIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto Italic\"), local(\"Roboto-Italic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1Mu51xIIzIXKMny.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium Italic\"), local(\"Roboto-MediumItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc3CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium Italic\"), local(\"Roboto-MediumItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc-CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium Italic\"), local(\"Roboto-MediumItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc2CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium Italic\"), local(\"Roboto-MediumItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc5CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium Italic\"), local(\"Roboto-MediumItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc1CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium Italic\"), local(\"Roboto-MediumItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc0CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium Italic\"), local(\"Roboto-MediumItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51S7ACc6CsTYl4BO.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold Italic\"), local(\"Roboto-BoldItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic3CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold Italic\"), local(\"Roboto-BoldItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic-CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold Italic\"), local(\"Roboto-BoldItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic2CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold Italic\"), local(\"Roboto-BoldItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic5CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold Italic\"), local(\"Roboto-BoldItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic1CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold Italic\"), local(\"Roboto-BoldItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic0CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold Italic\"), local(\"Roboto-BoldItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TzBic6CsTYl4BO.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black Italic\"), local(\"Roboto-BlackItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc3CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black Italic\"), local(\"Roboto-BlackItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc-CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black Italic\"), local(\"Roboto-BlackItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc2CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black Italic\"), local(\"Roboto-BlackItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc5CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black Italic\"), local(\"Roboto-BlackItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc1CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black Italic\"), local(\"Roboto-BlackItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc0CsTYl4BOQ3o.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: italic;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black Italic\"), local(\"Roboto-BlackItalic\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOjCnqEu92Fr1Mu51TLBCc6CsTYl4BO.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin\"), local(\"Roboto-Thin\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxFIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin\"), local(\"Roboto-Thin\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxMIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin\"), local(\"Roboto-Thin\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxEIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin\"), local(\"Roboto-Thin\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxLIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin\"), local(\"Roboto-Thin\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxHIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin\"), local(\"Roboto-Thin\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxGIzIXKMnyrYk.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 100;\r\n  font-display: swap;\r\n  src: local(\"Roboto Thin\"), local(\"Roboto-Thin\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOkCnqEu92Fr1MmgVxIIzIXKMny.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light\"), local(\"Roboto-Light\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fCRc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light\"), local(\"Roboto-Light\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fABc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light\"), local(\"Roboto-Light\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fCBc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light\"), local(\"Roboto-Light\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fBxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light\"), local(\"Roboto-Light\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fCxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light\"), local(\"Roboto-Light\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fChc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 300;\r\n  font-display: swap;\r\n  src: local(\"Roboto Light\"), local(\"Roboto-Light\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmSU5fBBc4AMP6lQ.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu72xKKTU1Kvnz.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu5mxKKTU1Kvnz.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu7mxKKTU1Kvnz.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4WxKKTU1Kvnz.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu7WxKKTU1Kvnz.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu7GxKKTU1Kvnz.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: swap;\r\n  src: local(\"Roboto\"), local(\"Roboto-Regular\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOmCnqEu92Fr1Mu4mxKKTU1Kg.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fCRc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fABc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fCBc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fBxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fCxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fChc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 500;\r\n  font-display: swap;\r\n  src: local(\"Roboto Medium\"), local(\"Roboto-Medium\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmEU9fBBc4AMP6lQ.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold\"), local(\"Roboto-Bold\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfCRc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold\"), local(\"Roboto-Bold\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfABc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold\"), local(\"Roboto-Bold\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfCBc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold\"), local(\"Roboto-Bold\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold\"), local(\"Roboto-Bold\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfCxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold\"), local(\"Roboto-Bold\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfChc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  font-display: swap;\r\n  src: local(\"Roboto Bold\"), local(\"Roboto-Bold\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmWUlfBBc4AMP6lQ.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/* cyrillic-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black\"), local(\"Roboto-Black\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfCRc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F,\r\n    U+FE2E-FE2F;\r\n}\r\n\r\n/* cyrillic */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black\"), local(\"Roboto-Black\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfABc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\r\n}\r\n\r\n/* greek-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black\"), local(\"Roboto-Black\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfCBc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+1F00-1FFF;\r\n}\r\n\r\n/* greek */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black\"), local(\"Roboto-Black\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfBxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0370-03FF;\r\n}\r\n\r\n/* vietnamese */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black\"), local(\"Roboto-Black\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfCxc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0102-0103, U+0110-0111, U+1EA0-1EF9, U+20AB;\r\n}\r\n\r\n/* latin-ext */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black\"), local(\"Roboto-Black\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfChc4AMP6lbBP.woff2) format(\"woff2\");\r\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB,\r\n    U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\r\n}\r\n\r\n/* latin */\r\n@font-face {\r\n  font-family: \"Roboto\";\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: swap;\r\n  src: local(\"Roboto Black\"), local(\"Roboto-Black\"),\r\n    url(https://fonts.gstatic.com/s/roboto/v20/KFOlCnqEu92Fr1MmYUtfBBc4AMP6lQ.woff2) format(\"woff2\");\r\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA,\r\n    U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215,\r\n    U+FEFF, U+FFFD;\r\n}\r\n\r\n/*\r\n   |--------------------------------------------------------------------------\r\n   | Mixins\r\n   |--------------------------------------------------------------------------\r\n   |\r\n   | Import helper mixins.\r\n   |\r\n   */\r\n/* Breakpoint up */\r\n/* Breakpoint down */\r\n/* Breakpoint only */\r\n/*\r\n   |--------------------------------------------------------------------------\r\n   | 3rd Party Libraries\r\n   |--------------------------------------------------------------------------\r\n   |\r\n   | Import 3rd party library CSS/SASS files.\r\n   |\r\n   */\r\n.breadcrumb {\r\n  display: flex;\r\n  align-items: center;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .breadcrumb {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.breadcrumb.breadcrumb-light {\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n  --tw-text-opacity: 0.9;\r\n}\r\n\r\n.breadcrumb.breadcrumb-light .breadcrumb-item:not(:first-child):before {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23e8eeff' stroke-width='1' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right breadcrumb__icon'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\r\n}\r\n\r\n.breadcrumb.breadcrumb-light .breadcrumb-item.active {\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n  --tw-text-opacity: 0.8;\r\n}\r\n\r\n.breadcrumb .breadcrumb-item:not(:first-child) {\r\n  position: relative;\r\n  margin-left: 1.25rem;\r\n  padding-left: 0.125rem;\r\n}\r\n\r\n.breadcrumb .breadcrumb-item:not(:first-child):before {\r\n  content: \"\";\r\n  width: 14px;\r\n  height: 14px;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right breadcrumb__icon'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\r\n  background-size: 100%;\r\n  margin-left: -1.125rem;\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n\r\n.breadcrumb .breadcrumb-item.active {\r\n  cursor: text;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .breadcrumb .breadcrumb-item.active {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .breadcrumb .breadcrumb-item:not(:first-child):before {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23718096' stroke-width='1' stroke-linecap='round' stroke-linejoin='round' class='feather feather-chevron-right breadcrumb__icon'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .form-inline {\r\n    display: block;\r\n  }\r\n\r\n  .form-inline .form-label {\r\n    margin-bottom: 0.5rem;\r\n    margin-right: 0px;\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n*>.intro-x:nth-child(1) {\r\n  z-index: calc(50 - 1);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(1) {\r\n  z-index: calc(50 - 1);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(1) {\r\n  /* z-index: calc(50 - 1); */\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(1) {\r\n  z-index: calc(50 - 1);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(2) {\r\n  z-index: calc(50 - 2);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(2) {\r\n  z-index: calc(50 - 2);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(2) {\r\n  /* z-index: calc(50 - 2); */\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(2) {\r\n  z-index: calc(50 - 2);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(3) {\r\n  z-index: calc(50 - 3);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(3) {\r\n  z-index: calc(50 - 3);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(3) {\r\n  z-index: calc(50 - 3);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(3) {\r\n  z-index: calc(50 - 3);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(4) {\r\n  z-index: calc(50 - 4);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(4) {\r\n  z-index: calc(50 - 4);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(4) {\r\n  z-index: calc(50 - 4);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(4) {\r\n  z-index: calc(50 - 4);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(5) {\r\n  z-index: calc(50 - 5);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(5) {\r\n  z-index: calc(50 - 5);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(5) {\r\n  z-index: calc(50 - 5);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(5) {\r\n  z-index: calc(50 - 5);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(6) {\r\n  z-index: calc(50 - 6);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(6) {\r\n  z-index: calc(50 - 6);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(6) {\r\n  z-index: calc(50 - 6);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(6) {\r\n  z-index: calc(50 - 6);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(7) {\r\n  z-index: calc(50 - 7);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(7) {\r\n  z-index: calc(50 - 7);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(7) {\r\n  z-index: calc(50 - 7);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(7) {\r\n  z-index: calc(50 - 7);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(8) {\r\n  z-index: calc(50 - 8);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(8) {\r\n  z-index: calc(50 - 8);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(8) {\r\n  z-index: calc(50 - 8);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(8) {\r\n  z-index: calc(50 - 8);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(9) {\r\n  z-index: calc(50 - 9);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(9) {\r\n  z-index: calc(50 - 9);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(9) {\r\n  z-index: calc(50 - 9);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(9) {\r\n  z-index: calc(50 - 9);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(10) {\r\n  z-index: calc(50 - 10);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(10) {\r\n  z-index: calc(50 - 10);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(10) {\r\n  z-index: calc(50 - 10);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(10) {\r\n  z-index: calc(50 - 10);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(11) {\r\n  z-index: calc(50 - 11);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(11) {\r\n  z-index: calc(50 - 11);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(11) {\r\n  z-index: calc(50 - 11);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(11) {\r\n  z-index: calc(50 - 11);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(12) {\r\n  z-index: calc(50 - 12);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(12) {\r\n  z-index: calc(50 - 12);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(12) {\r\n  z-index: calc(50 - 12);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(12) {\r\n  z-index: calc(50 - 12);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(13) {\r\n  z-index: calc(50 - 13);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(13) {\r\n  z-index: calc(50 - 13);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(13) {\r\n  z-index: calc(50 - 13);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(13) {\r\n  z-index: calc(50 - 13);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(14) {\r\n  z-index: calc(50 - 14);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(14) {\r\n  z-index: calc(50 - 14);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(14) {\r\n  z-index: calc(50 - 14);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(14) {\r\n  z-index: calc(50 - 14);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(15) {\r\n  z-index: calc(50 - 15);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(15) {\r\n  z-index: calc(50 - 15);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(15) {\r\n  z-index: calc(50 - 15);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(15) {\r\n  z-index: calc(50 - 15);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(16) {\r\n  z-index: calc(50 - 16);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(16) {\r\n  z-index: calc(50 - 16);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(16) {\r\n  z-index: calc(50 - 16);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(16) {\r\n  z-index: calc(50 - 16);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(17) {\r\n  z-index: calc(50 - 17);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(17) {\r\n  z-index: calc(50 - 17);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(17) {\r\n  z-index: calc(50 - 17);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(17) {\r\n  z-index: calc(50 - 17);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(18) {\r\n  z-index: calc(50 - 18);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(18) {\r\n  z-index: calc(50 - 18);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(18) {\r\n  z-index: calc(50 - 18);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(18) {\r\n  z-index: calc(50 - 18);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(19) {\r\n  z-index: calc(50 - 19);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(19) {\r\n  z-index: calc(50 - 19);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(19) {\r\n  z-index: calc(50 - 19);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(19) {\r\n  z-index: calc(50 - 19);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(20) {\r\n  z-index: calc(50 - 20);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(20) {\r\n  z-index: calc(50 - 20);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(20) {\r\n  z-index: calc(50 - 20);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(20) {\r\n  z-index: calc(50 - 20);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(21) {\r\n  z-index: calc(50 - 21);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(21) {\r\n  z-index: calc(50 - 21);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(21) {\r\n  z-index: calc(50 - 21);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(21) {\r\n  z-index: calc(50 - 21);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(22) {\r\n  z-index: calc(50 - 22);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(22) {\r\n  z-index: calc(50 - 22);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(22) {\r\n  z-index: calc(50 - 22);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(22) {\r\n  z-index: calc(50 - 22);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(23) {\r\n  z-index: calc(50 - 23);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(23) {\r\n  z-index: calc(50 - 23);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(23) {\r\n  z-index: calc(50 - 23);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(23) {\r\n  z-index: calc(50 - 23);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(24) {\r\n  z-index: calc(50 - 24);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(24) {\r\n  z-index: calc(50 - 24);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(24) {\r\n  z-index: calc(50 - 24);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(24) {\r\n  z-index: calc(50 - 24);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(25) {\r\n  z-index: calc(50 - 25);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(25) {\r\n  z-index: calc(50 - 25);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(25) {\r\n  z-index: calc(50 - 25);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(25) {\r\n  z-index: calc(50 - 25);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(26) {\r\n  z-index: calc(50 - 26);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(26) {\r\n  z-index: calc(50 - 26);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(26) {\r\n  z-index: calc(50 - 26);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(26) {\r\n  z-index: calc(50 - 26);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(27) {\r\n  z-index: calc(50 - 27);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(27) {\r\n  z-index: calc(50 - 27);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(27) {\r\n  z-index: calc(50 - 27);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(27) {\r\n  z-index: calc(50 - 27);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(28) {\r\n  z-index: calc(50 - 28);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(28) {\r\n  z-index: calc(50 - 28);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(28) {\r\n  z-index: calc(50 - 28);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(28) {\r\n  z-index: calc(50 - 28);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(29) {\r\n  z-index: calc(50 - 29);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(29) {\r\n  z-index: calc(50 - 29);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(29) {\r\n  z-index: calc(50 - 29);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(29) {\r\n  z-index: calc(50 - 29);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(30) {\r\n  z-index: calc(50 - 30);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(30) {\r\n  z-index: calc(50 - 30);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(30) {\r\n  z-index: calc(50 - 30);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(30) {\r\n  z-index: calc(50 - 30);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(31) {\r\n  z-index: calc(50 - 31);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(31) {\r\n  z-index: calc(50 - 31);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(31) {\r\n  z-index: calc(50 - 31);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(31) {\r\n  z-index: calc(50 - 31);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(32) {\r\n  z-index: calc(50 - 32);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(32) {\r\n  z-index: calc(50 - 32);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(32) {\r\n  z-index: calc(50 - 32);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(32) {\r\n  z-index: calc(50 - 32);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(33) {\r\n  z-index: calc(50 - 33);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(33) {\r\n  z-index: calc(50 - 33);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(33) {\r\n  z-index: calc(50 - 33);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(33) {\r\n  z-index: calc(50 - 33);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(34) {\r\n  z-index: calc(50 - 34);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(34) {\r\n  z-index: calc(50 - 34);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(34) {\r\n  z-index: calc(50 - 34);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(34) {\r\n  z-index: calc(50 - 34);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(35) {\r\n  z-index: calc(50 - 35);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(35) {\r\n  z-index: calc(50 - 35);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(35) {\r\n  z-index: calc(50 - 35);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(35) {\r\n  z-index: calc(50 - 35);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(36) {\r\n  z-index: calc(50 - 36);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(36) {\r\n  z-index: calc(50 - 36);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(36) {\r\n  z-index: calc(50 - 36);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(36) {\r\n  z-index: calc(50 - 36);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(37) {\r\n  z-index: calc(50 - 37);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(37) {\r\n  z-index: calc(50 - 37);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(37) {\r\n  z-index: calc(50 - 37);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(37) {\r\n  z-index: calc(50 - 37);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(38) {\r\n  z-index: calc(50 - 38);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(38) {\r\n  z-index: calc(50 - 38);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(38) {\r\n  z-index: calc(50 - 38);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(38) {\r\n  z-index: calc(50 - 38);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(39) {\r\n  z-index: calc(50 - 39);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(39) {\r\n  z-index: calc(50 - 39);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(39) {\r\n  z-index: calc(50 - 39);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(39) {\r\n  z-index: calc(50 - 39);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(40) {\r\n  z-index: calc(50 - 40);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(40) {\r\n  z-index: calc(50 - 40);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(40) {\r\n  z-index: calc(50 - 40);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(40) {\r\n  z-index: calc(50 - 40);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(41) {\r\n  z-index: calc(50 - 41);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(41) {\r\n  z-index: calc(50 - 41);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(41) {\r\n  z-index: calc(50 - 41);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(41) {\r\n  z-index: calc(50 - 41);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(42) {\r\n  z-index: calc(50 - 42);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(42) {\r\n  z-index: calc(50 - 42);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(42) {\r\n  z-index: calc(50 - 42);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(42) {\r\n  z-index: calc(50 - 42);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(43) {\r\n  z-index: calc(50 - 43);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(43) {\r\n  z-index: calc(50 - 43);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(43) {\r\n  z-index: calc(50 - 43);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(43) {\r\n  z-index: calc(50 - 43);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(44) {\r\n  z-index: calc(50 - 44);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(44) {\r\n  z-index: calc(50 - 44);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(44) {\r\n  z-index: calc(50 - 44);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(44) {\r\n  z-index: calc(50 - 44);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(45) {\r\n  z-index: calc(50 - 45);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(45) {\r\n  z-index: calc(50 - 45);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(45) {\r\n  z-index: calc(50 - 45);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(45) {\r\n  z-index: calc(50 - 45);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(46) {\r\n  z-index: calc(50 - 46);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(46) {\r\n  z-index: calc(50 - 46);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(46) {\r\n  z-index: calc(50 - 46);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(46) {\r\n  z-index: calc(50 - 46);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(47) {\r\n  z-index: calc(50 - 47);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(47) {\r\n  z-index: calc(50 - 47);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(47) {\r\n  z-index: calc(50 - 47);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(47) {\r\n  z-index: calc(50 - 47);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(48) {\r\n  z-index: calc(50 - 48);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(48) {\r\n  z-index: calc(50 - 48);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(48) {\r\n  z-index: calc(50 - 48);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(48) {\r\n  z-index: calc(50 - 48);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(49) {\r\n  z-index: calc(50 - 49);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(49) {\r\n  z-index: calc(50 - 49);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(49) {\r\n  z-index: calc(50 - 49);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(49) {\r\n  z-index: calc(50 - 49);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n*>.intro-x:nth-child(50) {\r\n  z-index: calc(50 - 50);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n*>.-intro-x:nth-child(50) {\r\n  z-index: calc(50 - 50);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateX(-50px);\r\n  -webkit-animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-x-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n*>.intro-y:nth-child(50) {\r\n  z-index: calc(50 - 50);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n*>.-intro-y:nth-child(50) {\r\n  z-index: calc(50 - 50);\r\n  opacity: 0;\r\n  position: relative;\r\n  transform: translateY(-50px);\r\n  -webkit-animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-y-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n@-webkit-keyframes intro-x-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@keyframes intro-x-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes intro-y-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@keyframes intro-y-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .modal.modal-slide-over.show>.modal-dialog .modal-content>[data-tw-dismiss=\"modal\"] {\r\n    margin-left: -2.5rem;\r\n  }\r\n\r\n  .pagination {\r\n    margin-right: 0px;\r\n    width: 100%;\r\n  }\r\n\r\n  .pagination .page-item {\r\n    flex: 1 1 0%;\r\n  }\r\n\r\n  .pagination .page-item:nth-child(1) .page-link,\r\n  .pagination .page-item:nth-child(2) .page-link,\r\n  .pagination .page-item:nth-child(3) .page-link,\r\n  .pagination .page-item:nth-child(7) .page-link,\r\n  .pagination .page-item:nth-child(8) .page-link,\r\n  .pagination .page-item:nth-child(9) .page-link {\r\n    padding-left: 0.25rem;\r\n    padding-right: 0.25rem;\r\n  }\r\n\r\n  .pagination .page-item .page-link {\r\n    margin-right: 0px;\r\n    min-width: 0px;\r\n  }\r\n}\r\n\r\n.table {\r\n  width: 100%;\r\n  text-align: left;\r\n}\r\n\r\n.table thead.table-dark {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .table thead.table-dark {\r\n  background-color: rgb(0 0 0 / 0.3);\r\n}\r\n\r\n.table thead.table-dark tr th {\r\n  border-bottom-width: 0px;\r\n}\r\n\r\n.table thead.table-light {\r\n  background-color: rgb(var(--color-slate-200) / 0.6);\r\n}\r\n\r\n.dark .table thead.table-light {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.table thead.table-light tr th {\r\n  border-bottom-width: 0px;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n.table th {\r\n  border-bottom-width: 2px;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.dark .table th {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));\r\n}\r\n\r\n.table td {\r\n  border-bottom-width: 1px;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n.dark .table td {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));\r\n}\r\n\r\n.table.table-dark {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-dark) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .table.table-dark {\r\n  background-color: rgb(0 0 0 / 0.3);\r\n}\r\n\r\n.table.table-dark th {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-600) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .table.table-dark th {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));\r\n}\r\n\r\n.table.table-dark td {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-600) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .table.table-dark td {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));\r\n}\r\n\r\n.table.table-bordered th,\r\n.table.table-bordered td {\r\n  border-left-width: 1px;\r\n  border-right-width: 1px;\r\n  border-top-width: 1px;\r\n}\r\n\r\n.table.table-hover tr:hover td {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .table.table-hover tr:hover td {\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.5;\r\n}\r\n\r\n.table.table-striped tr:nth-of-type(odd) td {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .table.table-striped tr:nth-of-type(odd) td {\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.5;\r\n}\r\n\r\n.table.table-sm th {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n.table.table-sm td {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n}\r\n\r\n/*\r\n\r\ngithub.com style (c) Vasily Polovnyov <vast@whiteants.net>\r\n\r\n*/\r\n.hljs {\r\n  display: block;\r\n  overflow-x: auto;\r\n  padding: 0.5em;\r\n  color: #333;\r\n  background: #f8f8f8;\r\n}\r\n\r\n.hljs-comment,\r\n.hljs-quote {\r\n  color: #998;\r\n  font-style: italic;\r\n}\r\n\r\n.hljs-keyword,\r\n.hljs-selector-tag,\r\n.hljs-subst {\r\n  color: #333;\r\n  font-weight: bold;\r\n}\r\n\r\n.hljs-number,\r\n.hljs-literal,\r\n.hljs-variable,\r\n.hljs-template-variable,\r\n.hljs-tag .hljs-attr {\r\n  color: #008080;\r\n}\r\n\r\n.hljs-string,\r\n.hljs-doctag {\r\n  color: #d14;\r\n}\r\n\r\n.hljs-title,\r\n.hljs-section,\r\n.hljs-selector-id {\r\n  color: #900;\r\n  font-weight: bold;\r\n}\r\n\r\n.hljs-subst {\r\n  font-weight: normal;\r\n}\r\n\r\n.hljs-type,\r\n.hljs-class .hljs-title {\r\n  color: #458;\r\n  font-weight: bold;\r\n}\r\n\r\n.hljs-tag,\r\n.hljs-name,\r\n.hljs-attribute {\r\n  color: #000080;\r\n  font-weight: normal;\r\n}\r\n\r\n.hljs-regexp,\r\n.hljs-link {\r\n  color: #009926;\r\n}\r\n\r\n.hljs-symbol,\r\n.hljs-bullet {\r\n  color: #990073;\r\n}\r\n\r\n.hljs-built_in,\r\n.hljs-builtin-name {\r\n  color: #0086b3;\r\n}\r\n\r\n.hljs-meta {\r\n  color: #999;\r\n  font-weight: bold;\r\n}\r\n\r\n.hljs-deletion {\r\n  background: #fdd;\r\n}\r\n\r\n.hljs-addition {\r\n  background: #dfd;\r\n}\r\n\r\n.hljs-emphasis {\r\n  font-style: italic;\r\n}\r\n\r\n.hljs-strong {\r\n  font-weight: bold;\r\n}\r\n\r\n.tippy-box[data-animation=fade][data-state=hidden] {\r\n  opacity: 0\r\n}\r\n\r\n[data-tippy-root] {\r\n  max-width: calc(100vw - 10px)\r\n}\r\n\r\n.tippy-box {\r\n  position: relative;\r\n  background-color: #333;\r\n  color: #fff;\r\n  border-radius: 4px;\r\n  font-size: 14px;\r\n  line-height: 1.4;\r\n  white-space: normal;\r\n  outline: 0;\r\n  transition-property: transform, visibility, opacity\r\n}\r\n\r\n.tippy-box[data-placement^=top]>.tippy-arrow {\r\n  bottom: 0\r\n}\r\n\r\n.tippy-box[data-placement^=top]>.tippy-arrow:before {\r\n  bottom: -7px;\r\n  left: 0;\r\n  border-width: 8px 8px 0;\r\n  border-top-color: initial;\r\n  transform-origin: center top\r\n}\r\n\r\n.tippy-box[data-placement^=bottom]>.tippy-arrow {\r\n  top: 0\r\n}\r\n\r\n.tippy-box[data-placement^=bottom]>.tippy-arrow:before {\r\n  top: -7px;\r\n  left: 0;\r\n  border-width: 0 8px 8px;\r\n  border-bottom-color: initial;\r\n  transform-origin: center bottom\r\n}\r\n\r\n.tippy-box[data-placement^=left]>.tippy-arrow {\r\n  right: 0\r\n}\r\n\r\n.tippy-box[data-placement^=left]>.tippy-arrow:before {\r\n  border-width: 8px 0 8px 8px;\r\n  border-left-color: initial;\r\n  right: -7px;\r\n  transform-origin: center left\r\n}\r\n\r\n.tippy-box[data-placement^=right]>.tippy-arrow {\r\n  left: 0\r\n}\r\n\r\n.tippy-box[data-placement^=right]>.tippy-arrow:before {\r\n  left: -7px;\r\n  border-width: 8px 8px 8px 0;\r\n  border-right-color: initial;\r\n  transform-origin: center right\r\n}\r\n\r\n.tippy-box[data-inertia][data-state=visible] {\r\n  transition-timing-function: cubic-bezier(.54, 1.5, .38, 1.11)\r\n}\r\n\r\n.tippy-arrow {\r\n  width: 16px;\r\n  height: 16px;\r\n  color: #333\r\n}\r\n\r\n.tippy-arrow:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  border-color: transparent;\r\n  border-style: solid\r\n}\r\n\r\n.tippy-content {\r\n  position: relative;\r\n  padding: 5px 9px;\r\n  z-index: 1\r\n}\r\n\r\n.tippy-box[data-theme~=light] {\r\n  color: #26323d;\r\n  box-shadow: 0 0 20px 4px rgba(154, 161, 177, .15), 0 4px 80px -8px rgba(36, 40, 47, .25), 0 4px 4px -2px rgba(91, 94, 105, .15);\r\n  background-color: #fff\r\n}\r\n\r\n.tippy-box[data-theme~=light][data-placement^=top]>.tippy-arrow:before {\r\n  border-top-color: #fff\r\n}\r\n\r\n.tippy-box[data-theme~=light][data-placement^=bottom]>.tippy-arrow:before {\r\n  border-bottom-color: #fff\r\n}\r\n\r\n.tippy-box[data-theme~=light][data-placement^=left]>.tippy-arrow:before {\r\n  border-left-color: #fff\r\n}\r\n\r\n.tippy-box[data-theme~=light][data-placement^=right]>.tippy-arrow:before {\r\n  border-right-color: #fff\r\n}\r\n\r\n.tippy-box[data-theme~=light]>.tippy-backdrop {\r\n  background-color: #fff\r\n}\r\n\r\n.tippy-box[data-theme~=light]>.tippy-svg-arrow {\r\n  fill: #fff\r\n}\r\n\r\n.tippy-box[data-placement^=top]>.tippy-svg-arrow {\r\n  bottom: 0\r\n}\r\n\r\n.tippy-box[data-placement^=top]>.tippy-svg-arrow:after,\r\n.tippy-box[data-placement^=top]>.tippy-svg-arrow>svg {\r\n  top: 16px;\r\n  transform: rotate(180deg)\r\n}\r\n\r\n.tippy-box[data-placement^=bottom]>.tippy-svg-arrow {\r\n  top: 0\r\n}\r\n\r\n.tippy-box[data-placement^=bottom]>.tippy-svg-arrow>svg {\r\n  bottom: 16px\r\n}\r\n\r\n.tippy-box[data-placement^=left]>.tippy-svg-arrow {\r\n  right: 0\r\n}\r\n\r\n.tippy-box[data-placement^=left]>.tippy-svg-arrow:after,\r\n.tippy-box[data-placement^=left]>.tippy-svg-arrow>svg {\r\n  transform: rotate(90deg);\r\n  top: calc(50% - 3px);\r\n  left: 11px\r\n}\r\n\r\n.tippy-box[data-placement^=right]>.tippy-svg-arrow {\r\n  left: 0\r\n}\r\n\r\n.tippy-box[data-placement^=right]>.tippy-svg-arrow:after,\r\n.tippy-box[data-placement^=right]>.tippy-svg-arrow>svg {\r\n  transform: rotate(-90deg);\r\n  top: calc(50% - 3px);\r\n  right: 11px\r\n}\r\n\r\n.tippy-svg-arrow {\r\n  width: 16px;\r\n  height: 16px;\r\n  fill: #333;\r\n  text-align: initial\r\n}\r\n\r\n.tippy-svg-arrow,\r\n.tippy-svg-arrow>svg {\r\n  position: absolute\r\n}\r\n\r\n.tippy-box[data-animation=shift-away][data-state=hidden] {\r\n  opacity: 0\r\n}\r\n\r\n.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=top] {\r\n  transform: translateY(10px)\r\n}\r\n\r\n.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=bottom] {\r\n  transform: translateY(-10px)\r\n}\r\n\r\n.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=left] {\r\n  transform: translateX(10px)\r\n}\r\n\r\n.tippy-box[data-animation=shift-away][data-state=hidden][data-placement^=right] {\r\n  transform: translateX(-10px)\r\n}\r\n\r\n/*!\r\n * Toastify js 1.11.2\r\n * https://github.com/apvarun/toastify-js\r\n * @license MIT licensed\r\n *\r\n * Copyright (C) 2018 Varun A P\r\n */\r\n.toastify {\r\n  padding: 12px 20px;\r\n  color: #ffffff;\r\n  display: inline-block;\r\n  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);\r\n  background: linear-gradient(135deg, #73a5ff, #5477f5);\r\n  position: fixed;\r\n  opacity: 0;\r\n  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\r\n  border-radius: 2px;\r\n  cursor: pointer;\r\n  text-decoration: none;\r\n  max-width: calc(50% - 20px);\r\n  z-index: 2147483647;\r\n}\r\n\r\n.toastify.on {\r\n  opacity: 1;\r\n}\r\n\r\n.toast-close {\r\n  opacity: 0.4;\r\n  padding: 0 5px;\r\n}\r\n\r\n.toastify-right {\r\n  right: 15px;\r\n}\r\n\r\n.toastify-left {\r\n  left: 15px;\r\n}\r\n\r\n.toastify-top {\r\n  top: -150px;\r\n}\r\n\r\n.toastify-bottom {\r\n  bottom: -150px;\r\n}\r\n\r\n.toastify-rounded {\r\n  border-radius: 25px;\r\n}\r\n\r\n.toastify-avatar {\r\n  width: 1.5em;\r\n  height: 1.5em;\r\n  margin: -7px 5px;\r\n  border-radius: 2px;\r\n}\r\n\r\n.toastify-center {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  left: 0;\r\n  right: 0;\r\n  max-width: -webkit-fit-content;\r\n  max-width: fit-content;\r\n  max-width: -moz-fit-content;\r\n}\r\n\r\n@media only screen and (max-width: 360px) {\r\n\r\n  .toastify-right,\r\n  .toastify-left {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    left: 0;\r\n    right: 0;\r\n    max-width: -webkit-fit-content;\r\n    max-width: -moz-fit-content;\r\n    max-width: fit-content;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes passing-through {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(40px);\r\n  }\r\n\r\n  30%,\r\n  70% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(-40px);\r\n  }\r\n}\r\n\r\n@keyframes passing-through {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(40px);\r\n  }\r\n\r\n  30%,\r\n  70% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n    transform: translateY(-40px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes slide-in {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(40px);\r\n  }\r\n\r\n  30% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@keyframes slide-in {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(40px);\r\n  }\r\n\r\n  30% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes pulse {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n\r\n  10% {\r\n    transform: scale(1.1);\r\n  }\r\n\r\n  20% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    transform: scale(1);\r\n  }\r\n\r\n  10% {\r\n    transform: scale(1.1);\r\n  }\r\n\r\n  20% {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.dropzone,\r\n.dropzone * {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.dropzone {\r\n  min-height: 150px;\r\n  border: 2px solid rgba(0, 0, 0, 0.3);\r\n  background: white;\r\n  padding: 20px 20px;\r\n}\r\n\r\n.dropzone.dz-clickable {\r\n  cursor: pointer;\r\n}\r\n\r\n.dropzone.dz-clickable * {\r\n  cursor: default;\r\n}\r\n\r\n.dropzone.dz-clickable .dz-message,\r\n.dropzone.dz-clickable .dz-message * {\r\n  cursor: pointer;\r\n}\r\n\r\n.dropzone.dz-started .dz-message {\r\n  display: none;\r\n}\r\n\r\n.dropzone.dz-drag-hover {\r\n  border-style: solid;\r\n}\r\n\r\n.dropzone.dz-drag-hover .dz-message {\r\n  opacity: 0.5;\r\n}\r\n\r\n.dropzone .dz-message {\r\n  text-align: center;\r\n  margin: 2em 0;\r\n}\r\n\r\n.dropzone .dz-message .dz-button {\r\n  background: none;\r\n  color: inherit;\r\n  border: none;\r\n  padding: 0;\r\n  font: inherit;\r\n  cursor: pointer;\r\n  outline: inherit;\r\n}\r\n\r\n.dropzone .dz-preview {\r\n  position: relative;\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  margin: 16px;\r\n  min-height: 100px;\r\n}\r\n\r\n.dropzone .dz-preview:hover {\r\n  z-index: 1000;\r\n}\r\n\r\n.dropzone .dz-preview:hover .dz-details {\r\n  opacity: 1;\r\n}\r\n\r\n.dropzone .dz-preview.dz-file-preview .dz-image {\r\n  border-radius: 20px;\r\n  background: #999;\r\n  background: linear-gradient(to bottom, #eee, #ddd);\r\n}\r\n\r\n.dropzone .dz-preview.dz-file-preview .dz-details {\r\n  opacity: 1;\r\n}\r\n\r\n.dropzone .dz-preview.dz-image-preview {\r\n  background: white;\r\n}\r\n\r\n.dropzone .dz-preview.dz-image-preview .dz-details {\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.dropzone .dz-preview .dz-remove {\r\n  font-size: 14px;\r\n  text-align: center;\r\n  display: block;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.dropzone .dz-preview .dz-remove:hover {\r\n  text-decoration: underline;\r\n}\r\n\r\n.dropzone .dz-preview:hover .dz-details {\r\n  opacity: 1;\r\n}\r\n\r\n.dropzone .dz-preview .dz-details {\r\n  z-index: 20;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  opacity: 0;\r\n  font-size: 13px;\r\n  min-width: 100%;\r\n  max-width: 100%;\r\n  padding: 2em 1em;\r\n  text-align: center;\r\n  color: rgba(0, 0, 0, 0.9);\r\n  line-height: 150%;\r\n}\r\n\r\n.dropzone .dz-preview .dz-details .dz-size {\r\n  margin-bottom: 1em;\r\n  font-size: 16px;\r\n}\r\n\r\n.dropzone .dz-preview .dz-details .dz-filename {\r\n  white-space: nowrap;\r\n}\r\n\r\n.dropzone .dz-preview .dz-details .dz-filename:hover span {\r\n  border: 1px solid rgba(200, 200, 200, 0.8);\r\n  background-color: rgba(255, 255, 255, 0.8);\r\n}\r\n\r\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.dropzone .dz-preview .dz-details .dz-filename:not(:hover) span {\r\n  border: 1px solid transparent;\r\n}\r\n\r\n.dropzone .dz-preview .dz-details .dz-filename span,\r\n.dropzone .dz-preview .dz-details .dz-size span {\r\n  background-color: rgba(255, 255, 255, 0.4);\r\n  padding: 0 0.4em;\r\n  border-radius: 3px;\r\n}\r\n\r\n.dropzone .dz-preview:hover .dz-image img {\r\n  transform: scale(1.05, 1.05);\r\n  filter: blur(8px);\r\n}\r\n\r\n.dropzone .dz-preview .dz-image {\r\n  border-radius: 20px;\r\n  overflow: hidden;\r\n  width: 120px;\r\n  height: 120px;\r\n  position: relative;\r\n  display: block;\r\n  z-index: 10;\r\n}\r\n\r\n.dropzone .dz-preview .dz-image img {\r\n  display: block;\r\n}\r\n\r\n.dropzone .dz-preview.dz-success .dz-success-mark {\r\n  -webkit-animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\r\n  animation: passing-through 3s cubic-bezier(0.77, 0, 0.175, 1);\r\n}\r\n\r\n.dropzone .dz-preview.dz-error .dz-error-mark {\r\n  opacity: 1;\r\n  -webkit-animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\r\n  animation: slide-in 3s cubic-bezier(0.77, 0, 0.175, 1);\r\n}\r\n\r\n.dropzone .dz-preview .dz-success-mark,\r\n.dropzone .dz-preview .dz-error-mark {\r\n  pointer-events: none;\r\n  opacity: 0;\r\n  z-index: 500;\r\n  position: absolute;\r\n  display: block;\r\n  top: 50%;\r\n  left: 50%;\r\n  margin-left: -27px;\r\n  margin-top: -27px;\r\n}\r\n\r\n.dropzone .dz-preview .dz-success-mark svg,\r\n.dropzone .dz-preview .dz-error-mark svg {\r\n  display: block;\r\n  width: 54px;\r\n  height: 54px;\r\n}\r\n\r\n.dropzone .dz-preview.dz-processing .dz-progress {\r\n  opacity: 1;\r\n  transition: all 0.2s linear;\r\n}\r\n\r\n.dropzone .dz-preview.dz-complete .dz-progress {\r\n  opacity: 0;\r\n  transition: opacity 0.4s ease-in;\r\n}\r\n\r\n.dropzone .dz-preview:not(.dz-processing) .dz-progress {\r\n  -webkit-animation: pulse 6s ease infinite;\r\n  animation: pulse 6s ease infinite;\r\n}\r\n\r\n.dropzone .dz-preview .dz-progress {\r\n  opacity: 1;\r\n  z-index: 1000;\r\n  pointer-events: none;\r\n  position: absolute;\r\n  height: 16px;\r\n  left: 50%;\r\n  top: 50%;\r\n  margin-top: -8px;\r\n  width: 80px;\r\n  margin-left: -40px;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  -webkit-transform: scale(1);\r\n  border-radius: 8px;\r\n  overflow: hidden;\r\n}\r\n\r\n.dropzone .dz-preview .dz-progress .dz-upload {\r\n  background: #333;\r\n  background: linear-gradient(to bottom, #666, #444);\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  width: 0;\r\n  transition: width 300ms ease-in-out;\r\n}\r\n\r\n.dropzone .dz-preview.dz-error .dz-error-message {\r\n  display: block;\r\n}\r\n\r\n.dropzone .dz-preview.dz-error:hover .dz-error-message {\r\n  opacity: 1;\r\n  pointer-events: auto;\r\n}\r\n\r\n.dropzone .dz-preview .dz-error-message {\r\n  pointer-events: none;\r\n  z-index: 1000;\r\n  position: absolute;\r\n  display: block;\r\n  display: none;\r\n  opacity: 0;\r\n  transition: opacity 0.3s ease;\r\n  border-radius: 8px;\r\n  font-size: 13px;\r\n  top: 130px;\r\n  left: -10px;\r\n  width: 140px;\r\n  background: #be2626;\r\n  background: linear-gradient(to bottom, #be2626, #a92222);\r\n  padding: 0.5em 1.2em;\r\n  color: white;\r\n}\r\n\r\n.dropzone .dz-preview .dz-error-message:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -6px;\r\n  left: 64px;\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid #be2626;\r\n}\r\n\r\nimg[data-action=\"zoom\"] {\r\n  cursor: zoom-in;\r\n}\r\n\r\n.zoom-img,\r\n.zoom-img-wrap {\r\n  position: relative;\r\n  z-index: 666;\r\n  transition: all 300ms;\r\n}\r\n\r\nimg.zoom-img {\r\n  cursor: zoom-out;\r\n}\r\n\r\n.zoom-overlay {\r\n  cursor: zoom-out;\r\n  z-index: 420;\r\n  background: #fff;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  filter: \"alpha(opacity=0)\";\r\n  opacity: 0;\r\n  transition: opacity 300ms;\r\n}\r\n\r\n.zoom-overlay-open .zoom-overlay {\r\n  filter: \"alpha(opacity=100)\";\r\n  opacity: 1;\r\n}\r\n\r\n/* Tabulator v4.9.3 (c) Oliver Folkerd */\r\n.tabulator {\r\n  position: relative;\r\n  border: 1px solid #999;\r\n  background-color: #888;\r\n  font-size: 12px;\r\n  text-align: left;\r\n  overflow: hidden;\r\n  transform: translatez(0);\r\n}\r\n\r\n.tabulator .hover_text:hover {\r\n  cursor: pointer;\r\n  font-weight: bold;\r\n}\r\n\r\n.tabulator[tabulator-layout=\"fitDataFill\"] .tabulator-tableHolder .tabulator-table {\r\n  min-width: 100%;\r\n}\r\n\r\n.tabulator[tabulator-layout=\"fitDataTable\"] {\r\n  display: inline-block;\r\n}\r\n\r\n.tabulator.tabulator-block-select {\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  -moz-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.tabulator .tabulator-header {\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  border-bottom: 1px solid #999;\r\n  background-color: #e6e6e6;\r\n  color: #555;\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -webkit-user-select: none;\r\n  -o-user-select: none;\r\n}\r\n\r\n.tabulator .tabulator-header.tabulator-header-hidden {\r\n  display: none;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col {\r\n  display: inline-block;\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  border-right: 1px solid #aaa;\r\n  background: #e6e6e6;\r\n  text-align: left;\r\n  vertical-align: bottom;\r\n  overflow: hidden;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-moving {\r\n  position: absolute;\r\n  border: 1px solid #999;\r\n  background: #cdcdcd;\r\n  pointer-events: none;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content {\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  padding: 4px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-header-menu-button {\r\n  padding: 0 8px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-header-menu-button:hover {\r\n  cursor: pointer;\r\n  opacity: .6;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title-holder {\r\n  position: relative;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title {\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  vertical-align: bottom;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title .tabulator-title-editor {\r\n  box-sizing: border-box;\r\n  width: 100%;\r\n  border: 1px solid #999;\r\n  padding: 1px;\r\n  background: #fff;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-title .tabulator-header-menu-button+.tabulator-title-editor {\r\n  width: calc(100% - 22px);\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-sorter {\r\n  display: flex;\r\n  align-items: center;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 4px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {\r\n  width: 0;\r\n  height: 0;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid #bbb;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-col-group .tabulator-col-group-cols {\r\n  position: relative;\r\n  display: flex;\r\n  border-top: 1px solid #aaa;\r\n  overflow: hidden;\r\n  margin-right: -1px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col:first-child .tabulator-col-resize-handle.prev {\r\n  display: none;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-header-filter {\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  margin-top: 2px;\r\n  width: 100%;\r\n  text-align: center;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-header-filter textarea {\r\n  height: auto !important;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-header-filter svg {\r\n  margin-top: 3px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col .tabulator-header-filter input::-ms-clear {\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {\r\n  padding-right: 25px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable:hover {\r\n  /* cursor: pointer;\r\n  background-color: #cdcdcd; */\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=\"none\"] .tabulator-col-content .tabulator-col-sorter {\r\n  color: #bbb;\r\n  display: none;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=\"none\"] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {\r\n  border-top: none;\r\n  border-bottom: 6px solid #bbb;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=\"asc\"] .tabulator-col-content .tabulator-col-sorter {\r\n  color: #666;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=\"asc\"] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {\r\n  border-top: none;\r\n  border-bottom: 6px solid #666;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=\"desc\"] .tabulator-col-content .tabulator-col-sorter {\r\n  color: #666;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-sortable[aria-sort=\"desc\"] .tabulator-col-content .tabulator-col-sorter .tabulator-arrow {\r\n  border-bottom: none;\r\n  border-top: 6px solid #666;\r\n  color: #666;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical .tabulator-col-content .tabulator-col-title {\r\n  -ms-writing-mode: tb-rl;\r\n  writing-mode: vertical-rl;\r\n  -webkit-text-orientation: mixed;\r\n  text-orientation: mixed;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-col-vertical-flip .tabulator-col-title {\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-sortable .tabulator-col-title {\r\n  padding-right: 0;\r\n  padding-top: 20px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-sortable.tabulator-col-vertical-flip .tabulator-col-title {\r\n  padding-right: 0;\r\n  padding-bottom: 20px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-col.tabulator-col-vertical.tabulator-sortable .tabulator-col-sorter {\r\n  justify-content: center;\r\n  left: 0;\r\n  right: 0;\r\n  top: 4px;\r\n  bottom: auto;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-frozen {\r\n  display: inline-block;\r\n  position: absolute;\r\n  z-index: 10;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-frozen.tabulator-frozen-left {\r\n  border-right: 2px solid #aaa;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-frozen.tabulator-frozen-right {\r\n  border-left: 2px solid #aaa;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-calcs-holder {\r\n  box-sizing: border-box;\r\n  min-width: 600%;\r\n  background: #f3f3f3 !important;\r\n  border-top: 1px solid #aaa;\r\n  border-bottom: 1px solid #aaa;\r\n  overflow: hidden;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-calcs-holder .tabulator-row {\r\n  background: #f3f3f3 !important;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-calcs-holder .tabulator-row .tabulator-col-resize-handle {\r\n  display: none;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-frozen-rows-holder {\r\n  min-width: 600%;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-frozen-rows-holder:empty {\r\n  display: none;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder {\r\n  position: relative;\r\n  width: 100%;\r\n  white-space: nowrap;\r\n  overflow: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder:focus {\r\n  outline: none;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-placeholder {\r\n  box-sizing: border-box;\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-placeholder[tabulator-render-mode=\"virtual\"] {\r\n  min-height: 100%;\r\n  min-width: 100%;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-placeholder span {\r\n  display: inline-block;\r\n  margin: 0 auto;\r\n  padding: 10px;\r\n  color: #ccc;\r\n  font-weight: bold;\r\n  font-size: 20px;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-table {\r\n  position: relative;\r\n  display: inline-block;\r\n  /* background-color: #fff; */\r\n  background-color: #fafafa;\r\n  white-space: nowrap;\r\n  overflow: visible;\r\n  color: #333;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-calcs {\r\n  font-weight: bold;\r\n  background: #e2e2e2 !important;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-calcs.tabulator-calcs-top {\r\n  border-bottom: 2px solid #aaa;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-table .tabulator-row.tabulator-calcs.tabulator-calcs-bottom {\r\n  border-top: 2px solid #aaa;\r\n}\r\n\r\n.tabulator .tabulator-footer {\r\n  padding: 5px 10px;\r\n  border-top: 1px solid #999;\r\n  background-color: #e6e6e6;\r\n  text-align: right;\r\n  color: #555;\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -webkit-user-select: none;\r\n  -o-user-select: none;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-calcs-holder {\r\n  box-sizing: border-box;\r\n  width: calc(100% + 20px);\r\n  margin: -5px -10px 5px -10px;\r\n  text-align: left;\r\n  background: #f3f3f3 !important;\r\n  border-bottom: 1px solid #aaa;\r\n  border-top: 1px solid #aaa;\r\n  overflow: hidden;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-calcs-holder .tabulator-row {\r\n  background: #f3f3f3 !important;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-calcs-holder .tabulator-row .tabulator-col-resize-handle {\r\n  display: none;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-calcs-holder:only-child {\r\n  margin-bottom: -5px;\r\n  border-bottom: none;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator {\r\n  color: #555;\r\n  font-family: inherit;\r\n  font-weight: inherit;\r\n  font-size: inherit;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-page-size {\r\n  display: inline-block;\r\n  margin: 0 5px;\r\n  padding: 2px 5px;\r\n  border: 1px solid #aaa;\r\n  border-radius: 3px;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-pages {\r\n  margin: 0 7px;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-page {\r\n  display: inline-block;\r\n  margin: 0 2px;\r\n  padding: 2px 5px;\r\n  border: 1px solid #aaa;\r\n  border-radius: 3px;\r\n  background: rgba(255, 255, 255, 0.2);\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-page.active {\r\n  color: #d00;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-page:disabled {\r\n  opacity: .5;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-page:not(.disabled):hover {\r\n  cursor: pointer;\r\n  background: rgba(0, 0, 0, 0.2);\r\n  color: #fff;\r\n}\r\n\r\n.tabulator .tabulator-col-resize-handle {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 5px;\r\n}\r\n\r\n.tabulator .tabulator-col-resize-handle.prev {\r\n  left: 0;\r\n  right: auto;\r\n}\r\n\r\n.tabulator .tabulator-col-resize-handle:hover {\r\n  cursor: ew-resize;\r\n}\r\n\r\n.tabulator .tabulator-loader {\r\n  position: absolute;\r\n  display: flex;\r\n  align-items: center;\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 100;\r\n  height: 100%;\r\n  width: 100%;\r\n  background: rgba(0, 0, 0, 0.4);\r\n  text-align: center;\r\n}\r\n\r\n.tabulator .tabulator-loader .tabulator-loader-msg {\r\n  display: inline-block;\r\n  margin: 0 auto;\r\n  padding: 10px 20px;\r\n  border-radius: 10px;\r\n  background: #fff;\r\n  font-weight: bold;\r\n  font-size: 16px;\r\n}\r\n\r\n.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-loading {\r\n  border: 4px solid #333;\r\n  color: #000;\r\n}\r\n\r\n.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-error {\r\n  border: 4px solid #D00;\r\n  color: #590000;\r\n}\r\n\r\n.tabulator-row {\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  min-height: 22px;\r\n  background-color: #fff;\r\n  display: flex;\r\n  user-select: none;\r\n  /* 표준 */\r\n  -webkit-user-select: none;\r\n  /* 크롬/사파리용 */\r\n  -moz-user-select: none;\r\n  /* 파이어폭스용 */\r\n  -ms-user-select: none;\r\n  /* IE/엣지 구버전용 */\r\n}\r\n\r\n.tabulator-row.tabulator-row-even {\r\n  background-color: #EFEFEF;\r\n}\r\n\r\n.tabulator-row.tabulator-selectable:hover {\r\n  background-color: #bbb;\r\n}\r\n\r\n.tabulator-row.tabulator-selected {\r\n  background-color: #9ABCEA;\r\n}\r\n\r\n.tabulator-row.tabulator-selected:hover {\r\n  background-color: #769BCC;\r\n  cursor: pointer;\r\n}\r\n\r\n.tabulator-row.tabulator-row-moving {\r\n  border: 1px solid #000;\r\n  background: #fff;\r\n}\r\n\r\n.tabulator-row.tabulator-moving {\r\n  position: absolute;\r\n  border-top: 1px solid #aaa;\r\n  border-bottom: 1px solid #aaa;\r\n  pointer-events: none;\r\n  z-index: 15;\r\n}\r\n\r\n.tabulator-row .tabulator-row-resize-handle {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  height: 5px;\r\n}\r\n\r\n.tabulator-row .tabulator-row-resize-handle.prev {\r\n  top: 0;\r\n  bottom: auto;\r\n}\r\n\r\n.tabulator-row .tabulator-row-resize-handle:hover {\r\n  cursor: ns-resize;\r\n}\r\n\r\n.tabulator-row .tabulator-frozen {\r\n  display: inline-block;\r\n  position: absolute;\r\n  background-color: inherit;\r\n  z-index: 10;\r\n}\r\n\r\n.tabulator-row .tabulator-frozen.tabulator-frozen-left {\r\n  border-right: 2px solid #aaa;\r\n}\r\n\r\n.tabulator-row .tabulator-frozen.tabulator-frozen-right {\r\n  border-left: 2px solid #aaa;\r\n}\r\n\r\n.tabulator-row .tabulator-responsive-collapse {\r\n  box-sizing: border-box;\r\n  padding: 5px;\r\n  border-top: 1px solid #aaa;\r\n  border-bottom: 1px solid #aaa;\r\n}\r\n\r\n.tabulator-row .tabulator-responsive-collapse:empty {\r\n  display: none;\r\n}\r\n\r\n.tabulator-row .tabulator-responsive-collapse table {\r\n  font-size: 14px;\r\n}\r\n\r\n.tabulator-row .tabulator-responsive-collapse table tr td {\r\n  position: relative;\r\n}\r\n\r\n.tabulator-row .tabulator-responsive-collapse table tr td:first-of-type {\r\n  padding-right: 10px;\r\n}\r\n\r\n.tabulator-row .tabulator-cell {\r\n  display: inline-block;\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  padding: 4px;\r\n  border-right: 1px solid #aaa;\r\n  vertical-align: middle;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.tabulator-row .tabulator-cell.tabulator-editing {\r\n  border: 1px solid #1D68CD;\r\n  outline: none;\r\n  padding: 0;\r\n}\r\n\r\n.tabulator-row .tabulator-cell.tabulator-editing input,\r\n.tabulator-row .tabulator-cell.tabulator-editing select {\r\n  border: 1px;\r\n  background: transparent;\r\n}\r\n\r\n.tabulator-row .tabulator-cell.tabulator-validation-fail {\r\n  border: 1px solid #dd0000;\r\n}\r\n\r\n.tabulator-row .tabulator-cell.tabulator-validation-fail input,\r\n.tabulator-row .tabulator-cell.tabulator-validation-fail select {\r\n  border: 1px;\r\n  background: transparent;\r\n  color: #dd0000;\r\n}\r\n\r\n.tabulator-row .tabulator-cell:first-child .tabulator-col-resize-handle.prev {\r\n  display: none;\r\n}\r\n\r\n.tabulator-row .tabulator-cell.tabulator-row-handle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -webkit-user-select: none;\r\n  -o-user-select: none;\r\n}\r\n\r\n.tabulator-row .tabulator-cell.tabulator-row-handle .tabulator-row-handle-box {\r\n  width: 80%;\r\n}\r\n\r\n.tabulator-row .tabulator-cell.tabulator-row-handle .tabulator-row-handle-box .tabulator-row-handle-bar {\r\n  width: 100%;\r\n  height: 3px;\r\n  margin-top: 2px;\r\n  background: #666;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-data-tree-branch {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  height: 9px;\r\n  width: 7px;\r\n  margin-top: -9px;\r\n  margin-right: 5px;\r\n  border-bottom-left-radius: 1px;\r\n  border-left: 2px solid #aaa;\r\n  border-bottom: 2px solid #aaa;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-data-tree-control {\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  vertical-align: middle;\r\n  height: 11px;\r\n  width: 11px;\r\n  margin-right: 5px;\r\n  border: 1px solid #333;\r\n  border-radius: 2px;\r\n  background: rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-data-tree-control:hover {\r\n  background: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-collapse {\r\n  display: inline-block;\r\n  position: relative;\r\n  height: 7px;\r\n  width: 1px;\r\n  background: transparent;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-collapse:after {\r\n  position: absolute;\r\n  content: \"\";\r\n  left: -3px;\r\n  top: 3px;\r\n  height: 1px;\r\n  width: 7px;\r\n  background: #333;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-expand {\r\n  display: inline-block;\r\n  position: relative;\r\n  height: 7px;\r\n  width: 1px;\r\n  background: #333;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-data-tree-control .tabulator-data-tree-control-expand:after {\r\n  position: absolute;\r\n  content: \"\";\r\n  left: -3px;\r\n  top: 3px;\r\n  height: 1px;\r\n  width: 7px;\r\n  background: #333;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  -moz-user-select: none;\r\n  -khtml-user-select: none;\r\n  -webkit-user-select: none;\r\n  -o-user-select: none;\r\n  height: 15px;\r\n  width: 15px;\r\n  border-radius: 20px;\r\n  background: #666;\r\n  color: #fff;\r\n  font-weight: bold;\r\n  font-size: 1.1em;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle:hover {\r\n  opacity: .7;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle.open .tabulator-responsive-collapse-toggle-close {\r\n  display: initial;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle.open .tabulator-responsive-collapse-toggle-open {\r\n  display: none;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle .tabulator-responsive-collapse-toggle-close {\r\n  display: none;\r\n}\r\n\r\n.tabulator-row .tabulator-cell .tabulator-traffic-light {\r\n  display: inline-block;\r\n  height: 14px;\r\n  width: 14px;\r\n  border-radius: 14px;\r\n}\r\n\r\n.tabulator-row.tabulator-group {\r\n  box-sizing: border-box;\r\n  border-bottom: 1px solid #999;\r\n  border-right: 1px solid #aaa;\r\n  border-top: 1px solid #999;\r\n  padding: 5px;\r\n  padding-left: 10px;\r\n  background: #ccc;\r\n  font-weight: bold;\r\n  min-width: 100%;\r\n}\r\n\r\n.tabulator-row.tabulator-group:hover {\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.tabulator-row.tabulator-group.tabulator-group-visible .tabulator-arrow {\r\n  margin-right: 10px;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-top: 6px solid #666;\r\n  border-bottom: 0;\r\n}\r\n\r\n.tabulator-row.tabulator-group.tabulator-group-level-1 {\r\n  padding-left: 30px;\r\n}\r\n\r\n.tabulator-row.tabulator-group.tabulator-group-level-2 {\r\n  padding-left: 50px;\r\n}\r\n\r\n.tabulator-row.tabulator-group.tabulator-group-level-3 {\r\n  padding-left: 70px;\r\n}\r\n\r\n.tabulator-row.tabulator-group.tabulator-group-level-4 {\r\n  padding-left: 90px;\r\n}\r\n\r\n.tabulator-row.tabulator-group.tabulator-group-level-5 {\r\n  padding-left: 110px;\r\n}\r\n\r\n.tabulator-row.tabulator-group .tabulator-group-toggle {\r\n  display: inline-block;\r\n}\r\n\r\n.tabulator-row.tabulator-group .tabulator-arrow {\r\n  display: inline-block;\r\n  width: 0;\r\n  height: 0;\r\n  margin-right: 16px;\r\n  border-top: 6px solid transparent;\r\n  border-bottom: 6px solid transparent;\r\n  border-right: 0;\r\n  border-left: 6px solid #666;\r\n  vertical-align: middle;\r\n}\r\n\r\n.tabulator-row.tabulator-group span {\r\n  margin-left: 10px;\r\n  color: #d00;\r\n}\r\n\r\n.tabulator-menu {\r\n  position: absolute;\r\n  display: inline-block;\r\n  box-sizing: border-box;\r\n  background: #fff;\r\n  border: 1px solid #aaa;\r\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);\r\n  font-size: 14px;\r\n  overflow-y: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  z-index: 10000;\r\n}\r\n\r\n.tabulator-menu .tabulator-menu-item {\r\n  position: relative;\r\n  box-sizing: border-box;\r\n  padding: 5px 10px;\r\n  -webkit-user-select: none;\r\n  -ms-user-select: none;\r\n  -moz-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.tabulator-menu .tabulator-menu-item.tabulator-menu-item-disabled {\r\n  opacity: .5;\r\n}\r\n\r\n.tabulator-menu .tabulator-menu-item:not(.tabulator-menu-item-disabled):hover {\r\n\r\n  background: #EFEFEF;\r\n}\r\n\r\n.tabulator-menu .tabulator-menu-item.tabulator-menu-item-submenu {\r\n  padding-right: 25px;\r\n}\r\n\r\n.tabulator-menu .tabulator-menu-item.tabulator-menu-item-submenu::after {\r\n  display: inline-block;\r\n  position: absolute;\r\n  top: calc(5px + .4em);\r\n  right: 10px;\r\n  height: 7px;\r\n  width: 7px;\r\n  content: '';\r\n  border-width: 1px 1px 0 0;\r\n  border-style: solid;\r\n  border-color: #aaa;\r\n  vertical-align: top;\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.tabulator-menu .tabulator-menu-separator {\r\n  border-top: 1px solid #aaa;\r\n}\r\n\r\n.tabulator-edit-select-list {\r\n  position: absolute;\r\n  display: inline-block;\r\n  box-sizing: border-box;\r\n  max-height: 200px;\r\n  background: #fff;\r\n  border: 1px solid #aaa;\r\n  font-size: 14px;\r\n  overflow-y: auto;\r\n  -webkit-overflow-scrolling: touch;\r\n  z-index: 10000;\r\n}\r\n\r\n.tabulator-edit-select-list .tabulator-edit-select-list-item {\r\n  padding: 4px;\r\n  color: #333;\r\n}\r\n\r\n.tabulator-edit-select-list .tabulator-edit-select-list-item.active {\r\n  color: #fff;\r\n  background: #1D68CD;\r\n}\r\n\r\n.tabulator-edit-select-list .tabulator-edit-select-list-item.active.focused {\r\n  outline: 1px solid rgba(255, 255, 255, 0.5);\r\n}\r\n\r\n.tabulator-edit-select-list .tabulator-edit-select-list-item.focused {\r\n  outline: 1px solid #1D68CD;\r\n}\r\n\r\n.tabulator-edit-select-list .tabulator-edit-select-list-item:hover {\r\n\r\n  color: #fff;\r\n  background: #1D68CD;\r\n}\r\n\r\n.tabulator-edit-select-list .tabulator-edit-select-list-notice {\r\n  padding: 4px;\r\n  color: #333;\r\n  text-align: center;\r\n}\r\n\r\n.tabulator-edit-select-list .tabulator-edit-select-list-group {\r\n  border-bottom: 1px solid #aaa;\r\n  padding: 4px;\r\n  padding-top: 6px;\r\n  color: #333;\r\n  font-weight: bold;\r\n}\r\n\r\n.tabulator.tabulator-ltr {\r\n  direction: ltr;\r\n}\r\n\r\n.tabulator.tabulator-rtl {\r\n  text-align: initial;\r\n  direction: rtl;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-header .tabulator-col {\r\n  text-align: initial;\r\n  border-left: 1px solid #aaa;\r\n  border-right: initial;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-header .tabulator-col.tabulator-col-group .tabulator-col-group-cols {\r\n  margin-right: initial;\r\n  margin-left: -1px;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-header .tabulator-col.tabulator-sortable .tabulator-col-title {\r\n  padding-right: 0;\r\n  padding-left: 25px;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-header .tabulator-col .tabulator-col-content .tabulator-arrow {\r\n  left: 8px;\r\n  right: initial;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-row .tabulator-cell {\r\n  border-right: initial;\r\n  border-left: 1px solid #aaa;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-row .tabulator-cell .tabulator-data-tree-branch {\r\n  margin-right: initial;\r\n  margin-left: 5px;\r\n  border-bottom-left-radius: initial;\r\n  border-bottom-right-radius: 1px;\r\n  border-left: initial;\r\n  border-right: 2px solid #aaa;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-row .tabulator-cell .tabulator-data-tree-control {\r\n  margin-right: initial;\r\n  margin-left: 5px;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-col-resize-handle {\r\n  position: absolute;\r\n  left: 0;\r\n  right: auto;\r\n}\r\n\r\n.tabulator.tabulator-rtl .tabulator-col-resize-handle.prev {\r\n  right: 0;\r\n  left: auto;\r\n}\r\n\r\n.tabulator-print-fullscreen {\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n  z-index: 10000;\r\n}\r\n\r\nbody.tabulator-print-fullscreen-hide>*:not(.tabulator-print-fullscreen) {\r\n  display: none !important;\r\n}\r\n\r\n.tabulator-print-table {\r\n  border-collapse: collapse;\r\n}\r\n\r\n.tabulator-print-table .tabulator-data-tree-branch {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  height: 9px;\r\n  width: 7px;\r\n  margin-top: -9px;\r\n  margin-right: 5px;\r\n  border-bottom-left-radius: 1px;\r\n  border-left: 2px solid #aaa;\r\n  border-bottom: 2px solid #aaa;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group {\r\n  box-sizing: border-box;\r\n  border-bottom: 1px solid #999;\r\n  border-right: 1px solid #aaa;\r\n  border-top: 1px solid #999;\r\n  padding: 5px;\r\n  padding-left: 10px;\r\n  background: #ccc;\r\n  font-weight: bold;\r\n  min-width: 100%;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group:hover {\r\n\r\n  background-color: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group.tabulator-group-visible .tabulator-arrow {\r\n  margin-right: 10px;\r\n  border-left: 6px solid transparent;\r\n  border-right: 6px solid transparent;\r\n  border-top: 6px solid #666;\r\n  border-bottom: 0;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-1 td {\r\n  padding-left: 30px !important;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-2 td {\r\n  padding-left: 50px !important;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-3 td {\r\n  padding-left: 70px !important;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-4 td {\r\n  padding-left: 90px !important;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group.tabulator-group-level-5 td {\r\n  padding-left: 110px !important;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group .tabulator-group-toggle {\r\n  display: inline-block;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group .tabulator-arrow {\r\n  display: inline-block;\r\n  width: 0;\r\n  height: 0;\r\n  margin-right: 16px;\r\n  border-top: 6px solid transparent;\r\n  border-bottom: 6px solid transparent;\r\n  border-right: 0;\r\n  border-left: 6px solid #666;\r\n  vertical-align: middle;\r\n}\r\n\r\n.tabulator-print-table .tabulator-print-table-group span {\r\n  margin-left: 10px;\r\n  color: #d00;\r\n}\r\n\r\n.tabulator-print-table .tabulator-data-tree-control {\r\n  display: inline-flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  vertical-align: middle;\r\n  height: 11px;\r\n  width: 11px;\r\n  margin-right: 5px;\r\n  border: 1px solid #333;\r\n  border-radius: 2px;\r\n  background: rgba(0, 0, 0, 0.1);\r\n  overflow: hidden;\r\n}\r\n\r\n.tabulator-print-table .tabulator-data-tree-control:hover {\r\n\r\n  background: rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-collapse {\r\n  display: inline-block;\r\n  position: relative;\r\n  height: 7px;\r\n  width: 1px;\r\n  background: transparent;\r\n}\r\n\r\n.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-collapse:after {\r\n  position: absolute;\r\n  content: \"\";\r\n  left: -3px;\r\n  top: 3px;\r\n  height: 1px;\r\n  width: 7px;\r\n  background: #333;\r\n}\r\n\r\n.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-expand {\r\n  display: inline-block;\r\n  position: relative;\r\n  height: 7px;\r\n  width: 1px;\r\n  background: #333;\r\n}\r\n\r\n.tabulator-print-table .tabulator-data-tree-control .tabulator-data-tree-control-expand:after {\r\n  position: absolute;\r\n  content: \"\";\r\n  left: -3px;\r\n  top: 3px;\r\n  height: 1px;\r\n  width: 7px;\r\n  background: #333;\r\n}\r\n\r\n/**\r\n * tom-select.css (v1.7.8)\r\n * Copyright (c) contributors\r\n *\r\n * Licensed under the Apache License, Version 2.0 (the \"License\"); you may not use this\r\n * file except in compliance with the License. You may obtain a copy of the License at:\r\n * http://www.apache.org/licenses/LICENSE-2.0\r\n *\r\n * Unless required by applicable law or agreed to in writing, software distributed under\r\n * the License is distributed on an \"AS IS\" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF\r\n * ANY KIND, either express or implied. See the License for the specific language\r\n * governing permissions and limitations under the License.\r\n *\r\n */\r\n.ts-control.plugin-drag_drop.multi>.ts-input>div.ui-sortable-placeholder {\r\n  visibility: visible !important;\r\n  background: #f2f2f2 !important;\r\n  background: rgba(0, 0, 0, 0.06) !important;\r\n  border: 0 none !important;\r\n  box-shadow: inset 0 0 12px 4px #fff;\r\n}\r\n\r\n.ts-control.plugin-drag_drop .ui-sortable-placeholder::after {\r\n  content: '!';\r\n  visibility: hidden;\r\n}\r\n\r\n.ts-control.plugin-drag_drop .ui-sortable-helper {\r\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.plugin-checkbox_options .option input {\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n.plugin-clear_button .items {\r\n  padding-right: calc(1em + (3 * 6px)) !important;\r\n}\r\n\r\n.plugin-clear_button .clear-button {\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 8px;\r\n  right: calc(8px - 6px);\r\n  margin-right: 0 !important;\r\n  background: transparent !important;\r\n  transition: opacity 0.5s;\r\n  cursor: pointer;\r\n}\r\n\r\n.plugin-clear_button.single .clear-button {\r\n  right: calc(8px - 6px + 2rem);\r\n}\r\n\r\n.plugin-clear_button .has-items.focus .clear-button,\r\n.plugin-clear_button:hover .has-items .clear-button {\r\n  opacity: 1;\r\n}\r\n\r\n.ts-control .dropdown-header {\r\n  position: relative;\r\n  padding: 10px 8px;\r\n  border-bottom: 1px solid #d0d0d0;\r\n  background: #f8f8f8;\r\n  border-radius: 3px 3px 0 0;\r\n}\r\n\r\n.ts-control .dropdown-header-close {\r\n  position: absolute;\r\n  right: 8px;\r\n  top: 50%;\r\n  color: #303030;\r\n  opacity: 0.4;\r\n  margin-top: -12px;\r\n  line-height: 20px;\r\n  font-size: 20px !important;\r\n}\r\n\r\n.ts-control .dropdown-header-close:hover {\r\n  color: black;\r\n}\r\n\r\n.plugin-dropdown_input .ts-input.focus {\r\n  box-shadow: none;\r\n  border: 1px solid #d0d0d0;\r\n}\r\n\r\n.plugin-dropdown_input .dropdown-input {\r\n  border: 1px solid #d0d0d0;\r\n  border-width: 0 0 1px 0;\r\n  display: block;\r\n  padding: 8px 8px;\r\n  box-shadow: none;\r\n  width: 100%;\r\n  background: transparent;\r\n}\r\n\r\n.ts-control.plugin-input_autogrow .ts-input.has-items>input {\r\n  min-width: 0;\r\n}\r\n\r\n.ts-control.plugin-input_autogrow .ts-input.focus.has-items>input {\r\n  flex: none;\r\n  min-width: 4px;\r\n}\r\n\r\n.ts-control.plugin-input_autogrow .ts-input.focus.has-items>input::-moz-placeholder {\r\n  color: transparent;\r\n}\r\n\r\n.ts-control.plugin-input_autogrow .ts-input.focus.has-items>input:-ms-input-placeholder {\r\n  color: transparent;\r\n}\r\n\r\n.ts-control.plugin-input_autogrow .ts-input.focus.has-items>input::placeholder {\r\n  color: transparent;\r\n}\r\n\r\n.ts-dropdown.plugin-optgroup_columns .ts-dropdown-content {\r\n  display: flex;\r\n}\r\n\r\n.ts-dropdown.plugin-optgroup_columns .optgroup {\r\n  border-right: 1px solid #f2f2f2;\r\n  border-top: 0 none;\r\n  flex-grow: 1;\r\n  flex-basis: 0;\r\n  min-width: 0;\r\n}\r\n\r\n.ts-dropdown.plugin-optgroup_columns .optgroup:last-child {\r\n  border-right: 0 none;\r\n}\r\n\r\n.ts-dropdown.plugin-optgroup_columns .optgroup:before {\r\n  display: none;\r\n}\r\n\r\n.ts-dropdown.plugin-optgroup_columns .optgroup-header {\r\n  border-top: 0 none;\r\n}\r\n\r\n.ts-control.plugin-remove_button .item {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding-right: 0 !important;\r\n}\r\n\r\n.ts-control.plugin-remove_button .item .remove {\r\n  color: inherit;\r\n  text-decoration: none;\r\n  vertical-align: middle;\r\n  display: inline-block;\r\n  padding: 2px 6px;\r\n  border-left: 1px solid #d0d0d0;\r\n  border-radius: 0 2px 2px 0;\r\n  box-sizing: border-box;\r\n  margin-left: 6px;\r\n}\r\n\r\n.ts-control.plugin-remove_button .item .remove:hover {\r\n  background: rgba(0, 0, 0, 0.05);\r\n}\r\n\r\n.ts-control.plugin-remove_button .item.active .remove {\r\n  border-left-color: #cacaca;\r\n}\r\n\r\n.ts-control.plugin-remove_button .disabled .item .remove:hover {\r\n  background: none;\r\n}\r\n\r\n.ts-control.plugin-remove_button .disabled .item .remove {\r\n  border-left-color: white;\r\n}\r\n\r\n.ts-control.plugin-remove_button .remove-single {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n  font-size: 23px;\r\n}\r\n\r\n.ts-control {\r\n  position: relative;\r\n}\r\n\r\n.ts-dropdown,\r\n.ts-input,\r\n.ts-input input {\r\n  color: #303030;\r\n  font-family: inherit;\r\n  font-size: 13px;\r\n  line-height: 18px;\r\n  font-smoothing: inherit;\r\n}\r\n\r\n.ts-input,\r\n.ts-control.single .ts-input.input-active {\r\n  background: #fff;\r\n  cursor: text;\r\n}\r\n\r\n.ts-input {\r\n  border: 1px solid #d0d0d0;\r\n  padding: 8px 8px;\r\n  width: 100%;\r\n  overflow: hidden;\r\n  position: relative;\r\n  z-index: 1;\r\n  box-sizing: border-box;\r\n  box-shadow: none;\r\n  border-radius: 3px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.ts-control.multi .ts-input.has-items {\r\n  padding: calc(8px - 2px - 0) 8px calc(8px - 2px - 3px - 0);\r\n}\r\n\r\n.ts-input.full {\r\n  background-color: #fff;\r\n}\r\n\r\n.ts-input.disabled,\r\n.ts-input.disabled * {\r\n  cursor: default !important;\r\n}\r\n\r\n.ts-input.focus {\r\n  box-shadow: none;\r\n}\r\n\r\n.ts-input>* {\r\n  vertical-align: baseline;\r\n  display: inline-block;\r\n}\r\n\r\n.ts-control.multi .ts-input>div {\r\n  cursor: pointer;\r\n  margin: 0 3px 3px 0;\r\n  padding: 2px 6px;\r\n  background: #f2f2f2;\r\n  color: #303030;\r\n  border: 0 solid #d0d0d0;\r\n}\r\n\r\n.ts-control.multi .ts-input>div.active {\r\n  background: #e8e8e8;\r\n  color: #303030;\r\n  border: 0 solid #cacaca;\r\n}\r\n\r\n.ts-control.multi .ts-input.disabled>div,\r\n.ts-control.multi .ts-input.disabled>div.active {\r\n  color: #7d7c7c;\r\n  background: white;\r\n  border: 0 solid white;\r\n}\r\n\r\n.ts-input>input {\r\n  flex: 1 1 auto;\r\n  min-width: 7rem;\r\n  display: inline-block !important;\r\n  padding: 0 !important;\r\n  min-height: 0 !important;\r\n  max-height: none !important;\r\n  max-width: 100% !important;\r\n  margin: 0 !important;\r\n  text-indent: 0 !important;\r\n  border: 0 none !important;\r\n  background: none !important;\r\n  line-height: inherit !important;\r\n  -webkit-user-select: auto !important;\r\n  -moz-user-select: auto !important;\r\n  -ms-user-select: auto !important;\r\n  user-select: auto !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.ts-input>input::-ms-clear {\r\n  display: none;\r\n}\r\n\r\n.ts-input>input:focus {\r\n  outline: none !important;\r\n}\r\n\r\n.ts-input.has-items>input {\r\n  margin: 0 4px !important;\r\n}\r\n\r\n.ts-input.dropdown-active::before {\r\n  content: ' ';\r\n  display: block;\r\n  position: absolute;\r\n  background: #f0f0f0;\r\n  height: 1px;\r\n  bottom: 0;\r\n  left: 0;\r\n  right: 0;\r\n}\r\n\r\n.ts-input.rtl {\r\n  text-align: right;\r\n}\r\n\r\n.ts-input.rtl.single .ts-input:after {\r\n  left: 15px;\r\n  right: auto;\r\n}\r\n\r\n.ts-input.rtl .ts-input>input {\r\n  margin: 0 4px 0 -2px !important;\r\n}\r\n\r\n.ts-input.disabled {\r\n  opacity: 0.5;\r\n  background-color: #fafafa;\r\n}\r\n\r\n.input-hidden .ts-input>input {\r\n  opacity: 0;\r\n  position: absolute;\r\n  left: -10000px;\r\n}\r\n\r\n.ts-dropdown {\r\n  position: absolute;\r\n  top: 100%;\r\n  left: 0;\r\n  width: 100%;\r\n  z-index: 10;\r\n  border: 1px solid #d0d0d0;\r\n  background: #fff;\r\n  margin: 0.25rem 0 0 0;\r\n  border-top: 0 none;\r\n  box-sizing: border-box;\r\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n  border-radius: 0 0 3px 3px;\r\n}\r\n\r\n.ts-dropdown [data-selectable] {\r\n  cursor: pointer;\r\n  overflow: hidden;\r\n}\r\n\r\n.ts-dropdown [data-selectable] .highlight {\r\n  background: rgba(125, 168, 208, 0.2);\r\n  border-radius: 1px;\r\n}\r\n\r\n.ts-dropdown .option,\r\n.ts-dropdown .optgroup-header,\r\n.ts-dropdown .no-results,\r\n.ts-dropdown .create {\r\n  padding: 5px 8px;\r\n}\r\n\r\n.ts-dropdown .option,\r\n.ts-dropdown [data-disabled],\r\n.ts-dropdown [data-disabled] [data-selectable].option {\r\n  cursor: inherit;\r\n  opacity: 0.5;\r\n}\r\n\r\n.ts-dropdown [data-selectable].option {\r\n  opacity: 1;\r\n  cursor: pointer;\r\n}\r\n\r\n.ts-dropdown .optgroup:first-child .optgroup-header {\r\n  border-top: 0 none;\r\n}\r\n\r\n.ts-dropdown .optgroup-header {\r\n  color: #303030;\r\n  background: #fff;\r\n  cursor: default;\r\n}\r\n\r\n.ts-dropdown .create:hover,\r\n.ts-dropdown .option:hover,\r\n.ts-dropdown .active {\r\n  background-color: #f5fafd;\r\n  color: #495c68;\r\n}\r\n\r\n.ts-dropdown .create:hover.create,\r\n.ts-dropdown .option:hover.create,\r\n.ts-dropdown .active.create {\r\n  color: #495c68;\r\n}\r\n\r\n.ts-dropdown .create {\r\n  color: rgba(48, 48, 48, 0.5);\r\n}\r\n\r\n.ts-dropdown .spinner {\r\n  display: inline-block;\r\n  width: 30px;\r\n  height: 30px;\r\n  margin: 5px 8px;\r\n}\r\n\r\n.ts-dropdown .spinner:after {\r\n  content: \" \";\r\n  display: block;\r\n  width: 24px;\r\n  height: 24px;\r\n  margin: 3px;\r\n  border-radius: 50%;\r\n  border: 5px solid #d0d0d0;\r\n  border-color: #d0d0d0 transparent #d0d0d0 transparent;\r\n  -webkit-animation: lds-dual-ring 1.2s linear infinite;\r\n  animation: lds-dual-ring 1.2s linear infinite;\r\n}\r\n\r\n@-webkit-keyframes lds-dual-ring {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n@keyframes lds-dual-ring {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n.ts-dropdown-content {\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  max-height: 200px;\r\n  overflow-scrolling: touch;\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.tns-outer {\r\n  padding: 0 !important\r\n}\r\n\r\n.tns-outer [hidden] {\r\n  display: none !important\r\n}\r\n\r\n.tns-outer [aria-controls],\r\n.tns-outer [data-action] {\r\n  cursor: pointer\r\n}\r\n\r\n.tns-slider {\r\n  transition: all 0s\r\n}\r\n\r\n.tns-slider>.tns-item {\r\n  box-sizing: border-box\r\n}\r\n\r\n.tns-horizontal.tns-subpixel {\r\n  white-space: nowrap\r\n}\r\n\r\n.tns-horizontal.tns-subpixel>.tns-item {\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  white-space: normal\r\n}\r\n\r\n.tns-horizontal.tns-no-subpixel:after {\r\n  content: '';\r\n  display: table;\r\n  clear: both\r\n}\r\n\r\n.tns-horizontal.tns-no-subpixel>.tns-item {\r\n  float: left\r\n}\r\n\r\n.tns-horizontal.tns-carousel.tns-no-subpixel>.tns-item {\r\n  margin-right: -100%\r\n}\r\n\r\n.tns-no-calc {\r\n  position: relative;\r\n  left: 0\r\n}\r\n\r\n.tns-gallery {\r\n  position: relative;\r\n  left: 0;\r\n  min-height: 1px\r\n}\r\n\r\n.tns-gallery>.tns-item {\r\n  position: absolute;\r\n  left: -100%;\r\n  transition: transform 0s, opacity 0s\r\n}\r\n\r\n.tns-gallery>.tns-slide-active {\r\n  position: relative;\r\n  left: auto !important\r\n}\r\n\r\n.tns-gallery>.tns-moving {\r\n  transition: all 0.25s\r\n}\r\n\r\n.tns-autowidth {\r\n  display: inline-block\r\n}\r\n\r\n.tns-lazy-img {\r\n  transition: opacity 0.6s;\r\n  opacity: 0.6\r\n}\r\n\r\n.tns-lazy-img.tns-complete {\r\n  opacity: 1\r\n}\r\n\r\n.tns-ah {\r\n  transition: height 0s\r\n}\r\n\r\n.tns-ovh {\r\n  overflow: hidden\r\n}\r\n\r\n.tns-visually-hidden {\r\n  position: absolute;\r\n  left: -10000em\r\n}\r\n\r\n.tns-transparent {\r\n  opacity: 0;\r\n  visibility: hidden\r\n}\r\n\r\n.tns-fadeIn {\r\n  opacity: 1;\r\n  filter: alpha(opacity=100);\r\n  z-index: 0\r\n}\r\n\r\n.tns-normal,\r\n.tns-fadeOut {\r\n  opacity: 0;\r\n  filter: alpha(opacity=0);\r\n  z-index: -1\r\n}\r\n\r\n.tns-vpfix {\r\n  white-space: nowrap\r\n}\r\n\r\n.tns-vpfix>div,\r\n.tns-vpfix>li {\r\n  display: inline-block\r\n}\r\n\r\n.tns-t-subp2 {\r\n  margin: 0 auto;\r\n  width: 310px;\r\n  position: relative;\r\n  height: 10px;\r\n  overflow: hidden\r\n}\r\n\r\n.tns-t-ct {\r\n  width: 2333.3333333%;\r\n  width: calc(100% * 70 / 3);\r\n  position: absolute;\r\n  right: 0\r\n}\r\n\r\n.tns-t-ct:after {\r\n  content: '';\r\n  display: table;\r\n  clear: both\r\n}\r\n\r\n.tns-t-ct>div {\r\n  width: 1.4285714%;\r\n  width: calc(100% / 70);\r\n  height: 10px;\r\n  float: left\r\n}\r\n\r\n[data-simplebar] {\r\n  position: relative;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.simplebar-wrapper {\r\n  overflow: hidden;\r\n  width: inherit;\r\n  height: inherit;\r\n  max-width: inherit;\r\n  max-height: inherit;\r\n}\r\n\r\n.simplebar-mask {\r\n  direction: inherit;\r\n  position: absolute;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  z-index: 0;\r\n}\r\n\r\n.simplebar-offset {\r\n  direction: inherit !important;\r\n  box-sizing: inherit !important;\r\n  resize: none !important;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  padding: 0;\r\n  margin: 0;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.simplebar-content-wrapper {\r\n  direction: inherit;\r\n  box-sizing: border-box !important;\r\n  position: relative;\r\n  display: block;\r\n  height: 100%;\r\n  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\r\n  width: auto;\r\n  max-width: 100%;\r\n  /* Not required for horizontal scroll to trigger */\r\n  max-height: 100%;\r\n  /* Needed for vertical scroll to trigger */\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n.simplebar-content-wrapper::-webkit-scrollbar,\r\n.simplebar-hide-scrollbar::-webkit-scrollbar {\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.simplebar-content:before,\r\n.simplebar-content:after {\r\n  content: ' ';\r\n  display: table;\r\n}\r\n\r\n.simplebar-placeholder {\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.simplebar-height-auto-observer-wrapper {\r\n  box-sizing: inherit !important;\r\n  height: 100%;\r\n  width: 100%;\r\n  max-width: 1px;\r\n  position: relative;\r\n  float: left;\r\n  max-height: 1px;\r\n  overflow: hidden;\r\n  z-index: -1;\r\n  padding: 0;\r\n  margin: 0;\r\n  pointer-events: none;\r\n  flex-grow: inherit;\r\n  flex-shrink: 0;\r\n  flex-basis: 0;\r\n}\r\n\r\n.simplebar-height-auto-observer {\r\n  box-sizing: inherit;\r\n  display: block;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 1000%;\r\n  width: 1000%;\r\n  min-height: 1px;\r\n  min-width: 1px;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n}\r\n\r\n.simplebar-track {\r\n  z-index: 1;\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n  overflow: hidden;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-content {\r\n  pointer-events: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-track {\r\n  pointer-events: all;\r\n}\r\n\r\n.simplebar-scrollbar {\r\n  position: absolute;\r\n  left: 0;\r\n  right: 0;\r\n  min-height: 10px;\r\n}\r\n\r\n.simplebar-scrollbar:before {\r\n  position: absolute;\r\n  content: '';\r\n  background: black;\r\n  border-radius: 7px;\r\n  left: 2px;\r\n  right: 2px;\r\n  opacity: 0;\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.simplebar-scrollbar.simplebar-visible:before {\r\n  /* When hovered, remove all transitions from drag handle */\r\n  opacity: 0.5;\r\n  transition: opacity 0s linear;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical {\r\n  top: 0;\r\n  width: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n  top: 2px;\r\n  bottom: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal {\r\n  left: 0;\r\n  height: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\r\n  height: 100%;\r\n  left: 2px;\r\n  right: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\r\n  right: auto;\r\n  left: 0;\r\n  top: 2px;\r\n  height: 7px;\r\n  min-height: 0;\r\n  min-width: 10px;\r\n  width: auto;\r\n}\r\n\r\n/* Rtl support */\r\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.hs-dummy-scrollbar-size {\r\n  direction: rtl;\r\n  position: fixed;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  height: 500px;\r\n  width: 500px;\r\n  overflow-y: hidden;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.simplebar-hide-scrollbar {\r\n  position: fixed;\r\n  left: 0;\r\n  visibility: hidden;\r\n  overflow-y: scroll;\r\n  scrollbar-width: none;\r\n  -ms-overflow-style: none;\r\n}\r\n\r\n/*\r\n |--------------------------------------------------------------------------\r\n | Components\r\n |--------------------------------------------------------------------------\r\n |\r\n | Import CSS/SCSS components.\r\n |\r\n */\r\nhtml {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  html {\r\n    --tw-bg-opacity: 1;\r\n    background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  }\r\n}\r\n\r\nhtml.dark {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\nhtml.dark body {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\nhtml.dark body *,\r\nhtml.dark body ::before,\r\nhtml.dark body ::after {\r\n  border-color: rgb(255 255 255 / 0.05);\r\n}\r\n\r\nhtml body {\r\n  overflow-x: hidden;\r\n  font-family: Roboto;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  background-color: #fff;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  html body {\r\n    padding-left: 2rem;\r\n    padding-right: 2rem;\r\n  }\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  html body {\r\n    padding-left: 0.75rem;\r\n    padding-right: 0.75rem;\r\n  }\r\n}\r\n\r\n.login {\r\n  position: relative;\r\n  overflow: hidden;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n  padding-left: 2rem;\r\n  padding-right: 2rem;\r\n}\r\n\r\n.dark .login {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .login {\r\n    --tw-bg-opacity: 1;\r\n    background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  }\r\n\r\n  .dark .login {\r\n    --tw-bg-opacity: 1;\r\n    background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  }\r\n}\r\n\r\n.login:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  margin-top: -28%;\r\n  margin-bottom: -15%;\r\n  margin-left: -13%;\r\n  width: 57%;\r\n  --tw-rotate: -4deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  border-radius: 100%;\r\n  background-color: rgb(var(--color-primary) / 0.2);\r\n}\r\n\r\n.dark .login:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .login:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.login:after {\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  margin-top: -20%;\r\n  margin-bottom: -12%;\r\n  margin-left: -13%;\r\n  width: 57%;\r\n  --tw-rotate: -4deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  border-radius: 100%;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\n}\n\n.login.login--light-tenant:before {\n  background-color: #c3cbd3;\n}\n\n.login.login--light-tenant:after {\n  background-color: #d9dee3;\n}\n\n.login.login--light-tenant .tenant-login-logo {\n  width: 14rem;\n  max-height: 7rem;\n  object-fit: contain;\n  object-position: left center;\n}\n\n.login.login--light-tenant .tenant-login-title {\n  color: #334155 !important;\n}\n\r\n.dark .login:after {\n  --tw-bg-opacity: 1;\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\n}\n\n.dark .login.login--light-tenant:before {\n  background-color: #c3cbd3;\n}\n\n.dark .login.login--light-tenant:after {\n  background-color: #d9dee3;\n}\n\r\n@media (max-width: calc(1280px - 1px)) {\n  .login.login--light-tenant {\n    background-color: #d9dee3;\n  }\n\n  .login:after {\n    display: none;\n  }\n}\n\r\n.login .login__input {\r\n  min-width: 350px;\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .login .login__input {\r\n    min-width: 100%;\r\n  }\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) {\r\n  border-spacing: 0 10px;\r\n  border-collapse: separate;\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) th {\r\n  border-bottom-width: 0px;\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) td {\r\n  border-bottom-width: 0px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .table-report:not(.table-report--bordered):not(.table-report--tabulator) td {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) td {\r\n  box-shadow: 20px 3px 20px #0000000b;\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) td:first-child {\r\n  border-top-left-radius: 0.375rem;\r\n  border-bottom-left-radius: 0.375rem;\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) td:last-child {\r\n  border-top-right-radius: 0.375rem;\r\n  border-bottom-right-radius: 0.375rem;\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) td.table-report__action {\r\n  position: relative;\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.table-report:not(.table-report--bordered):not(.table-report--tabulator) td.table-report__action::before {\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  display: block;\r\n  height: 2rem;\r\n  width: 1px;\r\n  content: var(--tw-content);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .table-report:not(.table-report--bordered):not(.table-report--tabulator) td.table-report__action::before {\r\n  content: var(--tw-content);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.table-report img {\r\n  box-shadow: 0px 0px 0px 2px #fff, 1px 1px 5px rgba(0, 0, 0, 0.32);\r\n}\r\n\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(3) .tabulator-col-content .tabulator-col-title,\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(4) .tabulator-col-content .tabulator-col-title,\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(5) .tabulator-col-content .tabulator-col-title,\r\n.table-report.table-report--tabulator .tabulator-header .tabulator-headers .tabulator-col:nth-child(6) .tabulator-col-content .tabulator-col-title {\r\n  /* text-align: center; */\r\n}\r\n\r\n.dark .table-report img {\r\n  box-shadow: 0px 0px 0px 2px #3f4865, 1px 1px 5px rgba(0, 0, 0, 0.32);\r\n}\r\n\r\n.report-chart {\r\n  position: relative;\r\n}\r\n\r\n.report-chart:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 0px;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  margin-left: 2.5rem;\r\n  margin-bottom: 1.75rem;\r\n  display: block;\r\n  width: 4rem;\r\n  background-image: linear-gradient(to right, var(--tw-gradient-stops));\r\n  --tw-gradient-from: #fff;\r\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0));\r\n  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.8), var(--tw-gradient-to, rgb(255 255 255 / 0));\r\n  --tw-gradient-to: transparent;\r\n}\r\n\r\n.dark .report-chart:before {\r\n  --tw-gradient-from: rgb(var(--color-darkmode-600));\r\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-600) / 0));\r\n}\r\n\r\n.report-chart:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  right: 0px;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  margin-bottom: 1.75rem;\r\n  display: block;\r\n  width: 4rem;\r\n  background-image: linear-gradient(to left, var(--tw-gradient-stops));\r\n  --tw-gradient-from: #fff;\r\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(255 255 255 / 0));\r\n  --tw-gradient-stops: var(--tw-gradient-from), rgb(255 255 255 / 0.8), var(--tw-gradient-to, rgb(255 255 255 / 0));\r\n  --tw-gradient-to: transparent;\r\n}\r\n\r\n.dark .report-chart:after {\r\n  --tw-gradient-from: rgb(var(--color-darkmode-600));\r\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-600) / 0));\r\n}\r\n\r\n.search {\r\n  position: relative;\r\n}\r\n\r\n.search .search__input {\r\n  width: 14rem;\r\n  border-radius: 9999px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  padding-right: 2rem;\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  transition-property: width;\r\n  transition-duration: 300ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.search .search__input:focus {\r\n  border-color: transparent;\r\n}\r\n\r\n.dark .search .search__input {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.search .search__input:focus {\r\n  width: 18rem;\r\n}\r\n\r\n.search .search__icon {\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  right: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  margin-right: 0.75rem;\r\n  height: 1.25rem;\r\n  width: 1.25rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n}\r\n\r\n.notification {\r\n  position: relative;\r\n  color: rgb(255 255 255 / 0.7);\r\n}\r\n\r\n.notification .notification__icon {\r\n  height: 1.25rem;\r\n  width: 1.25rem;\r\n}\r\n\r\n.notification.notification--bullet:before {\r\n  content: \"\";\r\n  width: 8px;\r\n  height: 8px;\r\n  position: absolute;\r\n  top: -2px;\r\n  right: 0px;\r\n  border-radius: 9999px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n}\r\n\r\n.report-box {\r\n  position: relative;\r\n}\r\n\r\n.report-box:before {\r\n  content: \"\";\r\n  width: 90%;\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  position: absolute;\r\n  left: 0px;\r\n  right: 0px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  margin-top: 0.75rem;\r\n  height: 100%;\r\n  border-radius: 0.375rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-50) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .report-box:before {\r\n  background-color: rgb(var(--color-darkmode-400) / 0.7);\r\n}\r\n\r\n.report-box .report-box__icon {\r\n  width: 28px;\r\n  height: 28px;\r\n}\r\n\r\n.report-box .report-box__indicator {\r\n  padding-top: 3px;\r\n  padding-bottom: 3px;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.25rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n  font-weight: 500;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.report-box-2 {\r\n  position: relative;\r\n}\r\n\r\n.report-box-2:before {\r\n  content: \"\";\r\n  width: 90%;\r\n  background: #f9fafc;\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  position: absolute;\r\n  left: 0px;\r\n  right: 0px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  margin-top: 0.75rem;\r\n  height: 100%;\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.dark .report-box-2:before {\r\n  background-color: rgb(var(--color-darkmode-400) / 0.7);\r\n}\r\n\r\n.report-box-2 .report-box-2__indicator {\r\n  padding-top: 3px;\r\n  padding-bottom: 3px;\r\n  margin-top: 0.75rem;\r\n  margin-right: auto;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 9999px;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.25rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n  font-weight: 500;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.report-box-3 {\r\n  margin-left: -22px;\r\n  margin-right: -22px;\r\n  position: relative;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .report-box-3 {\r\n    margin-left: -16px;\r\n    margin-right: -16px;\r\n  }\r\n}\r\n\r\n.report-box-3:before {\r\n  content: \"\";\r\n  border-radius: 30px 30px 0px 0px;\r\n  transform: translatey(35px);\r\n  -webkit-animation: 0.4s intro-report-box-3-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-report-box-3-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: 0.1s;\r\n  animation-delay: 0.1s;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  background-color: rgb(var(--color-slate-200) / 0.7);\r\n  opacity: 0;\r\n}\r\n\r\n.dark .report-box-3:before {\r\n  background-color: rgb(var(--color-darkmode-500) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.5;\r\n}\r\n\r\n.report-box-3.report-box-3--content {\r\n  padding: 0px 22px;\r\n  min-height: 400px;\r\n}\r\n\r\n.report-box-3.report-box-3--content:before {\r\n  content: \"\";\r\n  border-radius: 30px;\r\n  transform: translatey(35px);\r\n  -webkit-animation: 0.4s intro-report-box-3-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-report-box-3-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: 0.1s;\r\n  animation-delay: 0.1s;\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  opacity: 0;\r\n}\r\n\r\n.dark .report-box-3.report-box-3--content:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .report-box-3.report-box-3--content:before {\r\n    border-top-left-radius: 0px;\r\n    border-top-right-radius: 0px;\r\n    --tw-shadow: 0 0 #0000;\r\n    --tw-shadow-colored: 0 0 #0000;\r\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes intro-report-box-3-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@keyframes intro-report-box-3-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n.report-box-4 {\r\n  position: relative;\r\n}\r\n\r\n.report-box-4:before {\r\n  content: \"\";\r\n  border-radius: 30px 30px 0px 0px;\r\n  transform: translatey(35px);\r\n  -webkit-animation: 0.4s intro-report-box-4-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-report-box-4-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: 0.1s;\r\n  animation-delay: 0.1s;\r\n  margin-left: -22px;\r\n  margin-right: -22px;\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  right: 0px;\r\n  display: none;\r\n  height: 100%;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  opacity: 0;\r\n}\r\n\r\n.dark .report-box-4:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .report-box-4:before {\r\n    display: block;\r\n  }\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .report-box-4:before {\r\n    margin-left: -16px;\r\n    margin-right: -16px;\r\n  }\r\n}\r\n\r\n.report-box-4 .report-box-4__content {\r\n  flex: 1 1 0;\r\n}\r\n\r\n@-webkit-keyframes intro-report-box-4-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@keyframes intro-report-box-4-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n.content {\r\n  padding: 0px 22px;\r\n  position: relative;\r\n  /*margin-top: 0.25rem;*/\r\n  min-height: 100dvh;\r\n  min-width: 0px;\r\n  flex: 1 1 0%;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  padding-top: 5rem;\r\n  /* padding-bottom: 2rem; */\r\n}\r\n\r\n.dark .content {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .content {\r\n    border-radius: 5px;\r\n    /* border-radius: 30px; */\r\n    margin-top: 2.5rem;\r\n    max-width: 100%;\r\n    padding-left: .5rem;\r\n    padding-right: .5rem;\r\n    /* padding-top: 0px; */\r\n    padding-top: .3rem;\r\n    padding-bottom: .5rem;\r\n    margin-bottom: 15px;\r\n  }\r\n}\r\n\r\n.content:before {\r\n  content: \"\";\r\n  display: block;\r\n  height: 1px;\r\n  width: 100%;\r\n}\r\n\r\n.content.content--top-nav {\r\n  border-radius: 35px 35px 0 0;\r\n  margin-top: 1.25rem;\r\n  padding-top: 0px;\r\n}\r\n\r\n.top-nav {\r\n  transform: translatey(35px);\r\n  -webkit-animation: 0.4s intro-top-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-top-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: 0.2s;\r\n  animation-delay: 0.2s;\r\n  position: relative;\r\n  z-index: 50;\r\n  margin-top: -1rem;\r\n  padding-top: 8rem;\r\n  opacity: 0;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .top-nav {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.top-nav>ul>li:nth-child(1)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(1)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(2)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(2)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(3)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(3)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(4)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(4)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(5)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(5)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(6)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(6)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(7)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(7)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(8)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(8)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(9)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(9)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(10)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(10)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(11)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(11)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(12)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(12)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(13)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(13)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(14)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(14)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(15)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(15)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(16)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(16)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(17)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(17)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(18)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(18)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(19)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(19)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(20)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(20)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(21)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(21)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(22)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(22)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(23)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(23)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(24)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(24)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(25)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(25)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(26)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(26)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(27)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(27)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(28)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(28)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(29)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(29)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(30)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(30)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(31)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(31)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(32)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(32)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(33)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(33)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(34)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(34)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(35)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(35)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(36)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(36)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(37)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(37)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(38)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(38)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(39)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(39)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(40)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(40)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(41)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(41)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(42)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(42)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(43)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(43)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(44)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(44)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(45)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(45)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(46)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(46)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(47)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(47)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(48)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(48)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(49)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(49)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul>li:nth-child(50)>a:not(.top-menu--active) {\r\n  opacity: 0;\r\n  transform: translateY(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n.top-nav>ul>li:nth-child(50)>a.top-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.top-nav>ul {\r\n  padding: 0px 50px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul {\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n}\r\n\r\n.top-nav>ul>li>.top-menu {\r\n  margin-top: 3px;\r\n}\r\n\r\n.top-nav>ul>li>.top-menu>.top-menu__icon {\r\n  margin-top: -3px;\r\n}\r\n\r\n.top-nav>ul>li>.top-menu>.top-menu__title {\r\n  margin-top: -3px;\r\n}\r\n\r\n.top-nav>ul li {\r\n  position: relative;\r\n}\r\n\r\n.top-nav>ul li:hover>.top-menu>.top-menu__title>.top-menu__sub-icon {\r\n  --tw-rotate: 180deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n}\r\n\r\n.top-nav>ul li:hover>ul {\r\n  display: block;\r\n}\r\n\r\n.top-nav>ul li:hover>ul li:hover .top-menu>.top-menu__title>.top-menu__sub-icon {\r\n  --tw-rotate: -90deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n}\r\n\r\n.top-nav>ul li .top-menu {\r\n  height: 55px;\r\n  position: relative;\r\n  margin-right: 0.25rem;\r\n  display: flex;\r\n  align-items: center;\r\n  border-radius: 0.75rem;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul li .top-menu {\r\n    border-radius: 9999px;\r\n  }\r\n}\r\n\r\n.top-nav>ul li .top-menu.top-menu--active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .top-nav>ul li .top-menu.top-menu--active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n.top-nav>ul li .top-menu.top-menu--active:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  display: block;\r\n  border-radius: 0.75rem;\r\n  border-bottom-width: 3px;\r\n  border-style: solid;\r\n  border-color: rgb(0 0 0 / 0.08);\r\n}\r\n\r\n.dark .top-nav>ul li .top-menu.top-menu--active:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul li .top-menu.top-menu--active:before {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.top-nav>ul li .top-menu.top-menu--active:after {\r\n  content: \"\";\r\n  width: 20px;\r\n  height: 80px;\r\n  margin-bottom: -74px;\r\n  -webkit-animation: 0.3s active-top-menu-chevron-animation ease-in-out 0.33333s;\r\n  animation: 0.3s active-top-menu-chevron-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: 1s;\r\n  animation-delay: 1s;\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='80' viewBox='0 0 20 122.1'%3E%3Cpath data-name='Union 1' d='M16.038 122H16v-2.213a95.805 95.805 0 00-2.886-20.735 94.894 94.894 0 00-7.783-20.434A39.039 39.039 0 010 61.051a39.035 39.035 0 015.331-17.567 94.9 94.9 0 007.783-20.435A95.746 95.746 0 0016 2.314V0h4v122h-3.961v.1l-.001-.1z' fill='%23f1f5f8'/%3E%3C/svg%3E\");\r\n  position: absolute;\r\n  left: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  --tw-rotate: 90deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  opacity: 0;\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul li .top-menu.top-menu--active:after {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.dark .top-nav>ul li .top-menu.top-menu--active .top-menu__icon {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul li .top-menu.top-menu--active .top-menu__icon {\r\n    --tw-text-opacity: 1;\r\n    color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n  }\r\n}\r\n\r\n.top-nav>ul li .top-menu.top-menu--active .top-menu__title {\r\n  font-weight: 500;\r\n}\r\n\r\n.dark .top-nav>ul li .top-menu.top-menu--active .top-menu__title {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul li .top-menu.top-menu--active .top-menu__title {\r\n    --tw-text-opacity: 1;\r\n    color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n  }\r\n}\r\n\r\n.top-nav>ul li .top-menu .top-menu__icon {\r\n  z-index: 10;\r\n}\r\n\r\n.dark .top-nav>ul li .top-menu .top-menu__icon {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.top-nav>ul li .top-menu .top-menu__title {\r\n  z-index: 10;\r\n}\r\n\r\n.dark .top-nav>ul li .top-menu .top-menu__title {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.top-nav>ul li .top-menu .top-menu__title {\r\n  margin-left: 0.75rem;\r\n  display: flex;\r\n  align-items: center;\r\n  white-space: nowrap;\r\n}\r\n\r\n.top-nav>ul li .top-menu .top-menu__title .top-menu__sub-icon {\r\n  margin-left: 0.5rem;\r\n  height: 1rem;\r\n  width: 1rem;\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 100ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul li .top-menu .top-menu__title .top-menu__sub-icon {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.top-nav>ul li ul {\r\n  box-shadow: 0px 3px 20px #00000014;\r\n  position: absolute;\r\n  z-index: 20;\r\n  margin-top: 0.25rem;\r\n  display: none;\r\n  width: 14rem;\r\n  border-radius: 0.375rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  padding-left: 0px;\r\n  padding-right: 0px;\r\n}\r\n\r\n.top-nav>ul li ul::before {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  z-index: -1;\r\n  display: block;\r\n  height: 100%;\r\n  width: 100%;\r\n  border-radius: 0.375rem;\r\n  content: var(--tw-content);\r\n  background-color: rgb(255 255 255 / 0.04);\r\n}\r\n\r\n.dark .top-nav>ul li ul::before {\r\n  content: var(--tw-content);\r\n  background-color: rgb(0 0 0 / 0.1);\r\n}\r\n\r\n.top-nav>ul li ul:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  margin-top: -0.25rem;\r\n  height: 0.25rem;\r\n  width: 100%;\r\n  cursor: pointer;\r\n}\r\n\r\n.top-nav>ul li ul li {\r\n  position: relative;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n}\r\n\r\n.top-nav>ul li ul li .top-menu {\r\n  margin-right: 0px;\r\n  padding-left: 0px;\r\n  padding-right: 0px;\r\n}\r\n\r\n.top-nav>ul li ul li .top-menu .top-menu__icon:before {\r\n  display: none;\r\n}\r\n\r\n.top-nav>ul li ul li .top-menu .top-menu__title {\r\n  width: 100%;\r\n}\r\n\r\n.top-nav>ul li ul li .top-menu .top-menu__title .top-menu__sub-icon {\r\n  margin-left: auto;\r\n}\r\n\r\n.top-nav>ul li ul ul {\r\n  left: 100%;\r\n  top: 0px;\r\n  margin-top: 0px;\r\n  margin-left: 0px;\r\n  display: none;\r\n  border-radius: 0.375rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.top-nav>ul li ul ul::before {\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  z-index: -1;\r\n  display: block;\r\n  height: 100%;\r\n  width: 100%;\r\n  border-radius: 0.375rem;\r\n  content: var(--tw-content);\r\n  background-color: rgb(255 255 255 / 0.04);\r\n}\r\n\r\n.dark .top-nav>ul li ul ul::before {\r\n  content: var(--tw-content);\r\n  background-color: rgb(0 0 0 / 0.1);\r\n}\r\n\r\n.top-nav>ul>li:hover>.top-menu:not(.top-menu--active) {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .top-nav>ul>li:hover>.top-menu:not(.top-menu--active) {\r\n  background-color: transparent;\r\n}\r\n\r\n.top-nav>ul>li:hover>.top-menu:not(.top-menu--active):before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  z-index: -1;\r\n  display: block;\r\n  border-radius: 0.75rem;\r\n  border-bottom-width: 3px;\r\n  border-style: solid;\r\n  border-color: rgb(0 0 0 / 0.08);\r\n}\r\n\r\n.dark .top-nav>ul>li:hover>.top-menu:not(.top-menu--active):before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (max-width: calc(1280px - 1px)) {\r\n  .top-nav>ul>li:hover>.top-menu:not(.top-menu--active):before {\r\n    border-radius: 9999px;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes intro-top-menu-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@keyframes intro-top-menu-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes intro-active-top-menu-animation {\r\n  100% {\r\n    z-index: 10;\r\n  }\r\n}\r\n\r\n@keyframes intro-active-top-menu-animation {\r\n  100% {\r\n    z-index: 10;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes active-top-menu-chevron-animation {\r\n  100% {\r\n    margin-bottom: -54px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes active-top-menu-chevron-animation {\r\n  100% {\r\n    margin-bottom: -54px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.dark .top-nav>ul li .top-menu.top-menu--active:after {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='80' viewBox='0 0 20 122.1'%3E%3Cpath data-name='Union 1' d='M16.038 122H16v-2.213a95.805 95.805 0 00-2.886-20.735 94.894 94.894 0 00-7.783-20.434A39.039 39.039 0 010 61.051a39.035 39.035 0 015.331-17.567 94.9 94.9 0 007.783-20.435A95.746 95.746 0 0016 2.314V0h4v122h-3.961v.1l-.001-.1z' fill='%23232e45'/%3E%3C/svg%3E\");\r\n}\r\n\r\n.dark .top-nav>ul li ul {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .top-nav>ul ul {\r\n  box-shadow: 0px 3px 7px #0000001c;\r\n}\r\n\r\n.side-nav {\r\n  width: 260px;\r\n  z-index: 50;\r\n  margin-top: -1rem;\r\n  overflow-x: hidden;\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-bottom: 4rem;\r\n  padding-top: 8rem;\r\n}\r\n\r\n.side-nav ul li {\r\n  cursor: pointer;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .side-nav {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.side-nav.side-nav--simple {\r\n  width: 105px;\r\n}\r\n\r\n.side-nav.side-nav--simple .side-menu .side-menu__title {\r\n  display: none;\r\n}\r\n\r\n.side-nav.side-nav--simple .side-menu .side-menu__title .side-menu__sub-icon {\r\n  display: none;\r\n}\r\n\r\n.side-nav.side-nav--simple .side-menu:not(.side-menu--active) .side-menu__icon:before {\r\n  display: none;\r\n}\r\n\r\n.side-nav .side-nav__devider {\r\n  position: relative;\r\n  z-index: 10;\r\n  height: 1px;\r\n  width: 100%;\r\n  background-color: rgb(255 255 255 / 0.08);\r\n}\r\n\r\n.dark .side-nav .side-nav__devider {\r\n  background-color: rgb(255 255 255 / 0.07);\r\n}\r\n\r\n.side-nav .side-menu {\r\n  position: relative;\r\n  margin-bottom: 0.25rem;\r\n  display: flex;\r\n  height: 40px;\r\n  align-items: center;\r\n  border-radius: 0.75rem;\r\n  padding-left: 0.75rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .side-nav .side-menu {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.side-nav .side-menu .side-menu__title {\r\n  margin-left: 0.75rem;\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n}\r\n\r\n.side-nav .side-menu .side-menu__title .side-menu__sub-icon {\r\n  margin-left: auto;\r\n  margin-right: 1.25rem;\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 100ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\r\n}\r\n\r\n.side-nav .side-menu .side-menu__title .side-menu__sub-icon svg {\r\n  height: 1rem;\r\n  width: 1rem;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(1).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(1)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(1)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(2).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(2)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(2)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(3).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(3)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(3)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(4).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(4)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(4)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(5).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(5)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(5)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(6).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(6)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(6)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(7).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(7)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(7)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(8).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(8)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(8)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(9).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(9)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(9)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(10).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(10)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(10)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(11).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(11)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(11)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(12).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(12)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(12)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(13).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(13)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(13)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(14).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(14)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(14)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(15).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(15)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(15)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(16).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(16)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(16)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(17).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(17)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(17)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(18).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(18)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(18)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(19).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(19)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(19)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(20).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(20)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(20)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(21).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(21)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(21)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(22).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(22)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(22)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(23).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(23)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(23)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(24).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(24)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(24)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(25).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(25)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(25)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(26).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(26)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(26)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(27).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(27)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(27)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(28).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(28)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(28)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(29).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(29)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(29)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(30).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(30)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(30)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(31).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(31)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(31)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(32).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(32)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(32)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(33).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(33)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(33)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(34).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(34)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(34)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(35).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(35)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(35)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(36).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(36)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(36)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(37).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(37)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(37)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(38).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(38)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(38)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(39).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(39)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(39)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(40).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(40)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(40)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(41).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(41)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(41)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(42).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(42)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(42)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(43).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(43)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(43)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(44).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(44)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(44)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(45).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(45)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(45)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(46).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(46)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(46)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(47).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(47)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(47)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(48).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(48)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(48)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(49).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(49)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(49)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul>li:nth-child(50).side-nav__devider {\r\n  opacity: 0;\r\n  -webkit-animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-devider-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(50)>a:not(.side-menu--active) {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n.side-nav>ul>li:nth-child(50)>a.side-menu--active {\r\n  -webkit-animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  animation: 0.4s intro-active-menu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(1)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(1 * 0.1s);\r\n  animation-delay: calc(1 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(2)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(2 * 0.1s);\r\n  animation-delay: calc(2 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(3)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(3 * 0.1s);\r\n  animation-delay: calc(3 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(4)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(4 * 0.1s);\r\n  animation-delay: calc(4 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(5)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(5 * 0.1s);\r\n  animation-delay: calc(5 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(6)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(6 * 0.1s);\r\n  animation-delay: calc(6 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(7)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(7 * 0.1s);\r\n  animation-delay: calc(7 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(8)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(8 * 0.1s);\r\n  animation-delay: calc(8 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(9)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(9 * 0.1s);\r\n  animation-delay: calc(9 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(10)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(10 * 0.1s);\r\n  animation-delay: calc(10 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(11)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(11 * 0.1s);\r\n  animation-delay: calc(11 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(12)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(12 * 0.1s);\r\n  animation-delay: calc(12 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(13)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(13 * 0.1s);\r\n  animation-delay: calc(13 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(14)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(14 * 0.1s);\r\n  animation-delay: calc(14 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(15)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(15 * 0.1s);\r\n  animation-delay: calc(15 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(16)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(16 * 0.1s);\r\n  animation-delay: calc(16 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(17)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(17 * 0.1s);\r\n  animation-delay: calc(17 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(18)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(18 * 0.1s);\r\n  animation-delay: calc(18 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(19)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(19 * 0.1s);\r\n  animation-delay: calc(19 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(20)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(20 * 0.1s);\r\n  animation-delay: calc(20 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(21)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(21 * 0.1s);\r\n  animation-delay: calc(21 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(22)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(22 * 0.1s);\r\n  animation-delay: calc(22 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(23)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(23 * 0.1s);\r\n  animation-delay: calc(23 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(24)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(24 * 0.1s);\r\n  animation-delay: calc(24 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(25)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(25 * 0.1s);\r\n  animation-delay: calc(25 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(26)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(26 * 0.1s);\r\n  animation-delay: calc(26 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(27)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(27 * 0.1s);\r\n  animation-delay: calc(27 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(28)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(28 * 0.1s);\r\n  animation-delay: calc(28 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(29)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(29 * 0.1s);\r\n  animation-delay: calc(29 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(30)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(30 * 0.1s);\r\n  animation-delay: calc(30 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(31)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(31 * 0.1s);\r\n  animation-delay: calc(31 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(32)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(32 * 0.1s);\r\n  animation-delay: calc(32 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(33)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(33 * 0.1s);\r\n  animation-delay: calc(33 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(34)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(34 * 0.1s);\r\n  animation-delay: calc(34 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(35)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(35 * 0.1s);\r\n  animation-delay: calc(35 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(36)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(36 * 0.1s);\r\n  animation-delay: calc(36 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(37)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(37 * 0.1s);\r\n  animation-delay: calc(37 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(38)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(38 * 0.1s);\r\n  animation-delay: calc(38 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(39)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(39 * 0.1s);\r\n  animation-delay: calc(39 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(40)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(40 * 0.1s);\r\n  animation-delay: calc(40 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(41)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(41 * 0.1s);\r\n  animation-delay: calc(41 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(42)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(42 * 0.1s);\r\n  animation-delay: calc(42 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(43)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(43 * 0.1s);\r\n  animation-delay: calc(43 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(44)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(44 * 0.1s);\r\n  animation-delay: calc(44 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(45)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(45 * 0.1s);\r\n  animation-delay: calc(45 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(46)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(46 * 0.1s);\r\n  animation-delay: calc(46 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(47)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(47 * 0.1s);\r\n  animation-delay: calc(47 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(48)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(48 * 0.1s);\r\n  animation-delay: calc(48 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(49)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(49 * 0.1s);\r\n  animation-delay: calc(49 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul li:nth-child(50)>a {\r\n  opacity: 0;\r\n  transform: translateX(50px);\r\n  -webkit-animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  animation: 0.2s intro-submenu-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: calc(50 * 0.1s);\r\n  animation-delay: calc(50 * 0.1s);\r\n}\r\n\r\n.side-nav>ul ul {\r\n  position: relative;\r\n  /* display: none; */\r\n  border-radius: 0.75rem;\r\n  background-color: #fff;\r\n  /* background-color: rgb(255 255 255 / 0.04); */\r\n}\r\n\r\n.dark .side-nav>ul ul {\r\n  background-color: transparent;\r\n}\r\n\r\n.side-nav>ul ul:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  z-index: -1;\r\n  display: block;\r\n  border-radius: 0.75rem;\r\n  background-color: rgb(255 255 255 / 0.3);\r\n}\r\n\r\n.dark .side-nav>ul ul:before {\r\n  background-color: rgb(var(--color-darkmode-900) / 0.3);\r\n}\r\n\r\n.side-nav>ul ul.side-menu__sub-open {\r\n  display: block;\r\n}\r\n\r\n.side-nav>ul ul .side-menu__icon:before {\r\n  display: none;\r\n}\r\n\r\n.side-nav>ul ul li a:not(.side-menu--active) {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .side-nav>ul ul li a:not(.side-menu--active) {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.side-nav>ul ul li a.side-menu--active .side-menu__icon {\r\n  --tw-text-opacity: 1;\r\n  /* color: rgb(var(--color-slate-700) / var(--tw-text-opacity)); */\r\n}\r\n\r\n.dark .side-nav>ul ul li a.side-menu--active .side-menu__icon {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.side-nav>ul ul li a.side-menu--active .side-menu__title {\r\n  font-weight: 500;\r\n  --tw-text-opacity: 1;\r\n  /* color: rgb(var(--color-slate-700) / var(--tw-text-opacity)); */\r\n}\r\n\r\n.dark .side-nav>ul ul li a.side-menu--active .side-menu__title {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.side-nav>ul ul ul {\r\n  position: relative;\r\n  display: none;\r\n  border-radius: 0.75rem;\r\n  background-color: rgb(255 255 255 / 0.04);\r\n}\r\n\r\n.dark .side-nav>ul ul ul {\r\n  background-color: transparent;\r\n}\r\n\r\n.side-nav>ul ul ul:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  z-index: -1;\r\n  display: block;\r\n  border-radius: 0.75rem;\r\n  background-color: rgb(255 255 255 / 0.3);\r\n}\r\n\r\n.dark .side-nav>ul ul ul:before {\r\n  background-color: rgb(var(--color-darkmode-900) / 0.3);\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.side-menu.sideActive {\r\n  background: #676767;\r\n  color: #fff;\r\n}\r\n\r\n\r\n.dark .side-nav>ul>li>.side-menu.side-menu--active {\r\n  background-color: transparent;\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  display: block;\r\n  border-radius: 0.75rem;\r\n  border-bottom-width: 3px;\r\n  border-style: solid;\r\n  border-color: rgb(0 0 0 / 0.08);\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu.side-menu--active:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active::after {\r\n  content: \"\";\r\n  width: 20px;\r\n  height: 80px;\r\n  margin-right: -47px;\r\n  -webkit-animation: 0.3s active-side-menu-chevron-animation ease-in-out 0.33333s;\r\n  animation: 0.3s active-side-menu-chevron-animation ease-in-out 0.33333s;\r\n  -webkit-animation-fill-mode: forwards;\r\n  animation-fill-mode: forwards;\r\n  -webkit-animation-delay: 1s;\r\n  animation-delay: 1s;\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='80' viewBox='0 0 20 122.1'%3E%3Cpath data-name='Union 1' d='M16.038 122H16v-2.213a95.805 95.805 0 00-2.886-20.735 94.894 94.894 0 00-7.783-20.434A39.039 39.039 0 010 61.051a39.035 39.035 0 015.331-17.567 94.9 94.9 0 007.783-20.435A95.746 95.746 0 0016 2.314V0h4v122h-3.961v.1l-.001-.1z' fill='%23f1f5f8'/%3E%3C/svg%3E\");\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  right: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  background-size: cover;\r\n  background-repeat: no-repeat;\r\n  opacity: 0;\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active .side-menu__icon {\r\n  z-index: 10;\r\n  --tw-text-opacity: 1;\r\n  /* color: rgb(var(--color-primary) / var(--tw-text-opacity)); */\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu.side-menu--active .side-menu__icon {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.side-nav>ul>li>.side-menu.side-menu--active .side-menu__title {\r\n  z-index: 10;\r\n  font-weight: 500;\r\n  --tw-text-opacity: 1;\r\n  /* color: rgb(var(--color-primary) / var(--tw-text-opacity)); */\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu.side-menu--active .side-menu__title {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu .side-menu__icon {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu .side-menu__title {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open) {\r\n  --tw-bg-opacity: 1;\r\n  /* background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity)); */\r\n  background-color: #ffffff;\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open) {\r\n  background-color: transparent;\r\n}\r\n\r\n.side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open):before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  z-index: -1;\r\n  display: block;\r\n  border-radius: 0.75rem;\r\n  border-bottom-width: 3px;\r\n  border-style: solid;\r\n  border-color: rgb(0 0 0 / 0.08);\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu:hover:not(.side-menu--active):not(.side-menu--open):before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n@-webkit-keyframes intro-devider-animation {\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes intro-devider-animation {\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes intro-menu-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@keyframes intro-menu-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes intro-submenu-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@keyframes intro-submenu-animation {\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n@-webkit-keyframes intro-active-menu-animation {\r\n  100% {\r\n    z-index: 10;\r\n  }\r\n}\r\n\r\n@keyframes intro-active-menu-animation {\r\n  100% {\r\n    z-index: 10;\r\n  }\r\n}\r\n\r\n@-webkit-keyframes active-side-menu-chevron-animation {\r\n  100% {\r\n    margin-right: -27px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes active-side-menu-chevron-animation {\r\n  100% {\r\n    margin-right: -27px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.dark .side-nav>ul>li>.side-menu.side-menu--active:after {\r\n  background-image: url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='80' viewBox='0 0 20 122.1'%3E%3Cpath data-name='Union 1' d='M16.038 122H16v-2.213a95.805 95.805 0 00-2.886-20.735 94.894 94.894 0 00-7.783-20.434A39.039 39.039 0 010 61.051a39.035 39.035 0 015.331-17.567 94.9 94.9 0 007.783-20.435A95.746 95.746 0 0016 2.314V0h4v122h-3.961v.1l-.001-.1z' fill='%23232e45'/%3E%3C/svg%3E\");\r\n}\r\n\r\n.breadcrumb.breadcrumb-light {\r\n  margin-left: 2rem;\r\n  height: 100%;\r\n  border-left-width: 1px;\r\n  border-color: rgb(255 255 255 / 0.08);\r\n  padding-left: 1.5rem;\r\n}\r\n\r\n.breadcrumb.breadcrumb-light .active {\r\n  color: rgb(255 255 255 / 0.7) !important;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .breadcrumb.breadcrumb-light {\r\n    margin-left: 0px;\r\n    border-left-width: 0px;\r\n    padding-left: 0px;\r\n  }\r\n}\r\n\r\n.toastify {\r\n  background: none;\r\n  padding: 0px;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .toastify {\r\n    max-width: calc(100% - 30px);\r\n  }\r\n}\r\n\r\n.toastify .toast-close {\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  right: 0px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-right: 0.75rem;\r\n  color: transparent;\r\n  opacity: 1;\r\n}\r\n\r\n.toastify .toast-close:before {\r\n  content: \"×\";\r\n  margin-top: -0.375rem;\r\n  display: block;\r\n  font-size: 1.875rem;\r\n  line-height: 2.25rem;\r\n  font-weight: 300;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.toastify-content {\r\n  border-radius: 0.5rem;\r\n  border-width: 1px;\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n  padding-top: 1.25rem;\r\n  padding-bottom: 1.25rem;\r\n  padding-left: 1.25rem;\r\n  padding-right: 3.5rem;\r\n  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.dark .toastify-content {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.lucide {\r\n  stroke-width: 1.5;\r\n}\r\n\r\n.top-bar-boxed.top-bar-boxed--simple-menu .logo {\r\n  width: auto;\r\n}\r\n\r\n.top-bar-boxed.top-bar-boxed--simple-menu .logo .logo__text {\r\n  display: none;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .dark .top-bar-boxed.top-bar-boxed--top-menu {\r\n    --tw-gradient-from: rgb(var(--color-darkmode-800));\r\n    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-800) / 0));\r\n  }\r\n}\r\n\r\n.top-bar-boxed.top-bar-boxed--top-menu .logo {\r\n  width: auto;\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .top-bar-boxed.top-bar-boxed--top-menu .breadcrumb {\r\n    margin-left: 2.5rem;\r\n    padding-left: 2.5rem;\r\n  }\r\n}\r\n\r\n.top-bar-boxed:not(.top-bar-boxed--top-menu) .logo__text {\r\n  display: none;\r\n}\r\n\r\n@media (min-width: 1280px) {\r\n  .top-bar-boxed:not(.top-bar-boxed--top-menu) .logo__text {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.top-bar-boxed:before {\r\n  content: \"\";\r\n  position: absolute;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  top: 0px;\r\n  margin-left: 1.75rem;\r\n  margin-right: 1.75rem;\r\n  margin-top: 0.75rem;\r\n  display: none;\r\n  height: 65px;\r\n  border-radius: 0.75rem;\r\n  background-color: rgb(var(--color-primary) / 0.3);\r\n}\r\n\r\n.dark .top-bar-boxed:before {\r\n  background-color: rgb(var(--color-darkmode-600) / 0.3);\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .top-bar-boxed:before {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.top-bar-boxed:after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n  margin-left: 0.75rem;\r\n  margin-right: 0.75rem;\r\n  margin-top: 1.25rem;\r\n  display: none;\r\n  height: 65px;\r\n  border-radius: 0.75rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.dark .top-bar-boxed:after {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .top-bar-boxed:after {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.mobile-menu {\r\n  position: fixed;\r\n  z-index: 60;\r\n  margin-left: -2rem;\r\n  margin-right: -2rem;\r\n  margin-top: -1.25rem;\r\n  margin-bottom: 1.5rem;\r\n  width: 100%;\r\n  border-bottom-width: 1px;\r\n  border-color: rgb(255 255 255 / 0.08);\r\n  background-color: rgb(var(--color-primary) / 0.9);\r\n}\r\n\r\n.mobile-menu:before {\r\n  content: \"\";\r\n  visibility: hidden;\r\n  position: fixed;\r\n  left: 0px;\r\n  right: 0px;\r\n  z-index: 10;\r\n  height: 100dvh;\r\n  width: 100%;\r\n  background-color: rgb(0 0 0 / 0.9);\r\n  opacity: 0;\r\n  transition-property: opacity;\r\n  transition-duration: 200ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.mobile-menu.mobile-menu--active:before {\r\n  content: \"\";\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.mobile-menu.mobile-menu--active .scrollable {\r\n  margin-left: 0px;\r\n}\r\n\r\n.mobile-menu.mobile-menu--active .scrollable .mobile-menu-toggler {\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .mobile-menu {\r\n    margin-left: -0.75rem;\r\n    margin-right: -0.75rem;\r\n  }\r\n}\r\n\r\n.mobile-menu .mobile-menu-bar {\r\n  height: 52px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 2rem;\r\n  padding-right: 2rem;\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .mobile-menu .mobile-menu-bar {\r\n    padding-left: 0.75rem;\r\n    padding-right: 0.75rem;\r\n  }\r\n}\r\n\r\n.mobile-menu .scrollable {\r\n  position: fixed;\r\n  top: 0px;\r\n  left: 0px;\r\n  z-index: 20;\r\n  margin-left: -100%;\r\n  height: 100dvh;\r\n  width: 270px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  transition-property: all;\r\n  transition-duration: 300ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.mobile-menu .scrollable .mobile-menu-toggler {\r\n  visibility: hidden;\r\n  position: fixed;\r\n  top: 0px;\r\n  right: 0px;\r\n  margin-top: 1rem;\r\n  margin-right: 1rem;\r\n  opacity: 0;\r\n  transition-property: opacity;\r\n  transition-duration: 200ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.mobile-menu .scrollable .simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n  background-color: rgb(0 0 0 / 0.5);\r\n}\r\n\r\n.mobile-menu ul.menu__sub-open {\r\n  display: block;\r\n}\r\n\r\n.mobile-menu ul li {\r\n  cursor: pointer;\r\n  max-width: 1280px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  /* width: 100%; */\r\n}\r\n\r\n.mobile-menu ul li ul {\r\n  margin-left: 1rem;\r\n  margin-right: 1rem;\r\n  margin-top: 0.25rem;\r\n  margin-bottom: 0.25rem;\r\n  /* display: none; */\r\n  border-radius: 0.5rem;\r\n  background-color: rgb(0 0 0 / 0.1);\r\n}\r\n\r\n.dark .mobile-menu ul li ul {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n.mobile-menu ul li ul .menu {\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n}\r\n\r\n.mobile-menu ul li ul ul {\r\n  margin-left: 0px;\r\n  margin-right: 0px;\r\n  display: none;\r\n  border-radius: 0.5rem;\r\n  background-color: rgb(0 0 0 / 0.1);\r\n}\r\n\r\n.dark .mobile-menu ul li ul ul {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.mobile-menu .menu__devider {\r\n  position: relative;\r\n  height: 1px;\r\n  width: 100%;\r\n  background-color: rgb(255 255 255 / 0.08);\r\n}\r\n\r\n.mobile-menu .menu {\r\n  height: 50px;\r\n  display: flex;\r\n  align-items: center;\r\n  padding-left: 1.5rem;\r\n  padding-right: 1.5rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.mobile-menu .menu .menu__title {\r\n  margin-left: 0.75rem;\r\n  display: flex;\r\n  width: 100%;\r\n  align-items: center;\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon {\r\n  margin-left: auto;\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 100ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);\r\n}\r\n\r\n.mobile-menu .menu .menu__title .menu__sub-icon svg {\r\n  height: 1.25rem;\r\n  width: 1.25rem;\r\n}\r\n\r\n.inbox-filter .inbox-filter__dropdown-menu {\r\n  width: 250px;\r\n}\r\n\r\n.inbox-filter__dropdown-menu .dropdown-content {\r\n  margin-left: -228px;\r\n  width: auto;\r\n}\r\n\r\n.inbox .inbox__item {\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  cursor: pointer;\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-duration: 200ms;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.inbox .inbox__item:hover {\r\n  transform: scale(1.02, 1.02);\r\n  position: relative;\r\n  z-index: 20;\r\n  border-radius: 0.25rem;\r\n  border-width: 0px;\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.inbox .inbox__item.inbox__item--active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .inbox .inbox__item.inbox__item--active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.inbox .inbox__item.inbox__item--active .inbox__item--sender {\r\n  font-weight: 500;\r\n}\r\n\r\n.inbox .inbox__item.inbox__item--active .inbox__item--highlight {\r\n  font-weight: 500;\r\n}\r\n\r\n.inbox .inbox__item.inbox__item--active .inbox__item--time {\r\n  font-weight: 500;\r\n}\r\n\r\n.inbox .form-check-input {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.inbox .form-check-input:checked {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.chat .chat__chat-list {\r\n  height: 525px;\r\n}\r\n\r\n.chat .chat__user-list {\r\n  height: 525px;\r\n}\r\n\r\n.chat .chat__box {\r\n  height: 782px;\r\n}\r\n\r\n.chat .chat__box .chat__box__text-box {\r\n  max-width: 49%;\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .chat .chat__box .chat__box__text-box {\r\n    max-width: 90%;\r\n  }\r\n}\r\n\r\n.chat .chat__box__input {\r\n  height: 46px;\r\n}\r\n\r\n.chat-dropdown {\r\n  margin-top: -364px;\r\n  width: 320px;\r\n}\r\n\r\n.chat-dropdown .chat-dropdown__box {\r\n  height: 364px;\r\n}\r\n\r\n.chat-dropdown .chat-dropdown__box .chat-dropdown__box__tabs .nav-item .nav-link.active {\r\n  border-bottom-width: 0px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .chat-dropdown .chat-dropdown__box .chat-dropdown__box__tabs .nav-item .nav-link.active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.news .news__preview {\r\n  height: 400px;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .news .news__preview {\r\n    height: 250px;\r\n  }\r\n}\r\n\r\n.news p {\r\n  text-indent: 30px;\r\n}\r\n\r\n.news .news__input {\r\n  height: 69px;\r\n}\r\n\r\n.pricing-tabs.nav.nav-pills .nav-item .nav-link {\r\n  border-radius: 0px;\r\n}\r\n\r\n.error-page img {\r\n  width: 450px;\r\n}\r\n\r\n.search-result {\r\n  width: 250px;\r\n  visibility: hidden;\r\n  position: absolute;\r\n  right: 0px;\r\n  z-index: 20;\r\n  margin-top: 0.25rem;\r\n  opacity: 0;\r\n  transition: visibility 0s linear 0.2s, opacity 0.2s 0s;\r\n}\r\n\r\n.search-result.show {\r\n  transition: visibility 0s linear 0s, opacity 0.2s 0s;\r\n  visibility: visible;\r\n  opacity: 1;\r\n}\r\n\r\n.search-result.show>.search-result__content {\r\n  margin-top: -1px;\r\n}\r\n\r\n.search-result.show>.search-result__content .tab-content .tab-pane {\r\n  visibility: visible;\r\n}\r\n\r\n.search-result .search-result__content {\r\n  transition: margin-top 0.2s;\r\n  box-shadow: 0px 3px 20px #0000000b;\r\n  position: relative;\r\n  border-radius: 0.375rem;\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .search-result .search-result__content {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.search-result .search-result__content {\r\n  margin-top: 1.25rem;\r\n  padding: 1.25rem;\r\n}\r\n\r\n.search-result .search-result__content .search-result__content__title {\r\n  margin-bottom: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.notification-content {\r\n  width: 350px;\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .notification-content {\r\n    width: 280px;\r\n  }\r\n}\r\n\r\n.notification-content .notification-content__title {\r\n  margin-bottom: 1.25rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.notification-content .notification-content__box {\r\n  padding: 1.25rem;\r\n}\r\n\r\n.report-maps {\r\n  height: 310px;\r\n}\r\n\r\n.pos-dropdown .pos-dropdown__dropdown-menu {\r\n  width: 265px;\r\n}\r\n\r\n.post .post__tabs {\r\n  border-color: transparent;\r\n}\r\n\r\n.dark .post .post__tabs {\r\n  border-color: transparent;\r\n}\r\n\r\n.post .post__tabs .nav-item .nav-link {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.post .post__tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {\r\n  border-color: transparent;\r\n  background-color: transparent;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-600) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .post .post__tabs .nav-item .nav-link:hover:not(.disabled):not(.active):hover {\r\n  background-color: transparent;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.post .post__tabs .nav-item .nav-link.active {\r\n  border-color: transparent;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .post .post__tabs .nav-item .nav-link.active {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.litepicker {\r\n  border-radius: 0.375rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  z-index: 999999 !important;\r\n  margin-top: 7px;\r\n  box-shadow: 0px 3px 20px #00000014;\r\n}\r\n\r\n@media (max-width: calc(1024px - 1px)) {\r\n  .litepicker {\r\n    width: 310px;\r\n  }\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .litepicker {\r\n    left: 0px !important;\r\n    right: 0px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n}\r\n\r\n.litepicker:before {\r\n  content: \"\";\r\n  left: 9px;\r\n  top: -7px;\r\n  border-bottom-color: #f7f7f7;\r\n  border-right: 7px solid transparent;\r\n  border-left: 7px solid transparent;\r\n  border-bottom: 7px solid #e8e8e8;\r\n  position: absolute;\r\n  display: inline-block;\r\n}\r\n\r\n.litepicker:after {\r\n  content: \"\";\r\n  left: 10px;\r\n  top: -6px;\r\n  border-right: 6px solid transparent;\r\n  border-bottom: 6px solid #fff;\r\n  border-left: 6px solid transparent;\r\n  position: absolute;\r\n  display: inline-block;\r\n}\r\n\r\n.litepicker .container__months,\r\n.litepicker .container__footer {\r\n  background-color: transparent;\r\n  padding-top: 0px;\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.litepicker .container__footer {\r\n  margin: 0px;\r\n  border-top-width: 1px;\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n  padding: 0.75rem;\r\n}\r\n\r\n@media (max-width: calc(1024px - 1px)) {\r\n  .litepicker .container__footer {\r\n    display: flex;\r\n    flex-direction: column-reverse;\r\n    text-align: center;\r\n  }\r\n\r\n  .litepicker .container__footer .preview-date-range {\r\n    order: 1;\r\n    margin-bottom: 0.375rem;\r\n    display: block;\r\n    width: 100%;\r\n  }\r\n\r\n  .litepicker .container__footer .button-cancel {\r\n    width: 100% !important;\r\n    margin-left: 0px !important;\r\n    padding-top: 0.375rem !important;\r\n    padding-bottom: 0.375rem !important;\r\n  }\r\n\r\n  .litepicker .container__footer .button-apply {\r\n    width: 100% !important;\r\n    margin-left: 0px !important;\r\n    padding-top: 0.375rem !important;\r\n    padding-bottom: 0.375rem !important;\r\n    margin-bottom: 0.375rem;\r\n  }\r\n}\r\n\r\n.litepicker .container__footer .button-apply,\r\n.litepicker .container__footer .button-cancel {\r\n  margin-left: 0.25rem;\r\n  margin-right: 0px;\r\n  width: 5rem;\r\n  border-radius: 0.375rem;\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.litepicker .container__footer .button-apply {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.litepicker .container__footer .button-cancel {\r\n  background-color: rgb(var(--color-slate-200) / 0.7);\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.litepicker .container__months {\r\n  padding-left: 0.25rem;\r\n  padding-right: 0.25rem;\r\n}\r\n\r\n.litepicker .container__months .month-item-weekdays-row {\r\n  margin-top: 0.75rem;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.litepicker .container__months .month-item-header {\r\n  padding-left: 0px;\r\n  padding-right: 0px;\r\n  padding-bottom: 0px;\r\n  padding-top: 0.5rem;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-previous-month {\r\n  display: flex;\r\n  height: 2rem;\r\n  width: 2rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-previous-month:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-previous-month svg {\r\n  transform: rotate(135deg);\r\n  margin-right: -0.25rem;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-next-month {\r\n  display: flex;\r\n  height: 2rem;\r\n  width: 2rem;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-next-month:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-next-month svg {\r\n  transform: rotate(-45deg);\r\n  margin-left: -0.25rem;\r\n}\r\n\r\n.litepicker .container__months .month-item-header .button-previous-month:hover svg,\r\n.litepicker .container__months .month-item-header .button-previous-month svg,\r\n.litepicker .container__months .month-item-header .button-next-month:hover svg,\r\n.litepicker .container__months .month-item-header .button-next-month svg {\r\n  fill: transparent;\r\n  border: solid black;\r\n  border-width: 0 2px 2px 0;\r\n  border-radius: 0;\r\n  display: inline-block;\r\n  border-color: #4a5568;\r\n  display: block;\r\n  height: 0.5rem;\r\n  width: 0.5rem;\r\n}\r\n\r\n.litepicker .container__months .month-item-header div>.month-item-name,\r\n.litepicker .container__months .month-item-header div>.month-item-year {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgb(74, 85, 104)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='lucide lucide-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\r\n  background-size: 15px;\r\n  background-position: center right 0.6rem;\r\n  border-radius: 0.375rem;\r\n  border-width: 1px;\r\n  background-color: transparent;\r\n  background-repeat: no-repeat;\r\n  padding-top: 0.25rem !important;\r\n  padding-bottom: 0.25rem !important;\r\n  padding-left: 0.5rem !important;\r\n  padding-right: 2rem !important;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n}\r\n\r\n.litepicker .container__months .month-item-header div>.month-item-name:focus,\r\n.litepicker .container__months .month-item-header div>.month-item-year:focus {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n  --tw-ring-color: transparent;\r\n}\r\n\r\n.litepicker .container__days .day-item {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n}\r\n\r\n.litepicker .container__days .day-item:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.litepicker .container__days .day-item.is-today,\r\n.litepicker .container__days .day-item.is-today:hover {\r\n  font-weight: 500;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-primary) / var(--tw-text-opacity));\r\n}\r\n\r\n.litepicker .container__days .day-item.is-start-date,\r\n.litepicker .container__days .day-item.is-start-date:hover,\r\n.litepicker .container__days .day-item.is-end-date,\r\n.litepicker .container__days .day-item.is-end-date:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.litepicker .container__days .day-item.is-in-range,\r\n.litepicker .container__days .day-item.is-in-range:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.litepicker .container__days .week-number {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n@media (max-width: calc(1024px - 1px)) {\r\n  & :root {\r\n    --litepicker-day-width: 35px;\r\n  }\r\n}\r\n\r\n.dark .litepicker {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .litepicker:before,\r\n.dark .litepicker:after {\r\n  border-right-color: transparent;\r\n  border-left-color: transparent;\r\n  border-bottom-color: rgb(var(--color-darkmode-600));\r\n}\r\n\r\n.dark .litepicker .container__months .button-previous-month:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .litepicker .container__months .button-next-month:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .litepicker .container__months .month-item-header .button-previous-month:hover svg,\r\n.dark .litepicker .container__months .month-item-header .button-previous-month svg,\r\n.dark .litepicker .container__months .month-item-header .button-next-month:hover svg,\r\n.dark .litepicker .container__months .month-item-header .button-next-month svg {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .litepicker .container__months .month-item-header div>.month-item-name,\r\n.dark .litepicker .container__months .month-item-header div>.month-item-year {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .litepicker .container__days .day-item {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .litepicker .container__days .day-item:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .litepicker .container__days .day-item.is-start-date,\r\n.dark .litepicker .container__days .day-item.is-start-date:hover,\r\n.dark .litepicker .container__days .day-item.is-end-date,\r\n.dark .litepicker .container__days .day-item.is-end-date:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .litepicker .container__days .day-item.is-in-range,\r\n.dark .litepicker .container__days .day-item.is-in-range:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .litepicker .container__days .day-item.is-today,\r\n.dark .litepicker .container__days .day-item.is-today:hover {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .litepicker .container__footer {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .litepicker .container__footer .button-cancel {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .litepicker .container__tooltip {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .litepicker .container__tooltip:before,\r\n.dark .litepicker .container__tooltip:after {\r\n  border-top-color: rgb(var(--color-darkmode-600));\r\n}\r\n\r\n.tns-outer {\r\n  position: relative;\r\n}\r\n\r\n.tns-outer .tns-controls button {\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  z-index: 10;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  height: 1.25rem;\r\n  width: 1.25rem;\r\n  border-radius: 9999px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  color: transparent;\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.dark .tns-outer .tns-controls button {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tns-outer .tns-controls button:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tns-outer .tns-controls button:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tns-outer .tns-controls button[data-controls=\"prev\"] {\r\n  left: 0px;\r\n  margin-left: -1.5rem;\r\n}\r\n\r\n.tns-outer .tns-controls button[data-controls=\"prev\"]:before {\r\n  content: \"\";\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgb(102 113 132)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='lucide lucide-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\r\n  background-size: 80%;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  --tw-rotate: 90deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  background-position: center;\r\n}\r\n\r\n.tns-outer .tns-controls button[data-controls=\"next\"] {\r\n  right: 0px;\r\n  margin-right: -1.5rem;\r\n}\r\n\r\n.tns-outer .tns-controls button[data-controls=\"next\"]:before {\r\n  content: \"\";\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgb(102 113 132)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='lucide lucide-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\r\n  background-size: 80%;\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 100%;\r\n  width: 100%;\r\n  --tw-rotate: -90deg;\r\n  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));\r\n  background-position: center;\r\n}\r\n\r\n.tns-outer .tns-nav {\r\n  margin-bottom: -1.8rem;\r\n  position: absolute;\r\n  bottom: 0px;\r\n  z-index: 10;\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n}\r\n\r\n.tns-outer .tns-nav button {\r\n  margin-left: 0.25rem;\r\n  margin-right: 0.25rem;\r\n  height: 0.75rem;\r\n  width: 0.75rem;\r\n  border-radius: 9999px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.dark .tns-outer .tns-nav button {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tns-outer .tns-nav button.tns-nav-active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-500) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tns-outer .tns-nav button.tns-nav-active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tns-outer button[data-action] {\r\n  display: none;\r\n}\r\n\r\n.tns-outer .tns-visually-hidden {\r\n  display: none;\r\n}\r\n\r\n.tooltip-content {\r\n  left: 10000px;\r\n  position: fixed;\r\n}\r\n\r\n.tippy-box {\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.dark .tippy-box {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tippy-box>.tippy-svg-arrow {\r\n  fill: rgb(var(--color-darkmode-300));\r\n}\r\n\r\n.tippy-box .tippy-content {\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n  padding-top: 0.375rem;\r\n  padding-bottom: 0.375rem;\r\n}\r\n\r\n.tippy-popper[x-placement=\"left\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"left\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"right\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"right\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"left-start\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"left-start\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"left-end\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"left-end\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"right-start\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"right-start\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"right-end\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"right-end\"] .tippy-arrow {\r\n  top: 0px;\r\n  bottom: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n\r\n.tippy-popper[x-placement=\"top\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"top\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"bottom\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"bottom\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"top-start\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"top-start\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"top-end\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"top-end\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"bottom-start\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"bottom-start\"] .tippy-arrow,\r\n.tippy-popper[x-placement=\"bottom-end\"] .tippy-roundarrow,\r\n.tippy-popper[x-placement=\"bottom-end\"] .tippy-arrow {\r\n  left: 0px;\r\n  right: 0px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.dark .tippy-box {\r\n  box-shadow: 0 0 20px 4px #00000026, 0 4px 80px -8px #24282f40,\r\n    0 4px 4px -2px #5b5e6926;\r\n}\r\n\r\n.tabulator-print-fullscreen-hide:before {\r\n  content: \"\";\r\n  position: fixed;\r\n  top: 0px;\r\n  left: 0px;\r\n  height: 100dvh;\r\n  width: 100%;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.tabulator {\r\n  overflow: hidden;\r\n  border-width: 0px;\r\n  background-color: transparent;\r\n}\r\n\r\n.tabulator .tabulator-header {\r\n  border-top: 1px solid #e7eaf3;\r\n  border-bottom: 1px solid #e7eaf3;\r\n  background-color: transparent;\r\n  font-weight: 500;\r\n  color: currentColor;\r\n  outline: none;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-headers .tabulator-col {\r\n  background-color: transparent;\r\n  border-right: 1px solid #e7eaf3;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-headers .tabulator-col:first-child {\r\n  border-left: 1px solid #e7eaf3;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-headers .tabulator-col:hover {\r\n  /* --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity)); */\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-headers .tabulator-col .tabulator-col-content {\r\n  /* padding-left: 0.5rem; */\r\n  /* padding-right: 0.5rem; */\r\n  /* padding-top: 0.75rem; */\r\n  /* padding-bottom: 0.75rem; */\r\n  padding: 0.5rem;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-headers .tabulator-col .tabulator-col-content .tabulator-col-title {\r\n  padding-right: 0px;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-headers .tabulator-col .tabulator-col-content .tabulator-arrow {\r\n  top: -3px;\r\n  border-left-width: 5px;\r\n  border-right-width: 5px;\r\n  bottom: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n}\r\n\r\n.tabulator .tabulator-header .tabulator-headers .tabulator-col.tabulator-sortable[aria-sort=\"none\"] .tabulator-col-content .tabulator-arrow {\r\n  border-bottom-color: #cbd5e0;\r\n}\r\n\r\n.tabulator .tabulator-row {\r\n  border-bottom: 1px solid #e7eaf3;\r\n}\r\n\r\n.tabulator .tabulator-row:hover,\r\n.tabulator .tabulator-row.tabulator-row-even:hover {\r\n  background-color: #fafafa;\r\n}\r\n\r\n.tabulator .tabulator-row.tabulator-row-even {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tabulator .tabulator-row .tabulator-cell {\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  /* padding-left: 1.25rem;\r\n  padding-right: 1.25rem; */\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  border-right: 1px solid #e7eaf3;\r\n}\r\n\r\n.tabulator .tabulator-row .tabulator-cell:first-child {\r\n  border-left: 1px solid #e7eaf3;\r\n}\r\n\r\n.tabulator .tabulator-row.clickData .tabulator-cell:last-child {\r\n  border-right: none;\r\n}\r\n\r\n.tabulator .tabulator-row .tabulator-cell.tabulator-row-handle {\r\n  padding-left: 0px;\r\n  /*padding-right: 0px;*/\r\n}\r\n\r\n.tabulator .tabulator-row .tabulator-cell .tabulator-responsive-collapse-toggle {\r\n  margin-right: -1.25rem;\r\n  height: 1rem;\r\n  width: 1rem;\r\n  border-radius: 9999px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tabulator .tabulator-row .tabulator-responsive-collapse {\r\n  border-bottom-width: 0px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  padding: 0.75rem;\r\n}\r\n\r\n.tabulator .tabulator-row .tabulator-responsive-collapse td {\r\n  padding: 0.5rem;\r\n}\r\n\r\n.tabulator .tabulator-row .tabulator-responsive-collapse td strong {\r\n  font-weight: 500;\r\n}\r\n\r\n.tabulator .tabulator-footer {\r\n  margin-top: 0.5rem;\r\n  border-top-width: 0px;\r\n  background-color: transparent;\r\n  padding: 0px;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .tabulator .tabulator-footer {\r\n    white-space: normal;\r\n  }\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator {\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .tabulator .tabulator-footer .tabulator-paginator {\r\n    display: block;\r\n    text-align: left;\r\n  }\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator>label {\r\n  font-weight: 400;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page-size {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgb(74, 85, 104)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='lucide lucide-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\r\n  background-size: 15px;\r\n  background-position: center right 0.6rem;\r\n  margin-left: 0.5rem;\r\n  margin-right: auto;\r\n  -webkit-appearance: none;\r\n  -moz-appearance: none;\r\n  appearance: none;\r\n  border-radius: 0.375rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n  background-repeat: no-repeat;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n  padding-right: 2rem;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .tabulator .tabulator-footer .tabulator-paginator .tabulator-page-size {\r\n    margin-right: 0.75rem;\r\n  }\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page {\r\n  min-width: 37px;\r\n  display: inline-flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0.375rem;\r\n  border-width: 1px;\r\n  padding-top: 0.2rem;\r\n  padding-bottom: 0.2rem;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  font-weight: 500;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 200ms;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:focus {\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n}\r\n\r\n.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page {\r\n  transition-property: none;\r\n}\r\n\r\n.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.9;\r\n  --tw-bg-opacity: 0.9;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:not(button) {\r\n  text-align: center;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-color: transparent;\r\n  font-weight: 400;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .tabulator .tabulator-footer .tabulator-paginator .tabulator-page {\r\n    margin-right: 0px;\r\n    padding-left: 0.25rem;\r\n    padding-right: 0.25rem;\r\n  }\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  font-weight: 500;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"first\"],\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"prev\"],\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"next\"],\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"last\"] {\r\n  width: 1.25rem;\r\n  color: transparent;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"first\"] {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='%232d3748' stroke-width='1.1' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cpolyline points='11 17 6 12 11 7'%3E%3C/polyline%3E%3Cpolyline points='18 17 13 12 18 7'%3E%3C/polyline%3E%3C/svg%3E\");\r\n  background-size: 50%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"prev\"] {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='%232d3748' stroke-width='1.1' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cpolyline points='15 18 9 12 15 6'%3E%3C/polyline%3E%3C/svg%3E\");\r\n  background-size: 45%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"next\"] {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='%232d3748' stroke-width='1.1' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cpolyline points='9 18 15 12 9 6'%3E%3C/polyline%3E%3C/svg%3E\");\r\n  background-size: 45%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.tabulator .tabulator-footer .tabulator-paginator .tabulator-page[data-page=\"last\"] {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='24' height='24' stroke='%232d3748' stroke-width='1.1' fill='none' stroke-linecap='round' stroke-linejoin='round' class='css-i6dzq1'%3E%3Cpolyline points='13 17 18 12 13 7'%3E%3C/polyline%3E%3Cpolyline points='6 17 11 12 6 7'%3E%3C/polyline%3E%3C/svg%3E\");\r\n  background-size: 50%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\n.tabulator .tabulator-tableHolder .tabulator-placeholder span {\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  font-weight: 400;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.tabulator .tabulator-loader {\r\n  background: #ffffffbd;\r\n}\r\n\r\n.tabulator .tabulator-loader .tabulator-loader-msg {\r\n  background-color: transparent;\r\n  font-size: 1rem;\r\n  line-height: 1.5rem;\r\n  font-weight: 400;\r\n}\r\n\r\n.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-loading {\r\n  border-width: 0px;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-700) / var(--tw-text-opacity));\r\n}\r\n\r\n.tabulator .tabulator-loader .tabulator-loader-msg.tabulator-error {\r\n  border-width: 0px;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-danger) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-header {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-header .tabulator-headers .tabulator-col:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-table {\r\n  background-color: transparent;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-table .tabulator-row {\r\n  border-color: transparent;\r\n  background-color: transparent;\r\n}\r\n\r\n.dark .tabulator .tabulator-table .tabulator-row:hover,\r\n.dark .tabulator .tabulator-table .tabulator-row.tabulator-row-even:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-table .tabulator-row.tabulator-row-even {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-footer .tabulator-paginator>label {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page-size {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page {\r\n  background-color: transparent;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active,\r\n.dark .tabulator .tabulator-footer .tabulator-paginator .tabulator-page.active:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tabulator .tabulator-loader {\r\n  background-color: rgb(0 0 0 / 0.3);\r\n}\r\n\r\n.dark .tabulator .tabulator-loader .tabulator-loader-msg.tabulator-loading {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.tom-select .ts-input {\r\n  min-height: 40px;\r\n  padding: 7.5px 32px 7.5px 12px;\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgb(74 85 104)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='lucide lucide-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\r\n  background-size: 18px;\r\n  background-position: center right 0.6rem;\r\n  border-radius: 0.25rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  background-repeat: no-repeat;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.tom-select .ts-input .item {\r\n  line-height: 22px;\r\n}\r\n\r\n.tom-select .ts-input.dropdown-active {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14.828' height='8.414' viewBox='0 0 14.828 8.414'%3E%3Cpath id='chevron' d='M6,9l6,6,6-6' transform='translate(19.414 16) rotate(180)' fill='none' stroke='%234a5568' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3E%3C/svg%3E%0A\") !important;\r\n  background-size: 11px !important;\r\n  background-position: center right 0.8rem !important;\r\n  background-repeat: no-repeat !important;\r\n}\r\n\r\n.tom-select .ts-input input {\r\n  height: 23px;\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n}\r\n\r\n.tom-select.multi .ts-input {\r\n  padding-left: 0.375rem;\r\n  padding-right: 0.375rem;\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n}\r\n\r\n.tom-select.multi .ts-input>div {\r\n  margin-top: 0.125rem;\r\n  margin-bottom: 0.125rem;\r\n  margin-right: 0.25rem;\r\n  border-radius: 0.25rem;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n}\r\n\r\n.tom-select.multi .ts-input>div.active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.tom-select.multi .ts-input>div.active .remove {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.tom-select.plugin-remove_button .item .remove {\r\n  margin-left: 0.5rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-300) / var(--tw-border-opacity));\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n}\r\n\r\n.tom-select.plugin-dropdown_input .ts-input.focus {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.tom-select .ts-dropdown {\r\n  margin-top: -1px;\r\n  border-top: 1px solid rgba(226, 232, 240, var(--tw-border-opacity));\r\n  z-index: 50;\r\n  border-radius: 0.25rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.tom-select .ts-dropdown .optgroup-header {\r\n  padding: 9px 10px;\r\n  font-weight: 500;\r\n}\r\n\r\n.tom-select .ts-dropdown .option {\r\n  padding: 9px 13px;\r\n}\r\n\r\n.tom-select .ts-dropdown .option .highlight {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-danger) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.tom-select .ts-dropdown .option.active {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.tom-select .ts-dropdown .option:hover:not(.active) {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n}\r\n\r\n.tom-select .ts-dropdown.plugin-dropdown_input .dropdown-input-wrap {\r\n  padding: 0.5rem;\r\n}\r\n\r\n.tom-select .ts-dropdown.plugin-dropdown_input .dropdown-input-wrap input {\r\n  border-radius: 0.25rem;\r\n  border-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.tom-select .ts-dropdown .dropdown-header {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n}\r\n\r\n.tom-select .ts-dropdown .dropdown-header .dropdown-header-close {\r\n  margin-right: 0.125rem;\r\n  cursor: pointer;\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n  opacity: 1;\r\n}\r\n\r\n.dark .tom-select .ts-input {\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='rgb(255 255 255)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round' class='lucide lucide-chevron-down'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-input.dropdown-active {\r\n  border-color: transparent;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='14.828' height='8.414' viewBox='0 0 14.828 8.414'%3E%3Cpath id='chevron' d='M6,9l6,6,6-6' transform='translate(19.414 16) rotate(180)' fill='none' stroke='rgb(255 255 255)' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/%3E%3C/svg%3E%0A\") !important;\r\n}\r\n\r\n.dark .tom-select .ts-input.dropdown-active:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tom-select.multi .ts-input>div {\r\n  border-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tom-select.multi .ts-input>div.active {\r\n  background-color: rgb(var(--color-darkmode-400) / 0.8);\r\n}\r\n\r\n.dark .tom-select.multi .ts-input>div .remove {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .tom-select.plugin-dropdown_input .ts-input.focus {\r\n  border-color: transparent;\r\n}\r\n\r\n.dark .tom-select .ts-dropdown {\r\n  border-color: rgb(var(--color-darkmode-800) / 0.8);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-dropdown.plugin-dropdown_input .dropdown-input-wrap input {\r\n  border-color: rgb(var(--color-darkmode-800) / 0.8);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-dropdown .optgroup-header {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-dropdown .create {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-dropdown .create:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-dropdown .option:hover:not(.active) {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-dropdown .dropdown-header {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-700) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .tom-select .ts-dropdown .dropdown-header .dropdown-header-close {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dropzone {\r\n  border-style: dashed;\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n}\r\n\r\n.dark .dropzone {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.ck-editor,\r\n.document-editor,\r\n.ck-editor__editable {\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.document-editor {\r\n  display: flex;\r\n  max-height: 700px;\r\n  flex-flow: column nowrap;\r\n  border-radius: var(--ck-border-radius);\r\n  border-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.document-editor .document-editor__toolbar {\r\n  z-index: 1;\r\n  border-bottom-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.document-editor .document-editor__toolbar .ck-toolbar {\r\n  border: 0;\r\n  border-radius: 0;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.document-editor .document-editor__toolbar .ck-toolbar .ck-icon {\r\n  width: 16px;\r\n}\r\n\r\n.document-editor .document-editor__editable-container {\r\n  overflow-y: scroll;\r\n  padding: calc(2 * var(--ck-spacing-large));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.document-editor .document-editor__editable-container .ck-editor__editable {\r\n  width: 15.8cm;\r\n  margin: 0 auto;\r\n  min-height: 21cm;\r\n  background: white;\r\n  padding: 1cm 2cm 2cm;\r\n  border-radius: var(--ck-border-radius);\r\n  border-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\r\n  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.document-editor .ck-heading-dropdown .ck-list .ck-button__label {\r\n  line-height: calc(1.7 * var(--ck-line-height-base) * var(--ck-font-size-base));\r\n  min-width: 6em;\r\n}\r\n\r\n.document-editor .ck-heading-dropdown .ck-list .ck-button:not(.ck-heading_paragraph) .ck-button__label {\r\n  transform: scale(0.8);\r\n  transform-origin: left;\r\n}\r\n\r\n.document-editor .ck-content h2,\r\n.document-editor .ck-heading-dropdown .ck-heading_heading1 .ck-button__label {\r\n  font-size: 2.18em;\r\n  font-weight: normal;\r\n}\r\n\r\n.document-editor .ck-content h2 {\r\n  line-height: 1.37em;\r\n  padding-top: 0.342em;\r\n  margin-bottom: 0.142em;\r\n}\r\n\r\n.document-editor .ck-content h3,\r\n.document-editor .ck-heading-dropdown .ck-heading_heading2 .ck-button__label {\r\n  font-size: 1.75em;\r\n  font-weight: normal;\r\n  color: hsl(203, 100%, 50%);\r\n}\r\n\r\n.document-editor .ck-heading-dropdown .ck-heading_heading2.ck-on .ck-button__label {\r\n  color: var(--ck-color-list-button-on-text);\r\n}\r\n\r\n.document-editor .ck-content h3 {\r\n  line-height: 1.86em;\r\n  padding-top: 0.171em;\r\n  margin-bottom: 0.357em;\r\n}\r\n\r\n.document-editor .ck-content h4,\r\n.document-editor .ck-heading-dropdown .ck-heading_heading3 .ck-button__label {\r\n  font-size: 1.31em;\r\n  font-weight: bold;\r\n}\r\n\r\n.document-editor .ck-content h4 {\r\n  line-height: 1.24em;\r\n  padding-top: 0.286em;\r\n  margin-bottom: 0.952em;\r\n}\r\n\r\n.document-editor .ck-content p {\r\n  font-size: 1em;\r\n  line-height: 1.63em;\r\n  padding-top: 0.5em;\r\n  margin-bottom: 1.13em;\r\n}\r\n\r\n.document-editor .ck-content blockquote {\r\n  font-family: Georgia, serif;\r\n  margin-left: calc(2 * var(--ck-spacing-large));\r\n  margin-right: calc(2 * var(--ck-spacing-large));\r\n}\r\n\r\n.ck.ck-content {\r\n  min-height: 250px;\r\n}\r\n\r\n.ck.ck-content.ck-editor__editable_inline {\r\n  border-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.ck .ck .ck-content {\r\n  min-height: 250px;\r\n}\r\n\r\n.ck .ck .ck-content.ck-editor__editable_inline {\r\n  border-width: 1px;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.ck .ck.ck-reset_all,\r\n.ck .ck.ck-reset_all * {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-800) / var(--tw-text-opacity));\r\n}\r\n\r\n.ck .ck.ck-toolbar,\r\n.ck .ck.ck-balloon-panel {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.ck .ck.ck-toolbar .ck-icon,\r\n.ck .ck.ck-balloon-panel .ck-icon {\r\n  width: 16px;\r\n}\r\n\r\n.ck .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.ck .ck.ck-button:not(.ck-disabled):hover,\r\n.ck .cka.ck-button:not(.ck-disabled):hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .document-editor {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.3);\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.2);\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar {\r\n  background-color: rgb(var(--color-darkmode-900) / 0.2);\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar .ck-toolbar__separator {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar .ck-tooltip .ck-tooltip__text {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar .ck-tooltip .ck-tooltip__text:after {\r\n  --tw-border-opacity: 1;\r\n  border-bottom-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar .ck.ck-icon :not([fill]) {\r\n  fill: rgb(var(--color-slate-300));\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar .ck.ck-dropdown__panel {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar .ck.ck-button.ck-on,\r\n.dark .document-editor .document-editor__toolbar .ck-toolbar a.ck.ck-button.ck-on {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .document-editor .document-editor__editable-container {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .document-editor .document-editor__editable-container .ck-editor__editable {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.2);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck.ck-content.ck-editor__editable_inline {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.2);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck.ck-list {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck.ck-dropdown__panel {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck.ck.ck-input-text {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck.ck.ck-input-text:focus {\r\n  --tw-shadow: 0 0 #0000;\r\n  --tw-shadow-colored: 0 0 #0000;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n}\r\n\r\n.dark .ck .ck-insert-table-dropdown-grid-box {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .ck.ck-reset_all,\r\n.dark .ck.ck-reset_all * {\r\n  --tw-text-opacity: 1 !important;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity)) !important;\r\n}\r\n\r\n.dark .ck .ck .ck-content.ck-editor__editable_inline {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.2);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar,\r\n.dark .ck .ck.ck-balloon-panel {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.2);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar:before,\r\n.dark .ck .ck.ck-balloon-panel:before {\r\n  border-bottom-color: rgb(var(--color-darkmode-900) / 0.2) !important;\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar:after,\r\n.dark .ck .ck.ck-balloon-panel:after {\r\n  border-bottom-color: rgb(var(--color-darkmode-900) / 0.2) !important;\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar .ck-toolbar__separator,\r\n.dark .ck .ck.ck-balloon-panel .ck-toolbar__separator {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar .ck-tooltip .ck-tooltip__text,\r\n.dark .ck .ck.ck-balloon-panel .ck-tooltip .ck-tooltip__text {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar .ck-tooltip .ck-tooltip__text:after,\r\n.dark .ck .ck.ck-balloon-panel .ck-tooltip .ck-tooltip__text:after {\r\n  border-bottom-color: rgb(var(--color-darkmode-900) / 0.2);\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar .ck.ck-icon :not([fill]),\r\n.dark .ck .ck.ck-balloon-panel .ck.ck-icon :not([fill]) {\r\n  fill: rgb(var(--color-slate-300));\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar .ck.ck-dropdown__panel,\r\n.dark .ck .ck.ck-balloon-panel .ck.ck-dropdown__panel {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .ck .ck.ck-toolbar .ck.ck-button.ck-on,\r\n.dark .ck .ck.ck-toolbar a.ck.ck-button.ck-on,\r\n.dark .ck .ck.ck-balloon-panel .ck.ck-button.ck-on,\r\n.dark .ck .ck.ck-balloon-panel a.ck.ck-button.ck-on {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck .ck.ck-editor__main>.ck-editor__editable {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .ck .ck.ck-editor__main>.ck-editor__editable:not(.ck-focused) {\r\n  border-color: rgb(var(--color-darkmode-900) / 0.2);\r\n}\r\n\r\n.dark .ck .ck.ck-button:not(.ck-disabled):hover,\r\n.dark .ck .cka.ck-button:not(.ck-disabled):hover {\r\n  background-color: rgb(var(--color-darkmode-900) / 0.2);\r\n}\r\n\r\n.zoom-overlay {\r\n  background-color: rgb(0 0 0 / 0.75);\r\n}\r\n\r\n.dark .zoom-overlay {\r\n  background-color: rgb(0 0 0 / 0.4);\r\n}\r\n\r\n.dark-mode-switcher .dark-mode-switcher__toggle {\r\n  width: 38px;\r\n  height: 24px;\r\n  padding: 1px;\r\n  position: relative;\r\n  cursor: pointer;\r\n  border-radius: 9999px;\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.dark-mode-switcher .dark-mode-switcher__toggle:before {\r\n  content: \"\";\r\n  width: 22px;\r\n  height: 22px;\r\n  transition: all 0.2s ease-in-out;\r\n  box-shadow: 1px 1px 3px rgba(0, 0, 0, 0.25);\r\n  position: absolute;\r\n  top: 0px;\r\n  bottom: 0px;\r\n  margin-top: auto;\r\n  margin-bottom: auto;\r\n  border-radius: 9999px;\r\n}\r\n\r\n.dark-mode-switcher .dark-mode-switcher__toggle.dark-mode-switcher__toggle--active {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark-mode-switcher .dark-mode-switcher__toggle.dark-mode-switcher__toggle--active::before {\r\n  margin-left: 13px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(255 255 255 / var(--tw-bg-opacity));\r\n}\r\n\r\n.source-preview {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  padding-top: 0.625rem;\r\n  padding-bottom: 0.625rem;\r\n}\r\n\r\n.source-preview .hljs {\r\n  margin-top: -20px;\r\n  margin-bottom: -40px;\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n  line-height: 1.625;\r\n}\r\n\r\n.dark .source-preview .hljs {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.source-preview {\r\n  position: relative;\r\n}\r\n\r\n.source-preview code:before {\r\n  content: \"HTML\";\r\n  position: absolute;\r\n  top: 0px;\r\n  right: 0px;\r\n  display: block;\r\n  border-bottom-left-radius: 0.25rem;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n  --tw-bg-opacity: 0.7;\r\n  padding-left: 1rem;\r\n  padding-right: 1rem;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  font-family: Roboto;\r\n  font-weight: 500;\r\n}\r\n\r\n.dark .source-preview code:before {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.source-preview code.javascript:before {\r\n  content: \"JS\";\r\n}\r\n\r\n@media (max-width: calc(1024px - 1px)) {\r\n  .full-calendar .fc-toolbar {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(1) {\r\n  order: 3;\r\n}\r\n\r\n.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(2) {\r\n  order: 1;\r\n}\r\n\r\n.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) {\r\n  order: 2;\r\n}\r\n\r\n@media (max-width: calc(1024px - 1px)) {\r\n  .full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) {\r\n    margin-top: 0.75rem;\r\n    margin-bottom: 0.75rem;\r\n  }\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) .fc-button-group {\r\n    display: block;\r\n  }\r\n}\r\n\r\n.full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) .fc-button-group button {\r\n  width: 5rem;\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .full-calendar .fc-toolbar .fc-toolbar-chunk:nth-child(3) .fc-button-group button {\r\n    margin-bottom: 0.5rem;\r\n    width: 100%;\r\n    border-radius: 0.375rem;\r\n  }\r\n}\r\n\r\n.full-calendar .fc-toolbar .fc-toolbar-title {\r\n  font-size: 1.125rem;\r\n  line-height: 1.75rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.full-calendar .fc-toolbar-chunk .fc-button-primary:first-child {\r\n  border-top-left-radius: 0.375rem;\r\n  border-bottom-left-radius: 0.375rem;\r\n}\r\n\r\n.full-calendar .fc-toolbar-chunk .fc-button-primary:last-child {\r\n  border-top-right-radius: 0.375rem;\r\n  border-bottom-right-radius: 0.375rem;\r\n}\r\n\r\n.full-calendar.fc-theme-standard .fc-scrollgrid,\r\n.full-calendar.fc-theme-standard th,\r\n.full-calendar.fc-theme-standard td,\r\n.full-calendar.fc-theme-standard .fc-list {\r\n  border-color: rgb(var(--color-slate-200) / 0.6);\r\n}\r\n\r\n.dark .full-calendar.fc-theme-standard .fc-scrollgrid,\r\n.dark .full-calendar.fc-theme-standard th,\r\n.dark .full-calendar.fc-theme-standard td,\r\n.dark .full-calendar.fc-theme-standard .fc-list {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.full-calendar table {\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.full-calendar table tr th .fc-scrollgrid-sync-inner {\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n.full-calendar .fc-daygrid-event-harness {\r\n  margin-left: 1.25rem;\r\n  margin-right: 1.25rem;\r\n}\r\n\r\n.full-calendar .fc-h-event {\r\n  border-radius: 0.375rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.full-calendar .fc-event-title-container {\r\n  padding-top: 0.25rem;\r\n  padding-bottom: 0.25rem;\r\n  padding-left: 0.5rem;\r\n  padding-right: 0.5rem;\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n}\r\n\r\n.full-calendar .fc-daygrid-event {\r\n  font-size: 0.75rem;\r\n  line-height: 1rem;\r\n}\r\n\r\n.full-calendar .fc-daygrid-event-dot {\r\n  margin-right: 0.5rem;\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.full-calendar .fc-daygrid-dot-event .fc-event-title {\r\n  font-weight: 500;\r\n}\r\n\r\n.full-calendar .fc-col-header-cell-cushion {\r\n  font-weight: 500;\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .full-calendar.fc .fc-view-harness {\r\n    min-height: 400px !important;\r\n  }\r\n\r\n  .full-calendar.fc .fc-daygrid-day-frame {\r\n    min-height: 60px !important;\r\n  }\r\n}\r\n\r\n.full-calendar .fc-daygrid-more-link {\r\n  font-size: 0.875rem;\r\n  line-height: 1.25rem;\r\n}\r\n\r\n@media (max-width: calc(768px - 1px)) {\r\n  .full-calendar .fc-daygrid-more-link {\r\n    font-size: 10px;\r\n    --tw-text-opacity: 1;\r\n    color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n  }\r\n}\r\n\r\n@media (max-width: calc(640px - 1px)) {\r\n  .full-calendar .fc-daygrid-more-link {\r\n    margin-top: -0.75rem;\r\n    display: block;\r\n    padding-left: 0px;\r\n    line-height: 10px;\r\n  }\r\n}\r\n\r\n.full-calendar .fc-daygrid-day-bottom {\r\n  padding-top: 0.25rem;\r\n}\r\n\r\n.full-calendar .fc-day-other {\r\n  background-color: rgb(var(--color-slate-100) / 0.5);\r\n}\r\n\r\n.dark .full-calendar .fc-day-other {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n.full-calendar .fc-button-primary {\r\n  display: inline-block !important;\r\n  border-color: rgb(var(--color-slate-200) / 0.6) !important;\r\n  background-color: transparent !important;\r\n  padding-left: 0.65em !important;\r\n  padding-right: 0.65em !important;\r\n  padding-top: 0.4em !important;\r\n  padding-bottom: 0.4em !important;\r\n  text-transform: capitalize !important;\r\n  --tw-text-opacity: 1 !important;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity)) !important;\r\n  display: inline-flex;\r\n  cursor: pointer;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 0.375rem;\r\n  border-width: 1px;\r\n  padding-top: 0.5rem;\r\n  padding-bottom: 0.5rem;\r\n  padding-left: 0.75rem;\r\n  padding-right: 0.75rem;\r\n  font-weight: 500;\r\n  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);\r\n  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  transition-property: color, background-color, border-color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;\r\n  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-text-decoration-color, -webkit-backdrop-filter;\r\n  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\r\n  transition-duration: 200ms;\r\n}\r\n\r\n.full-calendar .fc-button-primary:focus {\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(4px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n  --tw-ring-color: rgb(var(--color-primary) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.2;\r\n}\r\n\r\n.dark .full-calendar .fc-button-primary {\r\n  transition-property: none;\r\n}\r\n\r\n.dark .full-calendar .fc-button-primary:focus {\r\n  --tw-ring-color: rgb(var(--color-slate-700) / var(--tw-ring-opacity));\r\n  --tw-ring-opacity: 0.5;\r\n}\r\n\r\n.full-calendar .fc-button-primary:hover:not(:disabled) {\r\n  --tw-border-opacity: 0.9;\r\n  --tw-bg-opacity: 0.9;\r\n}\r\n\r\n.full-calendar .fc-button-primary:not(button) {\r\n  text-align: center;\r\n}\r\n\r\n.full-calendar .fc-button-primary:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.7;\r\n}\r\n\r\n.full-calendar .fc-button-primary .fc-icon {\r\n  font-size: 1.2em !important;\r\n}\r\n\r\n.full-calendar .fc-button-primary:focus {\r\n  --tw-shadow: 0 0 #0000 !important;\r\n  --tw-shadow-colored: 0 0 #0000 !important;\r\n  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;\r\n}\r\n\r\n.full-calendar .fc-button-primary:not(:disabled):active,\r\n.full-calendar .fc-button-primary:not(:disabled).fc-button-active {\r\n  --tw-border-opacity: 1 !important;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity)) !important;\r\n  --tw-bg-opacity: 1 !important;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity)) !important;\r\n  --tw-text-opacity: 1 !important;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity)) !important;\r\n}\r\n\r\n.full-calendar .fc-list-day-cushion {\r\n  background-color: rgb(var(--color-slate-100) / 0.5) !important;\r\n  padding-left: 1.25rem !important;\r\n  padding-right: 1.25rem !important;\r\n  padding-top: 0.75rem !important;\r\n  padding-bottom: 0.75rem !important;\r\n}\r\n\r\n.full-calendar .fc-list-event td {\r\n  padding-left: 1.25rem;\r\n  padding-right: 1.25rem;\r\n  padding-top: 0.75rem;\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n.full-calendar .fc-list-event-dot {\r\n  --tw-border-opacity: 1 !important;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity)) !important;\r\n}\r\n\r\n.full-calendar .fc-event-time {\r\n  padding-left: 0.125rem;\r\n  padding-right: 0.125rem;\r\n  font-size: 0.75rem !important;\r\n}\r\n\r\n.full-calendar .fc-daygrid-more-link {\r\n  padding-left: 0.5rem;\r\n}\r\n\r\n.dark .full-calendar .fc-button-primary {\r\n  --tw-border-opacity: 1 !important;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity)) !important;\r\n  --tw-bg-opacity: 1 !important;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity)) !important;\r\n}\r\n\r\n.dark .full-calendar .fc-list-day-cushion {\r\n  --tw-bg-opacity: 1 !important;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity)) !important;\r\n}\r\n\r\n.dark .full-calendar .fc-event:hover td {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.has-error .form-control {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .has-error .form-control {\r\n  border-color: rgb(var(--color-danger) / 0.7);\r\n}\r\n\r\n.before\\:absolute::before {\r\n  content: var(--tw-content);\r\n  position: absolute;\r\n}\r\n\r\n.before\\:inset-0::before {\r\n  content: var(--tw-content);\r\n  top: 0px;\r\n  right: 0px;\r\n  bottom: 0px;\r\n  left: 0px;\r\n}\r\n\r\n.before\\:top-0::before {\r\n  content: var(--tw-content);\r\n  top: 0px;\r\n}\r\n\r\n.before\\:left-0::before {\r\n  content: var(--tw-content);\r\n  left: 0px;\r\n}\r\n\r\n.before\\:bottom-0::before {\r\n  content: var(--tw-content);\r\n  bottom: 0px;\r\n}\r\n\r\n.before\\:z-10::before {\r\n  content: var(--tw-content);\r\n  z-index: 10;\r\n}\r\n\r\n.before\\:z-\\[-1\\]::before {\r\n  content: var(--tw-content);\r\n  z-index: -1;\r\n}\r\n\r\n.before\\:ml-5::before {\r\n  content: var(--tw-content);\r\n  margin-left: 1.25rem;\r\n}\r\n\r\n.before\\:mt-5::before {\r\n  content: var(--tw-content);\r\n  margin-top: 1.25rem;\r\n}\r\n\r\n.before\\:mt-4::before {\r\n  content: var(--tw-content);\r\n  margin-top: 1rem;\r\n}\r\n\r\n.before\\:block::before {\r\n  content: var(--tw-content);\r\n  display: block;\r\n}\r\n\r\n.before\\:hidden::before {\r\n  content: var(--tw-content);\r\n  display: none;\r\n}\r\n\r\n.before\\:h-full::before {\r\n  content: var(--tw-content);\r\n  height: 100%;\r\n}\r\n\r\n.before\\:h-\\[85\\%\\]::before {\r\n  content: var(--tw-content);\r\n  height: 85%;\r\n}\r\n\r\n.before\\:h-px::before {\r\n  content: var(--tw-content);\r\n  height: 1px;\r\n}\r\n\r\n.before\\:h-\\[3px\\]::before {\r\n  content: var(--tw-content);\r\n  height: 3px;\r\n}\r\n\r\n.before\\:w-full::before {\r\n  content: var(--tw-content);\r\n  width: 100%;\r\n}\r\n\r\n.before\\:w-px::before {\r\n  content: var(--tw-content);\r\n  width: 1px;\r\n}\r\n\r\n.before\\:w-20::before {\r\n  content: var(--tw-content);\r\n  width: 5rem;\r\n}\r\n\r\n.before\\:w-\\[69\\%\\]::before {\r\n  content: var(--tw-content);\r\n  width: 69%;\r\n}\r\n\r\n.before\\:rounded-md::before {\r\n  content: var(--tw-content);\r\n  border-radius: 0.375rem;\r\n}\r\n\r\n.before\\:bg-slate-200::before {\r\n  content: var(--tw-content);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-200) / var(--tw-bg-opacity));\r\n}\r\n\r\n.before\\:bg-slate-100::before {\r\n  content: var(--tw-content);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.before\\:bg-black::before {\r\n  content: var(--tw-content);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(0 0 0 / var(--tw-bg-opacity));\r\n}\r\n\r\n.before\\:bg-gradient-to-t::before {\r\n  content: var(--tw-content);\r\n  background-image: linear-gradient(to top, var(--tw-gradient-stops));\r\n}\r\n\r\n.before\\:from-black\\/90::before {\r\n  content: var(--tw-content);\r\n  --tw-gradient-from: rgb(0 0 0 / 0.9);\r\n  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(0 0 0 / 0));\r\n}\r\n\r\n.before\\:to-black\\/10::before {\r\n  content: var(--tw-content);\r\n  --tw-gradient-to: rgb(0 0 0 / 0.1);\r\n}\r\n\r\n.before\\:pt-\\[100\\%\\]::before {\r\n  content: var(--tw-content);\r\n  padding-top: 100%;\r\n}\r\n\r\n.hover\\:border-slate-200:hover {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-slate-200) / var(--tw-border-opacity));\r\n}\r\n\r\n.hover\\:bg-slate-100:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-slate-100) / var(--tw-bg-opacity));\r\n}\r\n\r\n.hover\\:bg-white\\/5:hover {\r\n  background-color: rgb(255 255 255 / 0.05);\r\n}\r\n\r\n.hover\\:bg-opacity-30:hover {\r\n  --tw-bg-opacity: 0.3;\r\n}\r\n\r\n.focus\\:border-transparent:focus {\r\n  border-color: transparent;\r\n}\r\n\r\n.focus\\:outline-none:focus {\r\n  outline: 2px solid transparent;\r\n  outline-offset: 2px;\r\n}\r\n\r\n.focus\\:ring-0:focus {\r\n  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);\r\n  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color);\r\n  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);\r\n}\r\n\r\n.dark .dark\\:border-darkmode-400 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-400) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-darkmode-600 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-600) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-darkmode-300 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-300) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-darkmode-800 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-800) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-primary {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-primary) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-darkmode-500 {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-darkmode-500) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-transparent {\r\n  border-color: transparent;\r\n}\r\n\r\n.dark .dark\\:border-darkmode-100\\/40 {\r\n  border-color: rgb(var(--color-darkmode-100) / 0.4);\r\n}\r\n\r\n.dark .dark\\:border-success {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-success) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-warning {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-warning) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-danger {\r\n  --tw-border-opacity: 1;\r\n  border-color: rgb(var(--color-danger) / var(--tw-border-opacity));\r\n}\r\n\r\n.dark .dark\\:border-darkmode-800\\/80 {\r\n  border-color: rgb(var(--color-darkmode-800) / 0.8);\r\n}\r\n\r\n.dark .dark\\:bg-darkmode-300 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-300) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:bg-success\\/30 {\r\n  background-color: rgb(var(--color-success) / 0.3);\r\n}\r\n\r\n.dark .dark\\:bg-pending\\/30 {\r\n  background-color: rgb(var(--color-pending) / 0.3);\r\n}\r\n\r\n.dark .dark\\:bg-primary\\/50 {\r\n  background-color: rgb(var(--color-primary) / 0.5);\r\n}\r\n\r\n.dark .dark\\:bg-darkmode-400 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:bg-darkmode-600 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-600) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:bg-black\\/20 {\r\n  background-color: rgb(0 0 0 / 0.2);\r\n}\r\n\r\n.dark .dark\\:bg-darkmode-800 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-800) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:bg-transparent {\r\n  background-color: transparent;\r\n}\r\n\r\n.dark .dark\\:bg-black\\/10 {\r\n  background-color: rgb(0 0 0 / 0.1);\r\n}\r\n\r\n.dark .dark\\:bg-darkmode-700 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-700) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:bg-darkmode-400\\/70 {\r\n  background-color: rgb(var(--color-darkmode-400) / 0.7);\r\n}\r\n\r\n.dark .dark\\:bg-darkmode-500 {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-500) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:bg-primary {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-primary) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:bg-success\\/10 {\r\n  background-color: rgb(var(--color-success) / 0.1);\r\n}\r\n\r\n.dark .dark\\:bg-primary\\/20 {\r\n  background-color: rgb(var(--color-primary) / 0.2);\r\n}\r\n\r\n.dark .dark\\:text-slate-500 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-500) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .dark\\:text-slate-300 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-300) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .dark\\:text-slate-200 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-200) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .dark\\:text-white {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(255 255 255 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .dark\\:text-slate-400 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(var(--color-slate-400) / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .dark\\:text-gray-300 {\r\n  --tw-text-opacity: 1;\r\n  color: rgb(209 213 219 / var(--tw-text-opacity));\r\n}\r\n\r\n.dark .before\\:dark\\:bg-darkmode-400::before {\r\n  content: var(--tw-content);\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n.dark .dark\\:hover\\:bg-darkmode-400:hover {\r\n  --tw-bg-opacity: 1;\r\n  background-color: rgb(var(--color-darkmode-400) / var(--tw-bg-opacity));\r\n}\r\n\r\n@media (min-width: 640px) {\r\n  .sm\\:static {\r\n    position: static;\r\n  }\r\n\r\n  .sm\\:absolute {\r\n    position: absolute;\r\n  }\r\n\r\n  .sm\\:relative {\r\n    position: relative;\r\n  }\r\n\r\n  .sm\\:col-span-6 {\r\n    grid-column: span 6 / span 6;\r\n  }\r\n\r\n  .sm\\:col-span-4 {\r\n    grid-column: span 4 / span 4;\r\n  }\r\n\r\n  .sm\\:col-span-3 {\r\n    grid-column: span 3 / span 3;\r\n  }\r\n\r\n  .sm\\:col-span-1 {\r\n    grid-column: span 1 / span 1;\r\n  }\r\n\r\n  .sm\\:mx-0 {\r\n    margin-left: 0px;\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .sm\\:mx-2 {\r\n    margin-left: 0.5rem;\r\n    margin-right: 0.5rem;\r\n  }\r\n\r\n  .sm\\:-mx-8 {\r\n    margin-left: -2rem;\r\n    margin-right: -2rem;\r\n  }\r\n\r\n  .sm\\:ml-auto {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .sm\\:mt-0 {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .sm\\:ml-0 {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .sm\\:mr-auto {\r\n    margin-right: auto;\r\n  }\r\n\r\n  .sm\\:mr-3 {\r\n    margin-right: 0.75rem;\r\n  }\r\n\r\n  .sm\\:ml-3 {\r\n    margin-left: 0.75rem;\r\n  }\r\n\r\n  .sm\\:mb-0 {\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .sm\\:mr-5 {\r\n    margin-right: 1.25rem;\r\n  }\r\n\r\n  .sm\\:mt-5 {\r\n    margin-top: 1.25rem;\r\n  }\r\n\r\n  .sm\\:mt-2 {\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  .sm\\:mt-10 {\r\n    margin-top: 2.5rem;\r\n  }\r\n\r\n  .sm\\:ml-40 {\r\n    margin-left: 10rem;\r\n  }\r\n\r\n  .sm\\:mr-28 {\r\n    margin-right: 7rem;\r\n  }\r\n\r\n  .sm\\:mr-40 {\r\n    margin-right: 10rem;\r\n  }\r\n\r\n  .sm\\:mr-20 {\r\n    margin-right: 5rem;\r\n  }\r\n\r\n  .sm\\:mr-0 {\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .sm\\:mr-2 {\r\n    margin-right: 0.5rem;\r\n  }\r\n\r\n  .sm\\:ml-20 {\r\n    margin-left: 5rem;\r\n  }\r\n\r\n  .sm\\:mr-4 {\r\n    margin-right: 1rem;\r\n  }\r\n\r\n  .sm\\:ml-1 {\r\n    margin-left: 0.25rem;\r\n  }\r\n\r\n  .sm\\:ml-2 {\r\n    margin-left: 0.5rem;\r\n  }\r\n\r\n  .sm\\:mr-6 {\r\n    margin-right: 1.5rem;\r\n  }\r\n\r\n  .sm\\:block {\r\n    display: block;\r\n  }\r\n\r\n  .sm\\:flex {\r\n    display: flex;\r\n  }\r\n\r\n  .sm\\:grid {\r\n    display: grid;\r\n  }\r\n\r\n  .sm\\:hidden {\r\n    display: none;\r\n  }\r\n\r\n  .sm\\:h-10 {\r\n    height: 2.5rem;\r\n  }\r\n\r\n  .sm\\:h-12 {\r\n    height: 3rem;\r\n  }\r\n\r\n  .sm\\:h-5 {\r\n    height: 1.25rem;\r\n  }\r\n\r\n  .sm\\:h-24 {\r\n    height: 6rem;\r\n  }\r\n\r\n  .sm\\:w-auto {\r\n    width: auto;\r\n  }\r\n\r\n  .sm\\:w-10 {\r\n    width: 2.5rem;\r\n  }\r\n\r\n  .sm\\:w-12 {\r\n    width: 3rem;\r\n  }\r\n\r\n  .sm\\:w-5 {\r\n    width: 1.25rem;\r\n  }\r\n\r\n  .sm\\:w-56 {\r\n    width: 14rem;\r\n  }\r\n\r\n  .sm\\:w-72 {\r\n    width: 18rem;\r\n  }\r\n\r\n  .sm\\:w-52 {\r\n    width: 13rem;\r\n  }\r\n\r\n  .sm\\:w-60 {\r\n    width: 15rem;\r\n  }\r\n\r\n  .sm\\:w-full {\r\n    width: 100%;\r\n  }\r\n\r\n  .sm\\:w-64 {\r\n    width: 16rem;\r\n  }\r\n\r\n  .sm\\:w-3\\/4 {\r\n    width: 75%;\r\n  }\r\n\r\n  .sm\\:w-40 {\r\n    width: 10rem;\r\n  }\r\n\r\n  .sm\\:w-24 {\r\n    width: 6rem;\r\n  }\r\n\r\n  .sm\\:w-20 {\r\n    width: 5rem;\r\n  }\r\n\r\n  .sm\\:w-32 {\r\n    width: 8rem;\r\n  }\r\n\r\n  .sm\\:w-16 {\r\n    width: 4rem;\r\n  }\r\n\r\n  .sm\\:flex-row {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .sm\\:flex-nowrap {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .sm\\:items-end {\r\n    align-items: flex-end;\r\n  }\r\n\r\n  .sm\\:justify-start {\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .sm\\:justify-end {\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .sm\\:gap-10 {\r\n    gap: 2.5rem;\r\n  }\r\n\r\n  .sm\\:gap-6 {\r\n    gap: 1.5rem;\r\n  }\r\n\r\n  .sm\\:overflow-x-visible {\r\n    overflow-x: visible;\r\n  }\r\n\r\n  .sm\\:whitespace-normal {\r\n    white-space: normal;\r\n  }\r\n\r\n  .sm\\:border-0 {\r\n    border-width: 0px;\r\n  }\r\n\r\n  .sm\\:border-t-0 {\r\n    border-top-width: 0px;\r\n  }\r\n\r\n  .sm\\:border-l {\r\n    border-left-width: 1px;\r\n  }\r\n\r\n  .sm\\:border-b-0 {\r\n    border-bottom-width: 0px;\r\n  }\r\n\r\n  .sm\\:px-0 {\r\n    padding-left: 0px;\r\n    padding-right: 0px;\r\n  }\r\n\r\n  .sm\\:py-4 {\r\n    padding-top: 1rem;\r\n    padding-bottom: 1rem;\r\n  }\r\n\r\n  .sm\\:px-28 {\r\n    padding-left: 7rem;\r\n    padding-right: 7rem;\r\n  }\r\n\r\n  .sm\\:px-5 {\r\n    padding-left: 1.25rem;\r\n    padding-right: 1.25rem;\r\n  }\r\n\r\n  .sm\\:px-20 {\r\n    padding-left: 5rem;\r\n    padding-right: 5rem;\r\n  }\r\n\r\n  .sm\\:py-20 {\r\n    padding-top: 5rem;\r\n    padding-bottom: 5rem;\r\n  }\r\n\r\n  .sm\\:px-16 {\r\n    padding-left: 4rem;\r\n    padding-right: 4rem;\r\n  }\r\n\r\n  .sm\\:px-10 {\r\n    padding-left: 2.5rem;\r\n    padding-right: 2.5rem;\r\n  }\r\n\r\n  .sm\\:px-8 {\r\n    padding-left: 2rem;\r\n    padding-right: 2rem;\r\n  }\r\n\r\n  .sm\\:py-0 {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .sm\\:py-3 {\r\n    padding-top: 0.75rem;\r\n    padding-bottom: 0.75rem;\r\n  }\r\n\r\n  .sm\\:pt-6 {\r\n    padding-top: 1.5rem;\r\n  }\r\n\r\n  .sm\\:pt-0 {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .sm\\:pl-5 {\r\n    padding-left: 1.25rem;\r\n  }\r\n\r\n  .sm\\:pb-20 {\r\n    padding-bottom: 5rem;\r\n  }\r\n\r\n  .sm\\:pt-20 {\r\n    padding-top: 5rem;\r\n  }\r\n\r\n  .sm\\:pb-0 {\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .sm\\:text-left {\r\n    text-align: left;\r\n  }\r\n\r\n  .sm\\:text-right {\r\n    text-align: right;\r\n  }\r\n\r\n  .sm\\:text-sm {\r\n    font-size: 0.875rem;\r\n    line-height: 1.25rem;\r\n  }\r\n\r\n  .sm\\:text-2xl {\r\n    font-size: 1.5rem;\r\n    line-height: 2rem;\r\n  }\r\n\r\n  .sm\\:text-lg {\r\n    font-size: 1.125rem;\r\n    line-height: 1.75rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .md\\:fixed {\r\n    position: fixed;\r\n  }\r\n\r\n  .md\\:inset-x-0 {\r\n    left: 0px;\r\n    right: 0px;\r\n  }\r\n\r\n  .md\\:top-0 {\r\n    top: 0px;\r\n  }\r\n\r\n  .md\\:col-span-6 {\r\n    grid-column: span 6 / span 6;\r\n  }\r\n\r\n  .md\\:col-span-4 {\r\n    grid-column: span 4 / span 4;\r\n  }\r\n\r\n  .md\\:col-span-3 {\r\n    grid-column: span 3 / span 3;\r\n  }\r\n\r\n  .md\\:row-start-auto {\r\n    grid-row-start: auto;\r\n  }\r\n\r\n  .md\\:-mx-0 {\r\n    margin-left: -0px;\r\n    margin-right: -0px;\r\n  }\r\n\r\n  .md\\:ml-0 {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .md\\:ml-auto {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .md\\:mt-0 {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .md\\:mb-0 {\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .md\\:block {\r\n    display: block;\r\n  }\r\n\r\n  .md\\:flex {\r\n    display: flex;\r\n  }\r\n\r\n  .md\\:hidden {\r\n    display: none;\r\n  }\r\n\r\n  .md\\:h-\\[65px\\] {\r\n    height: 65px;\r\n  }\r\n\r\n  .md\\:flex-row {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .md\\:items-center {\r\n    align-items: center;\r\n  }\r\n\r\n  .md\\:border-t-0 {\r\n    border-top-width: 0px;\r\n  }\r\n\r\n  .md\\:border-l {\r\n    border-left-width: 1px;\r\n  }\r\n\r\n  .md\\:border-r {\r\n    border-right-width: 1px;\r\n  }\r\n\r\n  .md\\:border-l-0 {\r\n    border-left-width: 0px;\r\n  }\r\n\r\n  .md\\:border-b-0 {\r\n    border-bottom-width: 0px;\r\n  }\r\n\r\n  .md\\:bg-gradient-to-b {\r\n    background-image: linear-gradient(to bottom, var(--tw-gradient-stops));\r\n  }\r\n\r\n  .md\\:from-slate-100 {\r\n    --tw-gradient-from: rgb(var(--color-slate-100));\r\n    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-slate-100) / 0));\r\n  }\r\n\r\n  .md\\:to-transparent {\r\n    --tw-gradient-to: transparent;\r\n  }\r\n\r\n  .md\\:px-5 {\r\n    padding-left: 1.25rem;\r\n    padding-right: 1.25rem;\r\n  }\r\n\r\n  .md\\:py-0 {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .md\\:px-10 {\r\n    padding-left: 2.5rem;\r\n    padding-right: 2.5rem;\r\n  }\r\n\r\n  .md\\:pl-0 {\r\n    padding-left: 0px;\r\n  }\r\n\r\n  .md\\:pt-10 {\r\n    padding-top: 2.5rem;\r\n  }\r\n\r\n  .md\\:pt-15 {\r\n    padding-top: 3rem;\r\n  }\r\n\r\n  .dark .dark\\:md\\:from-darkmode-700 {\r\n    --tw-gradient-from: rgb(var(--color-darkmode-700));\r\n    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to, rgb(var(--color-darkmode-700) / 0));\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .lg\\:col-span-6 {\r\n    grid-column: span 6 / span 6;\r\n  }\r\n\r\n  .lg\\:col-span-4 {\r\n    grid-column: span 4 / span 4;\r\n  }\r\n\r\n  .lg\\:col-span-8 {\r\n    grid-column: span 8 / span 8;\r\n  }\r\n\r\n  .lg\\:col-span-3 {\r\n    grid-column: span 3 / span 3;\r\n  }\r\n\r\n  .lg\\:col-span-9 {\r\n    grid-column: span 9 / span 9;\r\n  }\r\n\r\n  .lg\\:col-span-2 {\r\n    grid-column: span 2 / span 2;\r\n  }\r\n\r\n  .lg\\:row-start-3 {\r\n    grid-row-start: 3;\r\n  }\r\n\r\n  .lg\\:mx-auto {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n\r\n  .lg\\:mt-5 {\r\n    margin-top: 1.25rem;\r\n  }\r\n\r\n  .lg\\:mt-6 {\r\n    margin-top: 1.5rem;\r\n  }\r\n\r\n  .lg\\:mr-20 {\r\n    margin-right: 5rem;\r\n  }\r\n\r\n  .lg\\:mt-0 {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .lg\\:ml-auto {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .lg\\:ml-5 {\r\n    margin-left: 1.25rem;\r\n  }\r\n\r\n  .lg\\:mb-0 {\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .lg\\:ml-8 {\r\n    margin-left: 2rem;\r\n  }\r\n\r\n  .lg\\:mt-3 {\r\n    margin-top: 0.75rem;\r\n  }\r\n\r\n  .lg\\:mr-1 {\r\n    margin-right: 0.25rem;\r\n  }\r\n\r\n  .lg\\:ml-2 {\r\n    margin-left: 0.5rem;\r\n  }\r\n\r\n  .lg\\:mr-auto {\r\n    margin-right: auto;\r\n  }\r\n\r\n  .lg\\:ml-0 {\r\n    margin-left: 0px;\r\n  }\r\n\r\n  .lg\\:ml-4 {\r\n    margin-left: 1rem;\r\n  }\r\n\r\n  .lg\\:block {\r\n    display: block;\r\n  }\r\n\r\n  .lg\\:flex {\r\n    display: flex;\r\n  }\r\n\r\n  .lg\\:h-auto {\r\n    height: auto;\r\n  }\r\n\r\n  .lg\\:h-32 {\r\n    height: 8rem;\r\n  }\r\n\r\n  .lg\\:h-12 {\r\n    height: 3rem;\r\n  }\r\n\r\n  .lg\\:w-auto {\r\n    width: auto;\r\n  }\r\n\r\n  .lg\\:w-2\\/4 {\r\n    width: 50%;\r\n  }\r\n\r\n  .lg\\:w-64 {\r\n    width: 16rem;\r\n  }\r\n\r\n  .lg\\:w-40 {\r\n    width: 10rem;\r\n  }\r\n\r\n  .lg\\:w-32 {\r\n    width: 8rem;\r\n  }\r\n\r\n  .lg\\:w-56 {\r\n    width: 14rem;\r\n  }\r\n\r\n  .lg\\:w-12 {\r\n    width: 3rem;\r\n  }\r\n\r\n  .lg\\:w-1\\/2 {\r\n    width: 50%;\r\n  }\r\n\r\n  .lg\\:flex-row {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .lg\\:flex-nowrap {\r\n    flex-wrap: nowrap;\r\n  }\r\n\r\n  .lg\\:items-start {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .lg\\:justify-start {\r\n    justify-content: flex-start;\r\n  }\r\n\r\n  .lg\\:justify-end {\r\n    justify-content: flex-end;\r\n  }\r\n\r\n  .lg\\:justify-center {\r\n    justify-content: center;\r\n  }\r\n\r\n  .lg\\:overflow-visible {\r\n    overflow: visible;\r\n  }\r\n\r\n  .lg\\:border-0 {\r\n    border-width: 0px;\r\n  }\r\n\r\n  .lg\\:border-t-0 {\r\n    border-top-width: 0px;\r\n  }\r\n\r\n  .lg\\:border-l {\r\n    border-left-width: 1px;\r\n  }\r\n\r\n  .lg\\:border-b-0 {\r\n    border-bottom-width: 0px;\r\n  }\r\n\r\n  .lg\\:border-r {\r\n    border-right-width: 1px;\r\n  }\r\n\r\n  .lg\\:px-6 {\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .lg\\:py-3 {\r\n    padding-top: 0.75rem;\r\n    padding-bottom: 0.75rem;\r\n  }\r\n\r\n  .lg\\:px-5 {\r\n    padding-left: 1.25rem;\r\n    padding-right: 1.25rem;\r\n  }\r\n\r\n  .lg\\:pb-0 {\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .lg\\:pl-5 {\r\n    padding-left: 1.25rem;\r\n  }\r\n\r\n  .lg\\:pb-20 {\r\n    padding-bottom: 5rem;\r\n  }\r\n\r\n  .lg\\:pt-0 {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .lg\\:text-left {\r\n    text-align: left;\r\n  }\r\n\r\n  .lg\\:text-center {\r\n    text-align: center;\r\n  }\r\n\r\n  .lg\\:text-right {\r\n    text-align: right;\r\n  }\r\n\r\n  .lg\\:text-justify {\r\n    text-align: justify;\r\n  }\r\n\r\n  .lg\\:text-3xl {\r\n    font-size: 1.875rem;\r\n    line-height: 2.25rem;\r\n  }\r\n\r\n  .before\\:lg\\:block::before {\r\n    content: var(--tw-content);\r\n    display: block;\r\n  }\r\n}\r\n\r\n@media (min-width: 1280px) {\r\n  .xl\\:absolute {\r\n    position: absolute;\r\n  }\r\n\r\n  .xl\\:sticky {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n  }\r\n\r\n  .xl\\:z-auto {\r\n    z-index: auto;\r\n  }\r\n\r\n  .xl\\:col-span-4 {\r\n    grid-column: span 4 / span 4;\r\n  }\r\n\r\n  .xl\\:col-span-8 {\r\n    grid-column: span 8 / span 8;\r\n  }\r\n\r\n  .xl\\:col-span-3 {\r\n    grid-column: span 3 / span 3;\r\n  }\r\n\r\n  .xl\\:col-span-12 {\r\n    grid-column: span 12 / span 12;\r\n  }\r\n\r\n  .xl\\:col-span-6 {\r\n    grid-column: span 6 / span 6;\r\n  }\r\n\r\n  .xl\\:col-span-9 {\r\n    grid-column: span 9 / span 9;\r\n  }\r\n\r\n  .xl\\:col-span-1 {\r\n    grid-column: span 1 / span 1;\r\n  }\r\n\r\n  .xl\\:col-span-2 {\r\n    grid-column: span 2 / span 2;\r\n  }\r\n\r\n  .xl\\:col-start-1 {\r\n    grid-column-start: 1;\r\n  }\r\n\r\n  .xl\\:col-start-10 {\r\n    grid-column-start: 10;\r\n  }\r\n\r\n  .xl\\:row-start-1 {\r\n    grid-row-start: 1;\r\n  }\r\n\r\n  .xl\\:row-start-2 {\r\n    grid-row-start: 2;\r\n  }\r\n\r\n  .xl\\:row-start-auto {\r\n    grid-row-start: auto;\r\n  }\r\n\r\n  .xl\\:mx-5 {\r\n    margin-left: 1.25rem;\r\n    margin-right: 1.25rem;\r\n  }\r\n\r\n  .xl\\:mx-6 {\r\n    margin-left: 1.5rem;\r\n    margin-right: 1.5rem;\r\n  }\r\n\r\n  .xl\\:my-0 {\r\n    margin-top: 0px;\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .xl\\:ml-auto {\r\n    margin-left: auto;\r\n  }\r\n\r\n  .xl\\:mt-2 {\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  .xl\\:mt-0 {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .xl\\:-mt-5 {\r\n    margin-top: -1.25rem;\r\n  }\r\n\r\n  .xl\\:mt-8 {\r\n    margin-top: 2rem;\r\n  }\r\n\r\n  .xl\\:ml-20 {\r\n    margin-left: 5rem;\r\n  }\r\n\r\n  .xl\\:mr-3 {\r\n    margin-right: 0.75rem;\r\n  }\r\n\r\n  .xl\\:mt-24 {\r\n    margin-top: 6rem;\r\n  }\r\n\r\n  .xl\\:mr-0 {\r\n    margin-right: 0px;\r\n  }\r\n\r\n  .xl\\:ml-6 {\r\n    margin-left: 1.5rem;\r\n  }\r\n\r\n  .xl\\:flex {\r\n    display: flex;\r\n  }\r\n\r\n  .xl\\:grid {\r\n    display: grid;\r\n  }\r\n\r\n  .xl\\:hidden {\r\n    display: none;\r\n  }\r\n\r\n  .xl\\:h-auto {\r\n    height: auto;\r\n  }\r\n\r\n  .xl\\:min-h-0 {\r\n    min-height: 0px;\r\n  }\r\n\r\n  .xl\\:w-3\\/5 {\r\n    width: 60%;\r\n  }\r\n\r\n  .xl\\:w-auto {\r\n    width: auto;\r\n  }\r\n\r\n  .xl\\:w-32 {\r\n    width: 8rem;\r\n  }\r\n\r\n  .xl\\:w-\\[180px\\] {\r\n    width: 180px;\r\n  }\r\n\r\n  .xl\\:flex-initial {\r\n    flex: 0 1 auto;\r\n  }\r\n\r\n  .xl\\:flex-row {\r\n    flex-direction: row;\r\n  }\r\n\r\n  .xl\\:items-start {\r\n    align-items: flex-start;\r\n  }\r\n\r\n  .xl\\:overflow-y-auto {\r\n    overflow-y: auto;\r\n  }\r\n\r\n  .xl\\:bg-transparent {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .xl\\:p-0 {\r\n    padding: 0px;\r\n  }\r\n\r\n  .xl\\:px-0 {\r\n    padding-left: 0px;\r\n    padding-right: 0px;\r\n  }\r\n\r\n  .xl\\:py-0 {\r\n    padding-top: 0px;\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .xl\\:pb-0 {\r\n    padding-bottom: 0px;\r\n  }\r\n\r\n  .xl\\:pb-16 {\r\n    padding-bottom: 4rem;\r\n  }\r\n\r\n  .xl\\:text-left {\r\n    text-align: left;\r\n  }\r\n\r\n  .xl\\:text-xl {\r\n    font-size: 1.25rem;\r\n    line-height: 1.75rem;\r\n  }\r\n\r\n  .xl\\:text-3xl {\r\n    font-size: 1.875rem;\r\n    line-height: 2.25rem;\r\n  }\r\n\r\n  .xl\\:shadow-none {\r\n    --tw-shadow: 0 0 #0000;\r\n    --tw-shadow-colored: 0 0 #0000;\r\n    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);\r\n  }\r\n\r\n  .xl\\:before\\:block::before {\r\n    content: var(--tw-content);\r\n    display: block;\r\n  }\r\n}\r\n\r\n@media (min-width: 1536px) {\r\n  .\\32xl\\:z-10 {\r\n    z-index: 10;\r\n  }\r\n\r\n  .\\32xl\\:col-span-3 {\r\n    grid-column: span 3 / span 3;\r\n  }\r\n\r\n  .\\32xl\\:col-span-9 {\r\n    grid-column: span 9 / span 9;\r\n  }\r\n\r\n  .\\32xl\\:col-span-12 {\r\n    grid-column: span 12 / span 12;\r\n  }\r\n\r\n  .\\32xl\\:col-span-2 {\r\n    grid-column: span 2 / span 2;\r\n  }\r\n\r\n  .\\32xl\\:col-span-10 {\r\n    grid-column: span 10 / span 10;\r\n  }\r\n\r\n  .\\32xl\\:col-span-5 {\r\n    grid-column: span 5 / span 5;\r\n  }\r\n\r\n  .\\32xl\\:col-span-6 {\r\n    grid-column: span 6 / span 6;\r\n  }\r\n\r\n  .\\32xl\\:col-start-auto {\r\n    grid-column-start: auto;\r\n  }\r\n\r\n  .\\32xl\\:row-start-auto {\r\n    grid-row-start: auto;\r\n  }\r\n\r\n  .\\32xl\\:mt-8 {\r\n    margin-top: 2rem;\r\n  }\r\n\r\n  .\\32xl\\:mt-6 {\r\n    margin-top: 1.5rem;\r\n  }\r\n\r\n  .\\32xl\\:mt-24 {\r\n    margin-top: 6rem;\r\n  }\r\n\r\n  .\\32xl\\:mt-0 {\r\n    margin-top: 0px;\r\n  }\r\n\r\n  .\\32xl\\:ml-16 {\r\n    margin-left: 4rem;\r\n  }\r\n\r\n  .\\32xl\\:-ml-20 {\r\n    margin-left: -5rem;\r\n  }\r\n\r\n  .\\32xl\\:mb-0 {\r\n    margin-bottom: 0px;\r\n  }\r\n\r\n  .\\32xl\\:-mt-1\\.5 {\r\n    margin-top: -0.375rem;\r\n  }\r\n\r\n  .\\32xl\\:-mt-1 {\r\n    margin-top: -0.25rem;\r\n  }\r\n\r\n  .\\32xl\\:mr-auto {\r\n    margin-right: auto;\r\n  }\r\n\r\n  .\\32xl\\:-mt-8 {\r\n    margin-top: -2rem;\r\n  }\r\n\r\n  .\\32xl\\:flex {\r\n    display: flex;\r\n  }\r\n\r\n  .\\32xl\\:h-56 {\r\n    height: 14rem;\r\n  }\r\n\r\n  .\\32xl\\:w-14 {\r\n    width: 3.5rem;\r\n  }\r\n\r\n  .\\32xl\\:w-52 {\r\n    width: 13rem;\r\n  }\r\n\r\n  .\\32xl\\:w-4\\/6 {\r\n    width: 66.666667%;\r\n  }\r\n\r\n  .\\32xl\\:w-2\\/3 {\r\n    width: 66.666667%;\r\n  }\r\n\r\n  .\\32xl\\:w-full {\r\n    width: 100%;\r\n  }\r\n\r\n  .\\32xl\\:flex-none {\r\n    flex: none;\r\n  }\r\n\r\n  .\\32xl\\:grid-cols-7 {\r\n    grid-template-columns: repeat(7, minmax(0, 1fr));\r\n  }\r\n\r\n  .\\32xl\\:justify-center {\r\n    justify-content: center;\r\n  }\r\n\r\n  .\\32xl\\:gap-x-0 {\r\n    -moz-column-gap: 0px;\r\n    column-gap: 0px;\r\n  }\r\n\r\n  .\\32xl\\:border-l {\r\n    border-left-width: 1px;\r\n  }\r\n\r\n  .\\32xl\\:bg-transparent {\r\n    background-color: transparent;\r\n  }\r\n\r\n  .\\32xl\\:p-0 {\r\n    padding: 0px;\r\n  }\r\n\r\n  .\\32xl\\:px-6 {\r\n    padding-left: 1.5rem;\r\n    padding-right: 1.5rem;\r\n  }\r\n\r\n  .\\32xl\\:pl-6 {\r\n    padding-left: 1.5rem;\r\n  }\r\n\r\n  .\\32xl\\:pt-0 {\r\n    padding-top: 0px;\r\n  }\r\n\r\n  .\\32xl\\:pl-4 {\r\n    padding-left: 1rem;\r\n  }\r\n\r\n  .\\32xl\\:pl-2\\.5 {\r\n    padding-left: 0.625rem;\r\n  }\r\n\r\n  .\\32xl\\:pl-2 {\r\n    padding-left: 0.5rem;\r\n  }\r\n\r\n  .\\32xl\\:text-base {\r\n    font-size: 1rem;\r\n    line-height: 1.5rem;\r\n  }\r\n\r\n  .\\32xl\\:text-lg {\r\n    font-size: 1.125rem;\r\n    line-height: 1.75rem;\r\n  }\r\n\r\n  .\\32xl\\:text-3xl {\r\n    font-size: 1.875rem;\r\n    line-height: 2.25rem;\r\n  }\r\n\r\n  .\\32xl\\:text-2xl {\r\n    font-size: 1.5rem;\r\n    line-height: 2rem;\r\n  }\r\n\r\n  .\\32xl\\:text-sm {\r\n    font-size: 0.875rem;\r\n    line-height: 1.25rem;\r\n  }\r\n\r\n  .\\32xl\\:text-xl {\r\n    font-size: 1.25rem;\r\n    line-height: 1.75rem;\r\n  }\r\n\r\n  .\\32xl\\:leading-5 {\r\n    line-height: 1.25rem;\r\n  }\r\n\r\n  .\\32xl\\:text-success {\r\n    --tw-text-opacity: 1;\r\n    color: rgb(var(--color-success) / var(--tw-text-opacity));\r\n  }\r\n}\r\n\r\n\r\n/**/\r\n.multiselect__container {\r\n  z-index: 9999;\r\n\r\n}\r\n\r\n.multiselect__show_search_box {\r\n  flex-basis: unset !important;\r\n  display: block;\r\n  width: 90%;\r\n\r\n  -webkit-box-align: center;\r\n  -ms-flex-align: center;\r\n  align-items: center;\r\n  background-color: #fff;\r\n  border-radius: 2px;\r\n  -webkit-box-shadow: 0 1px 3px 0 #d1d1d2, 0 0 0 1px #d1d1d2;\r\n  box-shadow: 0 1px 3px 0 #d1d1d2, 0 0 0 1px #d1d1d2;\r\n  -webkit-box-sizing: border-box;\r\n  box-sizing: border-box;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  font-family: Arial, Helvetica, sans-serif;\r\n  min-height: 36px;\r\n  padding: 4px 8px 0 8px;\r\n  position: relative;\r\n}\r\n\r\n.d_none {\r\n  display: none;\r\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
